import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Define a Relay Cursor type:
   * https://relay.dev/graphql/connections.htm#sec-Cursor
   */
  Cursor: { input: any; output: any; }
  DateOnly: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  JSON: { input: any; output: any; }
  /** The builtin Map type */
  Map: { input: any; output: any; }
  NullString: { input: any; output: any; }
  /** The builtin Time type */
  Time: { input: any; output: any; }
  TimeOnly: { input: any; output: any; }
};

export type ApiUser = Node & {
  __typename?: 'APIUser';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type ApiUserConnection = {
  __typename?: 'APIUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ApiUserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ApiUserEdge = {
  __typename?: 'APIUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ApiUser>;
};

export enum ApiUserField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Key = 'key',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for APIUser connections */
export type ApiUserOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order APIUsers. */
  field: ApiUserOrderField;
};

/** Properties by which APIUser connections can be ordered. */
export enum ApiUserOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * APIUserWhereInput is used for filtering APIUser objects.
 * Input was generated by ent.
 */
export type ApiUserWhereInput = {
  and?: InputMaybe<Array<ApiUserWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** key field predicates */
  key?: InputMaybe<Scalars['String']['input']>;
  keyContains?: InputMaybe<Scalars['String']['input']>;
  keyContainsFold?: InputMaybe<Scalars['String']['input']>;
  keyEqualFold?: InputMaybe<Scalars['String']['input']>;
  keyGT?: InputMaybe<Scalars['String']['input']>;
  keyGTE?: InputMaybe<Scalars['String']['input']>;
  keyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  keyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  keyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keyLT?: InputMaybe<Scalars['String']['input']>;
  keyLTE?: InputMaybe<Scalars['String']['input']>;
  keyNEQ?: InputMaybe<Scalars['String']['input']>;
  keyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ApiUserWhereInput>;
  or?: InputMaybe<Array<ApiUserWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AdhocTable = Node & {
  __typename?: 'AdhocTable';
  approvedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  haltPointID: Scalars['ID']['output'];
  haltpointLat?: Maybe<Scalars['Float']['output']>;
  haltpointLng?: Maybe<Scalars['Float']['output']>;
  haltpointLocation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  load?: Maybe<Scalars['Float']['output']>;
  organisationID: Scalars['ID']['output'];
  rejectedAt?: Maybe<Scalars['Time']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  serviceType: AdhocTableServiceType;
  status: AdhocTableStatus;
  targetID: Scalars['ID']['output'];
  tripID?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Time']['output'];
  wasteType?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type AdhocTableConnection = {
  __typename?: 'AdhocTableConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdhocTableEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdhocTableEdge = {
  __typename?: 'AdhocTableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AdhocTable>;
};

export enum AdhocTableField {
  ApprovedAt = 'approvedAt',
  CreatedAt = 'createdAt',
  HaltPointId = 'haltPointID',
  HaltpointLat = 'haltpointLat',
  HaltpointLng = 'haltpointLng',
  HaltpointLocation = 'haltpointLocation',
  Load = 'load',
  OrganisationId = 'organisationID',
  RejectedAt = 'rejectedAt',
  Remarks = 'remarks',
  ServiceType = 'serviceType',
  Status = 'status',
  TargetId = 'targetID',
  TripId = 'tripID',
  UpdatedAt = 'updatedAt',
  WasteType = 'wasteType'
}

/** Ordering options for AdhocTable connections */
export type AdhocTableOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AdhocTables. */
  field: AdhocTableOrderField;
};

/** Properties by which AdhocTable connections can be ordered. */
export enum AdhocTableOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** AdhocTableServiceType is enum for the field service_type */
export enum AdhocTableServiceType {
  Drop = 'DROP',
  Exchange = 'EXCHANGE',
  Pickup = 'PICKUP'
}

/** AdhocTableStatus is enum for the field status */
export enum AdhocTableStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Skipped = 'SKIPPED'
}

/**
 * AdhocTableWhereInput is used for filtering AdhocTable objects.
 * Input was generated by ent.
 */
export type AdhocTableWhereInput = {
  and?: InputMaybe<Array<AdhocTableWhereInput>>;
  /** approved_at field predicates */
  approvedAt?: InputMaybe<Scalars['Time']['input']>;
  approvedAtGT?: InputMaybe<Scalars['Time']['input']>;
  approvedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  approvedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approvedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approvedAtLT?: InputMaybe<Scalars['Time']['input']>;
  approvedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  approvedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  approvedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approvedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** halt_point_id field predicates */
  haltPointID?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDGT?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDGTE?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  haltPointIDLT?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDLTE?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** haltpoint_lat field predicates */
  haltpointLat?: InputMaybe<Scalars['Float']['input']>;
  haltpointLatGT?: InputMaybe<Scalars['Float']['input']>;
  haltpointLatGTE?: InputMaybe<Scalars['Float']['input']>;
  haltpointLatIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  haltpointLatIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  haltpointLatLT?: InputMaybe<Scalars['Float']['input']>;
  haltpointLatLTE?: InputMaybe<Scalars['Float']['input']>;
  haltpointLatNEQ?: InputMaybe<Scalars['Float']['input']>;
  haltpointLatNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  haltpointLatNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** haltpoint_lng field predicates */
  haltpointLng?: InputMaybe<Scalars['Float']['input']>;
  haltpointLngGT?: InputMaybe<Scalars['Float']['input']>;
  haltpointLngGTE?: InputMaybe<Scalars['Float']['input']>;
  haltpointLngIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  haltpointLngIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  haltpointLngLT?: InputMaybe<Scalars['Float']['input']>;
  haltpointLngLTE?: InputMaybe<Scalars['Float']['input']>;
  haltpointLngNEQ?: InputMaybe<Scalars['Float']['input']>;
  haltpointLngNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  haltpointLngNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** haltpoint_location field predicates */
  haltpointLocation?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationContains?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationContainsFold?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationEqualFold?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationGT?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationGTE?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  haltpointLocationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  haltpointLocationLT?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationLTE?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationNEQ?: InputMaybe<Scalars['String']['input']>;
  haltpointLocationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  haltpointLocationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** load field predicates */
  load?: InputMaybe<Scalars['Float']['input']>;
  loadGT?: InputMaybe<Scalars['Float']['input']>;
  loadGTE?: InputMaybe<Scalars['Float']['input']>;
  loadIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  loadIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  loadLT?: InputMaybe<Scalars['Float']['input']>;
  loadLTE?: InputMaybe<Scalars['Float']['input']>;
  loadNEQ?: InputMaybe<Scalars['Float']['input']>;
  loadNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  loadNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<AdhocTableWhereInput>;
  or?: InputMaybe<Array<AdhocTableWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** rejected_at field predicates */
  rejectedAt?: InputMaybe<Scalars['Time']['input']>;
  rejectedAtGT?: InputMaybe<Scalars['Time']['input']>;
  rejectedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  rejectedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  rejectedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rejectedAtLT?: InputMaybe<Scalars['Time']['input']>;
  rejectedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  rejectedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  rejectedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  rejectedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** remarks field predicates */
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksContains?: InputMaybe<Scalars['String']['input']>;
  remarksContainsFold?: InputMaybe<Scalars['String']['input']>;
  remarksEqualFold?: InputMaybe<Scalars['String']['input']>;
  remarksGT?: InputMaybe<Scalars['String']['input']>;
  remarksGTE?: InputMaybe<Scalars['String']['input']>;
  remarksHasPrefix?: InputMaybe<Scalars['String']['input']>;
  remarksHasSuffix?: InputMaybe<Scalars['String']['input']>;
  remarksIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remarksLT?: InputMaybe<Scalars['String']['input']>;
  remarksLTE?: InputMaybe<Scalars['String']['input']>;
  remarksNEQ?: InputMaybe<Scalars['String']['input']>;
  remarksNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** service_type field predicates */
  serviceType?: InputMaybe<AdhocTableServiceType>;
  serviceTypeIn?: InputMaybe<Array<AdhocTableServiceType>>;
  serviceTypeNEQ?: InputMaybe<AdhocTableServiceType>;
  serviceTypeNotIn?: InputMaybe<Array<AdhocTableServiceType>>;
  /** status field predicates */
  status?: InputMaybe<AdhocTableStatus>;
  statusIn?: InputMaybe<Array<AdhocTableStatus>>;
  statusNEQ?: InputMaybe<AdhocTableStatus>;
  statusNotIn?: InputMaybe<Array<AdhocTableStatus>>;
  /** target_id field predicates */
  targetID?: InputMaybe<Scalars['ID']['input']>;
  targetIDGT?: InputMaybe<Scalars['ID']['input']>;
  targetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  targetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetIDLT?: InputMaybe<Scalars['ID']['input']>;
  targetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  targetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  targetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** trip_id field predicates */
  tripID?: InputMaybe<Scalars['ID']['input']>;
  tripIDGT?: InputMaybe<Scalars['ID']['input']>;
  tripIDGTE?: InputMaybe<Scalars['ID']['input']>;
  tripIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  tripIDLT?: InputMaybe<Scalars['ID']['input']>;
  tripIDLTE?: InputMaybe<Scalars['ID']['input']>;
  tripIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** waste_type field predicates */
  wasteType?: InputMaybe<Scalars['String']['input']>;
  wasteTypeContains?: InputMaybe<Scalars['String']['input']>;
  wasteTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  wasteTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  wasteTypeGT?: InputMaybe<Scalars['String']['input']>;
  wasteTypeGTE?: InputMaybe<Scalars['String']['input']>;
  wasteTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  wasteTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  wasteTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  wasteTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  wasteTypeLT?: InputMaybe<Scalars['String']['input']>;
  wasteTypeLTE?: InputMaybe<Scalars['String']['input']>;
  wasteTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  wasteTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  wasteTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Attendance = Node & {
  __typename?: 'Attendance';
  attendanceDate: Scalars['Time']['output'];
  attendanceDetails?: Maybe<Array<AttendanceDetail>>;
  attendanceType: AttendanceAttendanceType;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  leaveDate?: Maybe<LeaveDate>;
  leaveDateID?: Maybe<Scalars['ID']['output']>;
  leaveRequest?: Maybe<LeaveRequest>;
  leaveRequestID?: Maybe<Scalars['ID']['output']>;
  leaveType?: Maybe<LeaveType>;
  leaveTypeID?: Maybe<Scalars['ID']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  overallStatus: AttendanceOverallStatus;
  remarks?: Maybe<Scalars['String']['output']>;
  totalActualMinutes?: Maybe<Scalars['Float']['output']>;
  totalScheduledMinutes?: Maybe<Scalars['Float']['output']>;
  totalShiftsCompleted?: Maybe<Scalars['Int']['output']>;
  totalShiftsScheduled?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  zoneName?: Maybe<Scalars['String']['output']>;
};

/** AttendanceAttendanceType is enum for the field attendance_type */
export enum AttendanceAttendanceType {
  Absent = 'absent',
  HalfDay = 'half_day',
  Leave = 'leave',
  Regular = 'regular',
  WorkFromHome = 'work_from_home'
}

/** A connection to a list of items. */
export type AttendanceConnection = {
  __typename?: 'AttendanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AttendanceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type AttendanceDWhereInput = {
  attendanceDateGTE?: InputMaybe<Scalars['Time']['input']>;
  attendanceDateLTE?: InputMaybe<Scalars['Time']['input']>;
  organisationId?: InputMaybe<Scalars['ID']['input']>;
};

export type AttendanceDetail = Node & {
  __typename?: 'AttendanceDetail';
  actualDurationMinutes?: Maybe<Scalars['Int']['output']>;
  actualMarkIn?: Maybe<Scalars['Time']['output']>;
  actualMarkOut?: Maybe<Scalars['Time']['output']>;
  attendance: Attendance;
  attendanceID: Scalars['ID']['output'];
  attendanceType?: Maybe<AttendanceDetailAttendanceType>;
  checkInDistanceFromWorkplaceMeters?: Maybe<Scalars['Float']['output']>;
  checkInFaceDetected: Scalars['Boolean']['output'];
  checkInFaceMatchScore?: Maybe<Scalars['Float']['output']>;
  checkInImagePath?: Maybe<Scalars['String']['output']>;
  checkInImageURL?: Maybe<Scalars['String']['output']>;
  checkInLatitude?: Maybe<Scalars['Float']['output']>;
  checkInLocationName?: Maybe<Scalars['String']['output']>;
  checkInLocationVerified: Scalars['Boolean']['output'];
  checkInLongitude?: Maybe<Scalars['Float']['output']>;
  checkOutDistanceFromWorkplaceMeters?: Maybe<Scalars['Float']['output']>;
  checkOutFaceDetected: Scalars['Boolean']['output'];
  checkOutFaceMatchScore?: Maybe<Scalars['Float']['output']>;
  checkOutImagePath?: Maybe<Scalars['String']['output']>;
  checkOutImageURL?: Maybe<Scalars['String']['output']>;
  checkOutLatitude?: Maybe<Scalars['Float']['output']>;
  checkOutLocationName?: Maybe<Scalars['String']['output']>;
  checkOutLocationVerified: Scalars['Boolean']['output'];
  checkOutLongitude?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  rosterShift: RosterShift;
  rosterShiftID: Scalars['ID']['output'];
  scheduledEndTime?: Maybe<Scalars['Time']['output']>;
  scheduledStartTime?: Maybe<Scalars['Time']['output']>;
  shiftNumber: Scalars['Int']['output'];
  status: AttendanceDetailStatus;
  updatedAt: Scalars['Time']['output'];
};

/** AttendanceDetailAttendanceType is enum for the field attendance_type */
export enum AttendanceDetailAttendanceType {
  Offline = 'offline',
  Online = 'online'
}

/** A connection to a list of items. */
export type AttendanceDetailConnection = {
  __typename?: 'AttendanceDetailConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AttendanceDetailEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AttendanceDetailEdge = {
  __typename?: 'AttendanceDetailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AttendanceDetail>;
};

export enum AttendanceDetailField {
  ActualDurationMinutes = 'actualDurationMinutes',
  ActualMarkIn = 'actualMarkIn',
  ActualMarkOut = 'actualMarkOut',
  AttendanceId = 'attendanceID',
  AttendanceType = 'attendanceType',
  CheckInDistanceFromWorkplaceMeters = 'checkInDistanceFromWorkplaceMeters',
  CheckInFaceDetected = 'checkInFaceDetected',
  CheckInFaceMatchScore = 'checkInFaceMatchScore',
  CheckInImagePath = 'checkInImagePath',
  CheckInImageUrl = 'checkInImageURL',
  CheckInLatitude = 'checkInLatitude',
  CheckInLocationName = 'checkInLocationName',
  CheckInLocationVerified = 'checkInLocationVerified',
  CheckInLongitude = 'checkInLongitude',
  CheckOutDistanceFromWorkplaceMeters = 'checkOutDistanceFromWorkplaceMeters',
  CheckOutFaceDetected = 'checkOutFaceDetected',
  CheckOutFaceMatchScore = 'checkOutFaceMatchScore',
  CheckOutImagePath = 'checkOutImagePath',
  CheckOutImageUrl = 'checkOutImageURL',
  CheckOutLatitude = 'checkOutLatitude',
  CheckOutLocationName = 'checkOutLocationName',
  CheckOutLocationVerified = 'checkOutLocationVerified',
  CheckOutLongitude = 'checkOutLongitude',
  CreatedAt = 'createdAt',
  Remarks = 'remarks',
  RosterShiftId = 'rosterShiftID',
  ScheduledEndTime = 'scheduledEndTime',
  ScheduledStartTime = 'scheduledStartTime',
  ShiftNumber = 'shiftNumber',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for AttendanceDetail connections */
export type AttendanceDetailOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AttendanceDetails. */
  field: AttendanceDetailOrderField;
};

/** Properties by which AttendanceDetail connections can be ordered. */
export enum AttendanceDetailOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** AttendanceDetailStatus is enum for the field status */
export enum AttendanceDetailStatus {
  Absent = 'absent',
  EarlyLeave = 'early_leave',
  Late = 'late',
  Partial = 'partial',
  Present = 'present'
}

/**
 * AttendanceDetailWhereInput is used for filtering AttendanceDetail objects.
 * Input was generated by ent.
 */
export type AttendanceDetailWhereInput = {
  /** actual_duration_minutes field predicates */
  actualDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  actualDurationMinutesGT?: InputMaybe<Scalars['Int']['input']>;
  actualDurationMinutesGTE?: InputMaybe<Scalars['Int']['input']>;
  actualDurationMinutesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  actualDurationMinutesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  actualDurationMinutesLT?: InputMaybe<Scalars['Int']['input']>;
  actualDurationMinutesLTE?: InputMaybe<Scalars['Int']['input']>;
  actualDurationMinutesNEQ?: InputMaybe<Scalars['Int']['input']>;
  actualDurationMinutesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  actualDurationMinutesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** actual_mark_in field predicates */
  actualMarkIn?: InputMaybe<Scalars['Time']['input']>;
  actualMarkInGT?: InputMaybe<Scalars['Time']['input']>;
  actualMarkInGTE?: InputMaybe<Scalars['Time']['input']>;
  actualMarkInIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  actualMarkInIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  actualMarkInLT?: InputMaybe<Scalars['Time']['input']>;
  actualMarkInLTE?: InputMaybe<Scalars['Time']['input']>;
  actualMarkInNEQ?: InputMaybe<Scalars['Time']['input']>;
  actualMarkInNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  actualMarkInNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** actual_mark_out field predicates */
  actualMarkOut?: InputMaybe<Scalars['Time']['input']>;
  actualMarkOutGT?: InputMaybe<Scalars['Time']['input']>;
  actualMarkOutGTE?: InputMaybe<Scalars['Time']['input']>;
  actualMarkOutIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  actualMarkOutIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  actualMarkOutLT?: InputMaybe<Scalars['Time']['input']>;
  actualMarkOutLTE?: InputMaybe<Scalars['Time']['input']>;
  actualMarkOutNEQ?: InputMaybe<Scalars['Time']['input']>;
  actualMarkOutNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  actualMarkOutNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<AttendanceDetailWhereInput>>;
  /** attendance_id field predicates */
  attendanceID?: InputMaybe<Scalars['ID']['input']>;
  attendanceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attendanceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attendanceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** attendance_type field predicates */
  attendanceType?: InputMaybe<AttendanceDetailAttendanceType>;
  attendanceTypeIn?: InputMaybe<Array<AttendanceDetailAttendanceType>>;
  attendanceTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  attendanceTypeNEQ?: InputMaybe<AttendanceDetailAttendanceType>;
  attendanceTypeNotIn?: InputMaybe<Array<AttendanceDetailAttendanceType>>;
  attendanceTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_distance_from_workplace_meters field predicates */
  checkInDistanceFromWorkplaceMeters?: InputMaybe<Scalars['Float']['input']>;
  checkInDistanceFromWorkplaceMetersGT?: InputMaybe<Scalars['Float']['input']>;
  checkInDistanceFromWorkplaceMetersGTE?: InputMaybe<Scalars['Float']['input']>;
  checkInDistanceFromWorkplaceMetersIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkInDistanceFromWorkplaceMetersIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInDistanceFromWorkplaceMetersLT?: InputMaybe<Scalars['Float']['input']>;
  checkInDistanceFromWorkplaceMetersLTE?: InputMaybe<Scalars['Float']['input']>;
  checkInDistanceFromWorkplaceMetersNEQ?: InputMaybe<Scalars['Float']['input']>;
  checkInDistanceFromWorkplaceMetersNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkInDistanceFromWorkplaceMetersNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_face_detected field predicates */
  checkInFaceDetected?: InputMaybe<Scalars['Boolean']['input']>;
  checkInFaceDetectedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_face_match_score field predicates */
  checkInFaceMatchScore?: InputMaybe<Scalars['Float']['input']>;
  checkInFaceMatchScoreGT?: InputMaybe<Scalars['Float']['input']>;
  checkInFaceMatchScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  checkInFaceMatchScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkInFaceMatchScoreIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInFaceMatchScoreLT?: InputMaybe<Scalars['Float']['input']>;
  checkInFaceMatchScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  checkInFaceMatchScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  checkInFaceMatchScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkInFaceMatchScoreNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_image_path field predicates */
  checkInImagePath?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathContains?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathGT?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathGTE?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInImagePathIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInImagePathLT?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathLTE?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathNEQ?: InputMaybe<Scalars['String']['input']>;
  checkInImagePathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInImagePathNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_image_url field predicates */
  checkInImageURL?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLContains?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLGT?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLGTE?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInImageURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInImageURLLT?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLLTE?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLNEQ?: InputMaybe<Scalars['String']['input']>;
  checkInImageURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInImageURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_latitude field predicates */
  checkInLatitude?: InputMaybe<Scalars['Float']['input']>;
  checkInLatitudeGT?: InputMaybe<Scalars['Float']['input']>;
  checkInLatitudeGTE?: InputMaybe<Scalars['Float']['input']>;
  checkInLatitudeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkInLatitudeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInLatitudeLT?: InputMaybe<Scalars['Float']['input']>;
  checkInLatitudeLTE?: InputMaybe<Scalars['Float']['input']>;
  checkInLatitudeNEQ?: InputMaybe<Scalars['Float']['input']>;
  checkInLatitudeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkInLatitudeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_location_name field predicates */
  checkInLocationName?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameContains?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameGT?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameGTE?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInLocationNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInLocationNameLT?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameLTE?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameNEQ?: InputMaybe<Scalars['String']['input']>;
  checkInLocationNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInLocationNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_location_verified field predicates */
  checkInLocationVerified?: InputMaybe<Scalars['Boolean']['input']>;
  checkInLocationVerifiedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_longitude field predicates */
  checkInLongitude?: InputMaybe<Scalars['Float']['input']>;
  checkInLongitudeGT?: InputMaybe<Scalars['Float']['input']>;
  checkInLongitudeGTE?: InputMaybe<Scalars['Float']['input']>;
  checkInLongitudeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkInLongitudeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInLongitudeLT?: InputMaybe<Scalars['Float']['input']>;
  checkInLongitudeLTE?: InputMaybe<Scalars['Float']['input']>;
  checkInLongitudeNEQ?: InputMaybe<Scalars['Float']['input']>;
  checkInLongitudeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkInLongitudeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_distance_from_workplace_meters field predicates */
  checkOutDistanceFromWorkplaceMeters?: InputMaybe<Scalars['Float']['input']>;
  checkOutDistanceFromWorkplaceMetersGT?: InputMaybe<Scalars['Float']['input']>;
  checkOutDistanceFromWorkplaceMetersGTE?: InputMaybe<Scalars['Float']['input']>;
  checkOutDistanceFromWorkplaceMetersIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkOutDistanceFromWorkplaceMetersIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutDistanceFromWorkplaceMetersLT?: InputMaybe<Scalars['Float']['input']>;
  checkOutDistanceFromWorkplaceMetersLTE?: InputMaybe<Scalars['Float']['input']>;
  checkOutDistanceFromWorkplaceMetersNEQ?: InputMaybe<Scalars['Float']['input']>;
  checkOutDistanceFromWorkplaceMetersNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkOutDistanceFromWorkplaceMetersNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_face_detected field predicates */
  checkOutFaceDetected?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutFaceDetectedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_face_match_score field predicates */
  checkOutFaceMatchScore?: InputMaybe<Scalars['Float']['input']>;
  checkOutFaceMatchScoreGT?: InputMaybe<Scalars['Float']['input']>;
  checkOutFaceMatchScoreGTE?: InputMaybe<Scalars['Float']['input']>;
  checkOutFaceMatchScoreIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkOutFaceMatchScoreIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutFaceMatchScoreLT?: InputMaybe<Scalars['Float']['input']>;
  checkOutFaceMatchScoreLTE?: InputMaybe<Scalars['Float']['input']>;
  checkOutFaceMatchScoreNEQ?: InputMaybe<Scalars['Float']['input']>;
  checkOutFaceMatchScoreNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkOutFaceMatchScoreNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_image_path field predicates */
  checkOutImagePath?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathContains?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathGT?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathGTE?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkOutImagePathIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutImagePathLT?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathLTE?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathNEQ?: InputMaybe<Scalars['String']['input']>;
  checkOutImagePathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkOutImagePathNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_image_url field predicates */
  checkOutImageURL?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLContains?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLGT?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLGTE?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkOutImageURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutImageURLLT?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLLTE?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLNEQ?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkOutImageURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_latitude field predicates */
  checkOutLatitude?: InputMaybe<Scalars['Float']['input']>;
  checkOutLatitudeGT?: InputMaybe<Scalars['Float']['input']>;
  checkOutLatitudeGTE?: InputMaybe<Scalars['Float']['input']>;
  checkOutLatitudeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkOutLatitudeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutLatitudeLT?: InputMaybe<Scalars['Float']['input']>;
  checkOutLatitudeLTE?: InputMaybe<Scalars['Float']['input']>;
  checkOutLatitudeNEQ?: InputMaybe<Scalars['Float']['input']>;
  checkOutLatitudeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkOutLatitudeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_location_name field predicates */
  checkOutLocationName?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameContains?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameGT?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameGTE?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkOutLocationNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutLocationNameLT?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameLTE?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameNEQ?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkOutLocationNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_location_verified field predicates */
  checkOutLocationVerified?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutLocationVerifiedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_longitude field predicates */
  checkOutLongitude?: InputMaybe<Scalars['Float']['input']>;
  checkOutLongitudeGT?: InputMaybe<Scalars['Float']['input']>;
  checkOutLongitudeGTE?: InputMaybe<Scalars['Float']['input']>;
  checkOutLongitudeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkOutLongitudeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutLongitudeLT?: InputMaybe<Scalars['Float']['input']>;
  checkOutLongitudeLTE?: InputMaybe<Scalars['Float']['input']>;
  checkOutLongitudeNEQ?: InputMaybe<Scalars['Float']['input']>;
  checkOutLongitudeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  checkOutLongitudeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** attendance edge predicates */
  hasAttendance?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttendanceWith?: InputMaybe<Array<AttendanceWhereInput>>;
  /** roster_shift edge predicates */
  hasRosterShift?: InputMaybe<Scalars['Boolean']['input']>;
  hasRosterShiftWith?: InputMaybe<Array<RosterShiftWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<AttendanceDetailWhereInput>;
  or?: InputMaybe<Array<AttendanceDetailWhereInput>>;
  /** remarks field predicates */
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksContains?: InputMaybe<Scalars['String']['input']>;
  remarksContainsFold?: InputMaybe<Scalars['String']['input']>;
  remarksEqualFold?: InputMaybe<Scalars['String']['input']>;
  remarksGT?: InputMaybe<Scalars['String']['input']>;
  remarksGTE?: InputMaybe<Scalars['String']['input']>;
  remarksHasPrefix?: InputMaybe<Scalars['String']['input']>;
  remarksHasSuffix?: InputMaybe<Scalars['String']['input']>;
  remarksIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remarksLT?: InputMaybe<Scalars['String']['input']>;
  remarksLTE?: InputMaybe<Scalars['String']['input']>;
  remarksNEQ?: InputMaybe<Scalars['String']['input']>;
  remarksNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** roster_shift_id field predicates */
  rosterShiftID?: InputMaybe<Scalars['ID']['input']>;
  rosterShiftIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rosterShiftIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  rosterShiftIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** scheduled_end_time field predicates */
  scheduledEndTime?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeGT?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  scheduledEndTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledEndTimeLT?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  scheduledEndTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** scheduled_start_time field predicates */
  scheduledStartTime?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  scheduledStartTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledStartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  scheduledStartTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** shift_number field predicates */
  shiftNumber?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberGT?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  shiftNumberLT?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** status field predicates */
  status?: InputMaybe<AttendanceDetailStatus>;
  statusIn?: InputMaybe<Array<AttendanceDetailStatus>>;
  statusNEQ?: InputMaybe<AttendanceDetailStatus>;
  statusNotIn?: InputMaybe<Array<AttendanceDetailStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type AttendanceEdge = {
  __typename?: 'AttendanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Attendance>;
};

export enum AttendanceField {
  AttendanceDate = 'attendanceDate',
  AttendanceType = 'attendanceType',
  CreatedAt = 'createdAt',
  LeaveDateId = 'leaveDateID',
  LeaveRequestId = 'leaveRequestID',
  LeaveTypeId = 'leaveTypeID',
  OrganisationId = 'organisationID',
  OverallStatus = 'overallStatus',
  Remarks = 'remarks',
  TotalActualMinutes = 'totalActualMinutes',
  TotalScheduledMinutes = 'totalScheduledMinutes',
  TotalShiftsCompleted = 'totalShiftsCompleted',
  TotalShiftsScheduled = 'totalShiftsScheduled',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  ZoneName = 'zoneName'
}

/** Ordering options for Attendance connections */
export type AttendanceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Attendances. */
  field: AttendanceOrderField;
};

/** Properties by which Attendance connections can be ordered. */
export enum AttendanceOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** AttendanceOverallStatus is enum for the field overall_status */
export enum AttendanceOverallStatus {
  Absent = 'absent',
  Late = 'late',
  Leave = 'leave',
  Partial = 'partial',
  Present = 'present'
}

/**
 * AttendanceWhereInput is used for filtering Attendance objects.
 * Input was generated by ent.
 */
export type AttendanceWhereInput = {
  and?: InputMaybe<Array<AttendanceWhereInput>>;
  /** attendance_date field predicates */
  attendanceDate?: InputMaybe<Scalars['Time']['input']>;
  attendanceDateGT?: InputMaybe<Scalars['Time']['input']>;
  attendanceDateGTE?: InputMaybe<Scalars['Time']['input']>;
  attendanceDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  attendanceDateLT?: InputMaybe<Scalars['Time']['input']>;
  attendanceDateLTE?: InputMaybe<Scalars['Time']['input']>;
  attendanceDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  attendanceDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** attendance_type field predicates */
  attendanceType?: InputMaybe<AttendanceAttendanceType>;
  attendanceTypeIn?: InputMaybe<Array<AttendanceAttendanceType>>;
  attendanceTypeNEQ?: InputMaybe<AttendanceAttendanceType>;
  attendanceTypeNotIn?: InputMaybe<Array<AttendanceAttendanceType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** attendance_details edge predicates */
  hasAttendanceDetails?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttendanceDetailsWith?: InputMaybe<Array<AttendanceDetailWhereInput>>;
  /** leave_date edge predicates */
  hasLeaveDate?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveDateWith?: InputMaybe<Array<LeaveDateWhereInput>>;
  /** leave_request edge predicates */
  hasLeaveRequest?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveRequestWith?: InputMaybe<Array<LeaveRequestWhereInput>>;
  /** leave_type edge predicates */
  hasLeaveType?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveTypeWith?: InputMaybe<Array<LeaveTypeWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** leave_date_id field predicates */
  leaveDateID?: InputMaybe<Scalars['ID']['input']>;
  leaveDateIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveDateIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  leaveDateIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  leaveDateIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveDateIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** leave_request_id field predicates */
  leaveRequestID?: InputMaybe<Scalars['ID']['input']>;
  leaveRequestIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveRequestIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  leaveRequestIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  leaveRequestIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveRequestIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** leave_type_id field predicates */
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveTypeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  leaveTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveTypeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<AttendanceWhereInput>;
  or?: InputMaybe<Array<AttendanceWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** overall_status field predicates */
  overallStatus?: InputMaybe<AttendanceOverallStatus>;
  overallStatusIn?: InputMaybe<Array<AttendanceOverallStatus>>;
  overallStatusNEQ?: InputMaybe<AttendanceOverallStatus>;
  overallStatusNotIn?: InputMaybe<Array<AttendanceOverallStatus>>;
  /** remarks field predicates */
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksContains?: InputMaybe<Scalars['String']['input']>;
  remarksContainsFold?: InputMaybe<Scalars['String']['input']>;
  remarksEqualFold?: InputMaybe<Scalars['String']['input']>;
  remarksGT?: InputMaybe<Scalars['String']['input']>;
  remarksGTE?: InputMaybe<Scalars['String']['input']>;
  remarksHasPrefix?: InputMaybe<Scalars['String']['input']>;
  remarksHasSuffix?: InputMaybe<Scalars['String']['input']>;
  remarksIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remarksLT?: InputMaybe<Scalars['String']['input']>;
  remarksLTE?: InputMaybe<Scalars['String']['input']>;
  remarksNEQ?: InputMaybe<Scalars['String']['input']>;
  remarksNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** total_actual_minutes field predicates */
  totalActualMinutes?: InputMaybe<Scalars['Float']['input']>;
  totalActualMinutesGT?: InputMaybe<Scalars['Float']['input']>;
  totalActualMinutesGTE?: InputMaybe<Scalars['Float']['input']>;
  totalActualMinutesIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalActualMinutesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  totalActualMinutesLT?: InputMaybe<Scalars['Float']['input']>;
  totalActualMinutesLTE?: InputMaybe<Scalars['Float']['input']>;
  totalActualMinutesNEQ?: InputMaybe<Scalars['Float']['input']>;
  totalActualMinutesNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalActualMinutesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** total_scheduled_minutes field predicates */
  totalScheduledMinutes?: InputMaybe<Scalars['Float']['input']>;
  totalScheduledMinutesGT?: InputMaybe<Scalars['Float']['input']>;
  totalScheduledMinutesGTE?: InputMaybe<Scalars['Float']['input']>;
  totalScheduledMinutesIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalScheduledMinutesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  totalScheduledMinutesLT?: InputMaybe<Scalars['Float']['input']>;
  totalScheduledMinutesLTE?: InputMaybe<Scalars['Float']['input']>;
  totalScheduledMinutesNEQ?: InputMaybe<Scalars['Float']['input']>;
  totalScheduledMinutesNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalScheduledMinutesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** total_shifts_completed field predicates */
  totalShiftsCompleted?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsCompletedGT?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsCompletedGTE?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsCompletedIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalShiftsCompletedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  totalShiftsCompletedLT?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsCompletedLTE?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsCompletedNEQ?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsCompletedNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalShiftsCompletedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** total_shifts_scheduled field predicates */
  totalShiftsScheduled?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsScheduledGT?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsScheduledGTE?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsScheduledIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalShiftsScheduledIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  totalShiftsScheduledLT?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsScheduledLTE?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsScheduledNEQ?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsScheduledNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalShiftsScheduledNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** zone_name field predicates */
  zoneName?: InputMaybe<Scalars['String']['input']>;
  zoneNameContains?: InputMaybe<Scalars['String']['input']>;
  zoneNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  zoneNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  zoneNameGT?: InputMaybe<Scalars['String']['input']>;
  zoneNameGTE?: InputMaybe<Scalars['String']['input']>;
  zoneNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  zoneNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  zoneNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  zoneNameLT?: InputMaybe<Scalars['String']['input']>;
  zoneNameLTE?: InputMaybe<Scalars['String']['input']>;
  zoneNameNEQ?: InputMaybe<Scalars['String']['input']>;
  zoneNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BaseAddon = Node & {
  __typename?: 'BaseAddon';
  baselicenseplanaddon?: Maybe<Array<BaseLicensePlanAddon>>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationCode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type BaseAddonConnection = {
  __typename?: 'BaseAddonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseAddonEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BaseAddonEdge = {
  __typename?: 'BaseAddonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseAddon>;
};

export enum BaseAddonField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Icon = 'icon',
  IntegrationCode = 'integrationCode',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for BaseAddon connections */
export type BaseAddonOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BaseAddons. */
  field: BaseAddonOrderField;
};

/** Properties by which BaseAddon connections can be ordered. */
export enum BaseAddonOrderField {
  Description = 'DESCRIPTION',
  Icon = 'ICON',
  IntegrationCode = 'INTEGRATION_CODE',
  IsActive = 'IS_ACTIVE',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * BaseAddonWhereInput is used for filtering BaseAddon objects.
 * Input was generated by ent.
 */
export type BaseAddonWhereInput = {
  and?: InputMaybe<Array<BaseAddonWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** baselicenseplanaddon edge predicates */
  hasBaselicenseplanaddon?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanaddonWith?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** icon field predicates */
  icon?: InputMaybe<Scalars['String']['input']>;
  iconContains?: InputMaybe<Scalars['String']['input']>;
  iconContainsFold?: InputMaybe<Scalars['String']['input']>;
  iconEqualFold?: InputMaybe<Scalars['String']['input']>;
  iconGT?: InputMaybe<Scalars['String']['input']>;
  iconGTE?: InputMaybe<Scalars['String']['input']>;
  iconHasPrefix?: InputMaybe<Scalars['String']['input']>;
  iconHasSuffix?: InputMaybe<Scalars['String']['input']>;
  iconIn?: InputMaybe<Array<Scalars['String']['input']>>;
  iconLT?: InputMaybe<Scalars['String']['input']>;
  iconLTE?: InputMaybe<Scalars['String']['input']>;
  iconNEQ?: InputMaybe<Scalars['String']['input']>;
  iconNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_code field predicates */
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  integrationCodeContains?: InputMaybe<Scalars['String']['input']>;
  integrationCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  integrationCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  integrationCodeGT?: InputMaybe<Scalars['String']['input']>;
  integrationCodeGTE?: InputMaybe<Scalars['String']['input']>;
  integrationCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  integrationCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  integrationCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationCodeLT?: InputMaybe<Scalars['String']['input']>;
  integrationCodeLTE?: InputMaybe<Scalars['String']['input']>;
  integrationCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  integrationCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<BaseAddonWhereInput>;
  or?: InputMaybe<Array<BaseAddonWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type BaseLicensePlan = Node & {
  __typename?: 'BaseLicensePlan';
  baselicenseplanaddon?: Maybe<Array<BaseLicensePlanAddon>>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  gracePeriodDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  licenseOrders?: Maybe<Array<SubscriptionLicenseOrder>>;
  module: BaseLicensePlanModule;
  name: Scalars['String']['output'];
  organisations?: Maybe<Array<Organisation>>;
  price: Scalars['Float']['output'];
  tenure: Scalars['Int']['output'];
  tenureUnit: BaseLicensePlanTenureUnit;
  updatedAt: Scalars['Time']['output'];
};

export type BaseLicensePlanAddon = Node & {
  __typename?: 'BaseLicensePlanAddon';
  addonID: Scalars['ID']['output'];
  baseLicensePlanID: Scalars['ID']['output'];
  baseaddon: BaseAddon;
  baselicenseplan: BaseLicensePlan;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  licenseorderaddons?: Maybe<Array<LicenseOrderAddon>>;
  price: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type BaseLicensePlanAddonConnection = {
  __typename?: 'BaseLicensePlanAddonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseLicensePlanAddonEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BaseLicensePlanAddonEdge = {
  __typename?: 'BaseLicensePlanAddonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseLicensePlanAddon>;
};

export enum BaseLicensePlanAddonField {
  AddonId = 'addonID',
  BaseLicensePlanId = 'baseLicensePlanID',
  CreatedAt = 'createdAt',
  Price = 'price',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for BaseLicensePlanAddon connections */
export type BaseLicensePlanAddonOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BaseLicensePlanAddons. */
  field: BaseLicensePlanAddonOrderField;
};

/** Properties by which BaseLicensePlanAddon connections can be ordered. */
export enum BaseLicensePlanAddonOrderField {
  Price = 'PRICE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * BaseLicensePlanAddonWhereInput is used for filtering BaseLicensePlanAddon objects.
 * Input was generated by ent.
 */
export type BaseLicensePlanAddonWhereInput = {
  /** addon_id field predicates */
  addonID?: InputMaybe<Scalars['ID']['input']>;
  addonIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  addonIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  addonIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  and?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** base_license_plan_id field predicates */
  baseLicensePlanID?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseLicensePlanIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** baseaddon edge predicates */
  hasBaseaddon?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaseaddonWith?: InputMaybe<Array<BaseAddonWhereInput>>;
  /** baselicenseplan edge predicates */
  hasBaselicenseplan?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanWith?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** licenseorderaddons edge predicates */
  hasLicenseorderaddons?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseorderaddonsWith?: InputMaybe<Array<LicenseOrderAddonWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<BaseLicensePlanAddonWhereInput>;
  or?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** price field predicates */
  price?: InputMaybe<Scalars['Float']['input']>;
  priceGT?: InputMaybe<Scalars['Float']['input']>;
  priceGTE?: InputMaybe<Scalars['Float']['input']>;
  priceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  priceLT?: InputMaybe<Scalars['Float']['input']>;
  priceLTE?: InputMaybe<Scalars['Float']['input']>;
  priceNEQ?: InputMaybe<Scalars['Float']['input']>;
  priceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type BaseLicensePlanConnection = {
  __typename?: 'BaseLicensePlanConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseLicensePlanEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BaseLicensePlanEdge = {
  __typename?: 'BaseLicensePlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseLicensePlan>;
};

export enum BaseLicensePlanField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Features = 'features',
  GracePeriodDays = 'gracePeriodDays',
  IsActive = 'isActive',
  Module = 'module',
  Name = 'name',
  Price = 'price',
  Tenure = 'tenure',
  TenureUnit = 'tenureUnit',
  UpdatedAt = 'updatedAt'
}

/** BaseLicensePlanModule is enum for the field module */
export enum BaseLicensePlanModule {
  Bolt = 'Bolt',
  Eta = 'Eta',
  Yard = 'Yard'
}

/** Ordering options for BaseLicensePlan connections */
export type BaseLicensePlanOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BaseLicensePlans. */
  field: BaseLicensePlanOrderField;
};

/** Properties by which BaseLicensePlan connections can be ordered. */
export enum BaseLicensePlanOrderField {
  Description = 'DESCRIPTION',
  Module = 'MODULE',
  Name = 'NAME',
  Price = 'PRICE',
  Tenure = 'TENURE',
  TenureUnit = 'TENURE_UNIT',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** BaseLicensePlanTenureUnit is enum for the field tenure_unit */
export enum BaseLicensePlanTenureUnit {
  Month = 'Month',
  Year = 'Year'
}

/**
 * BaseLicensePlanWhereInput is used for filtering BaseLicensePlan objects.
 * Input was generated by ent.
 */
export type BaseLicensePlanWhereInput = {
  and?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** grace_period_days field predicates */
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysGT?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  gracePeriodDaysLT?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** baselicenseplanaddon edge predicates */
  hasBaselicenseplanaddon?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanaddonWith?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** license_orders edge predicates */
  hasLicenseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseOrdersWith?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** organisations edge predicates */
  hasOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationsWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** module field predicates */
  module?: InputMaybe<BaseLicensePlanModule>;
  moduleIn?: InputMaybe<Array<BaseLicensePlanModule>>;
  moduleNEQ?: InputMaybe<BaseLicensePlanModule>;
  moduleNotIn?: InputMaybe<Array<BaseLicensePlanModule>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<BaseLicensePlanWhereInput>;
  or?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** price field predicates */
  price?: InputMaybe<Scalars['Float']['input']>;
  priceGT?: InputMaybe<Scalars['Float']['input']>;
  priceGTE?: InputMaybe<Scalars['Float']['input']>;
  priceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  priceLT?: InputMaybe<Scalars['Float']['input']>;
  priceLTE?: InputMaybe<Scalars['Float']['input']>;
  priceNEQ?: InputMaybe<Scalars['Float']['input']>;
  priceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** tenure field predicates */
  tenure?: InputMaybe<Scalars['Int']['input']>;
  tenureGT?: InputMaybe<Scalars['Int']['input']>;
  tenureGTE?: InputMaybe<Scalars['Int']['input']>;
  tenureIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  tenureLT?: InputMaybe<Scalars['Int']['input']>;
  tenureLTE?: InputMaybe<Scalars['Int']['input']>;
  tenureNEQ?: InputMaybe<Scalars['Int']['input']>;
  tenureNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** tenure_unit field predicates */
  tenureUnit?: InputMaybe<BaseLicensePlanTenureUnit>;
  tenureUnitIn?: InputMaybe<Array<BaseLicensePlanTenureUnit>>;
  tenureUnitNEQ?: InputMaybe<BaseLicensePlanTenureUnit>;
  tenureUnitNotIn?: InputMaybe<Array<BaseLicensePlanTenureUnit>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type BaseReport = Node & {
  __typename?: 'BaseReport';
  chartConfig: Scalars['JSON']['output'];
  createdAt: Scalars['Time']['output'];
  currentDateReport: Scalars['Boolean']['output'];
  derivedReports?: Maybe<Array<DerivedReport>>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputConfig: Scalars['JSON']['output'];
  mapConfig: Scalars['JSON']['output'];
  multiDateMultiRequest: Scalars['Boolean']['output'];
  multiDevice: Scalars['Boolean']['output'];
  multiDeviceMultiRequest: Scalars['Boolean']['output'];
  resolver: Scalars['String']['output'];
  tableConfig: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type BaseReportConnection = {
  __typename?: 'BaseReportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BaseReportEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BaseReportEdge = {
  __typename?: 'BaseReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BaseReport>;
};

export enum BaseReportField {
  ChartConfig = 'chartConfig',
  CreatedAt = 'createdAt',
  CurrentDateReport = 'currentDateReport',
  Description = 'description',
  InputConfig = 'inputConfig',
  MapConfig = 'mapConfig',
  MultiDateMultiRequest = 'multiDateMultiRequest',
  MultiDevice = 'multiDevice',
  MultiDeviceMultiRequest = 'multiDeviceMultiRequest',
  Resolver = 'resolver',
  TableConfig = 'tableConfig',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for BaseReport connections */
export type BaseReportOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order BaseReports. */
  field: BaseReportOrderField;
};

/** Properties by which BaseReport connections can be ordered. */
export enum BaseReportOrderField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Resolver = 'resolver',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/**
 * BaseReportWhereInput is used for filtering BaseReport objects.
 * Input was generated by ent.
 */
export type BaseReportWhereInput = {
  and?: InputMaybe<Array<BaseReportWhereInput>>;
  /** chart_config field predicates */
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  chartConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  chartConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** current_date_report field predicates */
  currentDateReport?: InputMaybe<Scalars['Boolean']['input']>;
  currentDateReportNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** derived_reports edge predicates */
  hasDerivedReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasDerivedReportsWith?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** input_config field predicates */
  inputConfig?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  inputConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  inputConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** map_config field predicates */
  mapConfig?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  mapConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  mapConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** multi_date_multi_request field predicates */
  multiDateMultiRequest?: InputMaybe<Scalars['Boolean']['input']>;
  multiDateMultiRequestNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** multi_device field predicates */
  multiDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** multi_device_multi_request field predicates */
  multiDeviceMultiRequest?: InputMaybe<Scalars['Boolean']['input']>;
  multiDeviceMultiRequestNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  multiDeviceNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BaseReportWhereInput>;
  or?: InputMaybe<Array<BaseReportWhereInput>>;
  /** resolver field predicates */
  resolver?: InputMaybe<Scalars['String']['input']>;
  resolverContains?: InputMaybe<Scalars['String']['input']>;
  resolverContainsFold?: InputMaybe<Scalars['String']['input']>;
  resolverEqualFold?: InputMaybe<Scalars['String']['input']>;
  resolverGT?: InputMaybe<Scalars['String']['input']>;
  resolverGTE?: InputMaybe<Scalars['String']['input']>;
  resolverHasPrefix?: InputMaybe<Scalars['String']['input']>;
  resolverHasSuffix?: InputMaybe<Scalars['String']['input']>;
  resolverIn?: InputMaybe<Array<Scalars['String']['input']>>;
  resolverLT?: InputMaybe<Scalars['String']['input']>;
  resolverLTE?: InputMaybe<Scalars['String']['input']>;
  resolverNEQ?: InputMaybe<Scalars['String']['input']>;
  resolverNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** table_config field predicates */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  tableConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ChangeLog = Node & {
  __typename?: 'ChangeLog';
  action: ChangeLogAction;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  impersonatedUserID?: Maybe<Scalars['ID']['output']>;
  modelID: Scalars['ID']['output'];
  modelName: Scalars['String']['output'];
  organisationID?: Maybe<Scalars['ID']['output']>;
  previousData?: Maybe<Scalars['JSON']['output']>;
  remoteIP?: Maybe<Scalars['NullString']['output']>;
  updatedAt: Scalars['Time']['output'];
  updatedData?: Maybe<Scalars['JSON']['output']>;
  userAgent?: Maybe<Scalars['NullString']['output']>;
  userID?: Maybe<Scalars['ID']['output']>;
};

/** ChangeLogAction is enum for the field action */
export enum ChangeLogAction {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

/** A connection to a list of items. */
export type ChangeLogConnection = {
  __typename?: 'ChangeLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ChangeLogEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ChangeLogEdge = {
  __typename?: 'ChangeLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ChangeLog>;
};

export enum ChangeLogField {
  Action = 'action',
  CreatedAt = 'createdAt',
  ImpersonatedUserId = 'impersonatedUserID',
  ModelId = 'modelID',
  ModelName = 'modelName',
  OrganisationId = 'organisationID',
  PreviousData = 'previousData',
  RemoteIp = 'remoteIP',
  UpdatedAt = 'updatedAt',
  UpdatedData = 'updatedData',
  UserAgent = 'userAgent',
  UserId = 'userID'
}

/** Ordering options for ChangeLog connections */
export type ChangeLogOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ChangeLogs. */
  field: ChangeLogOrderField;
};

/** Properties by which ChangeLog connections can be ordered. */
export enum ChangeLogOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  ModelName = 'modelName',
  RemoteIp = 'remoteIP',
  UpdatedAt = 'updatedAt',
  UserAgent = 'userAgent'
}

/**
 * ChangeLogWhereInput is used for filtering ChangeLog objects.
 * Input was generated by ent.
 */
export type ChangeLogWhereInput = {
  /** action field predicates */
  action?: InputMaybe<ChangeLogAction>;
  actionIn?: InputMaybe<Array<ChangeLogAction>>;
  actionNEQ?: InputMaybe<ChangeLogAction>;
  actionNotIn?: InputMaybe<Array<ChangeLogAction>>;
  and?: InputMaybe<Array<ChangeLogWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** impersonated_user_id field predicates */
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  impersonatedUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  impersonatedUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  impersonatedUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** model_id field predicates */
  modelID?: InputMaybe<Scalars['ID']['input']>;
  modelIDGT?: InputMaybe<Scalars['ID']['input']>;
  modelIDGTE?: InputMaybe<Scalars['ID']['input']>;
  modelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  modelIDLT?: InputMaybe<Scalars['ID']['input']>;
  modelIDLTE?: InputMaybe<Scalars['ID']['input']>;
  modelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  modelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** model_name field predicates */
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelNameContains?: InputMaybe<Scalars['String']['input']>;
  modelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  modelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  modelNameGT?: InputMaybe<Scalars['String']['input']>;
  modelNameGTE?: InputMaybe<Scalars['String']['input']>;
  modelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  modelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  modelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  modelNameLT?: InputMaybe<Scalars['String']['input']>;
  modelNameLTE?: InputMaybe<Scalars['String']['input']>;
  modelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  modelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ChangeLogWhereInput>;
  or?: InputMaybe<Array<ChangeLogWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** previous_data field predicates */
  previousData?: InputMaybe<Scalars['JSON']['input']>;
  previousDataGT?: InputMaybe<Scalars['JSON']['input']>;
  previousDataGTE?: InputMaybe<Scalars['JSON']['input']>;
  previousDataIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  previousDataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  previousDataLT?: InputMaybe<Scalars['JSON']['input']>;
  previousDataLTE?: InputMaybe<Scalars['JSON']['input']>;
  previousDataNEQ?: InputMaybe<Scalars['JSON']['input']>;
  previousDataNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  previousDataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** remote_ip field predicates */
  remoteIP?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPGT?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPGTE?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPIn?: InputMaybe<Array<Scalars['NullString']['input']>>;
  remoteIPIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remoteIPLT?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPLTE?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPNEQ?: InputMaybe<Scalars['NullString']['input']>;
  remoteIPNotIn?: InputMaybe<Array<Scalars['NullString']['input']>>;
  remoteIPNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_data field predicates */
  updatedData?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataGT?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataGTE?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  updatedDataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedDataLT?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataLTE?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataNEQ?: InputMaybe<Scalars['JSON']['input']>;
  updatedDataNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  updatedDataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_agent field predicates */
  userAgent?: InputMaybe<Scalars['NullString']['input']>;
  userAgentGT?: InputMaybe<Scalars['NullString']['input']>;
  userAgentGTE?: InputMaybe<Scalars['NullString']['input']>;
  userAgentIn?: InputMaybe<Array<Scalars['NullString']['input']>>;
  userAgentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userAgentLT?: InputMaybe<Scalars['NullString']['input']>;
  userAgentLTE?: InputMaybe<Scalars['NullString']['input']>;
  userAgentNEQ?: InputMaybe<Scalars['NullString']['input']>;
  userAgentNotIn?: InputMaybe<Array<Scalars['NullString']['input']>>;
  userAgentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerConfig = Node & {
  __typename?: 'ConsumerConfig';
  active: Scalars['Boolean']['output'];
  apiKeyName?: Maybe<Scalars['String']['output']>;
  apiKeySecret?: Maybe<Scalars['String']['output']>;
  apiSkipSsl: Scalars['Boolean']['output'];
  apiTimeoutSeconds: Scalars['Int']['output'];
  apiURL?: Maybe<Scalars['String']['output']>;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  lastFailedAt?: Maybe<Scalars['Time']['output']>;
  lastResponse?: Maybe<Scalars['String']['output']>;
  lastSuccessAt?: Maybe<Scalars['Time']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextAttemptAt?: Maybe<Scalars['Time']['output']>;
  periodicSeconds: Scalars['Int']['output'];
  taskName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['Int']['output']>;
  vehicleNameAsImei: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type ConsumerConfigConnection = {
  __typename?: 'ConsumerConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsumerConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConsumerConfigEdge = {
  __typename?: 'ConsumerConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConsumerConfig>;
};

export enum ConsumerConfigField {
  Active = 'active',
  ApiKeyName = 'apiKeyName',
  ApiKeySecret = 'apiKeySecret',
  ApiSkipSsl = 'apiSkipSsl',
  ApiTimeoutSeconds = 'apiTimeoutSeconds',
  ApiUrl = 'apiURL',
  Config = 'config',
  CreatedAt = 'createdAt',
  LastFailedAt = 'lastFailedAt',
  LastResponse = 'lastResponse',
  LastSuccessAt = 'lastSuccessAt',
  Name = 'name',
  NextAttemptAt = 'nextAttemptAt',
  PeriodicSeconds = 'periodicSeconds',
  TaskName = 'taskName',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  VehicleNameAsImei = 'vehicleNameAsImei'
}

/** Ordering options for ConsumerConfig connections */
export type ConsumerConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ConsumerConfigs. */
  field: ConsumerConfigOrderField;
};

/** Properties by which ConsumerConfig connections can be ordered. */
export enum ConsumerConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * ConsumerConfigWhereInput is used for filtering ConsumerConfig objects.
 * Input was generated by ent.
 */
export type ConsumerConfigWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<ConsumerConfigWhereInput>>;
  /** api_key_name field predicates */
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyNameLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key_secret field predicates */
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContains?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeySecretLT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_skip_ssl field predicates */
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiSkipSslNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_timeout_seconds field predicates */
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  apiTimeoutSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** api_url field predicates */
  apiURL?: InputMaybe<Scalars['String']['input']>;
  apiURLContains?: InputMaybe<Scalars['String']['input']>;
  apiURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiURLGT?: InputMaybe<Scalars['String']['input']>;
  apiURLGTE?: InputMaybe<Scalars['String']['input']>;
  apiURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiURLLT?: InputMaybe<Scalars['String']['input']>;
  apiURLLTE?: InputMaybe<Scalars['String']['input']>;
  apiURLNEQ?: InputMaybe<Scalars['String']['input']>;
  apiURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** config field predicates */
  config?: InputMaybe<Scalars['JSON']['input']>;
  configGT?: InputMaybe<Scalars['JSON']['input']>;
  configGTE?: InputMaybe<Scalars['JSON']['input']>;
  configIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  configLT?: InputMaybe<Scalars['JSON']['input']>;
  configLTE?: InputMaybe<Scalars['JSON']['input']>;
  configNEQ?: InputMaybe<Scalars['JSON']['input']>;
  configNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_failed_at field predicates */
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_response field predicates */
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastResponseContains?: InputMaybe<Scalars['String']['input']>;
  lastResponseContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastResponseEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastResponseGT?: InputMaybe<Scalars['String']['input']>;
  lastResponseGTE?: InputMaybe<Scalars['String']['input']>;
  lastResponseHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastResponseHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastResponseIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastResponseIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastResponseLT?: InputMaybe<Scalars['String']['input']>;
  lastResponseLTE?: InputMaybe<Scalars['String']['input']>;
  lastResponseNEQ?: InputMaybe<Scalars['String']['input']>;
  lastResponseNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastResponseNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_success_at field predicates */
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSuccessAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** next_attempt_at field predicates */
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtGT?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtGTE?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextAttemptAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextAttemptAtLT?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtLTE?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextAttemptAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ConsumerConfigWhereInput>;
  or?: InputMaybe<Array<ConsumerConfigWhereInput>>;
  /** periodic_seconds field predicates */
  periodicSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  periodicSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  periodicSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** task_name field predicates */
  taskName?: InputMaybe<Scalars['String']['input']>;
  taskNameContains?: InputMaybe<Scalars['String']['input']>;
  taskNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  taskNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  taskNameGT?: InputMaybe<Scalars['String']['input']>;
  taskNameGTE?: InputMaybe<Scalars['String']['input']>;
  taskNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  taskNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  taskNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  taskNameLT?: InputMaybe<Scalars['String']['input']>;
  taskNameLTE?: InputMaybe<Scalars['String']['input']>;
  taskNameNEQ?: InputMaybe<Scalars['String']['input']>;
  taskNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vehicle_name_as_imei field predicates */
  vehicleNameAsImei?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleNameAsImeiNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConsumerServer = Node & {
  __typename?: 'ConsumerServer';
  active: Scalars['Boolean']['output'];
  allowedImei: Array<Scalars['String']['output']>;
  apiKeyName?: Maybe<Scalars['String']['output']>;
  apiKeySecret?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  lastFailedAt?: Maybe<Scalars['Time']['output']>;
  lastFailedImei?: Maybe<Scalars['String']['output']>;
  lastSuccessAt?: Maybe<Scalars['Time']['output']>;
  lastSuccessImei?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type ConsumerServerConnection = {
  __typename?: 'ConsumerServerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsumerServerEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConsumerServerEdge = {
  __typename?: 'ConsumerServerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ConsumerServer>;
};

export enum ConsumerServerField {
  Active = 'active',
  AllowedImei = 'allowedImei',
  ApiKeyName = 'apiKeyName',
  ApiKeySecret = 'apiKeySecret',
  CreatedAt = 'createdAt',
  LastFailedAt = 'lastFailedAt',
  LastFailedImei = 'lastFailedImei',
  LastSuccessAt = 'lastSuccessAt',
  LastSuccessImei = 'lastSuccessImei',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for ConsumerServer connections */
export type ConsumerServerOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ConsumerServers. */
  field: ConsumerServerOrderField;
};

/** Properties by which ConsumerServer connections can be ordered. */
export enum ConsumerServerOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * ConsumerServerWhereInput is used for filtering ConsumerServer objects.
 * Input was generated by ent.
 */
export type ConsumerServerWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<ConsumerServerWhereInput>>;
  /** api_key_name field predicates */
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyNameLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key_secret field predicates */
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContains?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeySecretLT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_failed_at field predicates */
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_failed_imei field predicates */
  lastFailedImei?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiContains?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiGT?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiGTE?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastFailedImeiIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedImeiLT?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiLTE?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiNEQ?: InputMaybe<Scalars['String']['input']>;
  lastFailedImeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastFailedImeiNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_success_at field predicates */
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSuccessAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_success_imei field predicates */
  lastSuccessImei?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiContains?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiGT?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiGTE?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastSuccessImeiIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSuccessImeiLT?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiLTE?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiNEQ?: InputMaybe<Scalars['String']['input']>;
  lastSuccessImeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastSuccessImeiNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ConsumerServerWhereInput>;
  or?: InputMaybe<Array<ConsumerServerWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateAPIUserInput is used for create APIUser object.
 * Input was generated by ent.
 */
export type CreateApiUserInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateAdhocTableInput is used for create AdhocTable object.
 * Input was generated by ent.
 */
export type CreateAdhocTableInput = {
  approvedAt?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  haltPointID: Scalars['ID']['input'];
  haltpointLat?: InputMaybe<Scalars['Float']['input']>;
  haltpointLng?: InputMaybe<Scalars['Float']['input']>;
  haltpointLocation?: InputMaybe<Scalars['String']['input']>;
  load?: InputMaybe<Scalars['Float']['input']>;
  organisationID: Scalars['ID']['input'];
  rejectedAt?: InputMaybe<Scalars['Time']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  serviceType: AdhocTableServiceType;
  status?: InputMaybe<AdhocTableStatus>;
  targetID: Scalars['ID']['input'];
  tripID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  wasteType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateAttendanceDetailInput is used for create AttendanceDetail object.
 * Input was generated by ent.
 */
export type CreateAttendanceDetailInput = {
  actualDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  actualMarkIn?: InputMaybe<Scalars['Time']['input']>;
  actualMarkOut?: InputMaybe<Scalars['Time']['input']>;
  attendanceID: Scalars['ID']['input'];
  attendanceType?: InputMaybe<AttendanceDetailAttendanceType>;
  checkInDistanceFromWorkplaceMeters?: InputMaybe<Scalars['Float']['input']>;
  checkInFaceDetected?: InputMaybe<Scalars['Boolean']['input']>;
  checkInFaceMatchScore?: InputMaybe<Scalars['Float']['input']>;
  checkInImagePath?: InputMaybe<Scalars['String']['input']>;
  checkInImageURL?: InputMaybe<Scalars['String']['input']>;
  checkInLatitude?: InputMaybe<Scalars['Float']['input']>;
  checkInLocationName?: InputMaybe<Scalars['String']['input']>;
  checkInLocationVerified?: InputMaybe<Scalars['Boolean']['input']>;
  checkInLongitude?: InputMaybe<Scalars['Float']['input']>;
  checkOutDistanceFromWorkplaceMeters?: InputMaybe<Scalars['Float']['input']>;
  checkOutFaceDetected?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutFaceMatchScore?: InputMaybe<Scalars['Float']['input']>;
  checkOutImagePath?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURL?: InputMaybe<Scalars['String']['input']>;
  checkOutLatitude?: InputMaybe<Scalars['Float']['input']>;
  checkOutLocationName?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationVerified?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutLongitude?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  rosterShiftID: Scalars['ID']['input'];
  scheduledEndTime?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTime?: InputMaybe<Scalars['Time']['input']>;
  shiftNumber: Scalars['Int']['input'];
  status?: InputMaybe<AttendanceDetailStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateAttendanceInput is used for create Attendance object.
 * Input was generated by ent.
 */
export type CreateAttendanceInput = {
  attendanceDate: Scalars['Time']['input'];
  attendanceDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  attendanceType?: InputMaybe<AttendanceAttendanceType>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  leaveDateID?: InputMaybe<Scalars['ID']['input']>;
  leaveRequestID?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  organisationID: Scalars['ID']['input'];
  overallStatus?: InputMaybe<AttendanceOverallStatus>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  totalActualMinutes?: InputMaybe<Scalars['Float']['input']>;
  totalScheduledMinutes?: InputMaybe<Scalars['Float']['input']>;
  totalShiftsCompleted?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsScheduled?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
  zoneName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateBaseAddonInput is used for create BaseAddon object.
 * Input was generated by ent.
 */
export type CreateBaseAddonInput = {
  baselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  integrationCode: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateBaseLicensePlanAddonInput is used for create BaseLicensePlanAddon object.
 * Input was generated by ent.
 */
export type CreateBaseLicensePlanAddonInput = {
  baseaddonID: Scalars['ID']['input'];
  baselicenseplanID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  licenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateBaseLicensePlanInput is used for create BaseLicensePlan object.
 * Input was generated by ent.
 */
export type CreateBaseLicensePlanInput = {
  baselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  licenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  module: BaseLicensePlanModule;
  name: Scalars['String']['input'];
  organisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  price: Scalars['Float']['input'];
  tenure: Scalars['Int']['input'];
  tenureUnit?: InputMaybe<BaseLicensePlanTenureUnit>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateBaseReportInput is used for create BaseReport object.
 * Input was generated by ent.
 */
export type CreateBaseReportInput = {
  chartConfig: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  currentDateReport: Scalars['Boolean']['input'];
  derivedReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  description: Scalars['String']['input'];
  inputConfig: Scalars['JSON']['input'];
  mapConfig: Scalars['JSON']['input'];
  multiDateMultiRequest: Scalars['Boolean']['input'];
  multiDevice: Scalars['Boolean']['input'];
  multiDeviceMultiRequest: Scalars['Boolean']['input'];
  resolver: Scalars['String']['input'];
  tableConfig: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateChangeLogInput is used for create ChangeLog object.
 * Input was generated by ent.
 */
export type CreateChangeLogInput = {
  action?: InputMaybe<ChangeLogAction>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  modelID: Scalars['ID']['input'];
  modelName: Scalars['String']['input'];
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  previousData?: InputMaybe<Scalars['JSON']['input']>;
  remoteIP?: InputMaybe<Scalars['NullString']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedData?: InputMaybe<Scalars['JSON']['input']>;
  userAgent?: InputMaybe<Scalars['NullString']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateConsumerConfigInput is used for create ConsumerConfig object.
 * Input was generated by ent.
 */
export type CreateConsumerConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  periodicSeconds?: InputMaybe<Scalars['Int']['input']>;
  taskName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  vehicleNameAsImei?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateConsumerServerInput is used for create ConsumerServer object.
 * Input was generated by ent.
 */
export type CreateConsumerServerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowedImei: Array<Scalars['String']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedImei?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessImei?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateDerivedReportInput is used for create DerivedReport object.
 * Input was generated by ent.
 */
export type CreateDerivedReportInput = {
  baseReportID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  enabledForAllOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationReportAccessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tableConfig: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userReportBookmarkIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateDeviceACLInput is used for create DeviceACL object.
 * Input was generated by ent.
 */
export type CreateDeviceAclInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicegroupsID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organisationUserID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceActionLogInput is used for create DeviceActionLog object.
 * Input was generated by ent.
 */
export type CreateDeviceActionLogInput = {
  actionDescription: Scalars['String']['input'];
  actionType?: InputMaybe<DeviceActionLogActionType>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicesID: Scalars['ID']['input'];
  status?: InputMaybe<DeviceActionLogStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceAddonModelInput is used for create DeviceAddonModel object.
 * Input was generated by ent.
 */
export type CreateDeviceAddonModelInput = {
  addonType: DeviceAddonModelAddonType;
  channelType: DeviceAddonModelChannelType;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceAdvancedConfigInput is used for create DeviceAdvancedConfig object.
 * Input was generated by ent.
 */
export type CreateDeviceAdvancedConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value: Scalars['String']['input'];
};

/**
 * CreateDeviceCategoryInput is used for create DeviceCategory object.
 * Input was generated by ent.
 */
export type CreateDeviceCategoryInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupType?: InputMaybe<DeviceCategoryGroupType>;
  name: Scalars['String']['input'];
  stiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceChannelConfigInput is used for create DeviceChannelConfig object.
 * Input was generated by ent.
 */
export type CreateDeviceChannelConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  deviceaddonmodelID: Scalars['ID']['input'];
  devicemodelchannelID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceCommandInput is used for create DeviceCommand object.
 * Input was generated by ent.
 */
export type CreateDeviceCommandInput = {
  command: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  deviceModelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceConfigInput is used for create DeviceConfig object.
 * Input was generated by ent.
 */
export type CreateDeviceConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceDocumentInput is used for create DeviceDocument object.
 * Input was generated by ent.
 */
export type CreateDeviceDocumentInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceDocumentTypeID: Scalars['ID']['input'];
  deviceID: Scalars['ID']['input'];
  expiryDate: Scalars['Time']['input'];
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceDocumentTypeInput is used for create DeviceDocumentType object.
 * Input was generated by ent.
 */
export type CreateDeviceDocumentTypeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceGroupDocumentInput is used for create DeviceGroupDocument object.
 * Input was generated by ent.
 */
export type CreateDeviceGroupDocumentInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupDocumentTypeID: Scalars['ID']['input'];
  deviceGroupID: Scalars['ID']['input'];
  expiryDate: Scalars['Time']['input'];
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceGroupDocumentTypeInput is used for create DeviceGroupDocumentType object.
 * Input was generated by ent.
 */
export type CreateDeviceGroupDocumentTypeInput = {
  applicableGroupType: DeviceGroupDocumentTypeApplicableGroupType;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceGroupInput is used for create DeviceGroup object.
 * Input was generated by ent.
 */
export type CreateDeviceGroupInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceParkingModeConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceVehicleID?: InputMaybe<Scalars['ID']['input']>;
  deviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupOrganisationID: Scalars['ID']['input'];
  devicegroupRootOrganisationID: Scalars['ID']['input'];
  driverprofileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  friendlyName: Scalars['String']['input'];
  geofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupType: DeviceGroupGroupType;
  inspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  notifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumber?: InputMaybe<Scalars['String']['input']>;
  ownerFullName?: InputMaybe<Scalars['String']['input']>;
  ownerInstallationDate?: InputMaybe<Scalars['Time']['input']>;
  shiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardDriverTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateDeviceInput is used for create Device object.
 * Input was generated by ent.
 */
export type CreateDeviceInput = {
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceActionLogIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  devicePlaybackFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceadvancedconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicecategoryID: Scalars['ID']['input'];
  devicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicemodelID: Scalars['ID']['input'];
  externalID?: InputMaybe<Scalars['String']['input']>;
  imei: Scalars['String']['input'];
  ingestServer?: InputMaybe<DeviceIngestServer>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  lastPing?: InputMaybe<Scalars['Time']['input']>;
  licenseID?: InputMaybe<Scalars['ID']['input']>;
  midnightTotalDistance?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalEngineMs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  positionAttributeFormulaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationID: Scalars['ID']['input'];
  simID: Scalars['ID']['input'];
  speedLimitKmHr?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceModelChannelInput is used for create DeviceModelChannel object.
 * Input was generated by ent.
 */
export type CreateDeviceModelChannelInput = {
  channelName: Scalars['String']['input'];
  channelType: DeviceModelChannelChannelType;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceModelID: Scalars['ID']['input'];
  devicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isBuiltin: Scalars['Boolean']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceModelInput is used for create DeviceModel object.
 * Input was generated by ent.
 */
export type CreateDeviceModelInput = {
  commandIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicemodelchannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isAssetTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isDashcam?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isVehicleTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isWireless?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer: Scalars['String']['input'];
  mediaFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceParkingModeConfigInput is used for create DeviceParkingModeConfig object.
 * Input was generated by ent.
 */
export type CreateDeviceParkingModeConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupID: Scalars['ID']['input'];
  parkingMode?: InputMaybe<Scalars['Boolean']['input']>;
  parkingSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleDays?: InputMaybe<Array<Scalars['String']['input']>>;
  parkingScheduleEndUtc?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtc?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDevicePlaybackFilesInput is used for create DevicePlaybackFiles object.
 * Input was generated by ent.
 */
export type CreateDevicePlaybackFilesInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  deviceType?: InputMaybe<Scalars['String']['input']>;
  fileJSON?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceSharingInput is used for create DeviceSharing object.
 * Input was generated by ent.
 */
export type CreateDeviceSharingInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID: Scalars['ID']['input'];
  organisationUserID: Scalars['ID']['input'];
  shareType?: InputMaybe<DeviceSharingShareType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateDeviceVehicleInput is used for create DeviceVehicle object.
 * Input was generated by ent.
 */
export type CreateDeviceVehicleInput = {
  chassisNo?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dealer?: InputMaybe<Scalars['String']['input']>;
  deviceGroupID: Scalars['ID']['input'];
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceEndDate?: InputMaybe<Scalars['Time']['input']>;
  insurancePremium?: InputMaybe<Scalars['String']['input']>;
  insuranceStartDate?: InputMaybe<Scalars['Time']['input']>;
  oem?: InputMaybe<Scalars['String']['input']>;
  registeredRto?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleNumber: Scalars['String']['input'];
  vehicleType: DeviceVehicleVehicleType;
  warranty?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateDomainInput is used for create Domain object.
 * Input was generated by ent.
 */
export type CreateDomainInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  domain: Scalars['String']['input'];
  sslVerificationStatus?: InputMaybe<DomainSslVerificationStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  verificationID?: InputMaybe<Scalars['String']['input']>;
  verificationLastChecked?: InputMaybe<Scalars['Time']['input']>;
  verificationStatus?: InputMaybe<DomainVerificationStatus>;
  whitelabelID: Scalars['ID']['input'];
};

/**
 * CreateExportInput is used for create Export object.
 * Input was generated by ent.
 */
export type CreateExportInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  exportData: Scalars['String']['input'];
  exportKey: Scalars['String']['input'];
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ExportStatus>;
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateFirebasePrivateKeyInput is used for create FirebasePrivateKey object.
 * Input was generated by ent.
 */
export type CreateFirebasePrivateKeyInput = {
  authProviderX509CertURL: Scalars['String']['input'];
  authURI: Scalars['String']['input'];
  clientEmail: Scalars['String']['input'];
  clientID: Scalars['String']['input'];
  clientX509CertURL: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  fileName: Scalars['String']['input'];
  privateKey: Scalars['String']['input'];
  privateKeyID: Scalars['String']['input'];
  projectID: Scalars['String']['input'];
  senderID?: InputMaybe<Scalars['String']['input']>;
  tokenURI: Scalars['String']['input'];
  type: Scalars['String']['input'];
  universeDomain: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateGeofenceDeviceGroupInput is used for create GeofenceDeviceGroup object.
 * Input was generated by ent.
 */
export type CreateGeofenceDeviceGroupInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicegroupID: Scalars['ID']['input'];
  geofenceID: Scalars['ID']['input'];
  isIn?: InputMaybe<Scalars['Boolean']['input']>;
  lastCross?: InputMaybe<Scalars['Time']['input']>;
  lastEnter?: InputMaybe<Scalars['Time']['input']>;
  lastExit?: InputMaybe<Scalars['Time']['input']>;
  lastUpdate?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateGeofenceInput is used for create Geofence object.
 * Input was generated by ent.
 */
export type CreateGeofenceInput = {
  color: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  eventOnEntry?: InputMaybe<Scalars['Boolean']['input']>;
  eventOnExit?: InputMaybe<Scalars['Boolean']['input']>;
  geoJSON?: InputMaybe<Scalars['GeoJSON']['input']>;
  geofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  radius: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  useAsAddress?: InputMaybe<Scalars['Boolean']['input']>;
  yardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateHaltPointInput is used for create HaltPoint object.
 * Input was generated by ent.
 */
export type CreateHaltPointInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  geofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  routeHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateInspectionReportInput is used for create InspectionReport object.
 * Input was generated by ent.
 */
export type CreateInspectionReportInput = {
  bonnet: Scalars['Boolean']['input'];
  bonnetCondition?: InputMaybe<Scalars['String']['input']>;
  checkInPic?: InputMaybe<Scalars['String']['input']>;
  checkOutPic?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  damageKind: Scalars['String']['input'];
  damageSize: Scalars['String']['input'];
  deviceGroupID: Scalars['ID']['input'];
  doorFront: Scalars['Boolean']['input'];
  doorFrontCondition?: InputMaybe<Scalars['String']['input']>;
  doorRear: Scalars['Boolean']['input'];
  doorRearCondition?: InputMaybe<Scalars['String']['input']>;
  fenderFront: Scalars['Boolean']['input'];
  fenderFrontCondition?: InputMaybe<Scalars['String']['input']>;
  fenderRear: Scalars['Boolean']['input'];
  fenderRearCondition?: InputMaybe<Scalars['String']['input']>;
  frontBumper: Scalars['Boolean']['input'];
  frontBumperCondition?: InputMaybe<Scalars['String']['input']>;
  fuelMain: Scalars['String']['input'];
  fuelSub: Scalars['String']['input'];
  headLamp: Scalars['Boolean']['input'];
  headLampCondition?: InputMaybe<Scalars['String']['input']>;
  journey: InspectionReportJourney;
  kind: InspectionReportKind;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  outKm: Scalars['Float']['input'];
  outTime: Scalars['Time']['input'];
  roof: Scalars['Boolean']['input'];
  roofCondition?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  sideMirror: Scalars['Boolean']['input'];
  sideMirrorCondition?: InputMaybe<Scalars['String']['input']>;
  sideWindow: Scalars['Boolean']['input'];
  sideWindowCondition?: InputMaybe<Scalars['String']['input']>;
  tailLamp: Scalars['Boolean']['input'];
  tailLampCondition?: InputMaybe<Scalars['String']['input']>;
  tyreFront: Scalars['Boolean']['input'];
  tyreFrontCondition?: InputMaybe<Scalars['String']['input']>;
  tyreRear: Scalars['Boolean']['input'];
  tyreRearCondition?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  windscreen: Scalars['Boolean']['input'];
  windscreenCondition?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateKmlInput is used for create Kml object.
 * Input was generated by ent.
 */
export type CreateKmlInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  fileID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLeaveDateInput is used for create LeaveDate object.
 * Input was generated by ent.
 */
export type CreateLeaveDateInput = {
  attendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isHalfDay?: InputMaybe<Scalars['Boolean']['input']>;
  leaveDate: Scalars['Time']['input'];
  leaveRequestID: Scalars['ID']['input'];
  leaveTypeID: Scalars['ID']['input'];
  status?: InputMaybe<LeaveDateStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateLeaveRequestInput is used for create LeaveRequest object.
 * Input was generated by ent.
 */
export type CreateLeaveRequestInput = {
  approvedDate?: InputMaybe<Scalars['Time']['input']>;
  approverID?: InputMaybe<Scalars['ID']['input']>;
  attendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  endDate: Scalars['Time']['input'];
  leaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveTypeID: Scalars['ID']['input'];
  numberOfDays?: InputMaybe<Scalars['Float']['input']>;
  organisationID: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  requestStatus?: InputMaybe<LeaveRequestRequestStatus>;
  startDate: Scalars['Time']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateLeaveTypeInput is used for create LeaveType object.
 * Input was generated by ent.
 */
export type CreateLeaveTypeInput = {
  attendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  colorCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  leaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveTypeName: Scalars['String']['input'];
  maxDaysPerYear?: InputMaybe<Scalars['Int']['input']>;
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userLeaveBalanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateLegacySyncInput is used for create LegacySync object.
 * Input was generated by ent.
 */
export type CreateLegacySyncInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<LegacySyncStatus>;
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  syncData: Scalars['String']['input'];
  syncKey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLicenseInput is used for create License object.
 * Input was generated by ent.
 */
export type CreateLicenseInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  expiryReminderDays?: InputMaybe<Scalars['Int']['input']>;
  licenseOrderID: Scalars['ID']['input'];
  moduleType: LicenseModuleType;
  organisationID: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<LicenseStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLicenseOrderAddonInput is used for create LicenseOrderAddon object.
 * Input was generated by ent.
 */
export type CreateLicenseOrderAddonInput = {
  baselicenseaddonID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  licenseorderID: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateLoginLogInput is used for create LoginLog object.
 * Input was generated by ent.
 */
export type CreateLoginLogInput = {
  attempts: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  identifier: Scalars['String']['input'];
  identifierType: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateMapConfigInput is used for create MapConfig object.
 * Input was generated by ent.
 */
export type CreateMapConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: MapConfigKey;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/**
 * CreateMediaFileInput is used for create MediaFile object.
 * Input was generated by ent.
 */
export type CreateMediaFileInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceModelsMediaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  exportID?: InputMaybe<Scalars['ID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  kmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  path: Scalars['String']['input'];
  status?: InputMaybe<MediaFileStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
  userAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelLoginLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardDriverDetailsAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardDriverDetailsDlImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVehicleInsuranceImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVehiclePollutionImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVehicleRcImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateNotifyChannelInput is used for create NotifyChannel object.
 * Input was generated by ent.
 */
export type CreateNotifyChannelInput = {
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  fcmDevicePlatform?: InputMaybe<NotifyChannelFcmDevicePlatform>;
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  kind: NotifyChannelKind;
  linkedData: Scalars['String']['input'];
  loggedInDeviceID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  notifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  serverNotes?: InputMaybe<Scalars['String']['input']>;
  smsCountryCode?: InputMaybe<Scalars['Int']['input']>;
  smsNumber?: InputMaybe<Scalars['Int']['input']>;
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  telegramBotToken?: InputMaybe<Scalars['String']['input']>;
  telegramChatID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyConfigChannelInput is used for create NotifyConfigChannel object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigChannelInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  notifyChannelID: Scalars['ID']['input'];
  notifyConfigID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyConfigDeviceGroupInput is used for create NotifyConfigDeviceGroup object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigDeviceGroupInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupID: Scalars['ID']['input'];
  notifyConfigID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyConfigEventInput is used for create NotifyConfigEvent object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigEventInput = {
  acceptableMax?: InputMaybe<Scalars['Float']['input']>;
  acceptableMin?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  distanceMeters?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMeters?: InputMaybe<Scalars['Float']['input']>;
  notifyConfigID: Scalars['ID']['input'];
  notifyEventOptionID: Scalars['ID']['input'];
  speedToleranceKnots?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSeconds?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTimeSeconds?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * CreateNotifyConfigGeofenceInput is used for create NotifyConfigGeofence object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigGeofenceInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  geofenceID: Scalars['ID']['input'];
  notifyConfigID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyConfigInput is used for create NotifyConfig object.
 * Input was generated by ent.
 */
export type CreateNotifyConfigInput = {
  alertWindow: Scalars['Boolean']['input'];
  alertWindowEnd?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStart?: InputMaybe<Scalars['TimeOnly']['input']>;
  /** Offset in minutes from UTC for alert window start and end times */
  alertWindowToUtcOffset?: InputMaybe<Scalars['Int']['input']>;
  autoAddNewDevices: Scalars['Boolean']['input'];
  autoAddNewGeofences: Scalars['Boolean']['input'];
  channelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  enabled: Scalars['Boolean']['input'];
  eventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  geofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ignoreDuplicateForSeconds: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<NotifyConfigPriority>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateNotifyEventOptionInput is used for create NotifyEventOption object.
 * Input was generated by ent.
 */
export type CreateNotifyEventOptionInput = {
  acceptableMax?: InputMaybe<Scalars['Boolean']['input']>;
  acceptableMaxLabel: Scalars['String']['input'];
  acceptableMin?: InputMaybe<Scalars['Boolean']['input']>;
  acceptableMinLabel: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  distanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceMetersLabel: Scalars['String']['input'];
  distanceToleranceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceToleranceMetersLabel: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  /** Source of event for backend processing */
  kind?: InputMaybe<NotifyEventOptionKind>;
  /** label to display in UI */
  label: Scalars['String']['input'];
  notifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  speedToleranceKnots?: InputMaybe<Scalars['Boolean']['input']>;
  speedToleranceKnotsLabel: Scalars['String']['input'];
  timeToleranceSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  timeToleranceSecondsLabel: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTimeSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  waitTimeSecondsLabel: Scalars['String']['input'];
};

/**
 * CreateOrganisationInput is used for create Organisation object.
 * Input was generated by ent.
 */
export type CreateOrganisationInput = {
  allowChildCreation?: InputMaybe<Scalars['Boolean']['input']>;
  attendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  availableLicenses?: InputMaybe<Scalars['Int']['input']>;
  baselicenseplanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressState?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  billingGstin?: InputMaybe<Scalars['String']['input']>;
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  centralisedWallet?: InputMaybe<Scalars['Boolean']['input']>;
  childOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceLimit?: InputMaybe<Scalars['Int']['input']>;
  deviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupsRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicesRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  exportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  geofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  haltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ingestServer?: InputMaybe<OrganisationIngestServer>;
  inspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  legacysyncIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mapGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  organisationDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationLimit?: InputMaybe<Scalars['Int']['input']>;
  organisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organistionroleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rosterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rosterScheduleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeTimeLineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  shiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  simIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  totalLicenses?: InputMaybe<Scalars['Int']['input']>;
  tripConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripHaltPointTargetTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripHaltPointTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
  yardDriverProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardMaterialTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVehicleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardVendorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateOrganisationReportAccessInput is used for create OrganisationReportAccess object.
 * Input was generated by ent.
 */
export type CreateOrganisationReportAccessInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  derivedReportID: Scalars['ID']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOrganisationRoleInput is used for create OrganisationRole object.
 * Input was generated by ent.
 */
export type CreateOrganisationRoleInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  organisationRolePermissionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateOrganisationRolePermissionInput is used for create OrganisationRolePermission object.
 * Input was generated by ent.
 */
export type CreateOrganisationRolePermissionInput = {
  create?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  edit?: InputMaybe<Scalars['Boolean']['input']>;
  organisationRoleID: Scalars['ID']['input'];
  permissionID: Scalars['ID']['input'];
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOrganisationUpgradeInput is used for create OrganisationUpgrade object.
 * Input was generated by ent.
 */
export type CreateOrganisationUpgradeInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  endDate: Scalars['Time']['input'];
  organisationID: Scalars['ID']['input'];
  startDate: Scalars['Time']['input'];
  status?: InputMaybe<OrganisationUpgradeStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID: Scalars['ID']['input'];
};

/**
 * CreateOrganisationUserDocumentInput is used for create OrganisationUserDocument object.
 * Input was generated by ent.
 */
export type CreateOrganisationUserDocumentInput = {
  attachment: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationuserID: Scalars['ID']['input'];
  organisationuserdocumenttypeID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  verificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreateOrganisationUserDocumentTypeInput is used for create OrganisationUserDocumentType object.
 * Input was generated by ent.
 */
export type CreateOrganisationUserDocumentTypeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOrganisationUserInput is used for create OrganisationUser object.
 * Input was generated by ent.
 */
export type CreateOrganisationUserInput = {
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverprofilesID?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID: Scalars['ID']['input'];
  organisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleID: Scalars['ID']['input'];
  shiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  stiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
  userType?: InputMaybe<OrganisationUserUserType>;
};

/**
 * CreatePeriodicJobInput is used for create PeriodicJob object.
 * Input was generated by ent.
 */
export type CreatePeriodicJobInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastRunAt?: InputMaybe<Scalars['Time']['input']>;
  lastTaskResponse?: InputMaybe<Scalars['JSON']['input']>;
  nextRunAt?: InputMaybe<Scalars['Time']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  queueName: Scalars['String']['input'];
  schedule: Scalars['String']['input'];
  taskName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreatePermissionInput is used for create Permission object.
 * Input was generated by ent.
 */
export type CreatePermissionInput = {
  createLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deleteLabel?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  editLabel?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<PermissionGroup>;
  label: Scalars['String']['input'];
  name: PermissionName;
  readLabel?: InputMaybe<Scalars['String']['input']>;
  showCreate?: InputMaybe<Scalars['Boolean']['input']>;
  showDelete?: InputMaybe<Scalars['Boolean']['input']>;
  showEdit?: InputMaybe<Scalars['Boolean']['input']>;
  showRead?: InputMaybe<Scalars['Boolean']['input']>;
  sorter?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreatePinnedDevicesInput is used for create PinnedDevices object.
 * Input was generated by ent.
 */
export type CreatePinnedDevicesInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreatePoiInput is used for create Poi object.
 * Input was generated by ent.
 */
export type CreatePoiInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  iconColor: Scalars['String']['input'];
  iconName: Scalars['String']['input'];
  lat: Scalars['String']['input'];
  long: Scalars['String']['input'];
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreatePositionAttributeFormulaInput is used for create PositionAttributeFormula object.
 * Input was generated by ent.
 */
export type CreatePositionAttributeFormulaInput = {
  attribute: PositionAttributeFormulaAttribute;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID: Scalars['ID']['input'];
  expression: Scalars['String']['input'];
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateProfileInput is used for create Profile object.
 * Input was generated by ent.
 */
export type CreateProfileInput = {
  baseLocation: Scalars['String']['input'];
  bloodGroup: Scalars['String']['input'];
  contractNumber: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  department: Scalars['String']['input'];
  employeeNo: Scalars['String']['input'];
  groupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationusersID: Scalars['ID']['input'];
  supervisorName: Scalars['String']['input'];
  supervisorPhonenumber: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreatePusherConfigInput is used for create PusherConfig object.
 * Input was generated by ent.
 */
export type CreatePusherConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adminID?: InputMaybe<Scalars['Int']['input']>;
  allData?: InputMaybe<Scalars['Boolean']['input']>;
  allDevices?: InputMaybe<Scalars['Boolean']['input']>;
  apiExtra?: InputMaybe<Scalars['String']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSON']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceIds: Array<Scalars['Int']['input']>;
  headers: Scalars['JSON']['input'];
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  pauseOnFailureSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSize?: InputMaybe<Scalars['Int']['input']>;
  taskName: Scalars['String']['input'];
  type?: InputMaybe<PusherConfigType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  withAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * CreatePusherLogInput is used for create PusherLog object.
 * Input was generated by ent.
 */
export type CreatePusherLogInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceID?: InputMaybe<Scalars['Int']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  responseData?: InputMaybe<Scalars['String']['input']>;
  responseSeconds?: InputMaybe<Scalars['Int']['input']>;
  sentData?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * CreateRosterInput is used for create Roster object.
 * Input was generated by ent.
 */
export type CreateRosterInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  rosterDate: Scalars['Time']['input'];
  rosterShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateRosterScheduleInput is used for create RosterSchedule object.
 * Input was generated by ent.
 */
export type CreateRosterScheduleInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  shift1EndTime: Scalars['Time']['input'];
  shift1StartTime: Scalars['Time']['input'];
  shift2EndTime?: InputMaybe<Scalars['Time']['input']>;
  shift2StartTime?: InputMaybe<Scalars['Time']['input']>;
  shift3EndTime?: InputMaybe<Scalars['Time']['input']>;
  shift3StartTime?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  weekday: Scalars['Int']['input'];
};

/**
 * CreateRosterShiftInput is used for create RosterShift object.
 * Input was generated by ent.
 */
export type CreateRosterShiftInput = {
  attendanceDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  rosterID: Scalars['ID']['input'];
  scheduledEndTime?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTime?: InputMaybe<Scalars['Time']['input']>;
  shiftNumber: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateRouteHaltPointInput is used for create RouteHaltPoint object.
 * Input was generated by ent.
 */
export type CreateRouteHaltPointInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  haltPointID: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID: Scalars['ID']['input'];
  routeHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTime?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * CreateRouteHaltPointTargetInput is used for create RouteHaltPointTarget object.
 * Input was generated by ent.
 */
export type CreateRouteHaltPointTargetInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalTargetID?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID: Scalars['ID']['input'];
  plannedQty?: InputMaybe<Scalars['Int']['input']>;
  plannedUnit?: InputMaybe<Scalars['String']['input']>;
  routeHaltPointsID: Scalars['ID']['input'];
  taskType: RouteHaltPointTargetTaskType;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateRouteInput is used for create Route object.
 * Input was generated by ent.
 */
export type CreateRouteInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  endLocation?: InputMaybe<Scalars['String']['input']>;
  estimatedTime?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  routeHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeTimeLineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceType: RouteServiceType;
  startLocation?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<RouteStatusName>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateRouteShiftInput is used for create RouteShift object.
 * Input was generated by ent.
 */
export type CreateRouteShiftInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  routeID: Scalars['ID']['input'];
  shiftID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateRouteTimeLineInput is used for create RouteTimeLine object.
 * Input was generated by ent.
 */
export type CreateRouteTimeLineInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  routeID: Scalars['ID']['input'];
  timestamp: Scalars['Time']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateScheduleTaskInput is used for create ScheduleTask object.
 * Input was generated by ent.
 */
export type CreateScheduleTaskInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  eta?: InputMaybe<Scalars['Time']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  queueName: ScheduleTaskQueueName;
  status?: InputMaybe<ScheduleTaskStatus>;
  taskFailed?: InputMaybe<Scalars['Boolean']['input']>;
  taskName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateSettingInput is used for create Setting object.
 * Input was generated by ent.
 */
export type CreateSettingInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value: Scalars['String']['input'];
};

/**
 * CreateShiftInput is used for create Shift object.
 * Input was generated by ent.
 */
export type CreateShiftInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['ID']['input']>;
  /** End time of shift */
  endTime?: InputMaybe<Scalars['Time']['input']>;
  /** Exception dates - ISO 8601 date strings to exclude from recurrence (EXDATE) */
  exdates?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  /** Additional dates - ISO 8601 date strings to include in recurrence (RDATE) */
  rdates?: InputMaybe<Array<Scalars['String']['input']>>;
  /** End date/time for the recurring pattern (UNTIL), null for infinite */
  recurrenceEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Start date/time for the recurring pattern (DTSTART) */
  recurrenceStart?: InputMaybe<Scalars['Time']['input']>;
  routeShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** iCalendar RRULE string (e.g., 'FREQ=WEEKLY;BYDAY=MO,WE,FR;INTERVAL=1') */
  rrule?: InputMaybe<Scalars['String']['input']>;
  /** Start time of shift */
  startTime?: InputMaybe<Scalars['Time']['input']>;
  /** Timezone for recurrence calculations (e.g., 'America/New_York') */
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateSimInput is used for create Sim object.
 * Input was generated by ent.
 */
export type CreateSimInput = {
  activationDate?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  devicesID?: InputMaybe<Scalars['ID']['input']>;
  imsi: Scalars['String']['input'];
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  purchaseDate?: InputMaybe<Scalars['Time']['input']>;
  simNumber: Scalars['String']['input'];
  simOperator?: InputMaybe<SimSimOperator>;
  status?: InputMaybe<SimStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateStaffRoleInput is used for create StaffRole object.
 * Input was generated by ent.
 */
export type CreateStaffRoleInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateStiQRInput is used for create StiQR object.
 * Input was generated by ent.
 */
export type CreateStiQrInput = {
  activatedOn?: InputMaybe<Scalars['Time']['input']>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceCategoryID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  emergencyContactNumbers?: InputMaybe<Scalars['JSON']['input']>;
  enableMasked?: InputMaybe<Scalars['Boolean']['input']>;
  enableSms?: InputMaybe<Scalars['Boolean']['input']>;
  enableVoip?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID: Scalars['ID']['input'];
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSubscriptionLicenseOrderInput is used for create SubscriptionLicenseOrder object.
 * Input was generated by ent.
 */
export type CreateSubscriptionLicenseOrderInput = {
  baselicenseplanID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  licenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID: Scalars['ID']['input'];
  perUnitPrice: Scalars['Float']['input'];
  status?: InputMaybe<SubscriptionLicenseOrderStatus>;
  tenure: Scalars['Int']['input'];
  tenureUnit?: InputMaybe<SubscriptionLicenseOrderTenureUnit>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSupportDocumentInput is used for create SupportDocument object.
 * Input was generated by ent.
 */
export type CreateSupportDocumentInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  data: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  nchunk: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateSupportTicketInput is used for create SupportTicket object.
 * Input was generated by ent.
 */
export type CreateSupportTicketInput = {
  attachmentUrls?: InputMaybe<Scalars['JSON']['input']>;
  category: SupportTicketCategory;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SupportTicketStatus>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateTargetInput is used for create Target object.
 * Input was generated by ent.
 */
export type CreateTargetInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Scalars['Map']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  haltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  load?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  targetType: TargetTargetType;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateTripConfigsInput is used for create TripConfigs object.
 * Input was generated by ent.
 */
export type CreateTripConfigsInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceCategory?: InputMaybe<Scalars['String']['input']>;
  dropGeofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  organisationID: Scalars['ID']['input'];
  pickUpGeofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  targetAttributesConfig?: InputMaybe<Scalars['Map']['input']>;
  targetTypes: TripConfigsTargetTypes;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateTripHaltPointInput is used for create TripHaltPoint object.
 * Input was generated by ent.
 */
export type CreateTripHaltPointInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  haltName?: InputMaybe<Scalars['String']['input']>;
  haltPointID: Scalars['ID']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  organisationID: Scalars['ID']['input'];
  plannedTime?: InputMaybe<Scalars['String']['input']>;
  sequence: Scalars['Int']['input'];
  statusName?: InputMaybe<TripHaltPointStatusName>;
  tripHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripHaltPointTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  windowEnd?: InputMaybe<Scalars['Time']['input']>;
  windowStart?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateTripHaltPointTargetInput is used for create TripHaltPointTarget object.
 * Input was generated by ent.
 */
export type CreateTripHaltPointTargetInput = {
  attributes?: InputMaybe<Scalars['Map']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  externalID: Scalars['String']['input'];
  externalTargetID?: InputMaybe<Scalars['ID']['input']>;
  noShowReason?: InputMaybe<Scalars['String']['input']>;
  organisationID: Scalars['ID']['input'];
  proofOfDrop?: InputMaybe<Scalars['String']['input']>;
  proofOfDropTimestamp?: InputMaybe<Scalars['Time']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  routeHaltTargetID: Scalars['ID']['input'];
  statusName?: InputMaybe<TripHaltPointTargetStatusName>;
  targetID: Scalars['ID']['input'];
  targetName: Scalars['String']['input'];
  targetPhone: Scalars['String']['input'];
  targetType: Scalars['String']['input'];
  taskType: TripHaltPointTargetTaskType;
  tripHaltID: Scalars['ID']['input'];
  tripHaltPointTargetTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateTripHaltPointTargetTimeLineInput is used for create TripHaltPointTargetTimeLine object.
 * Input was generated by ent.
 */
export type CreateTripHaltPointTargetTimeLineInput = {
  actualQty?: InputMaybe<Scalars['Int']['input']>;
  actualUnit?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  eventTime: Scalars['Time']['input'];
  organisationID: Scalars['ID']['input'];
  photoURL?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<TripHaltPointTargetTimeLineStatusName>;
  tripHaltTargetID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userEmail: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
};

/**
 * CreateTripHaltPointTimeLineInput is used for create TripHaltPointTimeLine object.
 * Input was generated by ent.
 */
export type CreateTripHaltPointTimeLineInput = {
  arrivalTime?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  departureTime?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<TripHaltPointTimeLineStatusName>;
  tripHaltID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userEmail: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
};

/**
 * CreateTripInput is used for create Trip object.
 * Input was generated by ent.
 */
export type CreateTripInput = {
  acceptedAt?: InputMaybe<Scalars['Time']['input']>;
  assignedAt?: InputMaybe<Scalars['Time']['input']>;
  cancelledAt?: InputMaybe<Scalars['Time']['input']>;
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdByUserID?: InputMaybe<Scalars['ID']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  driverID?: InputMaybe<Scalars['ID']['input']>;
  driverLicenseNo?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhone?: InputMaybe<Scalars['String']['input']>;
  endLocation?: InputMaybe<Scalars['String']['input']>;
  estimatedTime?: InputMaybe<Scalars['Float']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  plannedEndTime?: InputMaybe<Scalars['Time']['input']>;
  plannedStartTime?: InputMaybe<Scalars['Time']['input']>;
  routeID: Scalars['ID']['input'];
  serviceDate?: InputMaybe<Scalars['Time']['input']>;
  startLocation?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['Time']['input']>;
  statusName?: InputMaybe<TripStatusName>;
  tripHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateTripTimeLineInput is used for create TripTimeLine object.
 * Input was generated by ent.
 */
export type CreateTripTimeLineInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<TripTimeLineStatusName>;
  timestamp: Scalars['Time']['input'];
  tripID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userEmail: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
  userPhone: Scalars['String']['input'];
};

/**
 * CreateUpgradeInput is used for create Upgrade object.
 * Input was generated by ent.
 */
export type CreateUpgradeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationCode: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateUpgradeOrganisationPriceInput is used for create UpgradeOrganisationPrice object.
 * Input was generated by ent.
 */
export type CreateUpgradeOrganisationPriceInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID: Scalars['ID']['input'];
};

/**
 * CreateUserConfigInput is used for create UserConfig object.
 * Input was generated by ent.
 */
export type CreateUserConfigInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: UserConfigKey;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/**
 * CreateUserFcmTokenInput is used for create UserFcmToken object.
 * Input was generated by ent.
 */
export type CreateUserFcmTokenInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceType: Scalars['String']['input'];
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmToken: Scalars['String']['input'];
  fcmValid?: InputMaybe<Scalars['Boolean']['input']>;
  invalidReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['Int']['input'];
};

/**
 * CreateUserInput is used for create User object.
 * Input was generated by ent.
 */
export type CreateUserInput = {
  /** Address of the user */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Alternate mobile number of the user */
  alternateMobileNumber?: InputMaybe<Scalars['String']['input']>;
  apiUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvedLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  attendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** City of the user */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country of the user */
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  deviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  exportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  inspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastLogin?: InputMaybe<Scalars['Time']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mapConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  mediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Mobile number of the user */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  organisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  password: Scalars['String']['input'];
  poiIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Postal code of the user */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  rosterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rosterScheduleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** State of the user */
  state?: InputMaybe<Scalars['String']['input']>;
  tripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  userLeaveBalanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatusInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatusOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsWarehouseInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsWarehouseOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateUserLeaveBalanceInput is used for create UserLeaveBalance object.
 * Input was generated by ent.
 */
export type CreateUserLeaveBalanceInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  leaveTypeID: Scalars['ID']['input'];
  totalAvailableDays: Scalars['Float']['input'];
  totalRemainingDays: Scalars['Float']['input'];
  totalUsedDays: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

/**
 * CreateUserReportBookmarkInput is used for create UserReportBookmark object.
 * Input was generated by ent.
 */
export type CreateUserReportBookmarkInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  derivedReportID: Scalars['ID']['input'];
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  lastGeneratedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * CreateUserRosterAssignmentInput is used for create UserRosterAssignment object.
 * Input was generated by ent.
 */
export type CreateUserRosterAssignmentInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  rosterScheduleID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID: Scalars['ID']['input'];
};

/**
 * CreateWalletInput is used for create Wallet object.
 * Input was generated by ent.
 */
export type CreateWalletInput = {
  autoLoadLimit?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  negativeLimit?: InputMaybe<Scalars['Float']['input']>;
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  walletpaymenttransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  wallettransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateWalletPaymentTransactionInput is used for create WalletPaymentTransaction object.
 * Input was generated by ent.
 */
export type CreateWalletPaymentTransactionInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentProcessor?: InputMaybe<WalletPaymentTransactionPaymentProcessor>;
  processorPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  processorTransactionID?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WalletPaymentTransactionStatus>;
  subtotal: Scalars['Float']['input'];
  tax: Scalars['Float']['input'];
  transactionDate: Scalars['Time']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  walletID: Scalars['ID']['input'];
};

/**
 * CreateWalletTransactionInput is used for create WalletTransaction object.
 * Input was generated by ent.
 */
export type CreateWalletTransactionInput = {
  amount: Scalars['Float']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  transactionType: WalletTransactionTransactionType;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  usageID?: InputMaybe<Scalars['String']['input']>;
  usageType?: InputMaybe<WalletTransactionUsageType>;
  walletID: Scalars['ID']['input'];
};

/**
 * CreateWhatsAppConfigInput is used for create WhatsAppConfig object.
 * Input was generated by ent.
 */
export type CreateWhatsAppConfigInput = {
  companyID: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  notes?: InputMaybe<Scalars['Int']['input']>;
  phoneNumberID?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateWhitelabelConfigInput is used for create WhitelabelConfig object.
 * Input was generated by ent.
 */
export type CreateWhitelabelConfigInput = {
  appcolorscheme?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: WhitelabelConfigKey;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value: Scalars['String']['input'];
  whitelabelID: Scalars['ID']['input'];
};

/**
 * CreateWhitelabelCoreSettingOverrideInput is used for create WhitelabelCoreSettingOverride object.
 * Input was generated by ent.
 */
export type CreateWhitelabelCoreSettingOverrideInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  key: WhitelabelCoreSettingOverrideKey;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value: Scalars['String']['input'];
  whitelabelID: Scalars['ID']['input'];
};

/**
 * CreateWhitelabelInput is used for create Whitelabel object.
 * Input was generated by ent.
 */
export type CreateWhitelabelInput = {
  brandName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  domainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Array of enabled methods, options are:
   * 				- email_password
   * 				- email_otp
   * 				- mobile_otp
   */
  enabledLoginMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediafileWhitelabelLoginLogoID?: InputMaybe<Scalars['ID']['input']>;
  mediafileWhitelabelLogoID?: InputMaybe<Scalars['ID']['input']>;
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  whitelabelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelcoresettingoverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardDriverProfileInput is used for create YardDriverProfile object.
 * Input was generated by ent.
 */
export type CreateYardDriverProfileInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  dlExpiry: Scalars['Time']['input'];
  dlNumber: Scalars['String']['input'];
  lastUpdated: Scalars['Time']['input'];
  mediafileAvatarID?: InputMaybe<Scalars['ID']['input']>;
  mediafileDlImageID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardMaterialInput is used for create YardMaterial object.
 * Input was generated by ent.
 */
export type CreateYardMaterialInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardMaterialTypeID?: InputMaybe<Scalars['ID']['input']>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardMaterialTypeInput is used for create YardMaterialType object.
 * Input was generated by ent.
 */
export type CreateYardMaterialTypeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardTripApprovalInput is used for create YardTripApproval object.
 * Input was generated by ent.
 */
export type CreateYardTripApprovalInput = {
  approvalMatrixID: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  organisationID: Scalars['ID']['input'];
  reviewReason?: InputMaybe<Scalars['String']['input']>;
  reviewedByID?: InputMaybe<Scalars['ID']['input']>;
  status: YardTripApprovalStatus;
  tripID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
};

/**
 * CreateYardTripInput is used for create YardTrip object.
 * Input was generated by ent.
 */
export type CreateYardTripInput = {
  assignedDriverTrackerID?: InputMaybe<Scalars['ID']['input']>;
  assignedRouteID?: InputMaybe<Scalars['ID']['input']>;
  assignedTrackerBatteryLevel?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerID?: InputMaybe<Scalars['ID']['input']>;
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  declaredMaterialID?: InputMaybe<Scalars['ID']['input']>;
  driverID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  organisationID: Scalars['ID']['input'];
  parkingID?: InputMaybe<Scalars['ID']['input']>;
  parkingInTime?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTime?: InputMaybe<Scalars['Time']['input']>;
  purpose?: InputMaybe<YardTripPurpose>;
  tripStatus?: InputMaybe<YardTripTripStatus>;
  tripStatusCurrentID?: InputMaybe<Scalars['ID']['input']>;
  tripStatusLastID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
  vendorID?: InputMaybe<Scalars['ID']['input']>;
  warehouseID: Scalars['ID']['input'];
  warehouseInByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseInTime?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseOutTime?: InputMaybe<Scalars['Time']['input']>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardTripStatusInput is used for create YardTripStatus object.
 * Input was generated by ent.
 */
export type CreateYardTripStatusInput = {
  activityStartTime?: InputMaybe<Scalars['Time']['input']>;
  activityTypeID?: InputMaybe<Scalars['ID']['input']>;
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dockID: Scalars['ID']['input'];
  externalID?: InputMaybe<Scalars['String']['input']>;
  materialID?: InputMaybe<Scalars['ID']['input']>;
  organisationID: Scalars['ID']['input'];
  routePathID: Scalars['ID']['input'];
  sequence?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<YardTripStatusStatus>;
  tripID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripsCurrentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripsLastIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardVehicleInput is used for create YardVehicle object.
 * Input was generated by ent.
 */
export type CreateYardVehicleInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiry?: InputMaybe<Scalars['Time']['input']>;
  lastUpdated: Scalars['Time']['input'];
  mediafileVehicleInsuranceImageID?: InputMaybe<Scalars['ID']['input']>;
  mediafileVehiclePollutionImageID?: InputMaybe<Scalars['ID']['input']>;
  mediafileVehicleRcID?: InputMaybe<Scalars['ID']['input']>;
  organisationID: Scalars['ID']['input'];
  pollutionExpiry?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleNumber: Scalars['String']['input'];
  vehicleRcExpiry: Scalars['Time']['input'];
  vehicleRcNumber: Scalars['String']['input'];
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardVendorInput is used for create YardVendor object.
 * Input was generated by ent.
 */
export type CreateYardVendorInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorCode: Scalars['String']['input'];
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseActivityTypeInput is used for create YardWarehouseActivityType object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseActivityTypeInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseApprovalMatrixInput is used for create YardWarehouseApprovalMatrix object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseApprovalMatrixInput = {
  approvalMatrixID?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  label: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  preApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseDockInput is used for create YardWarehouseDock object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseDockInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dockType?: InputMaybe<YardWarehouseDockDockType>;
  geofenceID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseDockSharingInput is used for create YardWarehouseDockSharing object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseDockSharingInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dockID: Scalars['ID']['input'];
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID: Scalars['ID']['input'];
  organisationUserID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateYardWarehouseInput is used for create YardWarehouse object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseParkingInput is used for create YardWarehouseParking object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseParkingInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID: Scalars['ID']['input'];
  slotName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseRouteInput is used for create YardWarehouseRoute object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseRouteInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  ensureOrder?: InputMaybe<Scalars['Boolean']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationID: Scalars['ID']['input'];
  preferredYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryDockID?: InputMaybe<Scalars['ID']['input']>;
  routeType: YardWarehouseRouteRouteType;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID: Scalars['ID']['input'];
  yardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateYardWarehouseRoutePathInput is used for create YardWarehouseRoutePath object.
 * Input was generated by ent.
 */
export type CreateYardWarehouseRoutePathInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  dockID: Scalars['ID']['input'];
  externalID?: InputMaybe<Scalars['String']['input']>;
  maxWaitTime: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  organisationID: Scalars['ID']['input'];
  routeID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CrudPermission = {
  __typename?: 'CrudPermission';
  create: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  name: PermissionName;
  read: Scalars['Boolean']['output'];
};

export type CurrentUserResponse = {
  __typename?: 'CurrentUserResponse';
  organisationUser: OrganisationUser;
  permissions: Array<Maybe<CrudPermission>>;
};

export type CustomCreateKmlInput = {
  createGeofence?: InputMaybe<Scalars['Boolean']['input']>;
  fileID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organisationID?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomUpdateKmlInput = {
  fileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
};

export type DerivedReport = Node & {
  __typename?: 'DerivedReport';
  baseReport: BaseReport;
  baseReportID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  enabledForAllOrganisation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organisationID?: Maybe<Scalars['ID']['output']>;
  organisationReportAccesses?: Maybe<Array<OrganisationReportAccess>>;
  tableConfig: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userReportBookmarks?: Maybe<Array<UserReportBookmark>>;
};

/** A connection to a list of items. */
export type DerivedReportConnection = {
  __typename?: 'DerivedReportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DerivedReportEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DerivedReportEdge = {
  __typename?: 'DerivedReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DerivedReport>;
};

export enum DerivedReportField {
  BaseReportId = 'baseReportID',
  CreatedAt = 'createdAt',
  Description = 'description',
  EnabledForAllOrganisation = 'enabledForAllOrganisation',
  OrganisationId = 'organisationID',
  TableConfig = 'tableConfig',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DerivedReport connections */
export type DerivedReportOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DerivedReports. */
  field: DerivedReportOrderField;
};

/** Properties by which DerivedReport connections can be ordered. */
export enum DerivedReportOrderField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

/**
 * DerivedReportWhereInput is used for filtering DerivedReport objects.
 * Input was generated by ent.
 */
export type DerivedReportWhereInput = {
  and?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** base_report_id field predicates */
  baseReportID?: InputMaybe<Scalars['ID']['input']>;
  baseReportIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseReportIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  baseReportIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** enabled_for_all_organisation field predicates */
  enabledForAllOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForAllOrganisationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** base_report edge predicates */
  hasBaseReport?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaseReportWith?: InputMaybe<Array<BaseReportWhereInput>>;
  /** organisation_report_accesses edge predicates */
  hasOrganisationReportAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationReportAccessesWith?: InputMaybe<Array<OrganisationReportAccessWhereInput>>;
  /** user_report_bookmarks edge predicates */
  hasUserReportBookmarks?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserReportBookmarksWith?: InputMaybe<Array<UserReportBookmarkWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DerivedReportWhereInput>;
  or?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** table_config field predicates */
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigGT?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigGTE?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  tableConfigLT?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigLTE?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigNEQ?: InputMaybe<Scalars['JSON']['input']>;
  tableConfigNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Device = Node & {
  __typename?: 'Device';
  associatedSimID: Scalars['ID']['output'];
  boltLegacyID?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  deviceActionLogs?: Maybe<Array<DeviceActionLog>>;
  deviceCategoryID: Scalars['ID']['output'];
  deviceConfigs?: Maybe<Array<DeviceConfig>>;
  deviceDocuments?: Maybe<Array<DeviceDocument>>;
  deviceGroup?: Maybe<DeviceGroup>;
  devicePlaybackFiles?: Maybe<Array<DevicePlaybackFiles>>;
  deviceadvancedconfigs?: Maybe<Array<DeviceAdvancedConfig>>;
  devicecategory: DeviceCategory;
  devicechannelconfigs?: Maybe<Array<DeviceChannelConfig>>;
  devicegroups?: Maybe<Array<DeviceGroup>>;
  devicemodel: DeviceModel;
  externalID?: Maybe<Scalars['String']['output']>;
  groupID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imei: Scalars['String']['output'];
  ingestServer: DeviceIngestServer;
  isActive: Scalars['Boolean']['output'];
  isMaintenance: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  lastPing?: Maybe<Scalars['Time']['output']>;
  license?: Maybe<License>;
  midnightTotalDistance: Scalars['Float']['output'];
  midnightTotalEngineMs: Scalars['Float']['output'];
  modelID: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  positionAttributeFormulas?: Maybe<Array<PositionAttributeFormula>>;
  rootOrganisation: Organisation;
  rootOrganisationID: Scalars['ID']['output'];
  sim: Sim;
  speedLimitKmHr: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type DeviceAcl = Node & {
  __typename?: 'DeviceACL';
  createdAt: Scalars['Time']['output'];
  devicegroupID: Scalars['ID']['output'];
  devicegroups: DeviceGroup;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organisationUser: OrganisationUser;
  organisationuserID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceAclConnection = {
  __typename?: 'DeviceACLConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceAclEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceAclEdge = {
  __typename?: 'DeviceACLEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceAcl>;
};

export enum DeviceAclField {
  CreatedAt = 'createdAt',
  DevicegroupId = 'devicegroupID',
  Name = 'name',
  OrganisationuserId = 'organisationuserID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceACL connections */
export type DeviceAclOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceACLs. */
  field: DeviceAclOrderField;
};

/** Properties by which DeviceACL connections can be ordered. */
export enum DeviceAclOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceACLWhereInput is used for filtering DeviceACL objects.
 * Input was generated by ent.
 */
export type DeviceAclWhereInput = {
  and?: InputMaybe<Array<DeviceAclWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devicegroup_id field predicates */
  devicegroupID?: InputMaybe<Scalars['ID']['input']>;
  devicegroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  devicegroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** devicegroups edge predicates */
  hasDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisation_user edge predicates */
  hasOrganisationUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationUserWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DeviceAclWhereInput>;
  or?: InputMaybe<Array<DeviceAclWhereInput>>;
  /** organisationuser_id field predicates */
  organisationuserID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceActionLog = Node & {
  __typename?: 'DeviceActionLog';
  actionDescription: Scalars['String']['output'];
  actionType: DeviceActionLogActionType;
  createdAt: Scalars['Time']['output'];
  deviceID: Scalars['ID']['output'];
  devices: Device;
  id: Scalars['ID']['output'];
  status: DeviceActionLogStatus;
  updatedAt: Scalars['Time']['output'];
};

/** DeviceActionLogActionType is enum for the field action_type */
export enum DeviceActionLogActionType {
  Command = 'Command',
  UpdateImei = 'UpdateIMEI'
}

/** A connection to a list of items. */
export type DeviceActionLogConnection = {
  __typename?: 'DeviceActionLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceActionLogEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceActionLogEdge = {
  __typename?: 'DeviceActionLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceActionLog>;
};

export enum DeviceActionLogField {
  ActionDescription = 'actionDescription',
  ActionType = 'actionType',
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceActionLog connections */
export type DeviceActionLogOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceActionLogs. */
  field: DeviceActionLogOrderField;
};

/** Properties by which DeviceActionLog connections can be ordered. */
export enum DeviceActionLogOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DeviceActionLogStatus is enum for the field status */
export enum DeviceActionLogStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Success = 'Success'
}

/**
 * DeviceActionLogWhereInput is used for filtering DeviceActionLog objects.
 * Input was generated by ent.
 */
export type DeviceActionLogWhereInput = {
  /** action_description field predicates */
  actionDescription?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionGT?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionGTE?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  actionDescriptionLT?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionLTE?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  actionDescriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** action_type field predicates */
  actionType?: InputMaybe<DeviceActionLogActionType>;
  actionTypeIn?: InputMaybe<Array<DeviceActionLogActionType>>;
  actionTypeNEQ?: InputMaybe<DeviceActionLogActionType>;
  actionTypeNotIn?: InputMaybe<Array<DeviceActionLogActionType>>;
  and?: InputMaybe<Array<DeviceActionLogWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceActionLogWhereInput>;
  or?: InputMaybe<Array<DeviceActionLogWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<DeviceActionLogStatus>;
  statusIn?: InputMaybe<Array<DeviceActionLogStatus>>;
  statusNEQ?: InputMaybe<DeviceActionLogStatus>;
  statusNotIn?: InputMaybe<Array<DeviceActionLogStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceAddonModel = Node & {
  __typename?: 'DeviceAddonModel';
  addonType: DeviceAddonModelAddonType;
  channelType: DeviceAddonModelChannelType;
  createdAt: Scalars['Time']['output'];
  devicechannelconfigs?: Maybe<Array<DeviceChannelConfig>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** DeviceAddonModelAddonType is enum for the field addon_type */
export enum DeviceAddonModelAddonType {
  Camera = 'Camera',
  Fuel = 'Fuel',
  Temperature = 'Temperature',
  Tracker = 'Tracker'
}

/** DeviceAddonModelChannelType is enum for the field channel_type */
export enum DeviceAddonModelChannelType {
  Analog = 'Analog',
  Digital = 'Digital',
  A = 'a',
  D = 'd'
}

/** A connection to a list of items. */
export type DeviceAddonModelConnection = {
  __typename?: 'DeviceAddonModelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceAddonModelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceAddonModelEdge = {
  __typename?: 'DeviceAddonModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceAddonModel>;
};

export enum DeviceAddonModelField {
  AddonType = 'addonType',
  ChannelType = 'channelType',
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceAddonModel connections */
export type DeviceAddonModelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceAddonModels. */
  field: DeviceAddonModelOrderField;
};

/** Properties by which DeviceAddonModel connections can be ordered. */
export enum DeviceAddonModelOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceAddonModelWhereInput is used for filtering DeviceAddonModel objects.
 * Input was generated by ent.
 */
export type DeviceAddonModelWhereInput = {
  /** addon_type field predicates */
  addonType?: InputMaybe<DeviceAddonModelAddonType>;
  addonTypeIn?: InputMaybe<Array<DeviceAddonModelAddonType>>;
  addonTypeNEQ?: InputMaybe<DeviceAddonModelAddonType>;
  addonTypeNotIn?: InputMaybe<Array<DeviceAddonModelAddonType>>;
  and?: InputMaybe<Array<DeviceAddonModelWhereInput>>;
  /** channel_type field predicates */
  channelType?: InputMaybe<DeviceAddonModelChannelType>;
  channelTypeIn?: InputMaybe<Array<DeviceAddonModelChannelType>>;
  channelTypeNEQ?: InputMaybe<DeviceAddonModelChannelType>;
  channelTypeNotIn?: InputMaybe<Array<DeviceAddonModelChannelType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devicechannelconfigs edge predicates */
  hasDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicechannelconfigsWith?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceAddonModelWhereInput>;
  or?: InputMaybe<Array<DeviceAddonModelWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceAdvancedConfig = Node & {
  __typename?: 'DeviceAdvancedConfig';
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type DeviceAdvancedConfigConnection = {
  __typename?: 'DeviceAdvancedConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceAdvancedConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceAdvancedConfigEdge = {
  __typename?: 'DeviceAdvancedConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceAdvancedConfig>;
};

export enum DeviceAdvancedConfigField {
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

/** Ordering options for DeviceAdvancedConfig connections */
export type DeviceAdvancedConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceAdvancedConfigs. */
  field: DeviceAdvancedConfigOrderField;
};

/** Properties by which DeviceAdvancedConfig connections can be ordered. */
export enum DeviceAdvancedConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceAdvancedConfigWhereInput is used for filtering DeviceAdvancedConfig objects.
 * Input was generated by ent.
 */
export type DeviceAdvancedConfigWhereInput = {
  and?: InputMaybe<Array<DeviceAdvancedConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<Scalars['String']['input']>;
  keyContains?: InputMaybe<Scalars['String']['input']>;
  keyContainsFold?: InputMaybe<Scalars['String']['input']>;
  keyEqualFold?: InputMaybe<Scalars['String']['input']>;
  keyGT?: InputMaybe<Scalars['String']['input']>;
  keyGTE?: InputMaybe<Scalars['String']['input']>;
  keyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  keyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  keyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keyLT?: InputMaybe<Scalars['String']['input']>;
  keyLTE?: InputMaybe<Scalars['String']['input']>;
  keyNEQ?: InputMaybe<Scalars['String']['input']>;
  keyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceAdvancedConfigWhereInput>;
  or?: InputMaybe<Array<DeviceAdvancedConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeviceCategory = Node & {
  __typename?: 'DeviceCategory';
  createdAt: Scalars['Time']['output'];
  devicegroups?: Maybe<Array<DeviceGroup>>;
  devices?: Maybe<Array<Device>>;
  groupType?: Maybe<DeviceCategoryGroupType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stiqrs?: Maybe<Array<StiQr>>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceCategoryConnection = {
  __typename?: 'DeviceCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceCategoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceCategoryEdge = {
  __typename?: 'DeviceCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceCategory>;
};

export enum DeviceCategoryField {
  CreatedAt = 'createdAt',
  GroupType = 'groupType',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** DeviceCategoryGroupType is enum for the field group_type */
export enum DeviceCategoryGroupType {
  Asset = 'Asset',
  Dashcam = 'Dashcam',
  Personal = 'Personal',
  Vehicle = 'Vehicle'
}

/** Ordering options for DeviceCategory connections */
export type DeviceCategoryOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceCategories. */
  field: DeviceCategoryOrderField;
};

/** Properties by which DeviceCategory connections can be ordered. */
export enum DeviceCategoryOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceCategoryWhereInput is used for filtering DeviceCategory objects.
 * Input was generated by ent.
 */
export type DeviceCategoryWhereInput = {
  and?: InputMaybe<Array<DeviceCategoryWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** group_type field predicates */
  groupType?: InputMaybe<DeviceCategoryGroupType>;
  groupTypeIn?: InputMaybe<Array<DeviceCategoryGroupType>>;
  groupTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  groupTypeNEQ?: InputMaybe<DeviceCategoryGroupType>;
  groupTypeNotIn?: InputMaybe<Array<DeviceCategoryGroupType>>;
  groupTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** devicegroups edge predicates */
  hasDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** stiqrs edge predicates */
  hasStiqrs?: InputMaybe<Scalars['Boolean']['input']>;
  hasStiqrsWith?: InputMaybe<Array<StiQrWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceCategoryWhereInput>;
  or?: InputMaybe<Array<DeviceCategoryWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceChannelConfig = Node & {
  __typename?: 'DeviceChannelConfig';
  attachedDeviceModelID: Scalars['ID']['output'];
  channelID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceID: Scalars['ID']['output'];
  deviceaddonmodel: DeviceAddonModel;
  devicemodelchannel: DeviceModelChannel;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceChannelConfigConnection = {
  __typename?: 'DeviceChannelConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceChannelConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceChannelConfigEdge = {
  __typename?: 'DeviceChannelConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceChannelConfig>;
};

export enum DeviceChannelConfigField {
  AttachedDeviceModelId = 'attachedDeviceModelID',
  ChannelId = 'channelID',
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceChannelConfig connections */
export type DeviceChannelConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceChannelConfigs. */
  field: DeviceChannelConfigOrderField;
};

/** Properties by which DeviceChannelConfig connections can be ordered. */
export enum DeviceChannelConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceChannelConfigWhereInput is used for filtering DeviceChannelConfig objects.
 * Input was generated by ent.
 */
export type DeviceChannelConfigWhereInput = {
  and?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** attached_device_model_id field predicates */
  attachedDeviceModelID?: InputMaybe<Scalars['ID']['input']>;
  attachedDeviceModelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachedDeviceModelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  attachedDeviceModelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** channel_id field predicates */
  channelID?: InputMaybe<Scalars['ID']['input']>;
  channelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  channelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** deviceaddonmodel edge predicates */
  hasDeviceaddonmodel?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceaddonmodelWith?: InputMaybe<Array<DeviceAddonModelWhereInput>>;
  /** devicemodelchannel edge predicates */
  hasDevicemodelchannel?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicemodelchannelWith?: InputMaybe<Array<DeviceModelChannelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceChannelConfigWhereInput>;
  or?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceCommand = Node & {
  __typename?: 'DeviceCommand';
  command: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  deviceModels?: Maybe<Array<DeviceModel>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceCommandConnection = {
  __typename?: 'DeviceCommandConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceCommandEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceCommandEdge = {
  __typename?: 'DeviceCommandEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceCommand>;
};

export enum DeviceCommandField {
  Command = 'command',
  CreatedAt = 'createdAt',
  Description = 'description',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceCommand connections */
export type DeviceCommandOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceCommands. */
  field: DeviceCommandOrderField;
};

/** Properties by which DeviceCommand connections can be ordered. */
export enum DeviceCommandOrderField {
  Description = 'DESCRIPTION',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceCommandWhereInput is used for filtering DeviceCommand objects.
 * Input was generated by ent.
 */
export type DeviceCommandWhereInput = {
  and?: InputMaybe<Array<DeviceCommandWhereInput>>;
  /** command field predicates */
  command?: InputMaybe<Scalars['String']['input']>;
  commandContains?: InputMaybe<Scalars['String']['input']>;
  commandContainsFold?: InputMaybe<Scalars['String']['input']>;
  commandEqualFold?: InputMaybe<Scalars['String']['input']>;
  commandGT?: InputMaybe<Scalars['String']['input']>;
  commandGTE?: InputMaybe<Scalars['String']['input']>;
  commandHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commandHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commandIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commandLT?: InputMaybe<Scalars['String']['input']>;
  commandLTE?: InputMaybe<Scalars['String']['input']>;
  commandNEQ?: InputMaybe<Scalars['String']['input']>;
  commandNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** device_models edge predicates */
  hasDeviceModels?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceModelsWith?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceCommandWhereInput>;
  or?: InputMaybe<Array<DeviceCommandWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceConfig = Node & {
  __typename?: 'DeviceConfig';
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceConfigConnection = {
  __typename?: 'DeviceConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceConfigEdge = {
  __typename?: 'DeviceConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceConfig>;
};

export enum DeviceConfigField {
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  Token = 'token',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceConfig connections */
export type DeviceConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceConfigs. */
  field: DeviceConfigOrderField;
};

/** Properties by which DeviceConfig connections can be ordered. */
export enum DeviceConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceConfigWhereInput is used for filtering DeviceConfig objects.
 * Input was generated by ent.
 */
export type DeviceConfigWhereInput = {
  and?: InputMaybe<Array<DeviceConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceConfigWhereInput>;
  or?: InputMaybe<Array<DeviceConfigWhereInput>>;
  /** token field predicates */
  token?: InputMaybe<Scalars['String']['input']>;
  tokenContains?: InputMaybe<Scalars['String']['input']>;
  tokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  tokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  tokenGT?: InputMaybe<Scalars['String']['input']>;
  tokenGTE?: InputMaybe<Scalars['String']['input']>;
  tokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  tokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  tokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  tokenLT?: InputMaybe<Scalars['String']['input']>;
  tokenLTE?: InputMaybe<Scalars['String']['input']>;
  tokenNEQ?: InputMaybe<Scalars['String']['input']>;
  tokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type DeviceDocument = Node & {
  __typename?: 'DeviceDocument';
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceDocumentType: DeviceDocumentType;
  deviceDocumentTypeID: Scalars['ID']['output'];
  deviceID: Scalars['ID']['output'];
  documentID?: Maybe<Scalars['ID']['output']>;
  expiryDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  mediafile?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceDocumentConnection = {
  __typename?: 'DeviceDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceDocumentEdge = {
  __typename?: 'DeviceDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceDocument>;
};

export enum DeviceDocumentField {
  CreatedAt = 'createdAt',
  DeviceDocumentTypeId = 'deviceDocumentTypeID',
  DeviceId = 'deviceID',
  DocumentId = 'documentID',
  ExpiryDate = 'expiryDate',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceDocument connections */
export type DeviceDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceDocuments. */
  field: DeviceDocumentOrderField;
};

/** Properties by which DeviceDocument connections can be ordered. */
export enum DeviceDocumentOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type DeviceDocumentType = Node & {
  __typename?: 'DeviceDocumentType';
  createdAt: Scalars['Time']['output'];
  deviceDocumentTypeDocuments?: Maybe<Array<DeviceDocument>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceDocumentTypeConnection = {
  __typename?: 'DeviceDocumentTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceDocumentTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceDocumentTypeEdge = {
  __typename?: 'DeviceDocumentTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceDocumentType>;
};

export enum DeviceDocumentTypeField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceDocumentType connections */
export type DeviceDocumentTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceDocumentTypes. */
  field: DeviceDocumentTypeOrderField;
};

/** Properties by which DeviceDocumentType connections can be ordered. */
export enum DeviceDocumentTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceDocumentTypeWhereInput is used for filtering DeviceDocumentType objects.
 * Input was generated by ent.
 */
export type DeviceDocumentTypeWhereInput = {
  and?: InputMaybe<Array<DeviceDocumentTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_document_type_documents edge predicates */
  hasDeviceDocumentTypeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceDocumentTypeDocumentsWith?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceDocumentTypeWhereInput>;
  or?: InputMaybe<Array<DeviceDocumentTypeWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * DeviceDocumentWhereInput is used for filtering DeviceDocument objects.
 * Input was generated by ent.
 */
export type DeviceDocumentWhereInput = {
  and?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_document_type_id field predicates */
  deviceDocumentTypeID?: InputMaybe<Scalars['ID']['input']>;
  deviceDocumentTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceDocumentTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceDocumentTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document_id field predicates */
  documentID?: InputMaybe<Scalars['ID']['input']>;
  documentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  documentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  documentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** expiry_date field predicates */
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  expiryDateGT?: InputMaybe<Scalars['Time']['input']>;
  expiryDateGTE?: InputMaybe<Scalars['Time']['input']>;
  expiryDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiryDateLT?: InputMaybe<Scalars['Time']['input']>;
  expiryDateLTE?: InputMaybe<Scalars['Time']['input']>;
  expiryDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiryDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_document_type edge predicates */
  hasDeviceDocumentType?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceDocumentTypeWith?: InputMaybe<Array<DeviceDocumentTypeWhereInput>>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceDocumentWhereInput>;
  or?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type DeviceEdge = {
  __typename?: 'DeviceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Device>;
};

export enum DeviceField {
  AssociatedSimId = 'associatedSimID',
  BoltLegacyId = 'boltLegacyID',
  CreatedAt = 'createdAt',
  DeviceCategoryId = 'deviceCategoryID',
  ExternalId = 'externalID',
  GroupId = 'groupID',
  Imei = 'imei',
  IngestServer = 'ingestServer',
  IsActive = 'isActive',
  IsMaintenance = 'isMaintenance',
  IsOnline = 'isOnline',
  LastPing = 'lastPing',
  MidnightTotalDistance = 'midnightTotalDistance',
  MidnightTotalEngineMs = 'midnightTotalEngineMs',
  ModelId = 'modelID',
  Name = 'name',
  OrganisationId = 'organisationID',
  RootOrganisationId = 'rootOrganisationID',
  SpeedLimitKmHr = 'speedLimitKmHr',
  UpdatedAt = 'updatedAt'
}

export type DeviceGroup = Node & {
  __typename?: 'DeviceGroup';
  createdAt: Scalars['Time']['output'];
  device?: Maybe<Device>;
  deviceGroupDocuments?: Maybe<Array<DeviceGroupDocument>>;
  deviceParkingModeConfigs?: Maybe<Array<DeviceParkingModeConfig>>;
  deviceSharings?: Maybe<Array<DeviceSharing>>;
  deviceVehicle?: Maybe<DeviceVehicle>;
  deviceacls?: Maybe<Array<DeviceAcl>>;
  devicegroupOrganisation: Organisation;
  devicegroupRootOrganisation: Organisation;
  devices?: Maybe<Array<Device>>;
  driverprofiles?: Maybe<Array<Profile>>;
  friendlyName: Scalars['String']['output'];
  geofenceDeviceGroups?: Maybe<Array<GeofenceDeviceGroup>>;
  groupType: DeviceGroupGroupType;
  id: Scalars['ID']['output'];
  inspectionReports?: Maybe<Array<InspectionReport>>;
  notifyConfigs?: Maybe<Array<NotifyConfig>>;
  organisationID: Scalars['ID']['output'];
  ownerAddress?: Maybe<Scalars['String']['output']>;
  ownerContactNumber?: Maybe<Scalars['String']['output']>;
  ownerFullName?: Maybe<Scalars['String']['output']>;
  ownerInstallationDate?: Maybe<Scalars['Time']['output']>;
  primaryTrackingDeviceID?: Maybe<Scalars['ID']['output']>;
  rootOrganisationID: Scalars['ID']['output'];
  shifts?: Maybe<Array<Shift>>;
  stiqrs?: Maybe<Array<StiQr>>;
  trips?: Maybe<Array<Trip>>;
  updatedAt: Scalars['Time']['output'];
  yardDriverTrips?: Maybe<Array<YardTrip>>;
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type DeviceGroupConnection = {
  __typename?: 'DeviceGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type DeviceGroupDocument = Node & {
  __typename?: 'DeviceGroupDocument';
  createdAt: Scalars['Time']['output'];
  deviceGroup: DeviceGroup;
  deviceGroupDocumentType: DeviceGroupDocumentType;
  deviceGroupDocumentTypeID: Scalars['ID']['output'];
  deviceGroupID: Scalars['ID']['output'];
  documentID?: Maybe<Scalars['ID']['output']>;
  expiryDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  mediafile?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceGroupDocumentConnection = {
  __typename?: 'DeviceGroupDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceGroupDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceGroupDocumentEdge = {
  __typename?: 'DeviceGroupDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceGroupDocument>;
};

export enum DeviceGroupDocumentField {
  CreatedAt = 'createdAt',
  DeviceGroupDocumentTypeId = 'deviceGroupDocumentTypeID',
  DeviceGroupId = 'deviceGroupID',
  DocumentId = 'documentID',
  ExpiryDate = 'expiryDate',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceGroupDocument connections */
export type DeviceGroupDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceGroupDocuments. */
  field: DeviceGroupDocumentOrderField;
};

/** Properties by which DeviceGroupDocument connections can be ordered. */
export enum DeviceGroupDocumentOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type DeviceGroupDocumentType = Node & {
  __typename?: 'DeviceGroupDocumentType';
  applicableGroupType: DeviceGroupDocumentTypeApplicableGroupType;
  createdAt: Scalars['Time']['output'];
  deviceGroupDocumentTypeDocuments?: Maybe<Array<DeviceGroupDocument>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** DeviceGroupDocumentTypeApplicableGroupType is enum for the field applicable_group_type */
export enum DeviceGroupDocumentTypeApplicableGroupType {
  Asset = 'Asset',
  Dashcam = 'Dashcam',
  Personal = 'Personal',
  Vehicle = 'Vehicle'
}

/** A connection to a list of items. */
export type DeviceGroupDocumentTypeConnection = {
  __typename?: 'DeviceGroupDocumentTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceGroupDocumentTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceGroupDocumentTypeEdge = {
  __typename?: 'DeviceGroupDocumentTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceGroupDocumentType>;
};

export enum DeviceGroupDocumentTypeField {
  ApplicableGroupType = 'applicableGroupType',
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceGroupDocumentType connections */
export type DeviceGroupDocumentTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceGroupDocumentTypes. */
  field: DeviceGroupDocumentTypeOrderField;
};

/** Properties by which DeviceGroupDocumentType connections can be ordered. */
export enum DeviceGroupDocumentTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceGroupDocumentTypeWhereInput is used for filtering DeviceGroupDocumentType objects.
 * Input was generated by ent.
 */
export type DeviceGroupDocumentTypeWhereInput = {
  and?: InputMaybe<Array<DeviceGroupDocumentTypeWhereInput>>;
  /** applicable_group_type field predicates */
  applicableGroupType?: InputMaybe<DeviceGroupDocumentTypeApplicableGroupType>;
  applicableGroupTypeIn?: InputMaybe<Array<DeviceGroupDocumentTypeApplicableGroupType>>;
  applicableGroupTypeNEQ?: InputMaybe<DeviceGroupDocumentTypeApplicableGroupType>;
  applicableGroupTypeNotIn?: InputMaybe<Array<DeviceGroupDocumentTypeApplicableGroupType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_group_document_type_documents edge predicates */
  hasDeviceGroupDocumentTypeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupDocumentTypeDocumentsWith?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceGroupDocumentTypeWhereInput>;
  or?: InputMaybe<Array<DeviceGroupDocumentTypeWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * DeviceGroupDocumentWhereInput is used for filtering DeviceGroupDocument objects.
 * Input was generated by ent.
 */
export type DeviceGroupDocumentWhereInput = {
  and?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_group_document_type_id field predicates */
  deviceGroupDocumentTypeID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupDocumentTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupDocumentTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupDocumentTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_group_id field predicates */
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** document_id field predicates */
  documentID?: InputMaybe<Scalars['ID']['input']>;
  documentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  documentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  documentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** expiry_date field predicates */
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  expiryDateGT?: InputMaybe<Scalars['Time']['input']>;
  expiryDateGTE?: InputMaybe<Scalars['Time']['input']>;
  expiryDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiryDateLT?: InputMaybe<Scalars['Time']['input']>;
  expiryDateLTE?: InputMaybe<Scalars['Time']['input']>;
  expiryDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiryDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_group_document_type edge predicates */
  hasDeviceGroupDocumentType?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupDocumentTypeWith?: InputMaybe<Array<DeviceGroupDocumentTypeWhereInput>>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceGroupDocumentWhereInput>;
  or?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type DeviceGroupEdge = {
  __typename?: 'DeviceGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceGroup>;
};

export enum DeviceGroupField {
  CreatedAt = 'createdAt',
  FriendlyName = 'friendlyName',
  GroupType = 'groupType',
  OrganisationId = 'organisationID',
  OwnerAddress = 'ownerAddress',
  OwnerContactNumber = 'ownerContactNumber',
  OwnerFullName = 'ownerFullName',
  OwnerInstallationDate = 'ownerInstallationDate',
  PrimaryTrackingDeviceId = 'primaryTrackingDeviceID',
  RootOrganisationId = 'rootOrganisationID',
  UpdatedAt = 'updatedAt'
}

/** DeviceGroupGroupType is enum for the field group_type */
export enum DeviceGroupGroupType {
  Asset = 'Asset',
  Dashcam = 'Dashcam',
  Personal = 'Personal',
  Vehicle = 'Vehicle',
  A = 'a',
  D = 'd',
  P = 'p',
  V = 'v'
}

/** Ordering options for DeviceGroup connections */
export type DeviceGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceGroups. */
  field: DeviceGroupOrderField;
};

/** Properties by which DeviceGroup connections can be ordered. */
export enum DeviceGroupOrderField {
  FriendlyName = 'FRIENDLY_NAME',
  OwnerAddress = 'OWNER_ADDRESS',
  OwnerContactNumber = 'OWNER_CONTACT_NUMBER',
  OwnerFullName = 'OWNER_FULL_NAME',
  OwnerInstallationDate = 'OWNER_INSTALLATION_DATE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceGroupWhereInput is used for filtering DeviceGroup objects.
 * Input was generated by ent.
 */
export type DeviceGroupWhereInput = {
  and?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** friendly_name field predicates */
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  friendlyNameContains?: InputMaybe<Scalars['String']['input']>;
  friendlyNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  friendlyNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  friendlyNameGT?: InputMaybe<Scalars['String']['input']>;
  friendlyNameGTE?: InputMaybe<Scalars['String']['input']>;
  friendlyNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  friendlyNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  friendlyNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  friendlyNameLT?: InputMaybe<Scalars['String']['input']>;
  friendlyNameLTE?: InputMaybe<Scalars['String']['input']>;
  friendlyNameNEQ?: InputMaybe<Scalars['String']['input']>;
  friendlyNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** group_type field predicates */
  groupType?: InputMaybe<DeviceGroupGroupType>;
  groupTypeIn?: InputMaybe<Array<DeviceGroupGroupType>>;
  groupTypeNEQ?: InputMaybe<DeviceGroupGroupType>;
  groupTypeNotIn?: InputMaybe<Array<DeviceGroupGroupType>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_group_documents edge predicates */
  hasDeviceGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupDocumentsWith?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** device_parking_mode_configs edge predicates */
  hasDeviceParkingModeConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceParkingModeConfigsWith?: InputMaybe<Array<DeviceParkingModeConfigWhereInput>>;
  /** device_sharings edge predicates */
  hasDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceSharingsWith?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** device_vehicle edge predicates */
  hasDeviceVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceVehicleWith?: InputMaybe<Array<DeviceVehicleWhereInput>>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** deviceacls edge predicates */
  hasDeviceacls?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceaclsWith?: InputMaybe<Array<DeviceAclWhereInput>>;
  /** devicegroup_organisation edge predicates */
  hasDevicegroupOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** devicegroup_root_organisation edge predicates */
  hasDevicegroupRootOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupRootOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** driverprofiles edge predicates */
  hasDriverprofiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasDriverprofilesWith?: InputMaybe<Array<ProfileWhereInput>>;
  /** geofence_device_groups edge predicates */
  hasGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceDeviceGroupsWith?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** inspection_reports edge predicates */
  hasInspectionReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasInspectionReportsWith?: InputMaybe<Array<InspectionReportWhereInput>>;
  /** notify_configs edge predicates */
  hasNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigsWith?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** shifts edge predicates */
  hasShifts?: InputMaybe<Scalars['Boolean']['input']>;
  hasShiftsWith?: InputMaybe<Array<ShiftWhereInput>>;
  /** stiqrs edge predicates */
  hasStiqrs?: InputMaybe<Scalars['Boolean']['input']>;
  hasStiqrsWith?: InputMaybe<Array<StiQrWhereInput>>;
  /** trips edge predicates */
  hasTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripsWith?: InputMaybe<Array<TripWhereInput>>;
  /** yard_driver_trips edge predicates */
  hasYardDriverTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardDriverTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceGroupWhereInput>;
  or?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** owner_address field predicates */
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerAddressContains?: InputMaybe<Scalars['String']['input']>;
  ownerAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  ownerAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  ownerAddressGT?: InputMaybe<Scalars['String']['input']>;
  ownerAddressGTE?: InputMaybe<Scalars['String']['input']>;
  ownerAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ownerAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ownerAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerAddressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerAddressLT?: InputMaybe<Scalars['String']['input']>;
  ownerAddressLTE?: InputMaybe<Scalars['String']['input']>;
  ownerAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  ownerAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerAddressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owner_contact_number field predicates */
  ownerContactNumber?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberContains?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberGT?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberGTE?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerContactNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerContactNumberLT?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberLTE?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerContactNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owner_full_name field predicates */
  ownerFullName?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameContains?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameGT?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameGTE?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerFullNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerFullNameLT?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameLTE?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameNEQ?: InputMaybe<Scalars['String']['input']>;
  ownerFullNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerFullNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** owner_installation_date field predicates */
  ownerInstallationDate?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateGT?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  ownerInstallationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerInstallationDateLT?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  ownerInstallationDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  ownerInstallationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** primary_tracking_device_id field predicates */
  primaryTrackingDeviceID?: InputMaybe<Scalars['ID']['input']>;
  primaryTrackingDeviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryTrackingDeviceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  primaryTrackingDeviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  primaryTrackingDeviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryTrackingDeviceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** root_organisation_id field predicates */
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** DeviceIngestServer is enum for the field ingest_server */
export enum DeviceIngestServer {
  Bolt = 'BOLT',
  Track = 'TRACK'
}

export type DeviceModel = Node & {
  __typename?: 'DeviceModel';
  commands?: Maybe<Array<DeviceCommand>>;
  createdAt: Scalars['Time']['output'];
  devicemodelchannels?: Maybe<Array<DeviceModelChannel>>;
  devices?: Maybe<Array<Device>>;
  id: Scalars['ID']['output'];
  isAssetTracker: Scalars['Boolean']['output'];
  isDashcam: Scalars['Boolean']['output'];
  isPersonalTracker: Scalars['Boolean']['output'];
  isVehicleTracker: Scalars['Boolean']['output'];
  isWireless: Scalars['Boolean']['output'];
  manufacturer: Scalars['String']['output'];
  mediaFiles?: Maybe<Array<MediaFile>>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type DeviceModelChannel = Node & {
  __typename?: 'DeviceModelChannel';
  channelName: Scalars['String']['output'];
  channelType: DeviceModelChannelChannelType;
  createdAt: Scalars['Time']['output'];
  deviceModel: DeviceModel;
  deviceModelID: Scalars['ID']['output'];
  devicechannelconfigs?: Maybe<Array<DeviceChannelConfig>>;
  id: Scalars['ID']['output'];
  isBuiltin: Scalars['Boolean']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** DeviceModelChannelChannelType is enum for the field channel_type */
export enum DeviceModelChannelChannelType {
  Analog = 'Analog',
  Digital = 'Digital',
  A = 'a',
  D = 'd'
}

/** A connection to a list of items. */
export type DeviceModelChannelConnection = {
  __typename?: 'DeviceModelChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceModelChannelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceModelChannelEdge = {
  __typename?: 'DeviceModelChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceModelChannel>;
};

export enum DeviceModelChannelField {
  ChannelName = 'channelName',
  ChannelType = 'channelType',
  CreatedAt = 'createdAt',
  DeviceModelId = 'deviceModelID',
  IsBuiltin = 'isBuiltin',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceModelChannel connections */
export type DeviceModelChannelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceModelChannels. */
  field: DeviceModelChannelOrderField;
};

/** Properties by which DeviceModelChannel connections can be ordered. */
export enum DeviceModelChannelOrderField {
  ChannelName = 'CHANNEL_NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceModelChannelWhereInput is used for filtering DeviceModelChannel objects.
 * Input was generated by ent.
 */
export type DeviceModelChannelWhereInput = {
  and?: InputMaybe<Array<DeviceModelChannelWhereInput>>;
  /** channel_name field predicates */
  channelName?: InputMaybe<Scalars['String']['input']>;
  channelNameContains?: InputMaybe<Scalars['String']['input']>;
  channelNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  channelNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  channelNameGT?: InputMaybe<Scalars['String']['input']>;
  channelNameGTE?: InputMaybe<Scalars['String']['input']>;
  channelNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  channelNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  channelNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  channelNameLT?: InputMaybe<Scalars['String']['input']>;
  channelNameLTE?: InputMaybe<Scalars['String']['input']>;
  channelNameNEQ?: InputMaybe<Scalars['String']['input']>;
  channelNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** channel_type field predicates */
  channelType?: InputMaybe<DeviceModelChannelChannelType>;
  channelTypeIn?: InputMaybe<Array<DeviceModelChannelChannelType>>;
  channelTypeNEQ?: InputMaybe<DeviceModelChannelChannelType>;
  channelTypeNotIn?: InputMaybe<Array<DeviceModelChannelChannelType>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_model_id field predicates */
  deviceModelID?: InputMaybe<Scalars['ID']['input']>;
  deviceModelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceModelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceModelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_model edge predicates */
  hasDeviceModel?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceModelWith?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** devicechannelconfigs edge predicates */
  hasDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicechannelconfigsWith?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_builtin field predicates */
  isBuiltin?: InputMaybe<Scalars['Boolean']['input']>;
  isBuiltinNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DeviceModelChannelWhereInput>;
  or?: InputMaybe<Array<DeviceModelChannelWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type DeviceModelConnection = {
  __typename?: 'DeviceModelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceModelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceModelEdge = {
  __typename?: 'DeviceModelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceModel>;
};

export enum DeviceModelField {
  CreatedAt = 'createdAt',
  IsAssetTracker = 'isAssetTracker',
  IsDashcam = 'isDashcam',
  IsPersonalTracker = 'isPersonalTracker',
  IsVehicleTracker = 'isVehicleTracker',
  IsWireless = 'isWireless',
  Manufacturer = 'manufacturer',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceModel connections */
export type DeviceModelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceModels. */
  field: DeviceModelOrderField;
};

/** Properties by which DeviceModel connections can be ordered. */
export enum DeviceModelOrderField {
  Manufacturer = 'MANUFACTURER',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceModelWhereInput is used for filtering DeviceModel objects.
 * Input was generated by ent.
 */
export type DeviceModelWhereInput = {
  and?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** commands edge predicates */
  hasCommands?: InputMaybe<Scalars['Boolean']['input']>;
  hasCommandsWith?: InputMaybe<Array<DeviceCommandWhereInput>>;
  /** devicemodelchannels edge predicates */
  hasDevicemodelchannels?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicemodelchannelsWith?: InputMaybe<Array<DeviceModelChannelWhereInput>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** media_files edge predicates */
  hasMediaFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediaFilesWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_asset_tracker field predicates */
  isAssetTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isAssetTrackerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_dashcam field predicates */
  isDashcam?: InputMaybe<Scalars['Boolean']['input']>;
  isDashcamNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_personal_tracker field predicates */
  isPersonalTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalTrackerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_vehicle_tracker field predicates */
  isVehicleTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isVehicleTrackerNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_wireless field predicates */
  isWireless?: InputMaybe<Scalars['Boolean']['input']>;
  isWirelessNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** manufacturer field predicates */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerContains?: InputMaybe<Scalars['String']['input']>;
  manufacturerContainsFold?: InputMaybe<Scalars['String']['input']>;
  manufacturerEqualFold?: InputMaybe<Scalars['String']['input']>;
  manufacturerGT?: InputMaybe<Scalars['String']['input']>;
  manufacturerGTE?: InputMaybe<Scalars['String']['input']>;
  manufacturerHasPrefix?: InputMaybe<Scalars['String']['input']>;
  manufacturerHasSuffix?: InputMaybe<Scalars['String']['input']>;
  manufacturerIn?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerLT?: InputMaybe<Scalars['String']['input']>;
  manufacturerLTE?: InputMaybe<Scalars['String']['input']>;
  manufacturerNEQ?: InputMaybe<Scalars['String']['input']>;
  manufacturerNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceModelWhereInput>;
  or?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Ordering options for Device connections */
export type DeviceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Devices. */
  field: DeviceOrderField;
};

/** Properties by which Device connections can be ordered. */
export enum DeviceOrderField {
  Imei = 'IMEI',
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type DeviceParkingModeConfig = Node & {
  __typename?: 'DeviceParkingModeConfig';
  createdAt: Scalars['Time']['output'];
  deviceGroup: DeviceGroup;
  deviceGroupID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  parkingMode: Scalars['Boolean']['output'];
  parkingSchedule: Scalars['Boolean']['output'];
  parkingScheduleDays?: Maybe<Array<Scalars['String']['output']>>;
  parkingScheduleEndUtc?: Maybe<Scalars['Time']['output']>;
  parkingScheduleStartUtc?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceParkingModeConfigConnection = {
  __typename?: 'DeviceParkingModeConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceParkingModeConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceParkingModeConfigEdge = {
  __typename?: 'DeviceParkingModeConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceParkingModeConfig>;
};

export enum DeviceParkingModeConfigField {
  CreatedAt = 'createdAt',
  DeviceGroupId = 'deviceGroupID',
  ParkingMode = 'parkingMode',
  ParkingSchedule = 'parkingSchedule',
  ParkingScheduleDays = 'parkingScheduleDays',
  ParkingScheduleEndUtc = 'parkingScheduleEndUtc',
  ParkingScheduleStartUtc = 'parkingScheduleStartUtc',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceParkingModeConfig connections */
export type DeviceParkingModeConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceParkingModeConfigs. */
  field: DeviceParkingModeConfigOrderField;
};

/** Properties by which DeviceParkingModeConfig connections can be ordered. */
export enum DeviceParkingModeConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DeviceParkingModeConfigWhereInput is used for filtering DeviceParkingModeConfig objects.
 * Input was generated by ent.
 */
export type DeviceParkingModeConfigWhereInput = {
  and?: InputMaybe<Array<DeviceParkingModeConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_group_id field predicates */
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DeviceParkingModeConfigWhereInput>;
  or?: InputMaybe<Array<DeviceParkingModeConfigWhereInput>>;
  /** parking_mode field predicates */
  parkingMode?: InputMaybe<Scalars['Boolean']['input']>;
  parkingModeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_schedule field predicates */
  parkingSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_schedule_end_utc field predicates */
  parkingScheduleEndUtc?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcGT?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcGTE?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingScheduleEndUtcIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleEndUtcLT?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcLTE?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcNEQ?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleEndUtcNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingScheduleEndUtcNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_schedule_start_utc field predicates */
  parkingScheduleStartUtc?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcGT?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcGTE?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingScheduleStartUtcIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleStartUtcLT?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcLTE?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcNEQ?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtcNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingScheduleStartUtcNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DevicePlaybackFiles = Node & {
  __typename?: 'DevicePlaybackFiles';
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceID: Scalars['ID']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  fileJSON?: Maybe<Array<Scalars['String']['output']>>;
  files?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DevicePlaybackFilesConnection = {
  __typename?: 'DevicePlaybackFilesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DevicePlaybackFilesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DevicePlaybackFilesEdge = {
  __typename?: 'DevicePlaybackFilesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DevicePlaybackFiles>;
};

export enum DevicePlaybackFilesField {
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  DeviceType = 'deviceType',
  FileJson = 'fileJSON',
  Files = 'files',
  Imei = 'imei',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DevicePlaybackFiles connections */
export type DevicePlaybackFilesOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DevicePlaybackFilesSlice. */
  field: DevicePlaybackFilesOrderField;
};

/** Properties by which DevicePlaybackFiles connections can be ordered. */
export enum DevicePlaybackFilesOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * DevicePlaybackFilesWhereInput is used for filtering DevicePlaybackFiles objects.
 * Input was generated by ent.
 */
export type DevicePlaybackFilesWhereInput = {
  and?: InputMaybe<Array<DevicePlaybackFilesWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_type field predicates */
  deviceType?: InputMaybe<Scalars['String']['input']>;
  deviceTypeContains?: InputMaybe<Scalars['String']['input']>;
  deviceTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  deviceTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  deviceTypeGT?: InputMaybe<Scalars['String']['input']>;
  deviceTypeGTE?: InputMaybe<Scalars['String']['input']>;
  deviceTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deviceTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deviceTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deviceTypeLT?: InputMaybe<Scalars['String']['input']>;
  deviceTypeLTE?: InputMaybe<Scalars['String']['input']>;
  deviceTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  deviceTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** files field predicates */
  files?: InputMaybe<Scalars['String']['input']>;
  filesContains?: InputMaybe<Scalars['String']['input']>;
  filesContainsFold?: InputMaybe<Scalars['String']['input']>;
  filesEqualFold?: InputMaybe<Scalars['String']['input']>;
  filesGT?: InputMaybe<Scalars['String']['input']>;
  filesGTE?: InputMaybe<Scalars['String']['input']>;
  filesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  filesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  filesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  filesLT?: InputMaybe<Scalars['String']['input']>;
  filesLTE?: InputMaybe<Scalars['String']['input']>;
  filesNEQ?: InputMaybe<Scalars['String']['input']>;
  filesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** imei field predicates */
  imei?: InputMaybe<Scalars['String']['input']>;
  imeiContains?: InputMaybe<Scalars['String']['input']>;
  imeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  imeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  imeiGT?: InputMaybe<Scalars['String']['input']>;
  imeiGTE?: InputMaybe<Scalars['String']['input']>;
  imeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  imeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  imeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imeiIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  imeiLT?: InputMaybe<Scalars['String']['input']>;
  imeiLTE?: InputMaybe<Scalars['String']['input']>;
  imeiNEQ?: InputMaybe<Scalars['String']['input']>;
  imeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imeiNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DevicePlaybackFilesWhereInput>;
  or?: InputMaybe<Array<DevicePlaybackFilesWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type DeviceSharing = Node & {
  __typename?: 'DeviceSharing';
  createdAt: Scalars['Time']['output'];
  deviceGroups?: Maybe<Array<DeviceGroup>>;
  expiresOn?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  organisationUser: User;
  shareType: DeviceSharingShareType;
  sharedbyID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type DeviceSharingConnection = {
  __typename?: 'DeviceSharingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceSharingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceSharingEdge = {
  __typename?: 'DeviceSharingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceSharing>;
};

export enum DeviceSharingField {
  CreatedAt = 'createdAt',
  ExpiresOn = 'expiresOn',
  IsActive = 'isActive',
  OrganisationId = 'organisationID',
  ShareType = 'shareType',
  SharedbyId = 'sharedbyID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for DeviceSharing connections */
export type DeviceSharingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceSharings. */
  field: DeviceSharingOrderField;
};

/** Properties by which DeviceSharing connections can be ordered. */
export enum DeviceSharingOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DeviceSharingShareType is enum for the field share_type */
export enum DeviceSharingShareType {
  Brief = 'Brief',
  Detailed = 'Detailed'
}

/**
 * DeviceSharingWhereInput is used for filtering DeviceSharing objects.
 * Input was generated by ent.
 */
export type DeviceSharingWhereInput = {
  and?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** expires_on field predicates */
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  expiresOnGT?: InputMaybe<Scalars['Time']['input']>;
  expiresOnGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresOnIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresOnLT?: InputMaybe<Scalars['Time']['input']>;
  expiresOnLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresOnNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresOnNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_groups edge predicates */
  hasDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_user edge predicates */
  hasOrganisationUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationUserWith?: InputMaybe<Array<UserWhereInput>>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DeviceSharingWhereInput>;
  or?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** share_type field predicates */
  shareType?: InputMaybe<DeviceSharingShareType>;
  shareTypeIn?: InputMaybe<Array<DeviceSharingShareType>>;
  shareTypeNEQ?: InputMaybe<DeviceSharingShareType>;
  shareTypeNotIn?: InputMaybe<Array<DeviceSharingShareType>>;
  /** sharedby_id field predicates */
  sharedbyID?: InputMaybe<Scalars['ID']['input']>;
  sharedbyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharedbyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sharedbyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export enum DeviceStatus {
  Idle = 'idle',
  IgnitionOff = 'ignitionOff',
  IgnitionOn = 'ignitionOn',
  Inactive = 'inactive'
}

export type DeviceTodayStatsResponse = {
  __typename?: 'DeviceTodayStatsResponse';
  averageSpeed: Scalars['Float']['output'];
  currentTripDistance: Scalars['Float']['output'];
  currentTripEndTime?: Maybe<Scalars['Time']['output']>;
  currentTripStartTime?: Maybe<Scalars['Time']['output']>;
  distance: Scalars['Float']['output'];
  idleSeconds: Scalars['Int']['output'];
  ignitionSeconds: Scalars['Int']['output'];
  isStopped: Scalars['Boolean']['output'];
  lastTripDistance: Scalars['Float']['output'];
  lastTripEndTime?: Maybe<Scalars['Time']['output']>;
  lastTripStartTime?: Maybe<Scalars['Time']['output']>;
  maxSpeed: Scalars['Float']['output'];
  motionSeconds: Scalars['Int']['output'];
  pastDataReceived: Scalars['Boolean']['output'];
  secondEngineSeconds: Scalars['Int']['output'];
  stoppedSince: Scalars['Time']['output'];
  stopsCount: Scalars['Int']['output'];
  tripsCount: Scalars['Int']['output'];
};

export type DeviceVehicle = Node & {
  __typename?: 'DeviceVehicle';
  chassisNo?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  dealer?: Maybe<Scalars['String']['output']>;
  deviceGroup: DeviceGroup;
  groupID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  insuranceCompany?: Maybe<Scalars['String']['output']>;
  insuranceEndDate?: Maybe<Scalars['Time']['output']>;
  insurancePremium?: Maybe<Scalars['String']['output']>;
  insuranceStartDate?: Maybe<Scalars['Time']['output']>;
  oem?: Maybe<Scalars['String']['output']>;
  registeredRto?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  vehicleNumber: Scalars['String']['output'];
  vehicleType: DeviceVehicleVehicleType;
  warranty?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type DeviceVehicleConnection = {
  __typename?: 'DeviceVehicleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeviceVehicleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceVehicleEdge = {
  __typename?: 'DeviceVehicleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeviceVehicle>;
};

export enum DeviceVehicleField {
  ChassisNo = 'chassisNo',
  Country = 'country',
  CreatedAt = 'createdAt',
  Dealer = 'dealer',
  GroupId = 'groupID',
  InsuranceCompany = 'insuranceCompany',
  InsuranceEndDate = 'insuranceEndDate',
  InsurancePremium = 'insurancePremium',
  InsuranceStartDate = 'insuranceStartDate',
  Oem = 'oem',
  RegisteredRto = 'registeredRto',
  State = 'state',
  UpdatedAt = 'updatedAt',
  VehicleNumber = 'vehicleNumber',
  VehicleType = 'vehicleType',
  Warranty = 'warranty'
}

/** Ordering options for DeviceVehicle connections */
export type DeviceVehicleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order DeviceVehicles. */
  field: DeviceVehicleOrderField;
};

/** Properties by which DeviceVehicle connections can be ordered. */
export enum DeviceVehicleOrderField {
  VehicleNumber = 'VEHICLE_NUMBER',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DeviceVehicleVehicleType is enum for the field vehicle_type */
export enum DeviceVehicleVehicleType {
  Ev = 'EV',
  NonEv = 'NonEV'
}

/**
 * DeviceVehicleWhereInput is used for filtering DeviceVehicle objects.
 * Input was generated by ent.
 */
export type DeviceVehicleWhereInput = {
  and?: InputMaybe<Array<DeviceVehicleWhereInput>>;
  /** chassis_no field predicates */
  chassisNo?: InputMaybe<Scalars['String']['input']>;
  chassisNoContains?: InputMaybe<Scalars['String']['input']>;
  chassisNoContainsFold?: InputMaybe<Scalars['String']['input']>;
  chassisNoEqualFold?: InputMaybe<Scalars['String']['input']>;
  chassisNoGT?: InputMaybe<Scalars['String']['input']>;
  chassisNoGTE?: InputMaybe<Scalars['String']['input']>;
  chassisNoHasPrefix?: InputMaybe<Scalars['String']['input']>;
  chassisNoHasSuffix?: InputMaybe<Scalars['String']['input']>;
  chassisNoIn?: InputMaybe<Array<Scalars['String']['input']>>;
  chassisNoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  chassisNoLT?: InputMaybe<Scalars['String']['input']>;
  chassisNoLTE?: InputMaybe<Scalars['String']['input']>;
  chassisNoNEQ?: InputMaybe<Scalars['String']['input']>;
  chassisNoNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  chassisNoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** country field predicates */
  country?: InputMaybe<Scalars['String']['input']>;
  countryContains?: InputMaybe<Scalars['String']['input']>;
  countryContainsFold?: InputMaybe<Scalars['String']['input']>;
  countryEqualFold?: InputMaybe<Scalars['String']['input']>;
  countryGT?: InputMaybe<Scalars['String']['input']>;
  countryGTE?: InputMaybe<Scalars['String']['input']>;
  countryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  countryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  countryLT?: InputMaybe<Scalars['String']['input']>;
  countryLTE?: InputMaybe<Scalars['String']['input']>;
  countryNEQ?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dealer field predicates */
  dealer?: InputMaybe<Scalars['String']['input']>;
  dealerContains?: InputMaybe<Scalars['String']['input']>;
  dealerContainsFold?: InputMaybe<Scalars['String']['input']>;
  dealerEqualFold?: InputMaybe<Scalars['String']['input']>;
  dealerGT?: InputMaybe<Scalars['String']['input']>;
  dealerGTE?: InputMaybe<Scalars['String']['input']>;
  dealerHasPrefix?: InputMaybe<Scalars['String']['input']>;
  dealerHasSuffix?: InputMaybe<Scalars['String']['input']>;
  dealerIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dealerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dealerLT?: InputMaybe<Scalars['String']['input']>;
  dealerLTE?: InputMaybe<Scalars['String']['input']>;
  dealerNEQ?: InputMaybe<Scalars['String']['input']>;
  dealerNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dealerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group_id field predicates */
  groupID?: InputMaybe<Scalars['ID']['input']>;
  groupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  groupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** insurance_company field predicates */
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyContains?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyContainsFold?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyEqualFold?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyGT?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyGTE?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  insuranceCompanyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceCompanyLT?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyLTE?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyNEQ?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  insuranceCompanyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** insurance_end_date field predicates */
  insuranceEndDate?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateGT?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateGTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceEndDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceEndDateLT?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateLTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  insuranceEndDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceEndDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** insurance_premium field predicates */
  insurancePremium?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumContains?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumContainsFold?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumEqualFold?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumGT?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumGTE?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumHasPrefix?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumHasSuffix?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumIn?: InputMaybe<Array<Scalars['String']['input']>>;
  insurancePremiumIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insurancePremiumLT?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumLTE?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumNEQ?: InputMaybe<Scalars['String']['input']>;
  insurancePremiumNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  insurancePremiumNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** insurance_start_date field predicates */
  insuranceStartDate?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateGT?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateGTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceStartDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceStartDateLT?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateLTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  insuranceStartDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceStartDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<DeviceVehicleWhereInput>;
  /** oem field predicates */
  oem?: InputMaybe<Scalars['String']['input']>;
  oemContains?: InputMaybe<Scalars['String']['input']>;
  oemContainsFold?: InputMaybe<Scalars['String']['input']>;
  oemEqualFold?: InputMaybe<Scalars['String']['input']>;
  oemGT?: InputMaybe<Scalars['String']['input']>;
  oemGTE?: InputMaybe<Scalars['String']['input']>;
  oemHasPrefix?: InputMaybe<Scalars['String']['input']>;
  oemHasSuffix?: InputMaybe<Scalars['String']['input']>;
  oemIn?: InputMaybe<Array<Scalars['String']['input']>>;
  oemIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  oemLT?: InputMaybe<Scalars['String']['input']>;
  oemLTE?: InputMaybe<Scalars['String']['input']>;
  oemNEQ?: InputMaybe<Scalars['String']['input']>;
  oemNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  oemNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<DeviceVehicleWhereInput>>;
  /** registered_rto field predicates */
  registeredRto?: InputMaybe<Scalars['String']['input']>;
  registeredRtoContains?: InputMaybe<Scalars['String']['input']>;
  registeredRtoContainsFold?: InputMaybe<Scalars['String']['input']>;
  registeredRtoEqualFold?: InputMaybe<Scalars['String']['input']>;
  registeredRtoGT?: InputMaybe<Scalars['String']['input']>;
  registeredRtoGTE?: InputMaybe<Scalars['String']['input']>;
  registeredRtoHasPrefix?: InputMaybe<Scalars['String']['input']>;
  registeredRtoHasSuffix?: InputMaybe<Scalars['String']['input']>;
  registeredRtoIn?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredRtoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  registeredRtoLT?: InputMaybe<Scalars['String']['input']>;
  registeredRtoLTE?: InputMaybe<Scalars['String']['input']>;
  registeredRtoNEQ?: InputMaybe<Scalars['String']['input']>;
  registeredRtoNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredRtoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state field predicates */
  state?: InputMaybe<Scalars['String']['input']>;
  stateContains?: InputMaybe<Scalars['String']['input']>;
  stateContainsFold?: InputMaybe<Scalars['String']['input']>;
  stateEqualFold?: InputMaybe<Scalars['String']['input']>;
  stateGT?: InputMaybe<Scalars['String']['input']>;
  stateGTE?: InputMaybe<Scalars['String']['input']>;
  stateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  stateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateLT?: InputMaybe<Scalars['String']['input']>;
  stateLTE?: InputMaybe<Scalars['String']['input']>;
  stateNEQ?: InputMaybe<Scalars['String']['input']>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_number field predicates */
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberContains?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberGT?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberGTE?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleNumberLT?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberLTE?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** vehicle_type field predicates */
  vehicleType?: InputMaybe<DeviceVehicleVehicleType>;
  vehicleTypeIn?: InputMaybe<Array<DeviceVehicleVehicleType>>;
  vehicleTypeNEQ?: InputMaybe<DeviceVehicleVehicleType>;
  vehicleTypeNotIn?: InputMaybe<Array<DeviceVehicleVehicleType>>;
  /** warranty field predicates */
  warranty?: InputMaybe<Scalars['String']['input']>;
  warrantyContains?: InputMaybe<Scalars['String']['input']>;
  warrantyContainsFold?: InputMaybe<Scalars['String']['input']>;
  warrantyEqualFold?: InputMaybe<Scalars['String']['input']>;
  warrantyGT?: InputMaybe<Scalars['String']['input']>;
  warrantyGTE?: InputMaybe<Scalars['String']['input']>;
  warrantyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  warrantyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  warrantyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  warrantyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warrantyLT?: InputMaybe<Scalars['String']['input']>;
  warrantyLTE?: InputMaybe<Scalars['String']['input']>;
  warrantyNEQ?: InputMaybe<Scalars['String']['input']>;
  warrantyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  warrantyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * DeviceWhereInput is used for filtering Device objects.
 * Input was generated by ent.
 */
export type DeviceWhereInput = {
  and?: InputMaybe<Array<DeviceWhereInput>>;
  /** associated_sim_id field predicates */
  associatedSimID?: InputMaybe<Scalars['ID']['input']>;
  associatedSimIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  associatedSimIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  associatedSimIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** bolt_legacy_id field predicates */
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContains?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  boltLegacyIDLT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDLTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_category_id field predicates */
  deviceCategoryID?: InputMaybe<Scalars['ID']['input']>;
  deviceCategoryIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceCategoryIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceCategoryIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group_id field predicates */
  groupID?: InputMaybe<Scalars['ID']['input']>;
  groupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  groupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  groupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_action_logs edge predicates */
  hasDeviceActionLogs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceActionLogsWith?: InputMaybe<Array<DeviceActionLogWhereInput>>;
  /** device_configs edge predicates */
  hasDeviceConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceConfigsWith?: InputMaybe<Array<DeviceConfigWhereInput>>;
  /** device_documents edge predicates */
  hasDeviceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceDocumentsWith?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** device_playback_files edge predicates */
  hasDevicePlaybackFiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicePlaybackFilesWith?: InputMaybe<Array<DevicePlaybackFilesWhereInput>>;
  /** deviceadvancedconfigs edge predicates */
  hasDeviceadvancedconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceadvancedconfigsWith?: InputMaybe<Array<DeviceAdvancedConfigWhereInput>>;
  /** devicecategory edge predicates */
  hasDevicecategory?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicecategoryWith?: InputMaybe<Array<DeviceCategoryWhereInput>>;
  /** devicechannelconfigs edge predicates */
  hasDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicechannelconfigsWith?: InputMaybe<Array<DeviceChannelConfigWhereInput>>;
  /** devicegroups edge predicates */
  hasDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** devicemodel edge predicates */
  hasDevicemodel?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicemodelWith?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** license edge predicates */
  hasLicense?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseWith?: InputMaybe<Array<LicenseWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** position_attribute_formulas edge predicates */
  hasPositionAttributeFormulas?: InputMaybe<Scalars['Boolean']['input']>;
  hasPositionAttributeFormulasWith?: InputMaybe<Array<PositionAttributeFormulaWhereInput>>;
  /** root_organisation edge predicates */
  hasRootOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasRootOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** sim edge predicates */
  hasSim?: InputMaybe<Scalars['Boolean']['input']>;
  hasSimWith?: InputMaybe<Array<SimWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** imei field predicates */
  imei?: InputMaybe<Scalars['String']['input']>;
  imeiContains?: InputMaybe<Scalars['String']['input']>;
  imeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  imeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  imeiGT?: InputMaybe<Scalars['String']['input']>;
  imeiGTE?: InputMaybe<Scalars['String']['input']>;
  imeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  imeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  imeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imeiLT?: InputMaybe<Scalars['String']['input']>;
  imeiLTE?: InputMaybe<Scalars['String']['input']>;
  imeiNEQ?: InputMaybe<Scalars['String']['input']>;
  imeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ingest_server field predicates */
  ingestServer?: InputMaybe<DeviceIngestServer>;
  ingestServerIn?: InputMaybe<Array<DeviceIngestServer>>;
  ingestServerNEQ?: InputMaybe<DeviceIngestServer>;
  ingestServerNotIn?: InputMaybe<Array<DeviceIngestServer>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_maintenance field predicates */
  isMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenanceNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_online field predicates */
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlineNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_ping field predicates */
  lastPing?: InputMaybe<Scalars['Time']['input']>;
  lastPingGT?: InputMaybe<Scalars['Time']['input']>;
  lastPingGTE?: InputMaybe<Scalars['Time']['input']>;
  lastPingIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastPingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastPingLT?: InputMaybe<Scalars['Time']['input']>;
  lastPingLTE?: InputMaybe<Scalars['Time']['input']>;
  lastPingNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastPingNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastPingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** midnight_total_distance field predicates */
  midnightTotalDistance?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalDistanceGT?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalDistanceGTE?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalDistanceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  midnightTotalDistanceLT?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalDistanceLTE?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalDistanceNEQ?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalDistanceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** midnight_total_engine_ms field predicates */
  midnightTotalEngineMs?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalEngineMsGT?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalEngineMsGTE?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalEngineMsIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  midnightTotalEngineMsLT?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalEngineMsLTE?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalEngineMsNEQ?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalEngineMsNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** model_id field predicates */
  modelID?: InputMaybe<Scalars['ID']['input']>;
  modelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  modelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  modelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<DeviceWhereInput>;
  or?: InputMaybe<Array<DeviceWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** root_organisation_id field predicates */
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** speed_limit_km_hr field predicates */
  speedLimitKmHr?: InputMaybe<Scalars['Float']['input']>;
  speedLimitKmHrGT?: InputMaybe<Scalars['Float']['input']>;
  speedLimitKmHrGTE?: InputMaybe<Scalars['Float']['input']>;
  speedLimitKmHrIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  speedLimitKmHrLT?: InputMaybe<Scalars['Float']['input']>;
  speedLimitKmHrLTE?: InputMaybe<Scalars['Float']['input']>;
  speedLimitKmHrNEQ?: InputMaybe<Scalars['Float']['input']>;
  speedLimitKmHrNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Domain = Node & {
  __typename?: 'Domain';
  alias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sslVerificationStatus: DomainSslVerificationStatus;
  updatedAt: Scalars['Time']['output'];
  verificationID?: Maybe<Scalars['String']['output']>;
  verificationLastChecked?: Maybe<Scalars['Time']['output']>;
  verificationStatus: DomainVerificationStatus;
  whitelabel: Whitelabel;
  whitelabelID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type DomainConnection = {
  __typename?: 'DomainConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DomainEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DomainEdge = {
  __typename?: 'DomainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Domain>;
};

export enum DomainField {
  Alias = 'alias',
  CreatedAt = 'createdAt',
  Domain = 'domain',
  SslVerificationStatus = 'sslVerificationStatus',
  UpdatedAt = 'updatedAt',
  VerificationId = 'verificationID',
  VerificationLastChecked = 'verificationLastChecked',
  VerificationStatus = 'verificationStatus',
  WhitelabelId = 'whitelabelID'
}

/** Ordering options for Domain connections */
export type DomainOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Domains. */
  field: DomainOrderField;
};

/** Properties by which Domain connections can be ordered. */
export enum DomainOrderField {
  Alias = 'ALIAS',
  Domain = 'DOMAIN',
  VerificationLastChecked = 'VERIFICATION_LAST_CHECKED',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** DomainSslVerificationStatus is enum for the field ssl_verification_status */
export enum DomainSslVerificationStatus {
  Active = 'Active',
  Pending = 'Pending',
  Provisioning = 'Provisioning',
  ProvisioningFailed = 'ProvisioningFailed',
  VerificationFailed = 'VerificationFailed',
  VerificationSuccess = 'VerificationSuccess',
  WaitingToVerify = 'WaitingToVerify'
}

/** DomainVerificationStatus is enum for the field verification_status */
export enum DomainVerificationStatus {
  Active = 'Active',
  Pending = 'Pending',
  Provisioning = 'Provisioning',
  ProvisioningFailed = 'ProvisioningFailed',
  VerificationFailed = 'VerificationFailed',
  VerificationSuccess = 'VerificationSuccess',
  WaitingToVerify = 'WaitingToVerify'
}

/**
 * DomainWhereInput is used for filtering Domain objects.
 * Input was generated by ent.
 */
export type DomainWhereInput = {
  /** alias field predicates */
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasContains?: InputMaybe<Scalars['String']['input']>;
  aliasContainsFold?: InputMaybe<Scalars['String']['input']>;
  aliasEqualFold?: InputMaybe<Scalars['String']['input']>;
  aliasGT?: InputMaybe<Scalars['String']['input']>;
  aliasGTE?: InputMaybe<Scalars['String']['input']>;
  aliasHasPrefix?: InputMaybe<Scalars['String']['input']>;
  aliasHasSuffix?: InputMaybe<Scalars['String']['input']>;
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  aliasLT?: InputMaybe<Scalars['String']['input']>;
  aliasLTE?: InputMaybe<Scalars['String']['input']>;
  aliasNEQ?: InputMaybe<Scalars['String']['input']>;
  aliasNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  aliasNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<DomainWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** domain field predicates */
  domain?: InputMaybe<Scalars['String']['input']>;
  domainContains?: InputMaybe<Scalars['String']['input']>;
  domainContainsFold?: InputMaybe<Scalars['String']['input']>;
  domainEqualFold?: InputMaybe<Scalars['String']['input']>;
  domainGT?: InputMaybe<Scalars['String']['input']>;
  domainGTE?: InputMaybe<Scalars['String']['input']>;
  domainHasPrefix?: InputMaybe<Scalars['String']['input']>;
  domainHasSuffix?: InputMaybe<Scalars['String']['input']>;
  domainIn?: InputMaybe<Array<Scalars['String']['input']>>;
  domainLT?: InputMaybe<Scalars['String']['input']>;
  domainLTE?: InputMaybe<Scalars['String']['input']>;
  domainNEQ?: InputMaybe<Scalars['String']['input']>;
  domainNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** whitelabel edge predicates */
  hasWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<DomainWhereInput>;
  or?: InputMaybe<Array<DomainWhereInput>>;
  /** ssl_verification_status field predicates */
  sslVerificationStatus?: InputMaybe<DomainSslVerificationStatus>;
  sslVerificationStatusIn?: InputMaybe<Array<DomainSslVerificationStatus>>;
  sslVerificationStatusNEQ?: InputMaybe<DomainSslVerificationStatus>;
  sslVerificationStatusNotIn?: InputMaybe<Array<DomainSslVerificationStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** verification_id field predicates */
  verificationID?: InputMaybe<Scalars['String']['input']>;
  verificationIDContains?: InputMaybe<Scalars['String']['input']>;
  verificationIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  verificationIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  verificationIDGT?: InputMaybe<Scalars['String']['input']>;
  verificationIDGTE?: InputMaybe<Scalars['String']['input']>;
  verificationIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  verificationIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  verificationIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  verificationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  verificationIDLT?: InputMaybe<Scalars['String']['input']>;
  verificationIDLTE?: InputMaybe<Scalars['String']['input']>;
  verificationIDNEQ?: InputMaybe<Scalars['String']['input']>;
  verificationIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  verificationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** verification_last_checked field predicates */
  verificationLastChecked?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedGT?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedGTE?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  verificationLastCheckedIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  verificationLastCheckedLT?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedLTE?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedNEQ?: InputMaybe<Scalars['Time']['input']>;
  verificationLastCheckedNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  verificationLastCheckedNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** verification_status field predicates */
  verificationStatus?: InputMaybe<DomainVerificationStatus>;
  verificationStatusIn?: InputMaybe<Array<DomainVerificationStatus>>;
  verificationStatusNEQ?: InputMaybe<DomainVerificationStatus>;
  verificationStatusNotIn?: InputMaybe<Array<DomainVerificationStatus>>;
  /** whitelabel_id field predicates */
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EventsResponse = {
  __typename?: 'EventsResponse';
  attributes?: Maybe<Scalars['JSON']['output']>;
  deviceId: Scalars['ID']['output'];
  eventName: Scalars['String']['output'];
  fixTime: Scalars['Time']['output'];
  geofenceName?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type Export = Node & {
  __typename?: 'Export';
  createdAt: Scalars['Time']['output'];
  exportData: Scalars['String']['output'];
  exportKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mediaID?: Maybe<Scalars['ID']['output']>;
  mediafile?: Maybe<MediaFile>;
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  status: ExportStatus;
  statusMsg?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type ExportConnection = {
  __typename?: 'ExportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExportEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ExportEdge = {
  __typename?: 'ExportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Export>;
};

export enum ExportField {
  CreatedAt = 'createdAt',
  ExportData = 'exportData',
  ExportKey = 'exportKey',
  MediaId = 'mediaID',
  OrganisationId = 'organisationID',
  Status = 'status',
  StatusMsg = 'statusMsg',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for Export connections */
export type ExportOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Exports. */
  field: ExportOrderField;
};

/** Properties by which Export connections can be ordered. */
export enum ExportOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** ExportStatus is enum for the field status */
export enum ExportStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Success = 'Success'
}

/**
 * ExportWhereInput is used for filtering Export objects.
 * Input was generated by ent.
 */
export type ExportWhereInput = {
  and?: InputMaybe<Array<ExportWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** export_data field predicates */
  exportData?: InputMaybe<Scalars['String']['input']>;
  exportDataContains?: InputMaybe<Scalars['String']['input']>;
  exportDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  exportDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  exportDataGT?: InputMaybe<Scalars['String']['input']>;
  exportDataGTE?: InputMaybe<Scalars['String']['input']>;
  exportDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  exportDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  exportDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  exportDataLT?: InputMaybe<Scalars['String']['input']>;
  exportDataLTE?: InputMaybe<Scalars['String']['input']>;
  exportDataNEQ?: InputMaybe<Scalars['String']['input']>;
  exportDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** export_key field predicates */
  exportKey?: InputMaybe<Scalars['String']['input']>;
  exportKeyContains?: InputMaybe<Scalars['String']['input']>;
  exportKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  exportKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  exportKeyGT?: InputMaybe<Scalars['String']['input']>;
  exportKeyGTE?: InputMaybe<Scalars['String']['input']>;
  exportKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  exportKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  exportKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  exportKeyLT?: InputMaybe<Scalars['String']['input']>;
  exportKeyLTE?: InputMaybe<Scalars['String']['input']>;
  exportKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  exportKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** media_id field predicates */
  mediaID?: InputMaybe<Scalars['ID']['input']>;
  mediaIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediaIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mediaIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  mediaIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediaIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ExportWhereInput>;
  or?: InputMaybe<Array<ExportWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<ExportStatus>;
  statusIn?: InputMaybe<Array<ExportStatus>>;
  /** status_msg field predicates */
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  statusMsgContains?: InputMaybe<Scalars['String']['input']>;
  statusMsgContainsFold?: InputMaybe<Scalars['String']['input']>;
  statusMsgEqualFold?: InputMaybe<Scalars['String']['input']>;
  statusMsgGT?: InputMaybe<Scalars['String']['input']>;
  statusMsgGTE?: InputMaybe<Scalars['String']['input']>;
  statusMsgHasPrefix?: InputMaybe<Scalars['String']['input']>;
  statusMsgHasSuffix?: InputMaybe<Scalars['String']['input']>;
  statusMsgIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusMsgIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusMsgLT?: InputMaybe<Scalars['String']['input']>;
  statusMsgLTE?: InputMaybe<Scalars['String']['input']>;
  statusMsgNEQ?: InputMaybe<Scalars['String']['input']>;
  statusMsgNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusMsgNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNEQ?: InputMaybe<ExportStatus>;
  statusNotIn?: InputMaybe<Array<ExportStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FirebasePrivateKey = Node & {
  __typename?: 'FirebasePrivateKey';
  authProviderX509CertURL: Scalars['String']['output'];
  authURI: Scalars['String']['output'];
  clientEmail: Scalars['String']['output'];
  clientID: Scalars['String']['output'];
  clientX509CertURL: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  privateKey: Scalars['String']['output'];
  privateKeyID: Scalars['String']['output'];
  projectID: Scalars['String']['output'];
  senderID?: Maybe<Scalars['String']['output']>;
  tokenURI: Scalars['String']['output'];
  type: Scalars['String']['output'];
  universeDomain: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type FirebasePrivateKeyConnection = {
  __typename?: 'FirebasePrivateKeyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FirebasePrivateKeyEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FirebasePrivateKeyEdge = {
  __typename?: 'FirebasePrivateKeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FirebasePrivateKey>;
};

export enum FirebasePrivateKeyField {
  AuthProviderX509CertUrl = 'authProviderX509CertURL',
  AuthUri = 'authURI',
  ClientEmail = 'clientEmail',
  ClientId = 'clientID',
  ClientX509CertUrl = 'clientX509CertURL',
  CreatedAt = 'createdAt',
  FileName = 'fileName',
  PrivateKey = 'privateKey',
  PrivateKeyId = 'privateKeyID',
  ProjectId = 'projectID',
  SenderId = 'senderID',
  TokenUri = 'tokenURI',
  Type = 'type',
  UniverseDomain = 'universeDomain',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for FirebasePrivateKey connections */
export type FirebasePrivateKeyOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FirebasePrivateKeys. */
  field: FirebasePrivateKeyOrderField;
};

/** Properties by which FirebasePrivateKey connections can be ordered. */
export enum FirebasePrivateKeyOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * FirebasePrivateKeyWhereInput is used for filtering FirebasePrivateKey objects.
 * Input was generated by ent.
 */
export type FirebasePrivateKeyWhereInput = {
  and?: InputMaybe<Array<FirebasePrivateKeyWhereInput>>;
  /** auth_provider_x509_cert_url field predicates */
  authProviderX509CertURL?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLContains?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLGT?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLGTE?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authProviderX509CertURLLT?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLLTE?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLNEQ?: InputMaybe<Scalars['String']['input']>;
  authProviderX509CertURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** auth_uri field predicates */
  authURI?: InputMaybe<Scalars['String']['input']>;
  authURIContains?: InputMaybe<Scalars['String']['input']>;
  authURIContainsFold?: InputMaybe<Scalars['String']['input']>;
  authURIEqualFold?: InputMaybe<Scalars['String']['input']>;
  authURIGT?: InputMaybe<Scalars['String']['input']>;
  authURIGTE?: InputMaybe<Scalars['String']['input']>;
  authURIHasPrefix?: InputMaybe<Scalars['String']['input']>;
  authURIHasSuffix?: InputMaybe<Scalars['String']['input']>;
  authURIIn?: InputMaybe<Array<Scalars['String']['input']>>;
  authURILT?: InputMaybe<Scalars['String']['input']>;
  authURILTE?: InputMaybe<Scalars['String']['input']>;
  authURINEQ?: InputMaybe<Scalars['String']['input']>;
  authURINotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** client_email field predicates */
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientEmailContains?: InputMaybe<Scalars['String']['input']>;
  clientEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  clientEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  clientEmailGT?: InputMaybe<Scalars['String']['input']>;
  clientEmailGTE?: InputMaybe<Scalars['String']['input']>;
  clientEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  clientEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  clientEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientEmailLT?: InputMaybe<Scalars['String']['input']>;
  clientEmailLTE?: InputMaybe<Scalars['String']['input']>;
  clientEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  clientEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** client_id field predicates */
  clientID?: InputMaybe<Scalars['String']['input']>;
  clientIDContains?: InputMaybe<Scalars['String']['input']>;
  clientIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  clientIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  clientIDGT?: InputMaybe<Scalars['String']['input']>;
  clientIDGTE?: InputMaybe<Scalars['String']['input']>;
  clientIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  clientIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  clientIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIDLT?: InputMaybe<Scalars['String']['input']>;
  clientIDLTE?: InputMaybe<Scalars['String']['input']>;
  clientIDNEQ?: InputMaybe<Scalars['String']['input']>;
  clientIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** client_x509_cert_url field predicates */
  clientX509CertURL?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLContains?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLGT?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLGTE?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientX509CertURLLT?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLLTE?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLNEQ?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_name field predicates */
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileNameContains?: InputMaybe<Scalars['String']['input']>;
  fileNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fileNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fileNameGT?: InputMaybe<Scalars['String']['input']>;
  fileNameGTE?: InputMaybe<Scalars['String']['input']>;
  fileNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fileNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fileNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileNameLT?: InputMaybe<Scalars['String']['input']>;
  fileNameLTE?: InputMaybe<Scalars['String']['input']>;
  fileNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fileNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<FirebasePrivateKeyWhereInput>;
  or?: InputMaybe<Array<FirebasePrivateKeyWhereInput>>;
  /** private_key field predicates */
  privateKey?: InputMaybe<Scalars['String']['input']>;
  privateKeyContains?: InputMaybe<Scalars['String']['input']>;
  privateKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyGT?: InputMaybe<Scalars['String']['input']>;
  privateKeyGTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  privateKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  /** private_key_id field predicates */
  privateKeyID?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDContains?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDGT?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDGTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  privateKeyIDLT?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDLTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  privateKeyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  privateKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  privateKeyLT?: InputMaybe<Scalars['String']['input']>;
  privateKeyLTE?: InputMaybe<Scalars['String']['input']>;
  privateKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  privateKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** project_id field predicates */
  projectID?: InputMaybe<Scalars['String']['input']>;
  projectIDContains?: InputMaybe<Scalars['String']['input']>;
  projectIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  projectIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  projectIDGT?: InputMaybe<Scalars['String']['input']>;
  projectIDGTE?: InputMaybe<Scalars['String']['input']>;
  projectIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  projectIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  projectIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  projectIDLT?: InputMaybe<Scalars['String']['input']>;
  projectIDLTE?: InputMaybe<Scalars['String']['input']>;
  projectIDNEQ?: InputMaybe<Scalars['String']['input']>;
  projectIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sender_id field predicates */
  senderID?: InputMaybe<Scalars['String']['input']>;
  senderIDContains?: InputMaybe<Scalars['String']['input']>;
  senderIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  senderIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  senderIDGT?: InputMaybe<Scalars['String']['input']>;
  senderIDGTE?: InputMaybe<Scalars['String']['input']>;
  senderIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  senderIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  senderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  senderIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  senderIDLT?: InputMaybe<Scalars['String']['input']>;
  senderIDLTE?: InputMaybe<Scalars['String']['input']>;
  senderIDNEQ?: InputMaybe<Scalars['String']['input']>;
  senderIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  senderIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** token_uri field predicates */
  tokenURI?: InputMaybe<Scalars['String']['input']>;
  tokenURIContains?: InputMaybe<Scalars['String']['input']>;
  tokenURIContainsFold?: InputMaybe<Scalars['String']['input']>;
  tokenURIEqualFold?: InputMaybe<Scalars['String']['input']>;
  tokenURIGT?: InputMaybe<Scalars['String']['input']>;
  tokenURIGTE?: InputMaybe<Scalars['String']['input']>;
  tokenURIHasPrefix?: InputMaybe<Scalars['String']['input']>;
  tokenURIHasSuffix?: InputMaybe<Scalars['String']['input']>;
  tokenURIIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenURILT?: InputMaybe<Scalars['String']['input']>;
  tokenURILTE?: InputMaybe<Scalars['String']['input']>;
  tokenURINEQ?: InputMaybe<Scalars['String']['input']>;
  tokenURINotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** type field predicates */
  type?: InputMaybe<Scalars['String']['input']>;
  typeContains?: InputMaybe<Scalars['String']['input']>;
  typeContainsFold?: InputMaybe<Scalars['String']['input']>;
  typeEqualFold?: InputMaybe<Scalars['String']['input']>;
  typeGT?: InputMaybe<Scalars['String']['input']>;
  typeGTE?: InputMaybe<Scalars['String']['input']>;
  typeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  typeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  typeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  typeLT?: InputMaybe<Scalars['String']['input']>;
  typeLTE?: InputMaybe<Scalars['String']['input']>;
  typeNEQ?: InputMaybe<Scalars['String']['input']>;
  typeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** universe_domain field predicates */
  universeDomain?: InputMaybe<Scalars['String']['input']>;
  universeDomainContains?: InputMaybe<Scalars['String']['input']>;
  universeDomainContainsFold?: InputMaybe<Scalars['String']['input']>;
  universeDomainEqualFold?: InputMaybe<Scalars['String']['input']>;
  universeDomainGT?: InputMaybe<Scalars['String']['input']>;
  universeDomainGTE?: InputMaybe<Scalars['String']['input']>;
  universeDomainHasPrefix?: InputMaybe<Scalars['String']['input']>;
  universeDomainHasSuffix?: InputMaybe<Scalars['String']['input']>;
  universeDomainIn?: InputMaybe<Array<Scalars['String']['input']>>;
  universeDomainLT?: InputMaybe<Scalars['String']['input']>;
  universeDomainLTE?: InputMaybe<Scalars['String']['input']>;
  universeDomainNEQ?: InputMaybe<Scalars['String']['input']>;
  universeDomainNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type GeneratePresignedUploadUrlResponse = {
  __typename?: 'GeneratePresignedUploadUrlResponse';
  downloadUrl: Scalars['String']['output'];
  uploadHeaders: Scalars['JSON']['output'];
  uploadMethod: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Geofence = Node & {
  __typename?: 'Geofence';
  color: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  eventOnEntry: Scalars['Boolean']['output'];
  eventOnExit: Scalars['Boolean']['output'];
  geoJSON?: Maybe<Scalars['GeoJSON']['output']>;
  geofenceDeviceGroups?: Maybe<Array<GeofenceDeviceGroup>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifyConfigs?: Maybe<Array<NotifyConfig>>;
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  radius: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  useAsAddress: Scalars['Boolean']['output'];
  yardWarehouseDocks?: Maybe<Array<YardWarehouseDock>>;
};

/** A connection to a list of items. */
export type GeofenceConnection = {
  __typename?: 'GeofenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GeofenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type GeofenceDeviceGroup = Node & {
  __typename?: 'GeofenceDeviceGroup';
  createdAt: Scalars['Time']['output'];
  devicegroup: DeviceGroup;
  devicegroupID: Scalars['ID']['output'];
  geofence: Geofence;
  geofenceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isIn: Scalars['Boolean']['output'];
  lastCross?: Maybe<Scalars['Time']['output']>;
  lastEnter?: Maybe<Scalars['Time']['output']>;
  lastExit?: Maybe<Scalars['Time']['output']>;
  lastUpdate?: Maybe<Scalars['Time']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type GeofenceDeviceGroupConnection = {
  __typename?: 'GeofenceDeviceGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GeofenceDeviceGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GeofenceDeviceGroupEdge = {
  __typename?: 'GeofenceDeviceGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GeofenceDeviceGroup>;
};

export enum GeofenceDeviceGroupField {
  CreatedAt = 'createdAt',
  DevicegroupId = 'devicegroupID',
  GeofenceId = 'geofenceID',
  IsIn = 'isIn',
  LastCross = 'lastCross',
  LastEnter = 'lastEnter',
  LastExit = 'lastExit',
  LastUpdate = 'lastUpdate',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for GeofenceDeviceGroup connections */
export type GeofenceDeviceGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GeofenceDeviceGroups. */
  field: GeofenceDeviceGroupOrderField;
};

/** Properties by which GeofenceDeviceGroup connections can be ordered. */
export enum GeofenceDeviceGroupOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * GeofenceDeviceGroupWhereInput is used for filtering GeofenceDeviceGroup objects.
 * Input was generated by ent.
 */
export type GeofenceDeviceGroupWhereInput = {
  and?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devicegroup_id field predicates */
  devicegroupID?: InputMaybe<Scalars['ID']['input']>;
  devicegroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  devicegroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  devicegroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** geofence_id field predicates */
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  geofenceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  geofenceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  geofenceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** devicegroup edge predicates */
  hasDevicegroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** geofence edge predicates */
  hasGeofence?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceWith?: InputMaybe<Array<GeofenceWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_in field predicates */
  isIn?: InputMaybe<Scalars['Boolean']['input']>;
  isInNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_cross field predicates */
  lastCross?: InputMaybe<Scalars['Time']['input']>;
  lastCrossGT?: InputMaybe<Scalars['Time']['input']>;
  lastCrossGTE?: InputMaybe<Scalars['Time']['input']>;
  lastCrossIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastCrossIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastCrossLT?: InputMaybe<Scalars['Time']['input']>;
  lastCrossLTE?: InputMaybe<Scalars['Time']['input']>;
  lastCrossNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastCrossNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastCrossNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_enter field predicates */
  lastEnter?: InputMaybe<Scalars['Time']['input']>;
  lastEnterGT?: InputMaybe<Scalars['Time']['input']>;
  lastEnterGTE?: InputMaybe<Scalars['Time']['input']>;
  lastEnterIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastEnterIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastEnterLT?: InputMaybe<Scalars['Time']['input']>;
  lastEnterLTE?: InputMaybe<Scalars['Time']['input']>;
  lastEnterNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastEnterNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastEnterNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_exit field predicates */
  lastExit?: InputMaybe<Scalars['Time']['input']>;
  lastExitGT?: InputMaybe<Scalars['Time']['input']>;
  lastExitGTE?: InputMaybe<Scalars['Time']['input']>;
  lastExitIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastExitIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastExitLT?: InputMaybe<Scalars['Time']['input']>;
  lastExitLTE?: InputMaybe<Scalars['Time']['input']>;
  lastExitNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastExitNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastExitNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_update field predicates */
  lastUpdate?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdateLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GeofenceDeviceGroupWhereInput>;
  or?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type GeofenceEdge = {
  __typename?: 'GeofenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Geofence>;
};

export enum GeofenceField {
  Color = 'color',
  CreatedAt = 'createdAt',
  EventOnEntry = 'eventOnEntry',
  EventOnExit = 'eventOnExit',
  GeoJson = 'geoJSON',
  IsActive = 'isActive',
  Name = 'name',
  OrganisationId = 'organisationID',
  Radius = 'radius',
  UpdatedAt = 'updatedAt',
  UseAsAddress = 'useAsAddress'
}

/** Ordering options for Geofence connections */
export type GeofenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Geofences. */
  field: GeofenceOrderField;
};

/** Properties by which Geofence connections can be ordered. */
export enum GeofenceOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * GeofenceWhereInput is used for filtering Geofence objects.
 * Input was generated by ent.
 */
export type GeofenceWhereInput = {
  and?: InputMaybe<Array<GeofenceWhereInput>>;
  /** color field predicates */
  color?: InputMaybe<Scalars['String']['input']>;
  colorContains?: InputMaybe<Scalars['String']['input']>;
  colorContainsFold?: InputMaybe<Scalars['String']['input']>;
  colorEqualFold?: InputMaybe<Scalars['String']['input']>;
  colorGT?: InputMaybe<Scalars['String']['input']>;
  colorGTE?: InputMaybe<Scalars['String']['input']>;
  colorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  colorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  colorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  colorLT?: InputMaybe<Scalars['String']['input']>;
  colorLTE?: InputMaybe<Scalars['String']['input']>;
  colorNEQ?: InputMaybe<Scalars['String']['input']>;
  colorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** event_on_entry field predicates */
  eventOnEntry?: InputMaybe<Scalars['Boolean']['input']>;
  eventOnEntryNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** event_on_exit field predicates */
  eventOnExit?: InputMaybe<Scalars['Boolean']['input']>;
  eventOnExitNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** geo_json field predicates */
  geoJSON?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONGT?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONGTE?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONIn?: InputMaybe<Array<Scalars['GeoJSON']['input']>>;
  geoJSONIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  geoJSONLT?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONLTE?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONNEQ?: InputMaybe<Scalars['GeoJSON']['input']>;
  geoJSONNotIn?: InputMaybe<Array<Scalars['GeoJSON']['input']>>;
  geoJSONNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** geofence_device_groups edge predicates */
  hasGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceDeviceGroupsWith?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** notify_configs edge predicates */
  hasNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigsWith?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_warehouse_docks edge predicates */
  hasYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDocksWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<GeofenceWhereInput>;
  or?: InputMaybe<Array<GeofenceWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** radius field predicates */
  radius?: InputMaybe<Scalars['Float']['input']>;
  radiusGT?: InputMaybe<Scalars['Float']['input']>;
  radiusGTE?: InputMaybe<Scalars['Float']['input']>;
  radiusIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  radiusLT?: InputMaybe<Scalars['Float']['input']>;
  radiusLTE?: InputMaybe<Scalars['Float']['input']>;
  radiusNEQ?: InputMaybe<Scalars['Float']['input']>;
  radiusNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** use_as_address field predicates */
  useAsAddress?: InputMaybe<Scalars['Boolean']['input']>;
  useAsAddressNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HaltPoint = Node & {
  __typename?: 'HaltPoint';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  geofenceRadius?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  routeHaltPoints?: Maybe<Array<RouteHaltPoint>>;
  targets?: Maybe<Array<Target>>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type HaltPointConnection = {
  __typename?: 'HaltPointConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<HaltPointEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HaltPointEdge = {
  __typename?: 'HaltPointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HaltPoint>;
};

export enum HaltPointField {
  Address = 'address',
  CreatedAt = 'createdAt',
  GeofenceRadius = 'geofenceRadius',
  IsActive = 'isActive',
  Lat = 'lat',
  Lng = 'lng',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for HaltPoint connections */
export type HaltPointOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order HaltPoints. */
  field: HaltPointOrderField;
};

/** Properties by which HaltPoint connections can be ordered. */
export enum HaltPointOrderField {
  Address = 'address',
  CreatedAt = 'createdAt',
  Id = 'id',
  Lat = 'lat',
  Lng = 'lng',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/**
 * HaltPointWhereInput is used for filtering HaltPoint objects.
 * Input was generated by ent.
 */
export type HaltPointWhereInput = {
  /** address field predicates */
  address?: InputMaybe<Scalars['String']['input']>;
  addressContains?: InputMaybe<Scalars['String']['input']>;
  addressContainsFold?: InputMaybe<Scalars['String']['input']>;
  addressEqualFold?: InputMaybe<Scalars['String']['input']>;
  addressGT?: InputMaybe<Scalars['String']['input']>;
  addressGTE?: InputMaybe<Scalars['String']['input']>;
  addressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  addressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  addressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addressLT?: InputMaybe<Scalars['String']['input']>;
  addressLTE?: InputMaybe<Scalars['String']['input']>;
  addressNEQ?: InputMaybe<Scalars['String']['input']>;
  addressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<HaltPointWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** geofence_radius field predicates */
  geofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  geofenceRadiusGT?: InputMaybe<Scalars['Float']['input']>;
  geofenceRadiusGTE?: InputMaybe<Scalars['Float']['input']>;
  geofenceRadiusIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  geofenceRadiusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  geofenceRadiusLT?: InputMaybe<Scalars['Float']['input']>;
  geofenceRadiusLTE?: InputMaybe<Scalars['Float']['input']>;
  geofenceRadiusNEQ?: InputMaybe<Scalars['Float']['input']>;
  geofenceRadiusNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  geofenceRadiusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route_halt_points edge predicates */
  hasRouteHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteHaltPointsWith?: InputMaybe<Array<RouteHaltPointWhereInput>>;
  /** targets edge predicates */
  hasTargets?: InputMaybe<Scalars['Boolean']['input']>;
  hasTargetsWith?: InputMaybe<Array<TargetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** lat field predicates */
  lat?: InputMaybe<Scalars['Float']['input']>;
  latGT?: InputMaybe<Scalars['Float']['input']>;
  latGTE?: InputMaybe<Scalars['Float']['input']>;
  latIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  latLT?: InputMaybe<Scalars['Float']['input']>;
  latLTE?: InputMaybe<Scalars['Float']['input']>;
  latNEQ?: InputMaybe<Scalars['Float']['input']>;
  latNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** lng field predicates */
  lng?: InputMaybe<Scalars['Float']['input']>;
  lngGT?: InputMaybe<Scalars['Float']['input']>;
  lngGTE?: InputMaybe<Scalars['Float']['input']>;
  lngIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  lngLT?: InputMaybe<Scalars['Float']['input']>;
  lngLTE?: InputMaybe<Scalars['Float']['input']>;
  lngNEQ?: InputMaybe<Scalars['Float']['input']>;
  lngNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<HaltPointWhereInput>;
  or?: InputMaybe<Array<HaltPointWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type InspectionReport = Node & {
  __typename?: 'InspectionReport';
  bonnet: Scalars['Boolean']['output'];
  bonnetCondition: Scalars['String']['output'];
  checkInPic?: Maybe<Scalars['String']['output']>;
  checkOutPic?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  damageKind: Scalars['String']['output'];
  damageSize: Scalars['String']['output'];
  deviceGroup: DeviceGroup;
  deviceGroupID: Scalars['ID']['output'];
  doorFront: Scalars['Boolean']['output'];
  doorFrontCondition: Scalars['String']['output'];
  doorRear: Scalars['Boolean']['output'];
  doorRearCondition: Scalars['String']['output'];
  fenderFront: Scalars['Boolean']['output'];
  fenderFrontCondition: Scalars['String']['output'];
  fenderRear: Scalars['Boolean']['output'];
  fenderRearCondition: Scalars['String']['output'];
  frontBumper: Scalars['Boolean']['output'];
  frontBumperCondition: Scalars['String']['output'];
  fuelMain: Scalars['String']['output'];
  fuelSub: Scalars['String']['output'];
  headLamp: Scalars['Boolean']['output'];
  headLampCondition: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  journey: InspectionReportJourney;
  kind: InspectionReportKind;
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  outKm: Scalars['Float']['output'];
  outTime: Scalars['Time']['output'];
  roof: Scalars['Boolean']['output'];
  roofCondition: Scalars['String']['output'];
  serialNumber?: Maybe<Scalars['Int']['output']>;
  sideMirror: Scalars['Boolean']['output'];
  sideMirrorCondition: Scalars['String']['output'];
  sideWindow: Scalars['Boolean']['output'];
  sideWindowCondition: Scalars['String']['output'];
  tailLamp: Scalars['Boolean']['output'];
  tailLampCondition: Scalars['String']['output'];
  tyreFront: Scalars['Boolean']['output'];
  tyreFrontCondition: Scalars['String']['output'];
  tyreRear: Scalars['Boolean']['output'];
  tyreRearCondition: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<User>;
  userID?: Maybe<Scalars['ID']['output']>;
  windscreen: Scalars['Boolean']['output'];
  windscreenCondition: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type InspectionReportConnection = {
  __typename?: 'InspectionReportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InspectionReportEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InspectionReportEdge = {
  __typename?: 'InspectionReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InspectionReport>;
};

export enum InspectionReportField {
  Bonnet = 'bonnet',
  BonnetCondition = 'bonnetCondition',
  CheckInPic = 'checkInPic',
  CheckOutPic = 'checkOutPic',
  CreatedAt = 'createdAt',
  DamageKind = 'damageKind',
  DamageSize = 'damageSize',
  DeviceGroupId = 'deviceGroupID',
  DoorFront = 'doorFront',
  DoorFrontCondition = 'doorFrontCondition',
  DoorRear = 'doorRear',
  DoorRearCondition = 'doorRearCondition',
  FenderFront = 'fenderFront',
  FenderFrontCondition = 'fenderFrontCondition',
  FenderRear = 'fenderRear',
  FenderRearCondition = 'fenderRearCondition',
  FrontBumper = 'frontBumper',
  FrontBumperCondition = 'frontBumperCondition',
  FuelMain = 'fuelMain',
  FuelSub = 'fuelSub',
  HeadLamp = 'headLamp',
  HeadLampCondition = 'headLampCondition',
  Journey = 'journey',
  Kind = 'kind',
  OrganisationId = 'organisationID',
  OutKm = 'outKm',
  OutTime = 'outTime',
  Roof = 'roof',
  RoofCondition = 'roofCondition',
  SerialNumber = 'serialNumber',
  SideMirror = 'sideMirror',
  SideMirrorCondition = 'sideMirrorCondition',
  SideWindow = 'sideWindow',
  SideWindowCondition = 'sideWindowCondition',
  TailLamp = 'tailLamp',
  TailLampCondition = 'tailLampCondition',
  TyreFront = 'tyreFront',
  TyreFrontCondition = 'tyreFrontCondition',
  TyreRear = 'tyreRear',
  TyreRearCondition = 'tyreRearCondition',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  Windscreen = 'windscreen',
  WindscreenCondition = 'windscreenCondition'
}

/** InspectionReportJourney is enum for the field journey */
export enum InspectionReportJourney {
  OneWay = 'one_way',
  TwoWay = 'two_way'
}

/** InspectionReportKind is enum for the field kind */
export enum InspectionReportKind {
  General = 'general',
  InOut = 'in_out'
}

/** Ordering options for InspectionReport connections */
export type InspectionReportOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order InspectionReports. */
  field: InspectionReportOrderField;
};

/** Properties by which InspectionReport connections can be ordered. */
export enum InspectionReportOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * InspectionReportWhereInput is used for filtering InspectionReport objects.
 * Input was generated by ent.
 */
export type InspectionReportWhereInput = {
  and?: InputMaybe<Array<InspectionReportWhereInput>>;
  /** bonnet field predicates */
  bonnet?: InputMaybe<Scalars['Boolean']['input']>;
  /** bonnet_condition field predicates */
  bonnetCondition?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionContains?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionGT?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionGTE?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bonnetConditionLT?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionLTE?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  bonnetConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bonnetNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_pic field predicates */
  checkInPic?: InputMaybe<Scalars['String']['input']>;
  checkInPicContains?: InputMaybe<Scalars['String']['input']>;
  checkInPicContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkInPicEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkInPicGT?: InputMaybe<Scalars['String']['input']>;
  checkInPicGTE?: InputMaybe<Scalars['String']['input']>;
  checkInPicHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkInPicHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkInPicIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInPicIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInPicLT?: InputMaybe<Scalars['String']['input']>;
  checkInPicLTE?: InputMaybe<Scalars['String']['input']>;
  checkInPicNEQ?: InputMaybe<Scalars['String']['input']>;
  checkInPicNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInPicNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_pic field predicates */
  checkOutPic?: InputMaybe<Scalars['String']['input']>;
  checkOutPicContains?: InputMaybe<Scalars['String']['input']>;
  checkOutPicContainsFold?: InputMaybe<Scalars['String']['input']>;
  checkOutPicEqualFold?: InputMaybe<Scalars['String']['input']>;
  checkOutPicGT?: InputMaybe<Scalars['String']['input']>;
  checkOutPicGTE?: InputMaybe<Scalars['String']['input']>;
  checkOutPicHasPrefix?: InputMaybe<Scalars['String']['input']>;
  checkOutPicHasSuffix?: InputMaybe<Scalars['String']['input']>;
  checkOutPicIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkOutPicIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutPicLT?: InputMaybe<Scalars['String']['input']>;
  checkOutPicLTE?: InputMaybe<Scalars['String']['input']>;
  checkOutPicNEQ?: InputMaybe<Scalars['String']['input']>;
  checkOutPicNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  checkOutPicNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** damage_kind field predicates */
  damageKind?: InputMaybe<Scalars['String']['input']>;
  damageKindContains?: InputMaybe<Scalars['String']['input']>;
  damageKindContainsFold?: InputMaybe<Scalars['String']['input']>;
  damageKindEqualFold?: InputMaybe<Scalars['String']['input']>;
  damageKindGT?: InputMaybe<Scalars['String']['input']>;
  damageKindGTE?: InputMaybe<Scalars['String']['input']>;
  damageKindHasPrefix?: InputMaybe<Scalars['String']['input']>;
  damageKindHasSuffix?: InputMaybe<Scalars['String']['input']>;
  damageKindIn?: InputMaybe<Array<Scalars['String']['input']>>;
  damageKindLT?: InputMaybe<Scalars['String']['input']>;
  damageKindLTE?: InputMaybe<Scalars['String']['input']>;
  damageKindNEQ?: InputMaybe<Scalars['String']['input']>;
  damageKindNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** damage_size field predicates */
  damageSize?: InputMaybe<Scalars['String']['input']>;
  damageSizeContains?: InputMaybe<Scalars['String']['input']>;
  damageSizeContainsFold?: InputMaybe<Scalars['String']['input']>;
  damageSizeEqualFold?: InputMaybe<Scalars['String']['input']>;
  damageSizeGT?: InputMaybe<Scalars['String']['input']>;
  damageSizeGTE?: InputMaybe<Scalars['String']['input']>;
  damageSizeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  damageSizeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  damageSizeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  damageSizeLT?: InputMaybe<Scalars['String']['input']>;
  damageSizeLTE?: InputMaybe<Scalars['String']['input']>;
  damageSizeNEQ?: InputMaybe<Scalars['String']['input']>;
  damageSizeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** device_group_id field predicates */
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** door_front field predicates */
  doorFront?: InputMaybe<Scalars['Boolean']['input']>;
  /** door_front_condition field predicates */
  doorFrontCondition?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionContains?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionGT?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionGTE?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  doorFrontConditionLT?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionLTE?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  doorFrontConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  doorFrontNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** door_rear field predicates */
  doorRear?: InputMaybe<Scalars['Boolean']['input']>;
  /** door_rear_condition field predicates */
  doorRearCondition?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionContains?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionGT?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionGTE?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  doorRearConditionLT?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionLTE?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  doorRearConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  doorRearNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** fender_front field predicates */
  fenderFront?: InputMaybe<Scalars['Boolean']['input']>;
  /** fender_front_condition field predicates */
  fenderFrontCondition?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionContains?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionGT?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionGTE?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fenderFrontConditionLT?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionLTE?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  fenderFrontConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fenderFrontNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** fender_rear field predicates */
  fenderRear?: InputMaybe<Scalars['Boolean']['input']>;
  /** fender_rear_condition field predicates */
  fenderRearCondition?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionContains?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionGT?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionGTE?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fenderRearConditionLT?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionLTE?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  fenderRearConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fenderRearNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** front_bumper field predicates */
  frontBumper?: InputMaybe<Scalars['Boolean']['input']>;
  /** front_bumper_condition field predicates */
  frontBumperCondition?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionContains?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionGT?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionGTE?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  frontBumperConditionLT?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionLTE?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  frontBumperConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  frontBumperNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** fuel_main field predicates */
  fuelMain?: InputMaybe<Scalars['String']['input']>;
  fuelMainContains?: InputMaybe<Scalars['String']['input']>;
  fuelMainContainsFold?: InputMaybe<Scalars['String']['input']>;
  fuelMainEqualFold?: InputMaybe<Scalars['String']['input']>;
  fuelMainGT?: InputMaybe<Scalars['String']['input']>;
  fuelMainGTE?: InputMaybe<Scalars['String']['input']>;
  fuelMainHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fuelMainHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fuelMainIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fuelMainLT?: InputMaybe<Scalars['String']['input']>;
  fuelMainLTE?: InputMaybe<Scalars['String']['input']>;
  fuelMainNEQ?: InputMaybe<Scalars['String']['input']>;
  fuelMainNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** fuel_sub field predicates */
  fuelSub?: InputMaybe<Scalars['String']['input']>;
  fuelSubContains?: InputMaybe<Scalars['String']['input']>;
  fuelSubContainsFold?: InputMaybe<Scalars['String']['input']>;
  fuelSubEqualFold?: InputMaybe<Scalars['String']['input']>;
  fuelSubGT?: InputMaybe<Scalars['String']['input']>;
  fuelSubGTE?: InputMaybe<Scalars['String']['input']>;
  fuelSubHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fuelSubHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fuelSubIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fuelSubLT?: InputMaybe<Scalars['String']['input']>;
  fuelSubLTE?: InputMaybe<Scalars['String']['input']>;
  fuelSubNEQ?: InputMaybe<Scalars['String']['input']>;
  fuelSubNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** head_lamp field predicates */
  headLamp?: InputMaybe<Scalars['Boolean']['input']>;
  /** head_lamp_condition field predicates */
  headLampCondition?: InputMaybe<Scalars['String']['input']>;
  headLampConditionContains?: InputMaybe<Scalars['String']['input']>;
  headLampConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  headLampConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  headLampConditionGT?: InputMaybe<Scalars['String']['input']>;
  headLampConditionGTE?: InputMaybe<Scalars['String']['input']>;
  headLampConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  headLampConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  headLampConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  headLampConditionLT?: InputMaybe<Scalars['String']['input']>;
  headLampConditionLTE?: InputMaybe<Scalars['String']['input']>;
  headLampConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  headLampConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  headLampNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** journey field predicates */
  journey?: InputMaybe<InspectionReportJourney>;
  journeyIn?: InputMaybe<Array<InspectionReportJourney>>;
  journeyNEQ?: InputMaybe<InspectionReportJourney>;
  journeyNotIn?: InputMaybe<Array<InspectionReportJourney>>;
  /** kind field predicates */
  kind?: InputMaybe<InspectionReportKind>;
  kindIn?: InputMaybe<Array<InspectionReportKind>>;
  kindNEQ?: InputMaybe<InspectionReportKind>;
  kindNotIn?: InputMaybe<Array<InspectionReportKind>>;
  not?: InputMaybe<InspectionReportWhereInput>;
  or?: InputMaybe<Array<InspectionReportWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** out_km field predicates */
  outKm?: InputMaybe<Scalars['Float']['input']>;
  outKmGT?: InputMaybe<Scalars['Float']['input']>;
  outKmGTE?: InputMaybe<Scalars['Float']['input']>;
  outKmIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  outKmLT?: InputMaybe<Scalars['Float']['input']>;
  outKmLTE?: InputMaybe<Scalars['Float']['input']>;
  outKmNEQ?: InputMaybe<Scalars['Float']['input']>;
  outKmNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** out_time field predicates */
  outTime?: InputMaybe<Scalars['Time']['input']>;
  outTimeGT?: InputMaybe<Scalars['Time']['input']>;
  outTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  outTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  outTimeLT?: InputMaybe<Scalars['Time']['input']>;
  outTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  outTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  outTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** roof field predicates */
  roof?: InputMaybe<Scalars['Boolean']['input']>;
  /** roof_condition field predicates */
  roofCondition?: InputMaybe<Scalars['String']['input']>;
  roofConditionContains?: InputMaybe<Scalars['String']['input']>;
  roofConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  roofConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  roofConditionGT?: InputMaybe<Scalars['String']['input']>;
  roofConditionGTE?: InputMaybe<Scalars['String']['input']>;
  roofConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  roofConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  roofConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  roofConditionLT?: InputMaybe<Scalars['String']['input']>;
  roofConditionLTE?: InputMaybe<Scalars['String']['input']>;
  roofConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  roofConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  roofNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** serial_number field predicates */
  serialNumber?: InputMaybe<Scalars['Int']['input']>;
  serialNumberGT?: InputMaybe<Scalars['Int']['input']>;
  serialNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  serialNumberIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  serialNumberLT?: InputMaybe<Scalars['Int']['input']>;
  serialNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  serialNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  serialNumberNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  serialNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** side_mirror field predicates */
  sideMirror?: InputMaybe<Scalars['Boolean']['input']>;
  /** side_mirror_condition field predicates */
  sideMirrorCondition?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionContains?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionGT?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionGTE?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sideMirrorConditionLT?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionLTE?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  sideMirrorConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sideMirrorNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** side_window field predicates */
  sideWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** side_window_condition field predicates */
  sideWindowCondition?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionContains?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionGT?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionGTE?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sideWindowConditionLT?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionLTE?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  sideWindowConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sideWindowNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** tail_lamp field predicates */
  tailLamp?: InputMaybe<Scalars['Boolean']['input']>;
  /** tail_lamp_condition field predicates */
  tailLampCondition?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionContains?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionGT?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionGTE?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tailLampConditionLT?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionLTE?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  tailLampConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tailLampNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** tyre_front field predicates */
  tyreFront?: InputMaybe<Scalars['Boolean']['input']>;
  /** tyre_front_condition field predicates */
  tyreFrontCondition?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionContains?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionGT?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionGTE?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tyreFrontConditionLT?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionLTE?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  tyreFrontConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tyreFrontNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** tyre_rear field predicates */
  tyreRear?: InputMaybe<Scalars['Boolean']['input']>;
  /** tyre_rear_condition field predicates */
  tyreRearCondition?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionContains?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionGT?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionGTE?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tyreRearConditionLT?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionLTE?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  tyreRearConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tyreRearNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** windscreen field predicates */
  windscreen?: InputMaybe<Scalars['Boolean']['input']>;
  /** windscreen_condition field predicates */
  windscreenCondition?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionContains?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionContainsFold?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionEqualFold?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionGT?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionGTE?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  windscreenConditionLT?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionLTE?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionNEQ?: InputMaybe<Scalars['String']['input']>;
  windscreenConditionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  windscreenNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Kml = Node & {
  __typename?: 'Kml';
  createdAt: Scalars['Time']['output'];
  file: MediaFile;
  fileID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type KmlConnection = {
  __typename?: 'KmlConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<KmlEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KmlEdge = {
  __typename?: 'KmlEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Kml>;
};

export enum KmlField {
  CreatedAt = 'createdAt',
  FileId = 'fileID',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Kml connections */
export type KmlOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Kmls. */
  field: KmlOrderField;
};

/** Properties by which Kml connections can be ordered. */
export enum KmlOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * KmlWhereInput is used for filtering Kml objects.
 * Input was generated by ent.
 */
export type KmlWhereInput = {
  and?: InputMaybe<Array<KmlWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_id field predicates */
  fileID?: InputMaybe<Scalars['ID']['input']>;
  fileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  fileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** file edge predicates */
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  hasFileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<KmlWhereInput>;
  or?: InputMaybe<Array<KmlWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type LastFewEventsResponse = {
  __typename?: 'LastFewEventsResponse';
  attributes?: Maybe<Scalars['JSON']['output']>;
  deviceId: Scalars['ID']['output'];
  eventName: Scalars['String']['output'];
  fixTime: Scalars['Time']['output'];
  geofenceName?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LeaveDate = Node & {
  __typename?: 'LeaveDate';
  attendances?: Maybe<Array<Attendance>>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isHalfDay: Scalars['Boolean']['output'];
  leaveDate: Scalars['Time']['output'];
  leaveRequest: LeaveRequest;
  leaveRequestID: Scalars['ID']['output'];
  leaveType: LeaveType;
  leaveTypeID: Scalars['ID']['output'];
  status: LeaveDateStatus;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type LeaveDateConnection = {
  __typename?: 'LeaveDateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LeaveDateEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LeaveDateEdge = {
  __typename?: 'LeaveDateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LeaveDate>;
};

export enum LeaveDateField {
  CreatedAt = 'createdAt',
  IsHalfDay = 'isHalfDay',
  LeaveDate = 'leaveDate',
  LeaveRequestId = 'leaveRequestID',
  LeaveTypeId = 'leaveTypeID',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for LeaveDate connections */
export type LeaveDateOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LeaveDates. */
  field: LeaveDateOrderField;
};

/** Properties by which LeaveDate connections can be ordered. */
export enum LeaveDateOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** LeaveDateStatus is enum for the field status */
export enum LeaveDateStatus {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Pending = 'pending',
  Rejected = 'rejected'
}

/**
 * LeaveDateWhereInput is used for filtering LeaveDate objects.
 * Input was generated by ent.
 */
export type LeaveDateWhereInput = {
  and?: InputMaybe<Array<LeaveDateWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** attendances edge predicates */
  hasAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttendancesWith?: InputMaybe<Array<AttendanceWhereInput>>;
  /** leave_request edge predicates */
  hasLeaveRequest?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveRequestWith?: InputMaybe<Array<LeaveRequestWhereInput>>;
  /** leave_type edge predicates */
  hasLeaveType?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveTypeWith?: InputMaybe<Array<LeaveTypeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_half_day field predicates */
  isHalfDay?: InputMaybe<Scalars['Boolean']['input']>;
  isHalfDayNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** leave_date field predicates */
  leaveDate?: InputMaybe<Scalars['Time']['input']>;
  leaveDateGT?: InputMaybe<Scalars['Time']['input']>;
  leaveDateGTE?: InputMaybe<Scalars['Time']['input']>;
  leaveDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  leaveDateLT?: InputMaybe<Scalars['Time']['input']>;
  leaveDateLTE?: InputMaybe<Scalars['Time']['input']>;
  leaveDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  leaveDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** leave_request_id field predicates */
  leaveRequestID?: InputMaybe<Scalars['ID']['input']>;
  leaveRequestIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveRequestIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  leaveRequestIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** leave_type_id field predicates */
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LeaveDateWhereInput>;
  or?: InputMaybe<Array<LeaveDateWhereInput>>;
  /** status field predicates */
  status?: InputMaybe<LeaveDateStatus>;
  statusIn?: InputMaybe<Array<LeaveDateStatus>>;
  statusNEQ?: InputMaybe<LeaveDateStatus>;
  statusNotIn?: InputMaybe<Array<LeaveDateStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LeaveRequest = Node & {
  __typename?: 'LeaveRequest';
  approvedBy?: Maybe<Scalars['ID']['output']>;
  approvedDate?: Maybe<Scalars['Time']['output']>;
  approver?: Maybe<User>;
  attendances?: Maybe<Array<Attendance>>;
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  leaveDates?: Maybe<Array<LeaveDate>>;
  leaveType: LeaveType;
  leaveTypeID: Scalars['ID']['output'];
  numberOfDays?: Maybe<Scalars['Float']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requestStatus: LeaveRequestRequestStatus;
  startDate: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type LeaveRequestConnection = {
  __typename?: 'LeaveRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LeaveRequestEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LeaveRequestEdge = {
  __typename?: 'LeaveRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LeaveRequest>;
};

export enum LeaveRequestField {
  ApprovedBy = 'approvedBy',
  ApprovedDate = 'approvedDate',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  LeaveTypeId = 'leaveTypeID',
  NumberOfDays = 'numberOfDays',
  OrganisationId = 'organisationID',
  Reason = 'reason',
  RejectionReason = 'rejectionReason',
  RequestStatus = 'requestStatus',
  StartDate = 'startDate',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for LeaveRequest connections */
export type LeaveRequestOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LeaveRequests. */
  field: LeaveRequestOrderField;
};

/** Properties by which LeaveRequest connections can be ordered. */
export enum LeaveRequestOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** LeaveRequestRequestStatus is enum for the field request_status */
export enum LeaveRequestRequestStatus {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Pending = 'pending',
  Rejected = 'rejected'
}

/**
 * LeaveRequestWhereInput is used for filtering LeaveRequest objects.
 * Input was generated by ent.
 */
export type LeaveRequestWhereInput = {
  and?: InputMaybe<Array<LeaveRequestWhereInput>>;
  /** approved_by field predicates */
  approvedBy?: InputMaybe<Scalars['ID']['input']>;
  approvedByIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approvedByNEQ?: InputMaybe<Scalars['ID']['input']>;
  approvedByNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** approved_date field predicates */
  approvedDate?: InputMaybe<Scalars['Time']['input']>;
  approvedDateGT?: InputMaybe<Scalars['Time']['input']>;
  approvedDateGTE?: InputMaybe<Scalars['Time']['input']>;
  approvedDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approvedDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approvedDateLT?: InputMaybe<Scalars['Time']['input']>;
  approvedDateLTE?: InputMaybe<Scalars['Time']['input']>;
  approvedDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  approvedDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  approvedDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** end_date field predicates */
  endDate?: InputMaybe<Scalars['Time']['input']>;
  endDateGT?: InputMaybe<Scalars['Time']['input']>;
  endDateGTE?: InputMaybe<Scalars['Time']['input']>;
  endDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endDateLT?: InputMaybe<Scalars['Time']['input']>;
  endDateLTE?: InputMaybe<Scalars['Time']['input']>;
  endDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  endDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** approver edge predicates */
  hasApprover?: InputMaybe<Scalars['Boolean']['input']>;
  hasApproverWith?: InputMaybe<Array<UserWhereInput>>;
  /** attendances edge predicates */
  hasAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttendancesWith?: InputMaybe<Array<AttendanceWhereInput>>;
  /** leave_dates edge predicates */
  hasLeaveDates?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveDatesWith?: InputMaybe<Array<LeaveDateWhereInput>>;
  /** leave_type edge predicates */
  hasLeaveType?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveTypeWith?: InputMaybe<Array<LeaveTypeWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** leave_type_id field predicates */
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LeaveRequestWhereInput>;
  /** number_of_days field predicates */
  numberOfDays?: InputMaybe<Scalars['Float']['input']>;
  numberOfDaysGT?: InputMaybe<Scalars['Float']['input']>;
  numberOfDaysGTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfDaysIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  numberOfDaysIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfDaysLT?: InputMaybe<Scalars['Float']['input']>;
  numberOfDaysLTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfDaysNEQ?: InputMaybe<Scalars['Float']['input']>;
  numberOfDaysNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  numberOfDaysNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<LeaveRequestWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** reason field predicates */
  reason?: InputMaybe<Scalars['String']['input']>;
  reasonContains?: InputMaybe<Scalars['String']['input']>;
  reasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  reasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  reasonGT?: InputMaybe<Scalars['String']['input']>;
  reasonGTE?: InputMaybe<Scalars['String']['input']>;
  reasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  reasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  reasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reasonLT?: InputMaybe<Scalars['String']['input']>;
  reasonLTE?: InputMaybe<Scalars['String']['input']>;
  reasonNEQ?: InputMaybe<Scalars['String']['input']>;
  reasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** rejection_reason field predicates */
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonContains?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonGT?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonGTE?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectionReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rejectionReasonLT?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonLTE?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectionReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_status field predicates */
  requestStatus?: InputMaybe<LeaveRequestRequestStatus>;
  requestStatusIn?: InputMaybe<Array<LeaveRequestRequestStatus>>;
  requestStatusNEQ?: InputMaybe<LeaveRequestRequestStatus>;
  requestStatusNotIn?: InputMaybe<Array<LeaveRequestRequestStatus>>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  startDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  startDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type LeaveType = Node & {
  __typename?: 'LeaveType';
  attendances?: Maybe<Array<Attendance>>;
  colorCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leaveDates?: Maybe<Array<LeaveDate>>;
  leaveRequests?: Maybe<Array<LeaveRequest>>;
  leaveTypeName: Scalars['String']['output'];
  maxDaysPerYear?: Maybe<Scalars['Int']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  userLeaveBalances?: Maybe<Array<UserLeaveBalance>>;
};

/** A connection to a list of items. */
export type LeaveTypeConnection = {
  __typename?: 'LeaveTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LeaveTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LeaveTypeEdge = {
  __typename?: 'LeaveTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LeaveType>;
};

export enum LeaveTypeField {
  ColorCode = 'colorCode',
  CreatedAt = 'createdAt',
  Description = 'description',
  LeaveTypeName = 'leaveTypeName',
  MaxDaysPerYear = 'maxDaysPerYear',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for LeaveType connections */
export type LeaveTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LeaveTypes. */
  field: LeaveTypeOrderField;
};

/** Properties by which LeaveType connections can be ordered. */
export enum LeaveTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * LeaveTypeWhereInput is used for filtering LeaveType objects.
 * Input was generated by ent.
 */
export type LeaveTypeWhereInput = {
  and?: InputMaybe<Array<LeaveTypeWhereInput>>;
  /** color_code field predicates */
  colorCode?: InputMaybe<Scalars['String']['input']>;
  colorCodeContains?: InputMaybe<Scalars['String']['input']>;
  colorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  colorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  colorCodeGT?: InputMaybe<Scalars['String']['input']>;
  colorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  colorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  colorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  colorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  colorCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  colorCodeLT?: InputMaybe<Scalars['String']['input']>;
  colorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  colorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  colorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  colorCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** attendances edge predicates */
  hasAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttendancesWith?: InputMaybe<Array<AttendanceWhereInput>>;
  /** leave_dates edge predicates */
  hasLeaveDates?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveDatesWith?: InputMaybe<Array<LeaveDateWhereInput>>;
  /** leave_requests edge predicates */
  hasLeaveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveRequestsWith?: InputMaybe<Array<LeaveRequestWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** user_leave_balances edge predicates */
  hasUserLeaveBalances?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserLeaveBalancesWith?: InputMaybe<Array<UserLeaveBalanceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** leave_type_name field predicates */
  leaveTypeName?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameContains?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameGT?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameGTE?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  leaveTypeNameLT?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameLTE?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameNEQ?: InputMaybe<Scalars['String']['input']>;
  leaveTypeNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** max_days_per_year field predicates */
  maxDaysPerYear?: InputMaybe<Scalars['Int']['input']>;
  maxDaysPerYearGT?: InputMaybe<Scalars['Int']['input']>;
  maxDaysPerYearGTE?: InputMaybe<Scalars['Int']['input']>;
  maxDaysPerYearIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxDaysPerYearIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  maxDaysPerYearLT?: InputMaybe<Scalars['Int']['input']>;
  maxDaysPerYearLTE?: InputMaybe<Scalars['Int']['input']>;
  maxDaysPerYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxDaysPerYearNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxDaysPerYearNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<LeaveTypeWhereInput>;
  or?: InputMaybe<Array<LeaveTypeWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type LegacySync = Node & {
  __typename?: 'LegacySync';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  status: LegacySyncStatus;
  statusMsg?: Maybe<Scalars['String']['output']>;
  syncData: Scalars['String']['output'];
  syncKey: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type LegacySyncConnection = {
  __typename?: 'LegacySyncConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LegacySyncEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LegacySyncEdge = {
  __typename?: 'LegacySyncEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LegacySync>;
};

export enum LegacySyncField {
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  Status = 'status',
  StatusMsg = 'statusMsg',
  SyncData = 'syncData',
  SyncKey = 'syncKey',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for LegacySync connections */
export type LegacySyncOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LegacySyncs. */
  field: LegacySyncOrderField;
};

/** Properties by which LegacySync connections can be ordered. */
export enum LegacySyncOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** LegacySyncStatus is enum for the field status */
export enum LegacySyncStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Success = 'Success'
}

/**
 * LegacySyncWhereInput is used for filtering LegacySync objects.
 * Input was generated by ent.
 */
export type LegacySyncWhereInput = {
  and?: InputMaybe<Array<LegacySyncWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LegacySyncWhereInput>;
  or?: InputMaybe<Array<LegacySyncWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<LegacySyncStatus>;
  statusIn?: InputMaybe<Array<LegacySyncStatus>>;
  /** status_msg field predicates */
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  statusMsgContains?: InputMaybe<Scalars['String']['input']>;
  statusMsgContainsFold?: InputMaybe<Scalars['String']['input']>;
  statusMsgEqualFold?: InputMaybe<Scalars['String']['input']>;
  statusMsgGT?: InputMaybe<Scalars['String']['input']>;
  statusMsgGTE?: InputMaybe<Scalars['String']['input']>;
  statusMsgHasPrefix?: InputMaybe<Scalars['String']['input']>;
  statusMsgHasSuffix?: InputMaybe<Scalars['String']['input']>;
  statusMsgIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusMsgIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusMsgLT?: InputMaybe<Scalars['String']['input']>;
  statusMsgLTE?: InputMaybe<Scalars['String']['input']>;
  statusMsgNEQ?: InputMaybe<Scalars['String']['input']>;
  statusMsgNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusMsgNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNEQ?: InputMaybe<LegacySyncStatus>;
  statusNotIn?: InputMaybe<Array<LegacySyncStatus>>;
  /** sync_data field predicates */
  syncData?: InputMaybe<Scalars['String']['input']>;
  syncDataContains?: InputMaybe<Scalars['String']['input']>;
  syncDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  syncDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  syncDataGT?: InputMaybe<Scalars['String']['input']>;
  syncDataGTE?: InputMaybe<Scalars['String']['input']>;
  syncDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  syncDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  syncDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  syncDataLT?: InputMaybe<Scalars['String']['input']>;
  syncDataLTE?: InputMaybe<Scalars['String']['input']>;
  syncDataNEQ?: InputMaybe<Scalars['String']['input']>;
  syncDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sync_key field predicates */
  syncKey?: InputMaybe<Scalars['String']['input']>;
  syncKeyContains?: InputMaybe<Scalars['String']['input']>;
  syncKeyContainsFold?: InputMaybe<Scalars['String']['input']>;
  syncKeyEqualFold?: InputMaybe<Scalars['String']['input']>;
  syncKeyGT?: InputMaybe<Scalars['String']['input']>;
  syncKeyGTE?: InputMaybe<Scalars['String']['input']>;
  syncKeyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  syncKeyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  syncKeyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  syncKeyLT?: InputMaybe<Scalars['String']['input']>;
  syncKeyLTE?: InputMaybe<Scalars['String']['input']>;
  syncKeyNEQ?: InputMaybe<Scalars['String']['input']>;
  syncKeyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type License = Node & {
  __typename?: 'License';
  autoRenew: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  device?: Maybe<Device>;
  endDate?: Maybe<Scalars['Time']['output']>;
  expiryReminderDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  licenseOrder: SubscriptionLicenseOrder;
  licenseOrderID: Scalars['ID']['output'];
  linkedDeviceID?: Maybe<Scalars['ID']['output']>;
  moduleType: LicenseModuleType;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Time']['output']>;
  status: LicenseStatus;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type LicenseConnection = {
  __typename?: 'LicenseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LicenseEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LicenseEdge = {
  __typename?: 'LicenseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<License>;
};

export enum LicenseField {
  AutoRenew = 'autoRenew',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  ExpiryReminderDays = 'expiryReminderDays',
  LicenseOrderId = 'licenseOrderID',
  LinkedDeviceId = 'linkedDeviceID',
  ModuleType = 'moduleType',
  OrganisationId = 'organisationID',
  StartDate = 'startDate',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** LicenseModuleType is enum for the field module_type */
export enum LicenseModuleType {
  Device = 'Device',
  User = 'User'
}

/** Ordering options for License connections */
export type LicenseOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Licenses. */
  field: LicenseOrderField;
};

export type LicenseOrderAddon = Node & {
  __typename?: 'LicenseOrderAddon';
  baseLicensePlanAddonID: Scalars['ID']['output'];
  baselicenseaddon: BaseLicensePlanAddon;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  licenseOrderID: Scalars['ID']['output'];
  licenseorder: SubscriptionLicenseOrder;
  price: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type LicenseOrderAddonConnection = {
  __typename?: 'LicenseOrderAddonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LicenseOrderAddonEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LicenseOrderAddonEdge = {
  __typename?: 'LicenseOrderAddonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LicenseOrderAddon>;
};

export enum LicenseOrderAddonField {
  BaseLicensePlanAddonId = 'baseLicensePlanAddonID',
  CreatedAt = 'createdAt',
  LicenseOrderId = 'licenseOrderID',
  Price = 'price',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for LicenseOrderAddon connections */
export type LicenseOrderAddonOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LicenseOrderAddons. */
  field: LicenseOrderAddonOrderField;
};

/** Properties by which LicenseOrderAddon connections can be ordered. */
export enum LicenseOrderAddonOrderField {
  Price = 'PRICE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * LicenseOrderAddonWhereInput is used for filtering LicenseOrderAddon objects.
 * Input was generated by ent.
 */
export type LicenseOrderAddonWhereInput = {
  and?: InputMaybe<Array<LicenseOrderAddonWhereInput>>;
  /** base_license_plan_addon_id field predicates */
  baseLicensePlanAddonID?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanAddonIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseLicensePlanAddonIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanAddonIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** baselicenseaddon edge predicates */
  hasBaselicenseaddon?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseaddonWith?: InputMaybe<Array<BaseLicensePlanAddonWhereInput>>;
  /** licenseorder edge predicates */
  hasLicenseorder?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseorderWith?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** license_order_id field predicates */
  licenseOrderID?: InputMaybe<Scalars['ID']['input']>;
  licenseOrderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseOrderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  licenseOrderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<LicenseOrderAddonWhereInput>;
  or?: InputMaybe<Array<LicenseOrderAddonWhereInput>>;
  /** price field predicates */
  price?: InputMaybe<Scalars['Float']['input']>;
  priceGT?: InputMaybe<Scalars['Float']['input']>;
  priceGTE?: InputMaybe<Scalars['Float']['input']>;
  priceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  priceLT?: InputMaybe<Scalars['Float']['input']>;
  priceLTE?: InputMaybe<Scalars['Float']['input']>;
  priceNEQ?: InputMaybe<Scalars['Float']['input']>;
  priceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Properties by which License connections can be ordered. */
export enum LicenseOrderField {
  EndDate = 'END_DATE',
  ModuleType = 'MODULE_TYPE',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** LicenseStatus is enum for the field status */
export enum LicenseStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Grace = 'Grace',
  Pending = 'Pending'
}

/**
 * LicenseWhereInput is used for filtering License objects.
 * Input was generated by ent.
 */
export type LicenseWhereInput = {
  and?: InputMaybe<Array<LicenseWhereInput>>;
  /** auto_renew field predicates */
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  autoRenewNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** end_date field predicates */
  endDate?: InputMaybe<Scalars['Time']['input']>;
  endDateGT?: InputMaybe<Scalars['Time']['input']>;
  endDateGTE?: InputMaybe<Scalars['Time']['input']>;
  endDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endDateLT?: InputMaybe<Scalars['Time']['input']>;
  endDateLTE?: InputMaybe<Scalars['Time']['input']>;
  endDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  endDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** expiry_reminder_days field predicates */
  expiryReminderDays?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysGT?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  expiryReminderDaysLT?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  expiryReminderDaysNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** license_order edge predicates */
  hasLicenseOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseOrderWith?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** license_order_id field predicates */
  licenseOrderID?: InputMaybe<Scalars['ID']['input']>;
  licenseOrderIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  licenseOrderIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  licenseOrderIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** linked_device_id field predicates */
  linkedDeviceID?: InputMaybe<Scalars['ID']['input']>;
  linkedDeviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkedDeviceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  linkedDeviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  linkedDeviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkedDeviceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** module_type field predicates */
  moduleType?: InputMaybe<LicenseModuleType>;
  moduleTypeIn?: InputMaybe<Array<LicenseModuleType>>;
  moduleTypeNEQ?: InputMaybe<LicenseModuleType>;
  moduleTypeNotIn?: InputMaybe<Array<LicenseModuleType>>;
  not?: InputMaybe<LicenseWhereInput>;
  or?: InputMaybe<Array<LicenseWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  startDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  startDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<LicenseStatus>;
  statusIn?: InputMaybe<Array<LicenseStatus>>;
  statusNEQ?: InputMaybe<LicenseStatus>;
  statusNotIn?: InputMaybe<Array<LicenseStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type LoginLog = Node & {
  __typename?: 'LoginLog';
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  identifierType: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type LoginLogConnection = {
  __typename?: 'LoginLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LoginLogEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LoginLogEdge = {
  __typename?: 'LoginLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LoginLog>;
};

export enum LoginLogField {
  Attempts = 'attempts',
  CreatedAt = 'createdAt',
  Identifier = 'identifier',
  IdentifierType = 'identifierType',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for LoginLog connections */
export type LoginLogOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order LoginLogs. */
  field: LoginLogOrderField;
};

/** Properties by which LoginLog connections can be ordered. */
export enum LoginLogOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * LoginLogWhereInput is used for filtering LoginLog objects.
 * Input was generated by ent.
 */
export type LoginLogWhereInput = {
  and?: InputMaybe<Array<LoginLogWhereInput>>;
  /** attempts field predicates */
  attempts?: InputMaybe<Scalars['Int']['input']>;
  attemptsGT?: InputMaybe<Scalars['Int']['input']>;
  attemptsGTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  attemptsLT?: InputMaybe<Scalars['Int']['input']>;
  attemptsLTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsNEQ?: InputMaybe<Scalars['Int']['input']>;
  attemptsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** identifier field predicates */
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifierContains?: InputMaybe<Scalars['String']['input']>;
  identifierContainsFold?: InputMaybe<Scalars['String']['input']>;
  identifierEqualFold?: InputMaybe<Scalars['String']['input']>;
  identifierGT?: InputMaybe<Scalars['String']['input']>;
  identifierGTE?: InputMaybe<Scalars['String']['input']>;
  identifierHasPrefix?: InputMaybe<Scalars['String']['input']>;
  identifierHasSuffix?: InputMaybe<Scalars['String']['input']>;
  identifierIn?: InputMaybe<Array<Scalars['String']['input']>>;
  identifierLT?: InputMaybe<Scalars['String']['input']>;
  identifierLTE?: InputMaybe<Scalars['String']['input']>;
  identifierNEQ?: InputMaybe<Scalars['String']['input']>;
  identifierNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** identifier_type field predicates */
  identifierType?: InputMaybe<Scalars['String']['input']>;
  identifierTypeContains?: InputMaybe<Scalars['String']['input']>;
  identifierTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  identifierTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  identifierTypeGT?: InputMaybe<Scalars['String']['input']>;
  identifierTypeGTE?: InputMaybe<Scalars['String']['input']>;
  identifierTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  identifierTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  identifierTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  identifierTypeLT?: InputMaybe<Scalars['String']['input']>;
  identifierTypeLTE?: InputMaybe<Scalars['String']['input']>;
  identifierTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  identifierTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<LoginLogWhereInput>;
  or?: InputMaybe<Array<LoginLogWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  organisationUser: OrganisationUser;
  permissions: Array<Maybe<CrudPermission>>;
  token: Scalars['String']['output'];
};

export type MapConfig = Node & {
  __typename?: 'MapConfig';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: MapConfigKey;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type MapConfigConnection = {
  __typename?: 'MapConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MapConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MapConfigEdge = {
  __typename?: 'MapConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MapConfig>;
};

export enum MapConfigField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  Value = 'value'
}

/** MapConfigKey is enum for the field key */
export enum MapConfigKey {
  GeofenceLabel = 'geofence_label',
  GroupLabels = 'group_labels',
  IdleSeconds = 'idle_seconds',
  MapCluster = 'map_cluster',
  PeriodicPan = 'periodic_pan',
  PeriodicPanGeoOut = 'periodic_pan_geo_out',
  PoiCluster = 'poi_cluster',
  PoisLoadZoom = 'pois_load_zoom',
  RefreshRate = 'refresh_rate',
  ShowGeofences = 'show_geofences',
  ShowPois = 'show_pois',
  StartStopLineGeofence = 'start_stop_line_geofence',
  ZoomOutOnGeofence = 'zoom_out_on_geofence'
}

/** Ordering options for MapConfig connections */
export type MapConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order MapConfigs. */
  field: MapConfigOrderField;
};

/** Properties by which MapConfig connections can be ordered. */
export enum MapConfigOrderField {
  Key = 'KEY',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * MapConfigWhereInput is used for filtering MapConfig objects.
 * Input was generated by ent.
 */
export type MapConfigWhereInput = {
  and?: InputMaybe<Array<MapConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<MapConfigKey>;
  keyIn?: InputMaybe<Array<MapConfigKey>>;
  keyNEQ?: InputMaybe<MapConfigKey>;
  keyNotIn?: InputMaybe<Array<MapConfigKey>>;
  not?: InputMaybe<MapConfigWhereInput>;
  or?: InputMaybe<Array<MapConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaFile = Node & {
  __typename?: 'MediaFile';
  createdAt: Scalars['Time']['output'];
  deviceDocumentMedia?: Maybe<Array<DeviceDocument>>;
  deviceGroupDocumentMedia?: Maybe<Array<DeviceGroupDocument>>;
  deviceModelsMedias?: Maybe<Array<DeviceModel>>;
  export?: Maybe<Export>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  kmls?: Maybe<Array<Kml>>;
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  path: Scalars['String']['output'];
  status: MediaFileStatus;
  updatedAt: Scalars['Time']['output'];
  upgrade?: Maybe<Upgrade>;
  user?: Maybe<User>;
  userAvatar?: Maybe<Array<User>>;
  userID?: Maybe<Scalars['ID']['output']>;
  whitelabelLoginLogo?: Maybe<Array<Whitelabel>>;
  whitelabelLogo?: Maybe<Array<Whitelabel>>;
  yardDriverDetailsAvatar?: Maybe<Array<YardDriverProfile>>;
  yardDriverDetailsDlImage?: Maybe<Array<YardDriverProfile>>;
  yardVehicleInsuranceImage?: Maybe<Array<YardVehicle>>;
  yardVehiclePollutionImage?: Maybe<Array<YardVehicle>>;
  yardVehicleRcImage?: Maybe<Array<YardVehicle>>;
};

/** A connection to a list of items. */
export type MediaFileConnection = {
  __typename?: 'MediaFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MediaFileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MediaFileEdge = {
  __typename?: 'MediaFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MediaFile>;
};

export enum MediaFileField {
  CreatedAt = 'createdAt',
  FileName = 'fileName',
  IsPublic = 'isPublic',
  OrganisationId = 'organisationID',
  Path = 'path',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for MediaFile connections */
export type MediaFileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order MediaFiles. */
  field: MediaFileOrderField;
};

/** Properties by which MediaFile connections can be ordered. */
export enum MediaFileOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** MediaFileStatus is enum for the field status */
export enum MediaFileStatus {
  Failed = 'Failed',
  Orphaned = 'Orphaned',
  Pending = 'Pending',
  Uploaded = 'Uploaded',
  Uploading = 'Uploading'
}

/**
 * MediaFileWhereInput is used for filtering MediaFile objects.
 * Input was generated by ent.
 */
export type MediaFileWhereInput = {
  and?: InputMaybe<Array<MediaFileWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** file_name field predicates */
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileNameContains?: InputMaybe<Scalars['String']['input']>;
  fileNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  fileNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  fileNameGT?: InputMaybe<Scalars['String']['input']>;
  fileNameGTE?: InputMaybe<Scalars['String']['input']>;
  fileNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fileNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fileNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fileNameLT?: InputMaybe<Scalars['String']['input']>;
  fileNameLTE?: InputMaybe<Scalars['String']['input']>;
  fileNameNEQ?: InputMaybe<Scalars['String']['input']>;
  fileNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fileNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_document_media edge predicates */
  hasDeviceDocumentMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceDocumentMediaWith?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** device_group_document_media edge predicates */
  hasDeviceGroupDocumentMedia?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupDocumentMediaWith?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** device_models_medias edge predicates */
  hasDeviceModelsMedias?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceModelsMediasWith?: InputMaybe<Array<DeviceModelWhereInput>>;
  /** export edge predicates */
  hasExport?: InputMaybe<Scalars['Boolean']['input']>;
  hasExportWith?: InputMaybe<Array<ExportWhereInput>>;
  /** kmls edge predicates */
  hasKmls?: InputMaybe<Scalars['Boolean']['input']>;
  hasKmlsWith?: InputMaybe<Array<KmlWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** upgrade edge predicates */
  hasUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeWith?: InputMaybe<Array<UpgradeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_avatar edge predicates */
  hasUserAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserAvatarWith?: InputMaybe<Array<UserWhereInput>>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** whitelabel_login_logo edge predicates */
  hasWhitelabelLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelLoginLogoWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** whitelabel_logo edge predicates */
  hasWhitelabelLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelLogoWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** yard_driver_details_avatar edge predicates */
  hasYardDriverDetailsAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardDriverDetailsAvatarWith?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** yard_driver_details_dl_image edge predicates */
  hasYardDriverDetailsDlImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardDriverDetailsDlImageWith?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** yard_vehicle_insurance_image edge predicates */
  hasYardVehicleInsuranceImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVehicleInsuranceImageWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** yard_vehicle_pollution_image edge predicates */
  hasYardVehiclePollutionImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVehiclePollutionImageWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** yard_vehicle_rc_image edge predicates */
  hasYardVehicleRcImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVehicleRcImageWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_public field predicates */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isPublicNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<MediaFileWhereInput>;
  or?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** path field predicates */
  path?: InputMaybe<Scalars['String']['input']>;
  pathContains?: InputMaybe<Scalars['String']['input']>;
  pathContainsFold?: InputMaybe<Scalars['String']['input']>;
  pathEqualFold?: InputMaybe<Scalars['String']['input']>;
  pathGT?: InputMaybe<Scalars['String']['input']>;
  pathGTE?: InputMaybe<Scalars['String']['input']>;
  pathHasPrefix?: InputMaybe<Scalars['String']['input']>;
  pathHasSuffix?: InputMaybe<Scalars['String']['input']>;
  pathIn?: InputMaybe<Array<Scalars['String']['input']>>;
  pathLT?: InputMaybe<Scalars['String']['input']>;
  pathLTE?: InputMaybe<Scalars['String']['input']>;
  pathNEQ?: InputMaybe<Scalars['String']['input']>;
  pathNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** status field predicates */
  status?: InputMaybe<MediaFileStatus>;
  statusIn?: InputMaybe<Array<MediaFileStatus>>;
  statusNEQ?: InputMaybe<MediaFileStatus>;
  statusNotIn?: InputMaybe<Array<MediaFileStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MinimalAttendanceDetailSyncInput = {
  actualMarkIn: Scalars['Time']['input'];
  actualMarkOut: Scalars['Time']['input'];
  attendanceType?: InputMaybe<Scalars['String']['input']>;
  rosterShiftId: Scalars['ID']['input'];
  shiftNumber: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type MinimalAttendanceDetailSyncResult = {
  __typename?: 'MinimalAttendanceDetailSyncResult';
  failedCount: Scalars['Int']['output'];
  rows: Array<MinimalAttendanceDetailSyncResultRow>;
  successCount: Scalars['Int']['output'];
};

export type MinimalAttendanceDetailSyncResultRow = {
  __typename?: 'MinimalAttendanceDetailSyncResultRow';
  actualDurationMinutes: Scalars['Int']['output'];
  attendanceDate: Scalars['Time']['output'];
  attendanceId: Scalars['ID']['output'];
  createdAttendance: Scalars['Boolean']['output'];
  createdDetail: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  rosterShiftId: Scalars['ID']['output'];
  shiftNumber: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AdhocTableCreate: AdhocTable;
  AdhocTableCreateBulk?: Maybe<Array<AdhocTable>>;
  AdhocTableDelete: AdhocTable;
  AdhocTableUpdate: AdhocTable;
  AttendanceCreate: Attendance;
  AttendanceCreateBulk?: Maybe<Array<Attendance>>;
  AttendanceDelete: Attendance;
  AttendanceDetailCreate: AttendanceDetail;
  AttendanceDetailCreateBulk?: Maybe<Array<AttendanceDetail>>;
  AttendanceDetailDelete: AttendanceDetail;
  AttendanceDetailUpdate: AttendanceDetail;
  AttendanceUpdate: Attendance;
  BaseAddonCreate: BaseAddon;
  BaseAddonCreateBulk?: Maybe<Array<BaseAddon>>;
  BaseAddonDelete: BaseAddon;
  BaseAddonUpdate: BaseAddon;
  BaseLicensePlanAddonCreate: BaseLicensePlanAddon;
  BaseLicensePlanAddonCreateBulk?: Maybe<Array<BaseLicensePlanAddon>>;
  BaseLicensePlanAddonDelete: BaseLicensePlanAddon;
  BaseLicensePlanAddonUpdate: BaseLicensePlanAddon;
  BaseLicensePlanCreate: BaseLicensePlan;
  BaseLicensePlanCreateBulk?: Maybe<Array<BaseLicensePlan>>;
  BaseLicensePlanDelete: BaseLicensePlan;
  BaseLicensePlanUpdate: BaseLicensePlan;
  BaseReportCreate: BaseReport;
  BaseReportCreateBulk?: Maybe<Array<BaseReport>>;
  BaseReportDelete: BaseReport;
  BaseReportUpdate: BaseReport;
  CaptureDeviceAddedOnPython: Scalars['Boolean']['output'];
  ChangeLogCreate: ChangeLog;
  ChangeLogCreateBulk?: Maybe<Array<ChangeLog>>;
  ChangeLogDelete: ChangeLog;
  ChangeLogUpdate: ChangeLog;
  ChangeUserPassword: Scalars['Boolean']['output'];
  ConsumerConfigCreate: ConsumerConfig;
  ConsumerConfigCreateBulk?: Maybe<Array<ConsumerConfig>>;
  ConsumerConfigDelete: ConsumerConfig;
  ConsumerConfigUpdate: ConsumerConfig;
  ConsumerServerCreate: ConsumerServer;
  ConsumerServerCreateBulk?: Maybe<Array<ConsumerServer>>;
  ConsumerServerDelete: ConsumerServer;
  ConsumerServerUpdate: ConsumerServer;
  CustomKmlCreate: Kml;
  DerivedReportCreate: DerivedReport;
  DerivedReportCreateBulk?: Maybe<Array<DerivedReport>>;
  DerivedReportDelete: DerivedReport;
  DerivedReportUpdate: DerivedReport;
  DeviceActionLogCreate: DeviceActionLog;
  DeviceActionLogCreateBulk?: Maybe<Array<DeviceActionLog>>;
  DeviceActionLogDelete: DeviceActionLog;
  DeviceActionLogUpdate: DeviceActionLog;
  DeviceCategoryCreate: DeviceCategory;
  DeviceCategoryCreateBulk?: Maybe<Array<DeviceCategory>>;
  DeviceCategoryDelete: DeviceCategory;
  DeviceCategoryUpdate: DeviceCategory;
  DeviceConfigCreate: DeviceConfig;
  DeviceConfigCreateBulk?: Maybe<Array<DeviceConfig>>;
  DeviceConfigDelete: DeviceConfig;
  DeviceConfigUpdate: DeviceConfig;
  DeviceCreate: Device;
  DeviceCreateBulk?: Maybe<Array<Device>>;
  DeviceDelete: Device;
  DeviceGroupCreate: DeviceGroup;
  DeviceGroupCreateBulk?: Maybe<Array<DeviceGroup>>;
  DeviceGroupDelete: DeviceGroup;
  DeviceGroupUpdate: DeviceGroup;
  DeviceModelCreate: DeviceModel;
  DeviceModelCreateBulk?: Maybe<Array<DeviceModel>>;
  DeviceModelDelete: DeviceModel;
  DeviceModelUpdate: DeviceModel;
  DeviceParkingModeConfigCreate: DeviceParkingModeConfig;
  DeviceParkingModeConfigCreateBulk?: Maybe<Array<DeviceParkingModeConfig>>;
  DeviceParkingModeConfigDelete: DeviceParkingModeConfig;
  DeviceParkingModeConfigUpdate: DeviceParkingModeConfig;
  DevicePlaybackFilesCreate: DevicePlaybackFiles;
  DevicePlaybackFilesCreateBulk?: Maybe<Array<DevicePlaybackFiles>>;
  DevicePlaybackFilesDelete: DevicePlaybackFiles;
  DevicePlaybackFilesUpdate: DevicePlaybackFiles;
  DeviceUpdate: Device;
  FirebasePrivateKeyCreate: FirebasePrivateKey;
  FirebasePrivateKeyCreateBulk?: Maybe<Array<FirebasePrivateKey>>;
  FirebasePrivateKeyDelete: FirebasePrivateKey;
  FirebasePrivateKeyUpdate: FirebasePrivateKey;
  GeofenceCreate: Geofence;
  GeofenceCreateBulk?: Maybe<Array<Geofence>>;
  GeofenceDelete: Geofence;
  GeofenceDeviceGroupCreate: GeofenceDeviceGroup;
  GeofenceDeviceGroupCreateBulk?: Maybe<Array<GeofenceDeviceGroup>>;
  GeofenceDeviceGroupDelete: GeofenceDeviceGroup;
  GeofenceDeviceGroupUpdate: GeofenceDeviceGroup;
  GeofenceUpdate: Geofence;
  HaltPointCreate: HaltPoint;
  HaltPointCreateBulk?: Maybe<Array<HaltPoint>>;
  HaltPointDelete: HaltPoint;
  HaltPointUpdate: HaltPoint;
  InspectionReportCreate: InspectionReport;
  InspectionReportCreateBulk?: Maybe<Array<InspectionReport>>;
  InspectionReportDelete: InspectionReport;
  InspectionReportUpdate: InspectionReport;
  KmlCreate: Kml;
  KmlCreateBulk?: Maybe<Array<Kml>>;
  KmlDelete: Kml;
  KmlUpdate: Kml;
  LeaveDateCreate: LeaveDate;
  LeaveDateCreateBulk?: Maybe<Array<LeaveDate>>;
  LeaveDateDelete: LeaveDate;
  LeaveDateUpdate: LeaveDate;
  LeaveRequestCreate: LeaveRequest;
  LeaveRequestCreateBulk?: Maybe<Array<LeaveRequest>>;
  LeaveRequestDelete: LeaveRequest;
  LeaveRequestUpdate: LeaveRequest;
  LeaveTypeCreate: LeaveType;
  LeaveTypeCreateBulk?: Maybe<Array<LeaveType>>;
  LeaveTypeDelete: LeaveType;
  LeaveTypeUpdate: LeaveType;
  LicenseCreate: License;
  LicenseCreateBulk?: Maybe<Array<License>>;
  LicenseDelete: License;
  LicenseOrderAddonCreate: LicenseOrderAddon;
  LicenseOrderAddonCreateBulk?: Maybe<Array<LicenseOrderAddon>>;
  LicenseOrderAddonDelete: LicenseOrderAddon;
  LicenseOrderAddonUpdate: LicenseOrderAddon;
  LicenseUpdate: License;
  MapConfigCreate: MapConfig;
  MapConfigCreateBulk?: Maybe<Array<MapConfig>>;
  MapConfigDelete: MapConfig;
  MapConfigUpdate: MapConfig;
  MinimalAttendanceDetailSync: MinimalAttendanceDetailSyncResult;
  NotifyChannelCreate: NotifyChannel;
  NotifyChannelCreateBulk?: Maybe<Array<NotifyChannel>>;
  NotifyChannelDelete: NotifyChannel;
  NotifyChannelUpdate: NotifyChannel;
  NotifyConfigChannelCreate: NotifyConfigChannel;
  NotifyConfigChannelCreateBulk?: Maybe<Array<NotifyConfigChannel>>;
  NotifyConfigChannelDelete: NotifyConfigChannel;
  NotifyConfigChannelUpdate: NotifyConfigChannel;
  NotifyConfigCreate: NotifyConfig;
  NotifyConfigCreateBulk?: Maybe<Array<NotifyConfig>>;
  NotifyConfigDelete: NotifyConfig;
  NotifyConfigDeviceGroupCreate: NotifyConfigDeviceGroup;
  NotifyConfigDeviceGroupCreateBulk?: Maybe<Array<NotifyConfigDeviceGroup>>;
  NotifyConfigDeviceGroupDelete: NotifyConfigDeviceGroup;
  NotifyConfigDeviceGroupUpdate: NotifyConfigDeviceGroup;
  NotifyConfigEventCreate: NotifyConfigEvent;
  NotifyConfigEventCreateBulk?: Maybe<Array<NotifyConfigEvent>>;
  NotifyConfigEventDelete: NotifyConfigEvent;
  NotifyConfigEventUpdate: NotifyConfigEvent;
  NotifyConfigGeofenceCreate: NotifyConfigGeofence;
  NotifyConfigGeofenceCreateBulk?: Maybe<Array<NotifyConfigGeofence>>;
  NotifyConfigGeofenceDelete: NotifyConfigGeofence;
  NotifyConfigGeofenceUpdate: NotifyConfigGeofence;
  NotifyConfigUpdate: NotifyConfig;
  NotifyEventOptionCreate: NotifyEventOption;
  NotifyEventOptionCreateBulk?: Maybe<Array<NotifyEventOption>>;
  NotifyEventOptionDelete: NotifyEventOption;
  NotifyEventOptionUpdate: NotifyEventOption;
  OrganisationCreate: Organisation;
  OrganisationCreateBulk?: Maybe<Array<Organisation>>;
  OrganisationDelete: Organisation;
  OrganisationRoleCreate: OrganisationRole;
  OrganisationRoleCreateBulk?: Maybe<Array<OrganisationRole>>;
  OrganisationRoleDelete: OrganisationRole;
  OrganisationRolePermissionCreate: OrganisationRolePermission;
  OrganisationRolePermissionCreateBulk?: Maybe<Array<OrganisationRolePermission>>;
  OrganisationRolePermissionDelete: OrganisationRolePermission;
  OrganisationRolePermissionUpdate: OrganisationRolePermission;
  OrganisationRoleUpdate: OrganisationRole;
  OrganisationUpdate: Organisation;
  OrganisationUpgradeCreate: OrganisationUpgrade;
  OrganisationUpgradeCreateBulk?: Maybe<Array<OrganisationUpgrade>>;
  OrganisationUpgradeDelete: OrganisationUpgrade;
  OrganisationUpgradeUpdate: OrganisationUpgrade;
  OrganisationUserCreate: OrganisationUser;
  OrganisationUserCreateBulk?: Maybe<Array<OrganisationUser>>;
  OrganisationUserDelete: OrganisationUser;
  OrganisationUserUpdate: OrganisationUser;
  PermissionCreate: Permission;
  PermissionCreateBulk?: Maybe<Array<Permission>>;
  PermissionDelete: Permission;
  PermissionUpdate: Permission;
  PinnedDevicesCreate: PinnedDevices;
  PinnedDevicesCreateBulk?: Maybe<Array<PinnedDevices>>;
  PinnedDevicesDelete: PinnedDevices;
  PinnedDevicesUpdate: PinnedDevices;
  PoiCreate: Poi;
  PoiCreateBulk?: Maybe<Array<Poi>>;
  PoiDelete: Poi;
  PoiUpdate: Poi;
  PositionAttributeFormulaCreate: PositionAttributeFormula;
  PositionAttributeFormulaCreateBulk?: Maybe<Array<PositionAttributeFormula>>;
  PositionAttributeFormulaDelete: PositionAttributeFormula;
  PositionAttributeFormulaUpdate: PositionAttributeFormula;
  ProfileCreate: Profile;
  ProfileCreateBulk?: Maybe<Array<Profile>>;
  ProfileDelete: Profile;
  ProfileUpdate: Profile;
  PusherConfigCreate: PusherConfig;
  PusherConfigCreateBulk?: Maybe<Array<PusherConfig>>;
  PusherConfigDelete: PusherConfig;
  PusherConfigUpdate: PusherConfig;
  RosterCreate: Roster;
  RosterCreateBulk?: Maybe<Array<Roster>>;
  RosterDelete: Roster;
  RosterScheduleCreate: RosterSchedule;
  RosterScheduleCreateBulk?: Maybe<Array<RosterSchedule>>;
  RosterScheduleDelete: RosterSchedule;
  RosterScheduleUpdate: RosterSchedule;
  RosterShiftCreate: RosterShift;
  RosterShiftCreateBulk?: Maybe<Array<RosterShift>>;
  RosterShiftDelete: RosterShift;
  RosterShiftUpdate: RosterShift;
  RosterUpdate: Roster;
  RouteCreate: Route;
  RouteCreateBulk?: Maybe<Array<Route>>;
  RouteDelete: Route;
  RouteHaltPointCreate: RouteHaltPoint;
  RouteHaltPointCreateBulk?: Maybe<Array<RouteHaltPoint>>;
  RouteHaltPointDelete: RouteHaltPoint;
  RouteHaltPointTargetCreate: RouteHaltPointTarget;
  RouteHaltPointTargetCreateBulk?: Maybe<Array<RouteHaltPointTarget>>;
  RouteHaltPointTargetDelete: RouteHaltPointTarget;
  RouteHaltPointTargetUpdate: RouteHaltPointTarget;
  RouteHaltPointUpdate: RouteHaltPoint;
  RouteShiftCreate: RouteShift;
  RouteShiftCreateBulk?: Maybe<Array<RouteShift>>;
  RouteShiftDelete: RouteShift;
  RouteShiftUpdate: RouteShift;
  RouteTimeLineCreate: RouteTimeLine;
  RouteTimeLineCreateBulk?: Maybe<Array<RouteTimeLine>>;
  RouteTimeLineDelete: RouteTimeLine;
  RouteTimeLineUpdate: RouteTimeLine;
  RouteUpdate: Route;
  SaveFcmToken: Scalars['Boolean']['output'];
  ScheduleTaskCreate: ScheduleTask;
  ScheduleTaskCreateBulk?: Maybe<Array<ScheduleTask>>;
  ScheduleTaskDelete: ScheduleTask;
  ScheduleTaskUpdate: ScheduleTask;
  ShiftCreate: Shift;
  ShiftCreateBulk?: Maybe<Array<Shift>>;
  ShiftDelete: Shift;
  ShiftUpdate: Shift;
  SimCreate: Sim;
  SimCreateBulk?: Maybe<Array<Sim>>;
  SimDelete: Sim;
  SimUpdate: Sim;
  StiQRCreate: StiQr;
  StiQRCreateBulk?: Maybe<Array<StiQr>>;
  StiQRDelete: StiQr;
  StiQRUpdate: StiQr;
  SubscriptionLicenseOrderCreate: SubscriptionLicenseOrder;
  SubscriptionLicenseOrderCreateBulk?: Maybe<Array<SubscriptionLicenseOrder>>;
  SubscriptionLicenseOrderDelete: SubscriptionLicenseOrder;
  SubscriptionLicenseOrderUpdate: SubscriptionLicenseOrder;
  SupportTicketCreate: SupportTicket;
  SupportTicketCreateBulk?: Maybe<Array<SupportTicket>>;
  SupportTicketDelete: SupportTicket;
  SupportTicketUpdate: SupportTicket;
  TargetCreate: Target;
  TargetCreateBulk?: Maybe<Array<Target>>;
  TargetDelete: Target;
  TargetUpdate: Target;
  TripConfigsCreate: TripConfigs;
  TripConfigsCreateBulk?: Maybe<Array<TripConfigs>>;
  TripConfigsDelete: TripConfigs;
  TripConfigsUpdate: TripConfigs;
  TripCreate: Trip;
  TripCreateBulk?: Maybe<Array<Trip>>;
  TripDelete: Trip;
  TripHaltPointCreate: TripHaltPoint;
  TripHaltPointCreateBulk?: Maybe<Array<TripHaltPoint>>;
  TripHaltPointDelete: TripHaltPoint;
  TripHaltPointTargetCreate: TripHaltPointTarget;
  TripHaltPointTargetCreateBulk?: Maybe<Array<TripHaltPointTarget>>;
  TripHaltPointTargetDelete: TripHaltPointTarget;
  TripHaltPointTargetTimeLineCreate: TripHaltPointTargetTimeLine;
  TripHaltPointTargetTimeLineCreateBulk?: Maybe<Array<TripHaltPointTargetTimeLine>>;
  TripHaltPointTargetTimeLineDelete: TripHaltPointTargetTimeLine;
  TripHaltPointTargetTimeLineUpdate: TripHaltPointTargetTimeLine;
  TripHaltPointTargetUpdate: TripHaltPointTarget;
  TripHaltPointTimeLineCreate: TripHaltPointTimeLine;
  TripHaltPointTimeLineCreateBulk?: Maybe<Array<TripHaltPointTimeLine>>;
  TripHaltPointTimeLineDelete: TripHaltPointTimeLine;
  TripHaltPointTimeLineUpdate: TripHaltPointTimeLine;
  TripHaltPointUpdate: TripHaltPoint;
  TripTimeLineCreate: TripTimeLine;
  TripTimeLineCreateBulk?: Maybe<Array<TripTimeLine>>;
  TripTimeLineDelete: TripTimeLine;
  TripTimeLineUpdate: TripTimeLine;
  TripUpdate: Trip;
  UpgradeCreate: Upgrade;
  UpgradeCreateBulk?: Maybe<Array<Upgrade>>;
  UpgradeDelete: Upgrade;
  UpgradeOrganisationPriceCreate: UpgradeOrganisationPrice;
  UpgradeOrganisationPriceCreateBulk?: Maybe<Array<UpgradeOrganisationPrice>>;
  UpgradeOrganisationPriceDelete: UpgradeOrganisationPrice;
  UpgradeOrganisationPriceUpdate: UpgradeOrganisationPrice;
  UpgradeUpdate: Upgrade;
  UserConfigCreate: UserConfig;
  UserConfigCreateBulk?: Maybe<Array<UserConfig>>;
  UserConfigDelete: UserConfig;
  UserConfigUpdate: UserConfig;
  UserCreate: User;
  UserCreateBulk?: Maybe<Array<User>>;
  UserDelete: User;
  UserLeaveBalanceCreate: UserLeaveBalance;
  UserLeaveBalanceCreateBulk?: Maybe<Array<UserLeaveBalance>>;
  UserLeaveBalanceDelete: UserLeaveBalance;
  UserLeaveBalanceUpdate: UserLeaveBalance;
  UserReportBookmarkCreate: UserReportBookmark;
  UserReportBookmarkCreateBulk?: Maybe<Array<UserReportBookmark>>;
  UserReportBookmarkDelete: UserReportBookmark;
  UserReportBookmarkUpdate: UserReportBookmark;
  UserRosterAssignmentCreate: UserRosterAssignment;
  UserRosterAssignmentCreateBulk?: Maybe<Array<UserRosterAssignment>>;
  UserRosterAssignmentDelete: UserRosterAssignment;
  UserRosterAssignmentUpdate: UserRosterAssignment;
  UserUpdate: User;
  WalletCreate: Wallet;
  WalletCreateBulk?: Maybe<Array<Wallet>>;
  WalletDelete: Wallet;
  WalletPaymentTransactionCreate: WalletPaymentTransaction;
  WalletPaymentTransactionCreateBulk?: Maybe<Array<WalletPaymentTransaction>>;
  WalletPaymentTransactionDelete: WalletPaymentTransaction;
  WalletPaymentTransactionUpdate: WalletPaymentTransaction;
  WalletTransactionCreate: WalletTransaction;
  WalletTransactionCreateBulk?: Maybe<Array<WalletTransaction>>;
  WalletTransactionDelete: WalletTransaction;
  WalletTransactionUpdate: WalletTransaction;
  WalletUpdate: Wallet;
  WhitelabelConfigCreate: WhitelabelConfig;
  WhitelabelConfigCreateBulk?: Maybe<Array<WhitelabelConfig>>;
  WhitelabelConfigDelete: WhitelabelConfig;
  WhitelabelConfigUpdate: WhitelabelConfig;
  YardTripStatusCreate: YardTripStatus;
  YardTripStatusCreateBulk?: Maybe<Array<YardTripStatus>>;
  YardTripStatusDelete: YardTripStatus;
  YardTripStatusUpdate: YardTripStatus;
  YardWarehouseDockCreate: YardWarehouseDock;
  YardWarehouseDockCreateBulk?: Maybe<Array<YardWarehouseDock>>;
  YardWarehouseDockDelete: YardWarehouseDock;
  YardWarehouseDockSharingCreate: YardWarehouseDockSharing;
  YardWarehouseDockSharingCreateBulk?: Maybe<Array<YardWarehouseDockSharing>>;
  YardWarehouseDockSharingDelete: YardWarehouseDockSharing;
  YardWarehouseDockSharingUpdate: YardWarehouseDockSharing;
  YardWarehouseDockUpdate: YardWarehouseDock;
  YardWarehouseRoutePathCreate: YardWarehouseRoutePath;
  YardWarehouseRoutePathCreateBulk?: Maybe<Array<YardWarehouseRoutePath>>;
  YardWarehouseRoutePathDelete: YardWarehouseRoutePath;
  YardWarehouseRoutePathUpdate: YardWarehouseRoutePath;
};


export type MutationAdhocTableCreateArgs = {
  input: CreateAdhocTableInput;
};


export type MutationAdhocTableCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateAdhocTableInput>>;
};


export type MutationAdhocTableDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdhocTableUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAdhocTableInput;
};


export type MutationAttendanceCreateArgs = {
  input: CreateAttendanceInput;
};


export type MutationAttendanceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateAttendanceInput>>;
};


export type MutationAttendanceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAttendanceDetailCreateArgs = {
  input: CreateAttendanceDetailInput;
};


export type MutationAttendanceDetailCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateAttendanceDetailInput>>;
};


export type MutationAttendanceDetailDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAttendanceDetailUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAttendanceDetailInput;
};


export type MutationAttendanceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAttendanceInput;
};


export type MutationBaseAddonCreateArgs = {
  input: CreateBaseAddonInput;
};


export type MutationBaseAddonCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateBaseAddonInput>>;
};


export type MutationBaseAddonDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBaseAddonUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBaseAddonInput;
};


export type MutationBaseLicensePlanAddonCreateArgs = {
  input: CreateBaseLicensePlanAddonInput;
};


export type MutationBaseLicensePlanAddonCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateBaseLicensePlanAddonInput>>;
};


export type MutationBaseLicensePlanAddonDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBaseLicensePlanAddonUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBaseLicensePlanAddonInput;
};


export type MutationBaseLicensePlanCreateArgs = {
  input: CreateBaseLicensePlanInput;
};


export type MutationBaseLicensePlanCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateBaseLicensePlanInput>>;
};


export type MutationBaseLicensePlanDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBaseLicensePlanUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBaseLicensePlanInput;
};


export type MutationBaseReportCreateArgs = {
  input: CreateBaseReportInput;
};


export type MutationBaseReportCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateBaseReportInput>>;
};


export type MutationBaseReportDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBaseReportUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBaseReportInput;
};


export type MutationCaptureDeviceAddedOnPythonArgs = {
  details: Scalars['JSON']['input'];
  deviceId: Scalars['String']['input'];
  server: DeviceIngestServer;
  userId: Scalars['String']['input'];
};


export type MutationChangeLogCreateArgs = {
  input: CreateChangeLogInput;
};


export type MutationChangeLogCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateChangeLogInput>>;
};


export type MutationChangeLogDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeLogUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateChangeLogInput;
};


export type MutationChangeUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationConsumerConfigCreateArgs = {
  input: CreateConsumerConfigInput;
};


export type MutationConsumerConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateConsumerConfigInput>>;
};


export type MutationConsumerConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConsumerConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConsumerConfigInput;
};


export type MutationConsumerServerCreateArgs = {
  input: CreateConsumerServerInput;
};


export type MutationConsumerServerCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateConsumerServerInput>>;
};


export type MutationConsumerServerDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConsumerServerUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConsumerServerInput;
};


export type MutationCustomKmlCreateArgs = {
  createGeofence?: InputMaybe<Scalars['Boolean']['input']>;
  fileID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organisationID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDerivedReportCreateArgs = {
  input: CreateDerivedReportInput;
};


export type MutationDerivedReportCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDerivedReportInput>>;
};


export type MutationDerivedReportDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDerivedReportUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDerivedReportInput;
};


export type MutationDeviceActionLogCreateArgs = {
  input: CreateDeviceActionLogInput;
};


export type MutationDeviceActionLogCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceActionLogInput>>;
};


export type MutationDeviceActionLogDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceActionLogUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceActionLogInput;
};


export type MutationDeviceCategoryCreateArgs = {
  input: CreateDeviceCategoryInput;
};


export type MutationDeviceCategoryCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceCategoryInput>>;
};


export type MutationDeviceCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceCategoryUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceCategoryInput;
};


export type MutationDeviceConfigCreateArgs = {
  input: CreateDeviceConfigInput;
};


export type MutationDeviceConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceConfigInput>>;
};


export type MutationDeviceConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceConfigInput;
};


export type MutationDeviceCreateArgs = {
  input: CreateDeviceInput;
};


export type MutationDeviceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceInput>>;
};


export type MutationDeviceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceGroupCreateArgs = {
  input: CreateDeviceGroupInput;
};


export type MutationDeviceGroupCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceGroupInput>>;
};


export type MutationDeviceGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceGroupInput;
};


export type MutationDeviceModelCreateArgs = {
  input: CreateDeviceModelInput;
};


export type MutationDeviceModelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceModelInput>>;
};


export type MutationDeviceModelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceModelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceModelInput;
};


export type MutationDeviceParkingModeConfigCreateArgs = {
  input: CreateDeviceParkingModeConfigInput;
};


export type MutationDeviceParkingModeConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDeviceParkingModeConfigInput>>;
};


export type MutationDeviceParkingModeConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeviceParkingModeConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceParkingModeConfigInput;
};


export type MutationDevicePlaybackFilesCreateArgs = {
  input: CreateDevicePlaybackFilesInput;
};


export type MutationDevicePlaybackFilesCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateDevicePlaybackFilesInput>>;
};


export type MutationDevicePlaybackFilesDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDevicePlaybackFilesUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDevicePlaybackFilesInput;
};


export type MutationDeviceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceInput;
};


export type MutationFirebasePrivateKeyCreateArgs = {
  input: CreateFirebasePrivateKeyInput;
};


export type MutationFirebasePrivateKeyCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateFirebasePrivateKeyInput>>;
};


export type MutationFirebasePrivateKeyDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFirebasePrivateKeyUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFirebasePrivateKeyInput;
};


export type MutationGeofenceCreateArgs = {
  input: CreateGeofenceInput;
};


export type MutationGeofenceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateGeofenceInput>>;
};


export type MutationGeofenceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGeofenceDeviceGroupCreateArgs = {
  input: CreateGeofenceDeviceGroupInput;
};


export type MutationGeofenceDeviceGroupCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateGeofenceDeviceGroupInput>>;
};


export type MutationGeofenceDeviceGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGeofenceDeviceGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGeofenceDeviceGroupInput;
};


export type MutationGeofenceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGeofenceInput;
};


export type MutationHaltPointCreateArgs = {
  input: CreateHaltPointInput;
};


export type MutationHaltPointCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateHaltPointInput>>;
};


export type MutationHaltPointDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationHaltPointUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHaltPointInput;
};


export type MutationInspectionReportCreateArgs = {
  input: CreateInspectionReportInput;
};


export type MutationInspectionReportCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateInspectionReportInput>>;
};


export type MutationInspectionReportDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInspectionReportUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInspectionReportInput;
};


export type MutationKmlCreateArgs = {
  input: CreateKmlInput;
};


export type MutationKmlCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateKmlInput>>;
};


export type MutationKmlDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationKmlUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKmlInput;
};


export type MutationLeaveDateCreateArgs = {
  input: CreateLeaveDateInput;
};


export type MutationLeaveDateCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLeaveDateInput>>;
};


export type MutationLeaveDateDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeaveDateUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeaveDateInput;
};


export type MutationLeaveRequestCreateArgs = {
  input: CreateLeaveRequestInput;
};


export type MutationLeaveRequestCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLeaveRequestInput>>;
};


export type MutationLeaveRequestDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeaveRequestUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeaveRequestInput;
};


export type MutationLeaveTypeCreateArgs = {
  input: CreateLeaveTypeInput;
};


export type MutationLeaveTypeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLeaveTypeInput>>;
};


export type MutationLeaveTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeaveTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeaveTypeInput;
};


export type MutationLicenseCreateArgs = {
  input: CreateLicenseInput;
};


export type MutationLicenseCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLicenseInput>>;
};


export type MutationLicenseDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLicenseOrderAddonCreateArgs = {
  input: CreateLicenseOrderAddonInput;
};


export type MutationLicenseOrderAddonCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateLicenseOrderAddonInput>>;
};


export type MutationLicenseOrderAddonDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLicenseOrderAddonUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLicenseOrderAddonInput;
};


export type MutationLicenseUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLicenseInput;
};


export type MutationMapConfigCreateArgs = {
  input: CreateMapConfigInput;
};


export type MutationMapConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateMapConfigInput>>;
};


export type MutationMapConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMapConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMapConfigInput;
};


export type MutationMinimalAttendanceDetailSyncArgs = {
  records: Array<MinimalAttendanceDetailSyncInput>;
};


export type MutationNotifyChannelCreateArgs = {
  input: CreateNotifyChannelInput;
};


export type MutationNotifyChannelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyChannelInput>>;
};


export type MutationNotifyChannelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyChannelInput;
};


export type MutationNotifyConfigChannelCreateArgs = {
  input: CreateNotifyConfigChannelInput;
};


export type MutationNotifyConfigChannelCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigChannelInput>>;
};


export type MutationNotifyConfigChannelDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigChannelInput;
};


export type MutationNotifyConfigCreateArgs = {
  input: CreateNotifyConfigInput;
};


export type MutationNotifyConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigInput>>;
};


export type MutationNotifyConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigDeviceGroupCreateArgs = {
  input: CreateNotifyConfigDeviceGroupInput;
};


export type MutationNotifyConfigDeviceGroupCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigDeviceGroupInput>>;
};


export type MutationNotifyConfigDeviceGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigDeviceGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigDeviceGroupInput;
};


export type MutationNotifyConfigEventCreateArgs = {
  input: CreateNotifyConfigEventInput;
};


export type MutationNotifyConfigEventCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigEventInput>>;
};


export type MutationNotifyConfigEventDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigEventUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigEventInput;
};


export type MutationNotifyConfigGeofenceCreateArgs = {
  input: CreateNotifyConfigGeofenceInput;
};


export type MutationNotifyConfigGeofenceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyConfigGeofenceInput>>;
};


export type MutationNotifyConfigGeofenceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyConfigGeofenceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigGeofenceInput;
};


export type MutationNotifyConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyConfigInput;
};


export type MutationNotifyEventOptionCreateArgs = {
  input: CreateNotifyEventOptionInput;
};


export type MutationNotifyEventOptionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateNotifyEventOptionInput>>;
};


export type MutationNotifyEventOptionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNotifyEventOptionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotifyEventOptionInput;
};


export type MutationOrganisationCreateArgs = {
  input: CreateOrganisationInput;
};


export type MutationOrganisationCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationInput>>;
};


export type MutationOrganisationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationRoleCreateArgs = {
  input: CreateOrganisationRoleInput;
};


export type MutationOrganisationRoleCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationRoleInput>>;
};


export type MutationOrganisationRoleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationRolePermissionCreateArgs = {
  input: CreateOrganisationRolePermissionInput;
};


export type MutationOrganisationRolePermissionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationRolePermissionInput>>;
};


export type MutationOrganisationRolePermissionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationRolePermissionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationRolePermissionInput;
};


export type MutationOrganisationRoleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationRoleInput;
};


export type MutationOrganisationUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationInput;
};


export type MutationOrganisationUpgradeCreateArgs = {
  input: CreateOrganisationUpgradeInput;
};


export type MutationOrganisationUpgradeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationUpgradeInput>>;
};


export type MutationOrganisationUpgradeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationUpgradeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationUpgradeInput;
};


export type MutationOrganisationUserCreateArgs = {
  input: CreateOrganisationUserInput;
};


export type MutationOrganisationUserCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateOrganisationUserInput>>;
};


export type MutationOrganisationUserDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrganisationUserUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganisationUserInput;
};


export type MutationPermissionCreateArgs = {
  input: CreatePermissionInput;
};


export type MutationPermissionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePermissionInput>>;
};


export type MutationPermissionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPermissionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePermissionInput;
};


export type MutationPinnedDevicesCreateArgs = {
  input: CreatePinnedDevicesInput;
};


export type MutationPinnedDevicesCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePinnedDevicesInput>>;
};


export type MutationPinnedDevicesDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPinnedDevicesUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePinnedDevicesInput;
};


export type MutationPoiCreateArgs = {
  input: CreatePoiInput;
};


export type MutationPoiCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePoiInput>>;
};


export type MutationPoiDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPoiUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePoiInput;
};


export type MutationPositionAttributeFormulaCreateArgs = {
  input: CreatePositionAttributeFormulaInput;
};


export type MutationPositionAttributeFormulaCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePositionAttributeFormulaInput>>;
};


export type MutationPositionAttributeFormulaDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPositionAttributeFormulaUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePositionAttributeFormulaInput;
};


export type MutationProfileCreateArgs = {
  input: CreateProfileInput;
};


export type MutationProfileCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateProfileInput>>;
};


export type MutationProfileDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProfileUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProfileInput;
};


export type MutationPusherConfigCreateArgs = {
  input: CreatePusherConfigInput;
};


export type MutationPusherConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreatePusherConfigInput>>;
};


export type MutationPusherConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPusherConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePusherConfigInput;
};


export type MutationRosterCreateArgs = {
  input: CreateRosterInput;
};


export type MutationRosterCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateRosterInput>>;
};


export type MutationRosterDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRosterScheduleCreateArgs = {
  input: CreateRosterScheduleInput;
};


export type MutationRosterScheduleCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateRosterScheduleInput>>;
};


export type MutationRosterScheduleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRosterScheduleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRosterScheduleInput;
};


export type MutationRosterShiftCreateArgs = {
  input: CreateRosterShiftInput;
};


export type MutationRosterShiftCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateRosterShiftInput>>;
};


export type MutationRosterShiftDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRosterShiftUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRosterShiftInput;
};


export type MutationRosterUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRosterInput;
};


export type MutationRouteCreateArgs = {
  input: CreateRouteInput;
};


export type MutationRouteCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateRouteInput>>;
};


export type MutationRouteDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRouteHaltPointCreateArgs = {
  input: CreateRouteHaltPointInput;
};


export type MutationRouteHaltPointCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateRouteHaltPointInput>>;
};


export type MutationRouteHaltPointDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRouteHaltPointTargetCreateArgs = {
  input: CreateRouteHaltPointTargetInput;
};


export type MutationRouteHaltPointTargetCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateRouteHaltPointTargetInput>>;
};


export type MutationRouteHaltPointTargetDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRouteHaltPointTargetUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRouteHaltPointTargetInput;
};


export type MutationRouteHaltPointUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRouteHaltPointInput;
};


export type MutationRouteShiftCreateArgs = {
  input: CreateRouteShiftInput;
};


export type MutationRouteShiftCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateRouteShiftInput>>;
};


export type MutationRouteShiftDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRouteShiftUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRouteShiftInput;
};


export type MutationRouteTimeLineCreateArgs = {
  input: CreateRouteTimeLineInput;
};


export type MutationRouteTimeLineCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateRouteTimeLineInput>>;
};


export type MutationRouteTimeLineDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRouteTimeLineUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRouteTimeLineInput;
};


export type MutationRouteUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRouteInput;
};


export type MutationSaveFcmTokenArgs = {
  fcmSenderId: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
  platformFriendlyName: Scalars['String']['input'];
  platformKind: NotifyChannelFcmDevicePlatform;
  platformUniqueId: Scalars['String']['input'];
};


export type MutationScheduleTaskCreateArgs = {
  input: CreateScheduleTaskInput;
};


export type MutationScheduleTaskCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateScheduleTaskInput>>;
};


export type MutationScheduleTaskDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationScheduleTaskUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateScheduleTaskInput;
};


export type MutationShiftCreateArgs = {
  input: CreateShiftInput;
};


export type MutationShiftCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateShiftInput>>;
};


export type MutationShiftDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShiftUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateShiftInput;
};


export type MutationSimCreateArgs = {
  input: CreateSimInput;
};


export type MutationSimCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateSimInput>>;
};


export type MutationSimDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSimUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSimInput;
};


export type MutationStiQrCreateArgs = {
  input: CreateStiQrInput;
};


export type MutationStiQrCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateStiQrInput>>;
};


export type MutationStiQrDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStiQrUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStiQrInput;
};


export type MutationSubscriptionLicenseOrderCreateArgs = {
  input: CreateSubscriptionLicenseOrderInput;
};


export type MutationSubscriptionLicenseOrderCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateSubscriptionLicenseOrderInput>>;
};


export type MutationSubscriptionLicenseOrderDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubscriptionLicenseOrderUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubscriptionLicenseOrderInput;
};


export type MutationSupportTicketCreateArgs = {
  input: CreateSupportTicketInput;
};


export type MutationSupportTicketCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateSupportTicketInput>>;
};


export type MutationSupportTicketDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSupportTicketUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupportTicketInput;
};


export type MutationTargetCreateArgs = {
  input: CreateTargetInput;
};


export type MutationTargetCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateTargetInput>>;
};


export type MutationTargetDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTargetUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTargetInput;
};


export type MutationTripConfigsCreateArgs = {
  input: CreateTripConfigsInput;
};


export type MutationTripConfigsCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateTripConfigsInput>>;
};


export type MutationTripConfigsDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTripConfigsUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTripConfigsInput;
};


export type MutationTripCreateArgs = {
  input: CreateTripInput;
};


export type MutationTripCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateTripInput>>;
};


export type MutationTripDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTripHaltPointCreateArgs = {
  input: CreateTripHaltPointInput;
};


export type MutationTripHaltPointCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateTripHaltPointInput>>;
};


export type MutationTripHaltPointDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTripHaltPointTargetCreateArgs = {
  input: CreateTripHaltPointTargetInput;
};


export type MutationTripHaltPointTargetCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateTripHaltPointTargetInput>>;
};


export type MutationTripHaltPointTargetDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTripHaltPointTargetTimeLineCreateArgs = {
  input: CreateTripHaltPointTargetTimeLineInput;
};


export type MutationTripHaltPointTargetTimeLineCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateTripHaltPointTargetTimeLineInput>>;
};


export type MutationTripHaltPointTargetTimeLineDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTripHaltPointTargetTimeLineUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTripHaltPointTargetTimeLineInput;
};


export type MutationTripHaltPointTargetUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTripHaltPointTargetInput;
};


export type MutationTripHaltPointTimeLineCreateArgs = {
  input: CreateTripHaltPointTimeLineInput;
};


export type MutationTripHaltPointTimeLineCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateTripHaltPointTimeLineInput>>;
};


export type MutationTripHaltPointTimeLineDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTripHaltPointTimeLineUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTripHaltPointTimeLineInput;
};


export type MutationTripHaltPointUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTripHaltPointInput;
};


export type MutationTripTimeLineCreateArgs = {
  input: CreateTripTimeLineInput;
};


export type MutationTripTimeLineCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateTripTimeLineInput>>;
};


export type MutationTripTimeLineDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTripTimeLineUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTripTimeLineInput;
};


export type MutationTripUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTripInput;
};


export type MutationUpgradeCreateArgs = {
  input: CreateUpgradeInput;
};


export type MutationUpgradeCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUpgradeInput>>;
};


export type MutationUpgradeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpgradeOrganisationPriceCreateArgs = {
  input: CreateUpgradeOrganisationPriceInput;
};


export type MutationUpgradeOrganisationPriceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUpgradeOrganisationPriceInput>>;
};


export type MutationUpgradeOrganisationPriceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpgradeOrganisationPriceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUpgradeOrganisationPriceInput;
};


export type MutationUpgradeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUpgradeInput;
};


export type MutationUserConfigCreateArgs = {
  input: CreateUserConfigInput;
};


export type MutationUserConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserConfigInput>>;
};


export type MutationUserConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserConfigInput;
};


export type MutationUserCreateArgs = {
  input: CreateUserInput;
};


export type MutationUserCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserInput>>;
};


export type MutationUserDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserLeaveBalanceCreateArgs = {
  input: CreateUserLeaveBalanceInput;
};


export type MutationUserLeaveBalanceCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserLeaveBalanceInput>>;
};


export type MutationUserLeaveBalanceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserLeaveBalanceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserLeaveBalanceInput;
};


export type MutationUserReportBookmarkCreateArgs = {
  input: CreateUserReportBookmarkInput;
};


export type MutationUserReportBookmarkCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserReportBookmarkInput>>;
};


export type MutationUserReportBookmarkDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserReportBookmarkUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserReportBookmarkInput;
};


export type MutationUserRosterAssignmentCreateArgs = {
  input: CreateUserRosterAssignmentInput;
};


export type MutationUserRosterAssignmentCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateUserRosterAssignmentInput>>;
};


export type MutationUserRosterAssignmentDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUserRosterAssignmentUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserRosterAssignmentInput;
};


export type MutationUserUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};


export type MutationWalletCreateArgs = {
  input: CreateWalletInput;
};


export type MutationWalletCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWalletInput>>;
};


export type MutationWalletDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWalletPaymentTransactionCreateArgs = {
  input: CreateWalletPaymentTransactionInput;
};


export type MutationWalletPaymentTransactionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWalletPaymentTransactionInput>>;
};


export type MutationWalletPaymentTransactionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWalletPaymentTransactionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWalletPaymentTransactionInput;
};


export type MutationWalletTransactionCreateArgs = {
  input: CreateWalletTransactionInput;
};


export type MutationWalletTransactionCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWalletTransactionInput>>;
};


export type MutationWalletTransactionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWalletTransactionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWalletTransactionInput;
};


export type MutationWalletUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWalletInput;
};


export type MutationWhitelabelConfigCreateArgs = {
  input: CreateWhitelabelConfigInput;
};


export type MutationWhitelabelConfigCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateWhitelabelConfigInput>>;
};


export type MutationWhitelabelConfigDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWhitelabelConfigUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWhitelabelConfigInput;
};


export type MutationYardTripStatusCreateArgs = {
  input: CreateYardTripStatusInput;
};


export type MutationYardTripStatusCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardTripStatusInput>>;
};


export type MutationYardTripStatusDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardTripStatusUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardTripStatusInput;
};


export type MutationYardWarehouseDockCreateArgs = {
  input: CreateYardWarehouseDockInput;
};


export type MutationYardWarehouseDockCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseDockInput>>;
};


export type MutationYardWarehouseDockDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseDockSharingCreateArgs = {
  input: CreateYardWarehouseDockSharingInput;
};


export type MutationYardWarehouseDockSharingCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseDockSharingInput>>;
};


export type MutationYardWarehouseDockSharingDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseDockSharingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseDockSharingInput;
};


export type MutationYardWarehouseDockUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseDockInput;
};


export type MutationYardWarehouseRoutePathCreateArgs = {
  input: CreateYardWarehouseRoutePathInput;
};


export type MutationYardWarehouseRoutePathCreateBulkArgs = {
  inputs: Array<InputMaybe<CreateYardWarehouseRoutePathInput>>;
};


export type MutationYardWarehouseRoutePathDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationYardWarehouseRoutePathUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateYardWarehouseRoutePathInput;
};

/**
 * An object with an ID.
 * Follows the [Relay Global Object Identification Specification](https://relay.dev/graphql/objectidentification.htm)
 */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
};

export type NotifyChannel = Node & {
  __typename?: 'NotifyChannel';
  bodyTemplate: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  emailTo: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  fcmDevicePlatform: NotifyChannelFcmDevicePlatform;
  fcmSenderID: Scalars['String']['output'];
  fcmToken: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: NotifyChannelKind;
  linkedData: Scalars['String']['output'];
  loggedInDeviceID: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  notifyConfigs?: Maybe<Array<NotifyConfig>>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  organisationUserID?: Maybe<Scalars['ID']['output']>;
  serverNotes: Scalars['String']['output'];
  smsCountryCode: Scalars['Int']['output'];
  smsNumber: Scalars['Int']['output'];
  subjectTemplate: Scalars['String']['output'];
  telegramBotToken: Scalars['String']['output'];
  telegramChatID: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotifyChannelConnection = {
  __typename?: 'NotifyChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyChannelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyChannelEdge = {
  __typename?: 'NotifyChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyChannel>;
};

/** NotifyChannelFcmDevicePlatform is enum for the field fcm_device_platform */
export enum NotifyChannelFcmDevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum NotifyChannelField {
  BodyTemplate = 'bodyTemplate',
  CreatedAt = 'createdAt',
  EmailTo = 'emailTo',
  Enabled = 'enabled',
  FcmDevicePlatform = 'fcmDevicePlatform',
  FcmSenderId = 'fcmSenderID',
  FcmToken = 'fcmToken',
  Kind = 'kind',
  LinkedData = 'linkedData',
  LoggedInDeviceId = 'loggedInDeviceID',
  Name = 'name',
  Notes = 'notes',
  OrganisationId = 'organisationID',
  OrganisationUserId = 'organisationUserID',
  ServerNotes = 'serverNotes',
  SmsCountryCode = 'smsCountryCode',
  SmsNumber = 'smsNumber',
  SubjectTemplate = 'subjectTemplate',
  TelegramBotToken = 'telegramBotToken',
  TelegramChatId = 'telegramChatID',
  UpdatedAt = 'updatedAt'
}

/** NotifyChannelKind is enum for the field kind */
export enum NotifyChannelKind {
  Call = 'Call',
  Email = 'Email',
  Push = 'Push',
  Sms = 'SMS',
  Telegram = 'Telegram',
  Webhook = 'Webhook',
  Whatsapp = 'Whatsapp'
}

/** Ordering options for NotifyChannel connections */
export type NotifyChannelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyChannels. */
  field: NotifyChannelOrderField;
};

/** Properties by which NotifyChannel connections can be ordered. */
export enum NotifyChannelOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyChannelWhereInput is used for filtering NotifyChannel objects.
 * Input was generated by ent.
 */
export type NotifyChannelWhereInput = {
  and?: InputMaybe<Array<NotifyChannelWhereInput>>;
  /** body_template field predicates */
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateContains?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateGT?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyTemplateLT?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  bodyTemplateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email_to field predicates */
  emailTo?: InputMaybe<Scalars['String']['input']>;
  emailToContains?: InputMaybe<Scalars['String']['input']>;
  emailToContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailToEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailToGT?: InputMaybe<Scalars['String']['input']>;
  emailToGTE?: InputMaybe<Scalars['String']['input']>;
  emailToHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailToHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailToIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailToLT?: InputMaybe<Scalars['String']['input']>;
  emailToLTE?: InputMaybe<Scalars['String']['input']>;
  emailToNEQ?: InputMaybe<Scalars['String']['input']>;
  emailToNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** fcm_device_platform field predicates */
  fcmDevicePlatform?: InputMaybe<NotifyChannelFcmDevicePlatform>;
  fcmDevicePlatformIn?: InputMaybe<Array<NotifyChannelFcmDevicePlatform>>;
  fcmDevicePlatformNEQ?: InputMaybe<NotifyChannelFcmDevicePlatform>;
  fcmDevicePlatformNotIn?: InputMaybe<Array<NotifyChannelFcmDevicePlatform>>;
  /** fcm_sender_id field predicates */
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDContains?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDGT?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDGTE?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmSenderIDLT?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDLTE?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDNEQ?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** fcm_token field predicates */
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  fcmTokenContains?: InputMaybe<Scalars['String']['input']>;
  fcmTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  fcmTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  fcmTokenGT?: InputMaybe<Scalars['String']['input']>;
  fcmTokenGTE?: InputMaybe<Scalars['String']['input']>;
  fcmTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fcmTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fcmTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmTokenLT?: InputMaybe<Scalars['String']['input']>;
  fcmTokenLTE?: InputMaybe<Scalars['String']['input']>;
  fcmTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  fcmTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notify_configs edge predicates */
  hasNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigsWith?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<NotifyChannelKind>;
  kindIn?: InputMaybe<Array<NotifyChannelKind>>;
  kindNEQ?: InputMaybe<NotifyChannelKind>;
  kindNotIn?: InputMaybe<Array<NotifyChannelKind>>;
  /** linked_data field predicates */
  linkedData?: InputMaybe<Scalars['String']['input']>;
  linkedDataContains?: InputMaybe<Scalars['String']['input']>;
  linkedDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  linkedDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  linkedDataGT?: InputMaybe<Scalars['String']['input']>;
  linkedDataGTE?: InputMaybe<Scalars['String']['input']>;
  linkedDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  linkedDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  linkedDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedDataLT?: InputMaybe<Scalars['String']['input']>;
  linkedDataLTE?: InputMaybe<Scalars['String']['input']>;
  linkedDataNEQ?: InputMaybe<Scalars['String']['input']>;
  linkedDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** logged_in_device_id field predicates */
  loggedInDeviceID?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDContains?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDGT?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDGTE?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  loggedInDeviceIDLT?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDLTE?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDNEQ?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NotifyChannelWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  or?: InputMaybe<Array<NotifyChannelWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_user_id field predicates */
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  organisationUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** server_notes field predicates */
  serverNotes?: InputMaybe<Scalars['String']['input']>;
  serverNotesContains?: InputMaybe<Scalars['String']['input']>;
  serverNotesContainsFold?: InputMaybe<Scalars['String']['input']>;
  serverNotesEqualFold?: InputMaybe<Scalars['String']['input']>;
  serverNotesGT?: InputMaybe<Scalars['String']['input']>;
  serverNotesGTE?: InputMaybe<Scalars['String']['input']>;
  serverNotesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  serverNotesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  serverNotesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  serverNotesLT?: InputMaybe<Scalars['String']['input']>;
  serverNotesLTE?: InputMaybe<Scalars['String']['input']>;
  serverNotesNEQ?: InputMaybe<Scalars['String']['input']>;
  serverNotesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sms_country_code field predicates */
  smsCountryCode?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeGT?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeGTE?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  smsCountryCodeLT?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeLTE?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeNEQ?: InputMaybe<Scalars['Int']['input']>;
  smsCountryCodeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** sms_number field predicates */
  smsNumber?: InputMaybe<Scalars['Int']['input']>;
  smsNumberGT?: InputMaybe<Scalars['Int']['input']>;
  smsNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  smsNumberIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  smsNumberLT?: InputMaybe<Scalars['Int']['input']>;
  smsNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  smsNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  smsNumberNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** subject_template field predicates */
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateContains?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateContainsFold?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateEqualFold?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateGT?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateGTE?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  subjectTemplateLT?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateLTE?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateNEQ?: InputMaybe<Scalars['String']['input']>;
  subjectTemplateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** telegram_bot_token field predicates */
  telegramBotToken?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenContains?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenGT?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenGTE?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  telegramBotTokenLT?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenLTE?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  telegramBotTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** telegram_chat_id field predicates */
  telegramChatID?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDContains?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDGT?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDGTE?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  telegramChatIDLT?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDLTE?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDNEQ?: InputMaybe<Scalars['String']['input']>;
  telegramChatIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type NotifyConfig = Node & {
  __typename?: 'NotifyConfig';
  alertWindow: Scalars['Boolean']['output'];
  alertWindowEnd?: Maybe<Scalars['TimeOnly']['output']>;
  alertWindowStart?: Maybe<Scalars['TimeOnly']['output']>;
  /** Offset in minutes from UTC for alert window start and end times */
  alertWindowToUtcOffset: Scalars['Int']['output'];
  autoAddNewDevices: Scalars['Boolean']['output'];
  autoAddNewGeofences: Scalars['Boolean']['output'];
  channels?: Maybe<Array<NotifyChannel>>;
  createdAt: Scalars['Time']['output'];
  deviceGroups?: Maybe<Array<DeviceGroup>>;
  enabled: Scalars['Boolean']['output'];
  events?: Maybe<Array<NotifyEventOption>>;
  geofences?: Maybe<Array<Geofence>>;
  id: Scalars['ID']['output'];
  ignoreDuplicateForSeconds: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifyConfigChannels?: Maybe<Array<NotifyConfigChannel>>;
  notifyConfigDeviceGroups?: Maybe<Array<NotifyConfigDeviceGroup>>;
  notifyConfigEvents?: Maybe<Array<NotifyConfigEvent>>;
  notifyConfigGeofences?: Maybe<Array<NotifyConfigGeofence>>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  priority: NotifyConfigPriority;
  updatedAt: Scalars['Time']['output'];
};

export type NotifyConfigChannel = Node & {
  __typename?: 'NotifyConfigChannel';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  notifyChannel: NotifyChannel;
  notifyChannelID: Scalars['ID']['output'];
  notifyConfig: NotifyConfig;
  notifyConfigID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotifyConfigChannelConnection = {
  __typename?: 'NotifyConfigChannelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigChannelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyConfigChannelEdge = {
  __typename?: 'NotifyConfigChannelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfigChannel>;
};

export enum NotifyConfigChannelField {
  CreatedAt = 'createdAt',
  NotifyChannelId = 'notifyChannelID',
  NotifyConfigId = 'notifyConfigID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for NotifyConfigChannel connections */
export type NotifyConfigChannelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigChannels. */
  field: NotifyConfigChannelOrderField;
};

/** Properties by which NotifyConfigChannel connections can be ordered. */
export enum NotifyConfigChannelOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyConfigChannelWhereInput is used for filtering NotifyConfigChannel objects.
 * Input was generated by ent.
 */
export type NotifyConfigChannelWhereInput = {
  and?: InputMaybe<Array<NotifyConfigChannelWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotifyConfigChannelWhereInput>;
  or?: InputMaybe<Array<NotifyConfigChannelWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type NotifyConfigConnection = {
  __typename?: 'NotifyConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type NotifyConfigDeviceGroup = Node & {
  __typename?: 'NotifyConfigDeviceGroup';
  createdAt: Scalars['Time']['output'];
  deviceGroup: DeviceGroup;
  deviceGroupID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  notifyConfig: NotifyConfig;
  notifyConfigID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotifyConfigDeviceGroupConnection = {
  __typename?: 'NotifyConfigDeviceGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigDeviceGroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyConfigDeviceGroupEdge = {
  __typename?: 'NotifyConfigDeviceGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfigDeviceGroup>;
};

export enum NotifyConfigDeviceGroupField {
  CreatedAt = 'createdAt',
  DeviceGroupId = 'deviceGroupID',
  NotifyConfigId = 'notifyConfigID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for NotifyConfigDeviceGroup connections */
export type NotifyConfigDeviceGroupOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigDeviceGroups. */
  field: NotifyConfigDeviceGroupOrderField;
};

/** Properties by which NotifyConfigDeviceGroup connections can be ordered. */
export enum NotifyConfigDeviceGroupOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyConfigDeviceGroupWhereInput is used for filtering NotifyConfigDeviceGroup objects.
 * Input was generated by ent.
 */
export type NotifyConfigDeviceGroupWhereInput = {
  and?: InputMaybe<Array<NotifyConfigDeviceGroupWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotifyConfigDeviceGroupWhereInput>;
  or?: InputMaybe<Array<NotifyConfigDeviceGroupWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** An edge in a connection. */
export type NotifyConfigEdge = {
  __typename?: 'NotifyConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfig>;
};

export type NotifyConfigEvent = Node & {
  __typename?: 'NotifyConfigEvent';
  acceptableMax: Scalars['Float']['output'];
  acceptableMin: Scalars['Float']['output'];
  createdAt: Scalars['Time']['output'];
  distanceMeters: Scalars['Float']['output'];
  distanceToleranceMeters: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  notifyConfig: NotifyConfig;
  notifyConfigID: Scalars['ID']['output'];
  notifyEventOption: NotifyEventOption;
  notifyEventOptionID: Scalars['ID']['output'];
  speedToleranceKnots: Scalars['Float']['output'];
  timeToleranceSeconds: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  waitTimeSeconds: Scalars['Float']['output'];
};

/** A connection to a list of items. */
export type NotifyConfigEventConnection = {
  __typename?: 'NotifyConfigEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigEventEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyConfigEventEdge = {
  __typename?: 'NotifyConfigEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfigEvent>;
};

export enum NotifyConfigEventField {
  AcceptableMax = 'acceptableMax',
  AcceptableMin = 'acceptableMin',
  CreatedAt = 'createdAt',
  DistanceMeters = 'distanceMeters',
  DistanceToleranceMeters = 'distanceToleranceMeters',
  NotifyConfigId = 'notifyConfigID',
  NotifyEventOptionId = 'notifyEventOptionID',
  SpeedToleranceKnots = 'speedToleranceKnots',
  TimeToleranceSeconds = 'timeToleranceSeconds',
  UpdatedAt = 'updatedAt',
  WaitTimeSeconds = 'waitTimeSeconds'
}

/** Ordering options for NotifyConfigEvent connections */
export type NotifyConfigEventOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigEvents. */
  field: NotifyConfigEventOrderField;
};

/** Properties by which NotifyConfigEvent connections can be ordered. */
export enum NotifyConfigEventOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyConfigEventWhereInput is used for filtering NotifyConfigEvent objects.
 * Input was generated by ent.
 */
export type NotifyConfigEventWhereInput = {
  /** acceptable_max field predicates */
  acceptableMax?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxGT?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxGTE?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  acceptableMaxLT?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxLTE?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxNEQ?: InputMaybe<Scalars['Float']['input']>;
  acceptableMaxNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** acceptable_min field predicates */
  acceptableMin?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinGT?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinGTE?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  acceptableMinLT?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinLTE?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinNEQ?: InputMaybe<Scalars['Float']['input']>;
  acceptableMinNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<NotifyConfigEventWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** distance_meters field predicates */
  distanceMeters?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersGT?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersGTE?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  distanceMetersLT?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersLTE?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersNEQ?: InputMaybe<Scalars['Float']['input']>;
  distanceMetersNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** distance_tolerance_meters field predicates */
  distanceToleranceMeters?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersGT?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersGTE?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  distanceToleranceMetersLT?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersLTE?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersNEQ?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMetersNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotifyConfigEventWhereInput>;
  or?: InputMaybe<Array<NotifyConfigEventWhereInput>>;
  /** speed_tolerance_knots field predicates */
  speedToleranceKnots?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsGT?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsGTE?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  speedToleranceKnotsLT?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsLTE?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsNEQ?: InputMaybe<Scalars['Float']['input']>;
  speedToleranceKnotsNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** time_tolerance_seconds field predicates */
  timeToleranceSeconds?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsGT?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsGTE?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  timeToleranceSecondsLT?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsLTE?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsNEQ?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSecondsNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wait_time_seconds field predicates */
  waitTimeSeconds?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsGT?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsGTE?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  waitTimeSecondsLT?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsLTE?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsNEQ?: InputMaybe<Scalars['Float']['input']>;
  waitTimeSecondsNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum NotifyConfigField {
  AlertWindow = 'alertWindow',
  AlertWindowEnd = 'alertWindowEnd',
  AlertWindowStart = 'alertWindowStart',
  AlertWindowToUtcOffset = 'alertWindowToUtcOffset',
  AutoAddNewDevices = 'autoAddNewDevices',
  AutoAddNewGeofences = 'autoAddNewGeofences',
  CreatedAt = 'createdAt',
  Enabled = 'enabled',
  IgnoreDuplicateForSeconds = 'ignoreDuplicateForSeconds',
  IsDefault = 'isDefault',
  Name = 'name',
  OrganisationId = 'organisationID',
  Priority = 'priority',
  UpdatedAt = 'updatedAt'
}

export type NotifyConfigGeofence = Node & {
  __typename?: 'NotifyConfigGeofence';
  createdAt: Scalars['Time']['output'];
  geofence: Geofence;
  geofenceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  notifyConfig: NotifyConfig;
  notifyConfigID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type NotifyConfigGeofenceConnection = {
  __typename?: 'NotifyConfigGeofenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyConfigGeofenceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyConfigGeofenceEdge = {
  __typename?: 'NotifyConfigGeofenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyConfigGeofence>;
};

export enum NotifyConfigGeofenceField {
  CreatedAt = 'createdAt',
  GeofenceId = 'geofenceID',
  NotifyConfigId = 'notifyConfigID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for NotifyConfigGeofence connections */
export type NotifyConfigGeofenceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigGeofences. */
  field: NotifyConfigGeofenceOrderField;
};

/** Properties by which NotifyConfigGeofence connections can be ordered. */
export enum NotifyConfigGeofenceOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyConfigGeofenceWhereInput is used for filtering NotifyConfigGeofence objects.
 * Input was generated by ent.
 */
export type NotifyConfigGeofenceWhereInput = {
  and?: InputMaybe<Array<NotifyConfigGeofenceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<NotifyConfigGeofenceWhereInput>;
  or?: InputMaybe<Array<NotifyConfigGeofenceWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Ordering options for NotifyConfig connections */
export type NotifyConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyConfigs. */
  field: NotifyConfigOrderField;
};

/** Properties by which NotifyConfig connections can be ordered. */
export enum NotifyConfigOrderField {
  AlertWindowEnd = 'alertWindowEnd',
  AlertWindowStart = 'alertWindowStart',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** NotifyConfigPriority is enum for the field priority */
export enum NotifyConfigPriority {
  Alarm = 'Alarm',
  Normal = 'Normal'
}

/**
 * NotifyConfigWhereInput is used for filtering NotifyConfig objects.
 * Input was generated by ent.
 */
export type NotifyConfigWhereInput = {
  /** alert_window field predicates */
  alertWindow?: InputMaybe<Scalars['Boolean']['input']>;
  /** alert_window_end field predicates */
  alertWindowEnd?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndGT?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndGTE?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndIn?: InputMaybe<Array<Scalars['TimeOnly']['input']>>;
  alertWindowEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  alertWindowEndLT?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndLTE?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndNEQ?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowEndNotIn?: InputMaybe<Array<Scalars['TimeOnly']['input']>>;
  alertWindowEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  alertWindowNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** alert_window_start field predicates */
  alertWindowStart?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartGT?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartGTE?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartIn?: InputMaybe<Array<Scalars['TimeOnly']['input']>>;
  alertWindowStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  alertWindowStartLT?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartLTE?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartNEQ?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStartNotIn?: InputMaybe<Array<Scalars['TimeOnly']['input']>>;
  alertWindowStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** alert_window_to_utc_offset field predicates */
  alertWindowToUtcOffset?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetGT?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetGTE?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  alertWindowToUtcOffsetLT?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetLTE?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetNEQ?: InputMaybe<Scalars['Int']['input']>;
  alertWindowToUtcOffsetNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** auto_add_new_devices field predicates */
  autoAddNewDevices?: InputMaybe<Scalars['Boolean']['input']>;
  autoAddNewDevicesNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** auto_add_new_geofences field predicates */
  autoAddNewGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  autoAddNewGeofencesNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** enabled field predicates */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** channels edge predicates */
  hasChannels?: InputMaybe<Scalars['Boolean']['input']>;
  hasChannelsWith?: InputMaybe<Array<NotifyChannelWhereInput>>;
  /** device_groups edge predicates */
  hasDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** events edge predicates */
  hasEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasEventsWith?: InputMaybe<Array<NotifyEventOptionWhereInput>>;
  /** geofences edge predicates */
  hasGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofencesWith?: InputMaybe<Array<GeofenceWhereInput>>;
  /** notify_config_channels edge predicates */
  hasNotifyConfigChannels?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigChannelsWith?: InputMaybe<Array<NotifyConfigChannelWhereInput>>;
  /** notify_config_device_groups edge predicates */
  hasNotifyConfigDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigDeviceGroupsWith?: InputMaybe<Array<NotifyConfigDeviceGroupWhereInput>>;
  /** notify_config_events edge predicates */
  hasNotifyConfigEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigEventsWith?: InputMaybe<Array<NotifyConfigEventWhereInput>>;
  /** notify_config_geofences edge predicates */
  hasNotifyConfigGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigGeofencesWith?: InputMaybe<Array<NotifyConfigGeofenceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ignore_duplicate_for_seconds field predicates */
  ignoreDuplicateForSeconds?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  ignoreDuplicateForSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  ignoreDuplicateForSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** is_default field predicates */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NotifyConfigWhereInput>;
  or?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** priority field predicates */
  priority?: InputMaybe<NotifyConfigPriority>;
  priorityIn?: InputMaybe<Array<NotifyConfigPriority>>;
  priorityNEQ?: InputMaybe<NotifyConfigPriority>;
  priorityNotIn?: InputMaybe<Array<NotifyConfigPriority>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type NotifyEventOption = Node & {
  __typename?: 'NotifyEventOption';
  acceptableMax: Scalars['Boolean']['output'];
  acceptableMaxLabel: Scalars['String']['output'];
  acceptableMin: Scalars['Boolean']['output'];
  acceptableMinLabel: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  distanceMeters: Scalars['Boolean']['output'];
  distanceMetersLabel: Scalars['String']['output'];
  distanceToleranceMeters: Scalars['Boolean']['output'];
  distanceToleranceMetersLabel: Scalars['String']['output'];
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Source of event for backend processing */
  kind: NotifyEventOptionKind;
  /** label to display in UI */
  label: Scalars['String']['output'];
  notifyConfigs?: Maybe<Array<NotifyConfig>>;
  speedToleranceKnots: Scalars['Boolean']['output'];
  speedToleranceKnotsLabel: Scalars['String']['output'];
  timeToleranceSeconds: Scalars['Boolean']['output'];
  timeToleranceSecondsLabel: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  waitTimeSeconds: Scalars['Boolean']['output'];
  waitTimeSecondsLabel: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type NotifyEventOptionConnection = {
  __typename?: 'NotifyEventOptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotifyEventOptionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotifyEventOptionEdge = {
  __typename?: 'NotifyEventOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<NotifyEventOption>;
};

export enum NotifyEventOptionField {
  AcceptableMax = 'acceptableMax',
  AcceptableMaxLabel = 'acceptableMaxLabel',
  AcceptableMin = 'acceptableMin',
  AcceptableMinLabel = 'acceptableMinLabel',
  CreatedAt = 'createdAt',
  Description = 'description',
  DistanceMeters = 'distanceMeters',
  DistanceMetersLabel = 'distanceMetersLabel',
  DistanceToleranceMeters = 'distanceToleranceMeters',
  DistanceToleranceMetersLabel = 'distanceToleranceMetersLabel',
  EventName = 'eventName',
  Kind = 'kind',
  Label = 'label',
  SpeedToleranceKnots = 'speedToleranceKnots',
  SpeedToleranceKnotsLabel = 'speedToleranceKnotsLabel',
  TimeToleranceSeconds = 'timeToleranceSeconds',
  TimeToleranceSecondsLabel = 'timeToleranceSecondsLabel',
  UpdatedAt = 'updatedAt',
  WaitTimeSeconds = 'waitTimeSeconds',
  WaitTimeSecondsLabel = 'waitTimeSecondsLabel'
}

/** NotifyEventOptionKind is enum for the field kind */
export enum NotifyEventOptionKind {
  Event = 'Event',
  Periodic = 'Periodic',
  Position = 'Position'
}

/** Ordering options for NotifyEventOption connections */
export type NotifyEventOptionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order NotifyEventOptions. */
  field: NotifyEventOptionOrderField;
};

/** Properties by which NotifyEventOption connections can be ordered. */
export enum NotifyEventOptionOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * NotifyEventOptionWhereInput is used for filtering NotifyEventOption objects.
 * Input was generated by ent.
 */
export type NotifyEventOptionWhereInput = {
  /** acceptable_max field predicates */
  acceptableMax?: InputMaybe<Scalars['Boolean']['input']>;
  /** acceptable_max_label field predicates */
  acceptableMaxLabel?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelContains?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelGT?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelGTE?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptableMaxLabelLT?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelLTE?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  acceptableMaxLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptableMaxNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** acceptable_min field predicates */
  acceptableMin?: InputMaybe<Scalars['Boolean']['input']>;
  /** acceptable_min_label field predicates */
  acceptableMinLabel?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelContains?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelGT?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelGTE?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptableMinLabelLT?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelLTE?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  acceptableMinLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  acceptableMinNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<NotifyEventOptionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** distance_meters field predicates */
  distanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  /** distance_meters_label field predicates */
  distanceMetersLabel?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelContains?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelGT?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelGTE?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceMetersLabelLT?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelLTE?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  distanceMetersLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceMetersNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** distance_tolerance_meters field predicates */
  distanceToleranceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  /** distance_tolerance_meters_label field predicates */
  distanceToleranceMetersLabel?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelContains?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelGT?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelGTE?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceToleranceMetersLabelLT?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelLTE?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMetersLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceToleranceMetersNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** event_name field predicates */
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventNameContains?: InputMaybe<Scalars['String']['input']>;
  eventNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventNameGT?: InputMaybe<Scalars['String']['input']>;
  eventNameGTE?: InputMaybe<Scalars['String']['input']>;
  eventNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventNameLT?: InputMaybe<Scalars['String']['input']>;
  eventNameLTE?: InputMaybe<Scalars['String']['input']>;
  eventNameNEQ?: InputMaybe<Scalars['String']['input']>;
  eventNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** notify_configs edge predicates */
  hasNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasNotifyConfigsWith?: InputMaybe<Array<NotifyConfigWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** kind field predicates */
  kind?: InputMaybe<NotifyEventOptionKind>;
  kindIn?: InputMaybe<Array<NotifyEventOptionKind>>;
  kindNEQ?: InputMaybe<NotifyEventOptionKind>;
  kindNotIn?: InputMaybe<Array<NotifyEventOptionKind>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NotifyEventOptionWhereInput>;
  or?: InputMaybe<Array<NotifyEventOptionWhereInput>>;
  /** speed_tolerance_knots field predicates */
  speedToleranceKnots?: InputMaybe<Scalars['Boolean']['input']>;
  /** speed_tolerance_knots_label field predicates */
  speedToleranceKnotsLabel?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelContains?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelGT?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelGTE?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speedToleranceKnotsLabelLT?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelLTE?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  speedToleranceKnotsLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  speedToleranceKnotsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** time_tolerance_seconds field predicates */
  timeToleranceSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  /** time_tolerance_seconds_label field predicates */
  timeToleranceSecondsLabel?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelContains?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelGT?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelGTE?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  timeToleranceSecondsLabelLT?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelLTE?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSecondsLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  timeToleranceSecondsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wait_time_seconds field predicates */
  waitTimeSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  /** wait_time_seconds_label field predicates */
  waitTimeSecondsLabel?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelContains?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelGT?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelGTE?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  waitTimeSecondsLabelLT?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelLTE?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  waitTimeSecondsLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  waitTimeSecondsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptimisedHaltpointResponse = {
  __typename?: 'OptimisedHaltpointResponse';
  endPoint?: Maybe<HaltPoint>;
  haltPoints: Array<HaltPoint>;
  startPoint?: Maybe<HaltPoint>;
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

export type Organisation = Node & {
  __typename?: 'Organisation';
  allowChildCreation: Scalars['Boolean']['output'];
  attendances?: Maybe<Array<Attendance>>;
  availableLicenses: Scalars['Int']['output'];
  baselicenseplan?: Maybe<Array<BaseLicensePlan>>;
  billingAddressCity?: Maybe<Scalars['String']['output']>;
  billingAddressCountry?: Maybe<Scalars['String']['output']>;
  billingAddressLine1?: Maybe<Scalars['String']['output']>;
  billingAddressLine2?: Maybe<Scalars['String']['output']>;
  billingAddressState?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingEnabled: Scalars['Boolean']['output'];
  billingGstin?: Maybe<Scalars['String']['output']>;
  boltLegacyID?: Maybe<Scalars['String']['output']>;
  centralisedWallet: Scalars['Boolean']['output'];
  childOrganisations?: Maybe<Array<Organisation>>;
  createdAt: Scalars['Time']['output'];
  deviceLimit: Scalars['Int']['output'];
  deviceSharings?: Maybe<Array<DeviceSharing>>;
  devicegroups?: Maybe<Array<DeviceGroup>>;
  devicegroupsRoot?: Maybe<Array<DeviceGroup>>;
  devices?: Maybe<Array<Device>>;
  devicesRoot?: Maybe<Array<Device>>;
  export?: Maybe<Array<Export>>;
  geofenceDeviceGroups?: Maybe<Array<GeofenceDeviceGroup>>;
  haltPoints?: Maybe<Array<HaltPoint>>;
  id: Scalars['ID']['output'];
  ingestServer: OrganisationIngestServer;
  inspectionReports?: Maybe<Array<InspectionReport>>;
  isActive: Scalars['Boolean']['output'];
  kmls?: Maybe<Array<Kml>>;
  leaveRequests?: Maybe<Array<LeaveRequest>>;
  leaveTypes?: Maybe<Array<LeaveType>>;
  legacysync?: Maybe<Array<LegacySync>>;
  license?: Maybe<Array<License>>;
  licenseOrders?: Maybe<Array<SubscriptionLicenseOrder>>;
  mapGeofences?: Maybe<Array<Geofence>>;
  mediafiles?: Maybe<Array<MediaFile>>;
  name: Scalars['String']['output'];
  organisationDeviceDocuments?: Maybe<Array<DeviceDocument>>;
  organisationDeviceGroupDocuments?: Maybe<Array<DeviceGroupDocument>>;
  organisationLimit: Scalars['Int']['output'];
  organisationupgrade?: Maybe<Array<OrganisationUpgrade>>;
  organisationusers?: Maybe<Array<OrganisationUser>>;
  organistionroles?: Maybe<Array<OrganisationRole>>;
  parentOrganisation?: Maybe<Organisation>;
  parentOrganisationID?: Maybe<Scalars['ID']['output']>;
  rootOrganisation?: Maybe<Organisation>;
  rootOrganisationID?: Maybe<Scalars['ID']['output']>;
  rosterSchedules?: Maybe<Array<RosterSchedule>>;
  rosters?: Maybe<Array<Roster>>;
  routeHaltPointTargets?: Maybe<Array<RouteHaltPointTarget>>;
  routeHaltPoints?: Maybe<Array<RouteHaltPoint>>;
  routeTimeLine?: Maybe<Array<RouteTimeLine>>;
  routes?: Maybe<Array<Route>>;
  shifts?: Maybe<Array<Shift>>;
  sim?: Maybe<Array<Sim>>;
  stiqrs?: Maybe<Array<StiQr>>;
  subOrganisations?: Maybe<Array<Organisation>>;
  targets?: Maybe<Array<Target>>;
  totalLicenses: Scalars['Int']['output'];
  tripConfigs?: Maybe<Array<TripConfigs>>;
  tripHaltPointTarget?: Maybe<Array<TripHaltPointTarget>>;
  tripHaltPointTargetTimelines?: Maybe<Array<TripHaltPointTargetTimeLine>>;
  tripHaltPointTimelines?: Maybe<Array<TripHaltPointTimeLine>>;
  tripHaltPoints?: Maybe<Array<TripHaltPoint>>;
  tripTimelines?: Maybe<Array<TripTimeLine>>;
  trips?: Maybe<Array<Trip>>;
  updatedAt: Scalars['Time']['output'];
  upgradeorganisationprice?: Maybe<Array<UpgradeOrganisationPrice>>;
  wallet?: Maybe<Wallet>;
  whitelabel?: Maybe<Whitelabel>;
  yardDriverProfiles?: Maybe<Array<YardDriverProfile>>;
  yardMaterialType?: Maybe<Array<YardMaterialType>>;
  yardMaterials?: Maybe<Array<YardMaterial>>;
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
  yardTrips?: Maybe<Array<YardTrip>>;
  yardVehicles?: Maybe<Array<YardVehicle>>;
  yardVendors?: Maybe<Array<YardVendor>>;
  yardWarehouseActivityTypes?: Maybe<Array<YardWarehouseActivityType>>;
  yardWarehouseApprovalMatrix?: Maybe<Array<YardWarehouseApprovalMatrix>>;
  yardWarehouseDockSharing?: Maybe<Array<YardWarehouseDockSharing>>;
  yardWarehouseDocks?: Maybe<Array<YardWarehouseDock>>;
  yardWarehouseParkings?: Maybe<Array<YardWarehouseParking>>;
  yardWarehouseRoutePaths?: Maybe<Array<YardWarehouseRoutePath>>;
  yardWarehouseRoutes?: Maybe<Array<YardWarehouseRoute>>;
  yardWarehouses?: Maybe<Array<YardWarehouse>>;
};

/** A connection to a list of items. */
export type OrganisationConnection = {
  __typename?: 'OrganisationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationEdge = {
  __typename?: 'OrganisationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organisation>;
};

export enum OrganisationField {
  AllowChildCreation = 'allowChildCreation',
  AvailableLicenses = 'availableLicenses',
  BillingAddressCity = 'billingAddressCity',
  BillingAddressCountry = 'billingAddressCountry',
  BillingAddressLine1 = 'billingAddressLine1',
  BillingAddressLine2 = 'billingAddressLine2',
  BillingAddressState = 'billingAddressState',
  BillingEmail = 'billingEmail',
  BillingEnabled = 'billingEnabled',
  BillingGstin = 'billingGstin',
  BoltLegacyId = 'boltLegacyID',
  CentralisedWallet = 'centralisedWallet',
  CreatedAt = 'createdAt',
  DeviceLimit = 'deviceLimit',
  IngestServer = 'ingestServer',
  IsActive = 'isActive',
  Name = 'name',
  OrganisationLimit = 'organisationLimit',
  ParentOrganisationId = 'parentOrganisationID',
  RootOrganisationId = 'rootOrganisationID',
  TotalLicenses = 'totalLicenses',
  UpdatedAt = 'updatedAt'
}

/** OrganisationIngestServer is enum for the field ingest_server */
export enum OrganisationIngestServer {
  Bolt = 'BOLT',
  Track = 'TRACK'
}

/** Ordering options for Organisation connections */
export type OrganisationOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Organisations. */
  field: OrganisationOrderField;
};

/** Properties by which Organisation connections can be ordered. */
export enum OrganisationOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type OrganisationReportAccess = Node & {
  __typename?: 'OrganisationReportAccess';
  createdAt: Scalars['Time']['output'];
  derivedReport: DerivedReport;
  derivedReportID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OrganisationReportAccessConnection = {
  __typename?: 'OrganisationReportAccessConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationReportAccessEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationReportAccessEdge = {
  __typename?: 'OrganisationReportAccessEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationReportAccess>;
};

export enum OrganisationReportAccessField {
  CreatedAt = 'createdAt',
  DerivedReportId = 'derivedReportID',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for OrganisationReportAccess connections */
export type OrganisationReportAccessOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationReportAccesses. */
  field: OrganisationReportAccessOrderField;
};

/** Properties by which OrganisationReportAccess connections can be ordered. */
export enum OrganisationReportAccessOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * OrganisationReportAccessWhereInput is used for filtering OrganisationReportAccess objects.
 * Input was generated by ent.
 */
export type OrganisationReportAccessWhereInput = {
  and?: InputMaybe<Array<OrganisationReportAccessWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** derived_report_id field predicates */
  derivedReportID?: InputMaybe<Scalars['ID']['input']>;
  derivedReportIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  derivedReportIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  derivedReportIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** derived_report edge predicates */
  hasDerivedReport?: InputMaybe<Scalars['Boolean']['input']>;
  hasDerivedReportWith?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganisationReportAccessWhereInput>;
  or?: InputMaybe<Array<OrganisationReportAccessWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OrganisationRole = Node & {
  __typename?: 'OrganisationRole';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  organisationRolePermissions?: Maybe<Array<OrganisationRolePermission>>;
  organisationusers?: Maybe<Array<OrganisationUser>>;
  permissions?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['Time']['output'];
  yardWarehouseApprovalMatrix?: Maybe<Array<YardWarehouseApprovalMatrix>>;
};

/** A connection to a list of items. */
export type OrganisationRoleConnection = {
  __typename?: 'OrganisationRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationRoleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationRoleEdge = {
  __typename?: 'OrganisationRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationRole>;
};

export enum OrganisationRoleField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  OrganisationId = 'organisationID',
  Permissions = 'permissions',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for OrganisationRole connections */
export type OrganisationRoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationRoles. */
  field: OrganisationRoleOrderField;
};

/** Properties by which OrganisationRole connections can be ordered. */
export enum OrganisationRoleOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type OrganisationRolePermission = Node & {
  __typename?: 'OrganisationRolePermission';
  create: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  delete: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organisationRole: OrganisationRole;
  organisationRoleID: Scalars['ID']['output'];
  permission: Permission;
  permissionID: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OrganisationRolePermissionConnection = {
  __typename?: 'OrganisationRolePermissionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationRolePermissionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationRolePermissionEdge = {
  __typename?: 'OrganisationRolePermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationRolePermission>;
};

export enum OrganisationRolePermissionField {
  Create = 'create',
  CreatedAt = 'createdAt',
  Delete = 'delete',
  Edit = 'edit',
  OrganisationRoleId = 'organisationRoleID',
  PermissionId = 'permissionID',
  Read = 'read',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for OrganisationRolePermission connections */
export type OrganisationRolePermissionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationRolePermissions. */
  field: OrganisationRolePermissionOrderField;
};

/** Properties by which OrganisationRolePermission connections can be ordered. */
export enum OrganisationRolePermissionOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * OrganisationRolePermissionWhereInput is used for filtering OrganisationRolePermission objects.
 * Input was generated by ent.
 */
export type OrganisationRolePermissionWhereInput = {
  and?: InputMaybe<Array<OrganisationRolePermissionWhereInput>>;
  /** create field predicates */
  create?: InputMaybe<Scalars['Boolean']['input']>;
  createNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** delete field predicates */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  deleteNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** edit field predicates */
  edit?: InputMaybe<Scalars['Boolean']['input']>;
  editNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_role edge predicates */
  hasOrganisationRole?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationRoleWith?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** permission edge predicates */
  hasPermission?: InputMaybe<Scalars['Boolean']['input']>;
  hasPermissionWith?: InputMaybe<Array<PermissionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganisationRolePermissionWhereInput>;
  or?: InputMaybe<Array<OrganisationRolePermissionWhereInput>>;
  /** organisation_role_id field predicates */
  organisationRoleID?: InputMaybe<Scalars['ID']['input']>;
  organisationRoleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationRoleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationRoleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** permission_id field predicates */
  permissionID?: InputMaybe<Scalars['ID']['input']>;
  permissionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  permissionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  permissionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** read field predicates */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  readNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * OrganisationRoleWhereInput is used for filtering OrganisationRole objects.
 * Input was generated by ent.
 */
export type OrganisationRoleWhereInput = {
  and?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_role_permissions edge predicates */
  hasOrganisationRolePermissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationRolePermissionsWith?: InputMaybe<Array<OrganisationRolePermissionWhereInput>>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** organisationusers edge predicates */
  hasOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationusersWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** yard_warehouse_approval_matrix edge predicates */
  hasYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganisationRoleWhereInput>;
  or?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** permissions field predicates */
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  permissionsGT?: InputMaybe<Scalars['JSON']['input']>;
  permissionsGTE?: InputMaybe<Scalars['JSON']['input']>;
  permissionsIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  permissionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  permissionsLT?: InputMaybe<Scalars['JSON']['input']>;
  permissionsLTE?: InputMaybe<Scalars['JSON']['input']>;
  permissionsNEQ?: InputMaybe<Scalars['JSON']['input']>;
  permissionsNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  permissionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OrganisationUpgrade = Node & {
  __typename?: 'OrganisationUpgrade';
  autoRenew: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  endDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  startDate: Scalars['Time']['output'];
  status: OrganisationUpgradeStatus;
  updatedAt: Scalars['Time']['output'];
  upgrade: Upgrade;
  upgradeID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type OrganisationUpgradeConnection = {
  __typename?: 'OrganisationUpgradeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationUpgradeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationUpgradeEdge = {
  __typename?: 'OrganisationUpgradeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationUpgrade>;
};

export enum OrganisationUpgradeField {
  AutoRenew = 'autoRenew',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  OrganisationId = 'organisationID',
  StartDate = 'startDate',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UpgradeId = 'upgradeID'
}

/** Ordering options for OrganisationUpgrade connections */
export type OrganisationUpgradeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationUpgrades. */
  field: OrganisationUpgradeOrderField;
};

/** Properties by which OrganisationUpgrade connections can be ordered. */
export enum OrganisationUpgradeOrderField {
  EndDate = 'END_DATE',
  StartDate = 'START_DATE',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** OrganisationUpgradeStatus is enum for the field status */
export enum OrganisationUpgradeStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Grace = 'Grace',
  Pending = 'Pending'
}

/**
 * OrganisationUpgradeWhereInput is used for filtering OrganisationUpgrade objects.
 * Input was generated by ent.
 */
export type OrganisationUpgradeWhereInput = {
  and?: InputMaybe<Array<OrganisationUpgradeWhereInput>>;
  /** auto_renew field predicates */
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  autoRenewNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** end_date field predicates */
  endDate?: InputMaybe<Scalars['Time']['input']>;
  endDateGT?: InputMaybe<Scalars['Time']['input']>;
  endDateGTE?: InputMaybe<Scalars['Time']['input']>;
  endDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endDateLT?: InputMaybe<Scalars['Time']['input']>;
  endDateLTE?: InputMaybe<Scalars['Time']['input']>;
  endDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  endDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** upgrade edge predicates */
  hasUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeWith?: InputMaybe<Array<UpgradeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganisationUpgradeWhereInput>;
  or?: InputMaybe<Array<OrganisationUpgradeWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** start_date field predicates */
  startDate?: InputMaybe<Scalars['Time']['input']>;
  startDateGT?: InputMaybe<Scalars['Time']['input']>;
  startDateGTE?: InputMaybe<Scalars['Time']['input']>;
  startDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startDateLT?: InputMaybe<Scalars['Time']['input']>;
  startDateLTE?: InputMaybe<Scalars['Time']['input']>;
  startDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  startDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** status field predicates */
  status?: InputMaybe<OrganisationUpgradeStatus>;
  statusIn?: InputMaybe<Array<OrganisationUpgradeStatus>>;
  statusNEQ?: InputMaybe<OrganisationUpgradeStatus>;
  statusNotIn?: InputMaybe<Array<OrganisationUpgradeStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** upgrade_id field predicates */
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
  upgradeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  upgradeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  upgradeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrganisationUser = Node & {
  __typename?: 'OrganisationUser';
  boltLegacyID?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  deviceacls?: Maybe<Array<DeviceAcl>>;
  driverprofiles?: Maybe<Profile>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  organisationuserDocuments?: Maybe<Array<OrganisationUserDocument>>;
  role: OrganisationRole;
  roleID: Scalars['ID']['output'];
  shifts?: Maybe<Array<Shift>>;
  stiqrs?: Maybe<Array<StiQr>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  userType: OrganisationUserUserType;
};

/** A connection to a list of items. */
export type OrganisationUserConnection = {
  __typename?: 'OrganisationUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationUserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type OrganisationUserDocument = Node & {
  __typename?: 'OrganisationUserDocument';
  attachment: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisationuser: OrganisationUser;
  organisationuserID: Scalars['ID']['output'];
  organisationuserdocumenttype: OrganisationUserDocumentType;
  organisationuserdocumenttypeID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  verificationStatus: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type OrganisationUserDocumentConnection = {
  __typename?: 'OrganisationUserDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationUserDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationUserDocumentEdge = {
  __typename?: 'OrganisationUserDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationUserDocument>;
};

export enum OrganisationUserDocumentField {
  Attachment = 'attachment',
  CreatedAt = 'createdAt',
  OrganisationuserId = 'organisationuserID',
  OrganisationuserdocumenttypeId = 'organisationuserdocumenttypeID',
  UpdatedAt = 'updatedAt',
  VerificationStatus = 'verificationStatus'
}

/** Ordering options for OrganisationUserDocument connections */
export type OrganisationUserDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationUserDocuments. */
  field: OrganisationUserDocumentOrderField;
};

/** Properties by which OrganisationUserDocument connections can be ordered. */
export enum OrganisationUserDocumentOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type OrganisationUserDocumentType = Node & {
  __typename?: 'OrganisationUserDocumentType';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationuserDocuments?: Maybe<Array<OrganisationUserDocument>>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OrganisationUserDocumentTypeConnection = {
  __typename?: 'OrganisationUserDocumentTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationUserDocumentTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationUserDocumentTypeEdge = {
  __typename?: 'OrganisationUserDocumentTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationUserDocumentType>;
};

export enum OrganisationUserDocumentTypeField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for OrganisationUserDocumentType connections */
export type OrganisationUserDocumentTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationUserDocumentTypes. */
  field: OrganisationUserDocumentTypeOrderField;
};

/** Properties by which OrganisationUserDocumentType connections can be ordered. */
export enum OrganisationUserDocumentTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * OrganisationUserDocumentTypeWhereInput is used for filtering OrganisationUserDocumentType objects.
 * Input was generated by ent.
 */
export type OrganisationUserDocumentTypeWhereInput = {
  and?: InputMaybe<Array<OrganisationUserDocumentTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisationuser_documents edge predicates */
  hasOrganisationuserDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationuserDocumentsWith?: InputMaybe<Array<OrganisationUserDocumentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganisationUserDocumentTypeWhereInput>;
  or?: InputMaybe<Array<OrganisationUserDocumentTypeWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * OrganisationUserDocumentWhereInput is used for filtering OrganisationUserDocument objects.
 * Input was generated by ent.
 */
export type OrganisationUserDocumentWhereInput = {
  and?: InputMaybe<Array<OrganisationUserDocumentWhereInput>>;
  /** attachment field predicates */
  attachment?: InputMaybe<Scalars['String']['input']>;
  attachmentContains?: InputMaybe<Scalars['String']['input']>;
  attachmentContainsFold?: InputMaybe<Scalars['String']['input']>;
  attachmentEqualFold?: InputMaybe<Scalars['String']['input']>;
  attachmentGT?: InputMaybe<Scalars['String']['input']>;
  attachmentGTE?: InputMaybe<Scalars['String']['input']>;
  attachmentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  attachmentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  attachmentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentLT?: InputMaybe<Scalars['String']['input']>;
  attachmentLTE?: InputMaybe<Scalars['String']['input']>;
  attachmentNEQ?: InputMaybe<Scalars['String']['input']>;
  attachmentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisationuser edge predicates */
  hasOrganisationuser?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationuserWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** organisationuserdocumenttype edge predicates */
  hasOrganisationuserdocumenttype?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationuserdocumenttypeWith?: InputMaybe<Array<OrganisationUserDocumentTypeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OrganisationUserDocumentWhereInput>;
  or?: InputMaybe<Array<OrganisationUserDocumentWhereInput>>;
  /** organisationuser_id field predicates */
  organisationuserID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** organisationuserdocumenttype_id field predicates */
  organisationuserdocumenttypeID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserdocumenttypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserdocumenttypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationuserdocumenttypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** verification_status field predicates */
  verificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
  verificationStatusNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An edge in a connection. */
export type OrganisationUserEdge = {
  __typename?: 'OrganisationUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganisationUser>;
};

export enum OrganisationUserField {
  BoltLegacyId = 'boltLegacyID',
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  OrganisationId = 'organisationID',
  RoleId = 'roleID',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  UserType = 'userType'
}

/** Ordering options for OrganisationUser connections */
export type OrganisationUserOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order OrganisationUsers. */
  field: OrganisationUserOrderField;
};

/** Properties by which OrganisationUser connections can be ordered. */
export enum OrganisationUserOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** OrganisationUserUserType is enum for the field user_type */
export enum OrganisationUserUserType {
  Driver = 'driver',
  User = 'user'
}

/**
 * OrganisationUserWhereInput is used for filtering OrganisationUser objects.
 * Input was generated by ent.
 */
export type OrganisationUserWhereInput = {
  and?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** bolt_legacy_id field predicates */
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContains?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  boltLegacyIDLT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDLTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** deviceacls edge predicates */
  hasDeviceacls?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceaclsWith?: InputMaybe<Array<DeviceAclWhereInput>>;
  /** driverprofiles edge predicates */
  hasDriverprofiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasDriverprofilesWith?: InputMaybe<Array<ProfileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** organisationuser_documents edge predicates */
  hasOrganisationuserDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationuserDocumentsWith?: InputMaybe<Array<OrganisationUserDocumentWhereInput>>;
  /** role edge predicates */
  hasRole?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoleWith?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** shifts edge predicates */
  hasShifts?: InputMaybe<Scalars['Boolean']['input']>;
  hasShiftsWith?: InputMaybe<Array<ShiftWhereInput>>;
  /** stiqrs edge predicates */
  hasStiqrs?: InputMaybe<Scalars['Boolean']['input']>;
  hasStiqrsWith?: InputMaybe<Array<StiQrWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<OrganisationUserWhereInput>;
  or?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** role_id field predicates */
  roleID?: InputMaybe<Scalars['ID']['input']>;
  roleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  roleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** user_type field predicates */
  userType?: InputMaybe<OrganisationUserUserType>;
  userTypeIn?: InputMaybe<Array<OrganisationUserUserType>>;
  userTypeNEQ?: InputMaybe<OrganisationUserUserType>;
  userTypeNotIn?: InputMaybe<Array<OrganisationUserUserType>>;
};

/**
 * OrganisationWhereInput is used for filtering Organisation objects.
 * Input was generated by ent.
 */
export type OrganisationWhereInput = {
  /** allow_child_creation field predicates */
  allowChildCreation?: InputMaybe<Scalars['Boolean']['input']>;
  allowChildCreationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<OrganisationWhereInput>>;
  /** available_licenses field predicates */
  availableLicenses?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesGT?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesGTE?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  availableLicensesLT?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesLTE?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesNEQ?: InputMaybe<Scalars['Int']['input']>;
  availableLicensesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** billing_address_city field predicates */
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityContains?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityGT?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityGTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressCityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressCityLT?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityLTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityNEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressCityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressCityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_address_country field predicates */
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryContains?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryGT?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryGTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressCountryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressCountryLT?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryLTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryNEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressCountryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_address_line_1 field predicates */
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1Contains?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1ContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1EqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1GT?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1GTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1HasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1HasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1In?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressLine1IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressLine1LT?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1LTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1NEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressLine1NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_address_line_2 field predicates */
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2Contains?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2ContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2EqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2GT?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2GTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2HasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2HasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2In?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressLine2IsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressLine2LT?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2LTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2NEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2NotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressLine2NotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_address_state field predicates */
  billingAddressState?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateContains?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateGT?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateGTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressStateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddressStateLT?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateLTE?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateNEQ?: InputMaybe<Scalars['String']['input']>;
  billingAddressStateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingAddressStateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_email field predicates */
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEmailContains?: InputMaybe<Scalars['String']['input']>;
  billingEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingEmailGT?: InputMaybe<Scalars['String']['input']>;
  billingEmailGTE?: InputMaybe<Scalars['String']['input']>;
  billingEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingEmailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingEmailLT?: InputMaybe<Scalars['String']['input']>;
  billingEmailLTE?: InputMaybe<Scalars['String']['input']>;
  billingEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  billingEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingEmailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_enabled field predicates */
  billingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  billingEnabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** billing_gstin field predicates */
  billingGstin?: InputMaybe<Scalars['String']['input']>;
  billingGstinContains?: InputMaybe<Scalars['String']['input']>;
  billingGstinContainsFold?: InputMaybe<Scalars['String']['input']>;
  billingGstinEqualFold?: InputMaybe<Scalars['String']['input']>;
  billingGstinGT?: InputMaybe<Scalars['String']['input']>;
  billingGstinGTE?: InputMaybe<Scalars['String']['input']>;
  billingGstinHasPrefix?: InputMaybe<Scalars['String']['input']>;
  billingGstinHasSuffix?: InputMaybe<Scalars['String']['input']>;
  billingGstinIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingGstinIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  billingGstinLT?: InputMaybe<Scalars['String']['input']>;
  billingGstinLTE?: InputMaybe<Scalars['String']['input']>;
  billingGstinNEQ?: InputMaybe<Scalars['String']['input']>;
  billingGstinNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  billingGstinNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** bolt_legacy_id field predicates */
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContains?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDGTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  boltLegacyIDLT?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDLTE?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNEQ?: InputMaybe<Scalars['String']['input']>;
  boltLegacyIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  boltLegacyIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** centralised_wallet field predicates */
  centralisedWallet?: InputMaybe<Scalars['Boolean']['input']>;
  centralisedWalletNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_limit field predicates */
  deviceLimit?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitGT?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitGTE?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  deviceLimitLT?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitLTE?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitNEQ?: InputMaybe<Scalars['Int']['input']>;
  deviceLimitNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** attendances edge predicates */
  hasAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttendancesWith?: InputMaybe<Array<AttendanceWhereInput>>;
  /** baselicenseplan edge predicates */
  hasBaselicenseplan?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanWith?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** child_organisations edge predicates */
  hasChildOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildOrganisationsWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** device_sharings edge predicates */
  hasDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceSharingsWith?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** devicegroups edge predicates */
  hasDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** devicegroups_root edge predicates */
  hasDevicegroupsRoot?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicegroupsRootWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  hasDevicegroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  /** devices_root edge predicates */
  hasDevicesRoot?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesRootWith?: InputMaybe<Array<DeviceWhereInput>>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** export edge predicates */
  hasExport?: InputMaybe<Scalars['Boolean']['input']>;
  hasExportWith?: InputMaybe<Array<ExportWhereInput>>;
  /** geofence_device_groups edge predicates */
  hasGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceDeviceGroupsWith?: InputMaybe<Array<GeofenceDeviceGroupWhereInput>>;
  /** halt_points edge predicates */
  hasHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasHaltPointsWith?: InputMaybe<Array<HaltPointWhereInput>>;
  /** inspection_reports edge predicates */
  hasInspectionReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasInspectionReportsWith?: InputMaybe<Array<InspectionReportWhereInput>>;
  /** kmls edge predicates */
  hasKmls?: InputMaybe<Scalars['Boolean']['input']>;
  hasKmlsWith?: InputMaybe<Array<KmlWhereInput>>;
  /** leave_requests edge predicates */
  hasLeaveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveRequestsWith?: InputMaybe<Array<LeaveRequestWhereInput>>;
  /** leave_types edge predicates */
  hasLeaveTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveTypesWith?: InputMaybe<Array<LeaveTypeWhereInput>>;
  /** legacysync edge predicates */
  hasLegacysync?: InputMaybe<Scalars['Boolean']['input']>;
  hasLegacysyncWith?: InputMaybe<Array<LegacySyncWhereInput>>;
  /** license edge predicates */
  hasLicense?: InputMaybe<Scalars['Boolean']['input']>;
  /** license_orders edge predicates */
  hasLicenseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseOrdersWith?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  hasLicenseWith?: InputMaybe<Array<LicenseWhereInput>>;
  /** map_geofences edge predicates */
  hasMapGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  hasMapGeofencesWith?: InputMaybe<Array<GeofenceWhereInput>>;
  /** mediafiles edge predicates */
  hasMediafiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafilesWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation_device_documents edge predicates */
  hasOrganisationDeviceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationDeviceDocumentsWith?: InputMaybe<Array<DeviceDocumentWhereInput>>;
  /** organisation_device_group_documents edge predicates */
  hasOrganisationDeviceGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationDeviceGroupDocumentsWith?: InputMaybe<Array<DeviceGroupDocumentWhereInput>>;
  /** organisationupgrade edge predicates */
  hasOrganisationupgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationupgradeWith?: InputMaybe<Array<OrganisationUpgradeWhereInput>>;
  /** organisationusers edge predicates */
  hasOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationusersWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** organistionroles edge predicates */
  hasOrganistionroles?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganistionrolesWith?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** parent_organisation edge predicates */
  hasParentOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasParentOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** root_organisation edge predicates */
  hasRootOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasRootOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** roster_schedules edge predicates */
  hasRosterSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasRosterSchedulesWith?: InputMaybe<Array<RosterScheduleWhereInput>>;
  /** rosters edge predicates */
  hasRosters?: InputMaybe<Scalars['Boolean']['input']>;
  hasRostersWith?: InputMaybe<Array<RosterWhereInput>>;
  /** route_halt_point_targets edge predicates */
  hasRouteHaltPointTargets?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteHaltPointTargetsWith?: InputMaybe<Array<RouteHaltPointTargetWhereInput>>;
  /** route_halt_points edge predicates */
  hasRouteHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteHaltPointsWith?: InputMaybe<Array<RouteHaltPointWhereInput>>;
  /** route_time_line edge predicates */
  hasRouteTimeLine?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteTimeLineWith?: InputMaybe<Array<RouteTimeLineWhereInput>>;
  /** routes edge predicates */
  hasRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoutesWith?: InputMaybe<Array<RouteWhereInput>>;
  /** shifts edge predicates */
  hasShifts?: InputMaybe<Scalars['Boolean']['input']>;
  hasShiftsWith?: InputMaybe<Array<ShiftWhereInput>>;
  /** sim edge predicates */
  hasSim?: InputMaybe<Scalars['Boolean']['input']>;
  hasSimWith?: InputMaybe<Array<SimWhereInput>>;
  /** stiqrs edge predicates */
  hasStiqrs?: InputMaybe<Scalars['Boolean']['input']>;
  hasStiqrsWith?: InputMaybe<Array<StiQrWhereInput>>;
  /** sub_organisations edge predicates */
  hasSubOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubOrganisationsWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** targets edge predicates */
  hasTargets?: InputMaybe<Scalars['Boolean']['input']>;
  hasTargetsWith?: InputMaybe<Array<TargetWhereInput>>;
  /** trip_configs edge predicates */
  hasTripConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripConfigsWith?: InputMaybe<Array<TripConfigsWhereInput>>;
  /** trip_halt_point_target edge predicates */
  hasTripHaltPointTarget?: InputMaybe<Scalars['Boolean']['input']>;
  /** trip_halt_point_target_timelines edge predicates */
  hasTripHaltPointTargetTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltPointTargetTimelinesWith?: InputMaybe<Array<TripHaltPointTargetTimeLineWhereInput>>;
  hasTripHaltPointTargetWith?: InputMaybe<Array<TripHaltPointTargetWhereInput>>;
  /** trip_halt_point_timelines edge predicates */
  hasTripHaltPointTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltPointTimelinesWith?: InputMaybe<Array<TripHaltPointTimeLineWhereInput>>;
  /** trip_halt_points edge predicates */
  hasTripHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltPointsWith?: InputMaybe<Array<TripHaltPointWhereInput>>;
  /** trip_timelines edge predicates */
  hasTripTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripTimelinesWith?: InputMaybe<Array<TripTimeLineWhereInput>>;
  /** trips edge predicates */
  hasTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripsWith?: InputMaybe<Array<TripWhereInput>>;
  /** upgradeorganisationprice edge predicates */
  hasUpgradeorganisationprice?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeorganisationpriceWith?: InputMaybe<Array<UpgradeOrganisationPriceWhereInput>>;
  /** wallet edge predicates */
  hasWallet?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletWith?: InputMaybe<Array<WalletWhereInput>>;
  /** whitelabel edge predicates */
  hasWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** yard_driver_profiles edge predicates */
  hasYardDriverProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardDriverProfilesWith?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** yard_material_type edge predicates */
  hasYardMaterialType?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardMaterialTypeWith?: InputMaybe<Array<YardMaterialTypeWhereInput>>;
  /** yard_materials edge predicates */
  hasYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardMaterialsWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_vehicles edge predicates */
  hasYardVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVehiclesWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** yard_vendors edge predicates */
  hasYardVendors?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardVendorsWith?: InputMaybe<Array<YardVendorWhereInput>>;
  /** yard_warehouse_activity_types edge predicates */
  hasYardWarehouseActivityTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseActivityTypesWith?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** yard_warehouse_approval_matrix edge predicates */
  hasYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** yard_warehouse_dock_sharing edge predicates */
  hasYardWarehouseDockSharing?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDockSharingWith?: InputMaybe<Array<YardWarehouseDockSharingWhereInput>>;
  /** yard_warehouse_docks edge predicates */
  hasYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDocksWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** yard_warehouse_parkings edge predicates */
  hasYardWarehouseParkings?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseParkingsWith?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** yard_warehouse_route_paths edge predicates */
  hasYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutePathsWith?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** yard_warehouse_routes edge predicates */
  hasYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutesWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** yard_warehouses edge predicates */
  hasYardWarehouses?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehousesWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ingest_server field predicates */
  ingestServer?: InputMaybe<OrganisationIngestServer>;
  ingestServerIn?: InputMaybe<Array<OrganisationIngestServer>>;
  ingestServerNEQ?: InputMaybe<OrganisationIngestServer>;
  ingestServerNotIn?: InputMaybe<Array<OrganisationIngestServer>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<OrganisationWhereInput>;
  or?: InputMaybe<Array<OrganisationWhereInput>>;
  /** organisation_limit field predicates */
  organisationLimit?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitGT?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitGTE?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  organisationLimitLT?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitLTE?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitNEQ?: InputMaybe<Scalars['Int']['input']>;
  organisationLimitNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** parent_organisation_id field predicates */
  parentOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  parentOrganisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentOrganisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parentOrganisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parentOrganisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentOrganisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** root_organisation_id field predicates */
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rootOrganisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  rootOrganisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** total_licenses field predicates */
  totalLicenses?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesGT?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesGTE?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalLicensesLT?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesLTE?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesNEQ?: InputMaybe<Scalars['Int']['input']>;
  totalLicensesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OrganisationWithCounts = {
  __typename?: 'OrganisationWithCounts';
  deviceCount: Scalars['Int']['output'];
  organisation: Organisation;
  userCount: Scalars['Int']['output'];
};

/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type ParsedPositionSubPacket = {
  __typename?: 'ParsedPositionSubPacket';
  altitude: Scalars['Float']['output'];
  attributes: PositionAttributesParsed;
  course: Scalars['Float']['output'];
  deviceTime: Scalars['Time']['output'];
  fixTime: Scalars['Time']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  outdated: Scalars['Boolean']['output'];
  protocol: Scalars['String']['output'];
  serverTime: Scalars['Time']['output'];
  speed: Scalars['Float']['output'];
  valid: Scalars['Boolean']['output'];
};

export type PeriodicJob = Node & {
  __typename?: 'PeriodicJob';
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastRunAt?: Maybe<Scalars['Time']['output']>;
  lastTaskResponse?: Maybe<Scalars['JSON']['output']>;
  nextRunAt?: Maybe<Scalars['Time']['output']>;
  params?: Maybe<Scalars['JSON']['output']>;
  queueName: Scalars['String']['output'];
  schedule: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type PeriodicJobConnection = {
  __typename?: 'PeriodicJobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PeriodicJobEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PeriodicJobEdge = {
  __typename?: 'PeriodicJobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PeriodicJob>;
};

export enum PeriodicJobField {
  CreatedAt = 'createdAt',
  Description = 'description',
  IsActive = 'isActive',
  LastRunAt = 'lastRunAt',
  LastTaskResponse = 'lastTaskResponse',
  NextRunAt = 'nextRunAt',
  Params = 'params',
  QueueName = 'queueName',
  Schedule = 'schedule',
  TaskName = 'taskName',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for PeriodicJob connections */
export type PeriodicJobOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PeriodicJobs. */
  field: PeriodicJobOrderField;
};

/** Properties by which PeriodicJob connections can be ordered. */
export enum PeriodicJobOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PeriodicJobWhereInput is used for filtering PeriodicJob objects.
 * Input was generated by ent.
 */
export type PeriodicJobWhereInput = {
  and?: InputMaybe<Array<PeriodicJobWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_run_at field predicates */
  lastRunAt?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastRunAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastRunAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastRunAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastRunAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_task_response field predicates */
  lastTaskResponse?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseGT?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseGTE?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  lastTaskResponseIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastTaskResponseLT?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseLTE?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseNEQ?: InputMaybe<Scalars['JSON']['input']>;
  lastTaskResponseNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  lastTaskResponseNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** next_run_at field predicates */
  nextRunAt?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtGT?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtGTE?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextRunAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextRunAtLT?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtLTE?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextRunAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextRunAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PeriodicJobWhereInput>;
  or?: InputMaybe<Array<PeriodicJobWhereInput>>;
  /** params field predicates */
  params?: InputMaybe<Scalars['JSON']['input']>;
  paramsGT?: InputMaybe<Scalars['JSON']['input']>;
  paramsGTE?: InputMaybe<Scalars['JSON']['input']>;
  paramsIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  paramsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  paramsLT?: InputMaybe<Scalars['JSON']['input']>;
  paramsLTE?: InputMaybe<Scalars['JSON']['input']>;
  paramsNEQ?: InputMaybe<Scalars['JSON']['input']>;
  paramsNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  paramsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** queue_name field predicates */
  queueName?: InputMaybe<Scalars['String']['input']>;
  queueNameContains?: InputMaybe<Scalars['String']['input']>;
  queueNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  queueNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  queueNameGT?: InputMaybe<Scalars['String']['input']>;
  queueNameGTE?: InputMaybe<Scalars['String']['input']>;
  queueNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  queueNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  queueNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  queueNameLT?: InputMaybe<Scalars['String']['input']>;
  queueNameLTE?: InputMaybe<Scalars['String']['input']>;
  queueNameNEQ?: InputMaybe<Scalars['String']['input']>;
  queueNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** schedule field predicates */
  schedule?: InputMaybe<Scalars['String']['input']>;
  scheduleContains?: InputMaybe<Scalars['String']['input']>;
  scheduleContainsFold?: InputMaybe<Scalars['String']['input']>;
  scheduleEqualFold?: InputMaybe<Scalars['String']['input']>;
  scheduleGT?: InputMaybe<Scalars['String']['input']>;
  scheduleGTE?: InputMaybe<Scalars['String']['input']>;
  scheduleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  scheduleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  scheduleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleLT?: InputMaybe<Scalars['String']['input']>;
  scheduleLTE?: InputMaybe<Scalars['String']['input']>;
  scheduleNEQ?: InputMaybe<Scalars['String']['input']>;
  scheduleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** task_name field predicates */
  taskName?: InputMaybe<Scalars['String']['input']>;
  taskNameContains?: InputMaybe<Scalars['String']['input']>;
  taskNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  taskNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  taskNameGT?: InputMaybe<Scalars['String']['input']>;
  taskNameGTE?: InputMaybe<Scalars['String']['input']>;
  taskNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  taskNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  taskNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  taskNameLT?: InputMaybe<Scalars['String']['input']>;
  taskNameLTE?: InputMaybe<Scalars['String']['input']>;
  taskNameNEQ?: InputMaybe<Scalars['String']['input']>;
  taskNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Permission = Node & {
  __typename?: 'Permission';
  createLabel: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  deleteLabel: Scalars['String']['output'];
  description: Scalars['String']['output'];
  editLabel: Scalars['String']['output'];
  group: PermissionGroup;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: PermissionName;
  readLabel: Scalars['String']['output'];
  showCreate: Scalars['Boolean']['output'];
  showDelete: Scalars['Boolean']['output'];
  showEdit: Scalars['Boolean']['output'];
  showRead: Scalars['Boolean']['output'];
  sorter: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type PermissionConnection = {
  __typename?: 'PermissionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PermissionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PermissionEdge = {
  __typename?: 'PermissionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Permission>;
};

export enum PermissionField {
  CreateLabel = 'createLabel',
  CreatedAt = 'createdAt',
  DeleteLabel = 'deleteLabel',
  Description = 'description',
  EditLabel = 'editLabel',
  Group = 'group',
  Label = 'label',
  Name = 'name',
  ReadLabel = 'readLabel',
  ShowCreate = 'showCreate',
  ShowDelete = 'showDelete',
  ShowEdit = 'showEdit',
  ShowRead = 'showRead',
  Sorter = 'sorter',
  UpdatedAt = 'updatedAt'
}

/** PermissionGroup is enum for the field group */
export enum PermissionGroup {
  Device = 'device',
  License = 'license',
  Organisation = 'organisation',
  User = 'user',
  Yard = 'yard'
}

/** PermissionName is enum for the field name */
export enum PermissionName {
  Admin = 'Admin',
  BaseAddon = 'BaseAddon',
  BaseLicensePlan = 'BaseLicensePlan',
  BaseLicensePlanAddon = 'BaseLicensePlanAddon',
  ChangeUserPassword = 'ChangeUserPassword',
  Chatbot = 'Chatbot',
  ConsumerConfig = 'ConsumerConfig',
  ConsumerServer = 'ConsumerServer',
  Device = 'Device',
  DeviceAcl = 'DeviceAcl',
  DeviceActionLog = 'DeviceActionLog',
  DeviceAddonModel = 'DeviceAddonModel',
  DeviceAdvancedConfig = 'DeviceAdvancedConfig',
  DeviceCategory = 'DeviceCategory',
  DeviceChannelConfig = 'DeviceChannelConfig',
  DeviceCommand = 'DeviceCommand',
  DeviceDocument = 'DeviceDocument',
  DeviceDocumentType = 'DeviceDocumentType',
  DeviceGroup = 'DeviceGroup',
  DeviceGroupAll = 'DeviceGroupAll',
  DeviceGroupDocument = 'DeviceGroupDocument',
  DeviceGroupDocumentType = 'DeviceGroupDocumentType',
  DeviceModel = 'DeviceModel',
  DeviceModelChannel = 'DeviceModelChannel',
  DeviceShare = 'DeviceShare',
  DeviceShareRequest = 'DeviceShareRequest',
  DeviceSharing = 'DeviceSharing',
  DeviceVehicle = 'DeviceVehicle',
  Domain = 'Domain',
  Geofence = 'Geofence',
  Kml = 'Kml',
  License = 'License',
  LicenseOrder = 'LicenseOrder',
  MapConfig = 'MapConfig',
  Notification = 'Notification',
  Organisation = 'Organisation',
  OrganisationRole = 'OrganisationRole',
  OrganisationUser = 'OrganisationUser',
  OrganisationUserDocument = 'OrganisationUserDocument',
  OrganisationUserDocumentType = 'OrganisationUserDocumentType',
  Poi = 'Poi',
  Profile = 'Profile',
  Report = 'Report',
  Sim = 'Sim',
  Upgrade = 'Upgrade',
  User = 'User',
  UserImpersonate = 'UserImpersonate',
  Vehicle = 'Vehicle',
  Wallet = 'Wallet',
  WalletPaymentTransaction = 'WalletPaymentTransaction',
  WalletTransaction = 'WalletTransaction',
  Whitelabel = 'Whitelabel',
  WhitelabelConfig = 'WhitelabelConfig',
  WhitelabelCoreSettingOverride = 'WhitelabelCoreSettingOverride',
  YardAssignDriver = 'YardAssignDriver',
  YardAssignMaterial = 'YardAssignMaterial',
  YardAssignParking = 'YardAssignParking',
  YardAssignRoute = 'YardAssignRoute',
  YardAssignTracker = 'YardAssignTracker',
  YardAssignVehicle = 'YardAssignVehicle',
  YardAssignVehicleTracker = 'YardAssignVehicleTracker',
  YardAssignVendor = 'YardAssignVendor',
  YardCheckin = 'YardCheckin',
  YardCheckout = 'YardCheckout',
  YardDriverProfile = 'YardDriverProfile',
  YardGuardApp = 'YardGuardApp',
  YardManage = 'YardManage',
  YardMaterial = 'YardMaterial',
  YardMaterialType = 'YardMaterialType',
  YardParkingCheckin = 'YardParkingCheckin',
  YardParkingCheckout = 'YardParkingCheckout',
  YardRecharge = 'YardRecharge',
  YardSetDockActivity = 'YardSetDockActivity',
  YardTransfer = 'YardTransfer',
  YardTrip = 'YardTrip',
  YardVehicle = 'YardVehicle',
  YardVendor = 'YardVendor',
  YardWarehouse = 'YardWarehouse',
  YardWarehouseActivityType = 'YardWarehouseActivityType',
  YardWarehouseApprovalMatrix = 'YardWarehouseApprovalMatrix',
  YardWarehouseCheckin = 'YardWarehouseCheckin',
  YardWarehouseCheckout = 'YardWarehouseCheckout',
  YardWarehouseDock = 'YardWarehouseDock',
  YardWarehouseParking = 'YardWarehouseParking',
  YardWarehouseRoute = 'YardWarehouseRoute',
  YardWarehouseRoutePath = 'YardWarehouseRoutePath'
}

/** Ordering options for Permission connections */
export type PermissionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Permissions. */
  field: PermissionOrderField;
};

/** Properties by which Permission connections can be ordered. */
export enum PermissionOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PermissionWhereInput is used for filtering Permission objects.
 * Input was generated by ent.
 */
export type PermissionWhereInput = {
  and?: InputMaybe<Array<PermissionWhereInput>>;
  /** create_label field predicates */
  createLabel?: InputMaybe<Scalars['String']['input']>;
  createLabelContains?: InputMaybe<Scalars['String']['input']>;
  createLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  createLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  createLabelGT?: InputMaybe<Scalars['String']['input']>;
  createLabelGTE?: InputMaybe<Scalars['String']['input']>;
  createLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  createLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  createLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  createLabelLT?: InputMaybe<Scalars['String']['input']>;
  createLabelLTE?: InputMaybe<Scalars['String']['input']>;
  createLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  createLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** delete_label field predicates */
  deleteLabel?: InputMaybe<Scalars['String']['input']>;
  deleteLabelContains?: InputMaybe<Scalars['String']['input']>;
  deleteLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  deleteLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  deleteLabelGT?: InputMaybe<Scalars['String']['input']>;
  deleteLabelGTE?: InputMaybe<Scalars['String']['input']>;
  deleteLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deleteLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deleteLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deleteLabelLT?: InputMaybe<Scalars['String']['input']>;
  deleteLabelLTE?: InputMaybe<Scalars['String']['input']>;
  deleteLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  deleteLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** edit_label field predicates */
  editLabel?: InputMaybe<Scalars['String']['input']>;
  editLabelContains?: InputMaybe<Scalars['String']['input']>;
  editLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  editLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  editLabelGT?: InputMaybe<Scalars['String']['input']>;
  editLabelGTE?: InputMaybe<Scalars['String']['input']>;
  editLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  editLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  editLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  editLabelLT?: InputMaybe<Scalars['String']['input']>;
  editLabelLTE?: InputMaybe<Scalars['String']['input']>;
  editLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  editLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** group field predicates */
  group?: InputMaybe<PermissionGroup>;
  groupIn?: InputMaybe<Array<PermissionGroup>>;
  groupNEQ?: InputMaybe<PermissionGroup>;
  groupNotIn?: InputMaybe<Array<PermissionGroup>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<PermissionName>;
  nameIn?: InputMaybe<Array<PermissionName>>;
  nameNEQ?: InputMaybe<PermissionName>;
  nameNotIn?: InputMaybe<Array<PermissionName>>;
  not?: InputMaybe<PermissionWhereInput>;
  or?: InputMaybe<Array<PermissionWhereInput>>;
  /** read_label field predicates */
  readLabel?: InputMaybe<Scalars['String']['input']>;
  readLabelContains?: InputMaybe<Scalars['String']['input']>;
  readLabelContainsFold?: InputMaybe<Scalars['String']['input']>;
  readLabelEqualFold?: InputMaybe<Scalars['String']['input']>;
  readLabelGT?: InputMaybe<Scalars['String']['input']>;
  readLabelGTE?: InputMaybe<Scalars['String']['input']>;
  readLabelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  readLabelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  readLabelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  readLabelLT?: InputMaybe<Scalars['String']['input']>;
  readLabelLTE?: InputMaybe<Scalars['String']['input']>;
  readLabelNEQ?: InputMaybe<Scalars['String']['input']>;
  readLabelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** show_create field predicates */
  showCreate?: InputMaybe<Scalars['Boolean']['input']>;
  showCreateNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_delete field predicates */
  showDelete?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleteNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_edit field predicates */
  showEdit?: InputMaybe<Scalars['Boolean']['input']>;
  showEditNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** show_read field predicates */
  showRead?: InputMaybe<Scalars['Boolean']['input']>;
  showReadNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** sorter field predicates */
  sorter?: InputMaybe<Scalars['Int']['input']>;
  sorterGT?: InputMaybe<Scalars['Int']['input']>;
  sorterGTE?: InputMaybe<Scalars['Int']['input']>;
  sorterIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sorterLT?: InputMaybe<Scalars['Int']['input']>;
  sorterLTE?: InputMaybe<Scalars['Int']['input']>;
  sorterNEQ?: InputMaybe<Scalars['Int']['input']>;
  sorterNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type PinnedDevices = Node & {
  __typename?: 'PinnedDevices';
  createdAt: Scalars['Time']['output'];
  device: Device;
  /** ID of the pinned device */
  deviceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: OrganisationUser;
  /** ID of the user who pinned the device */
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type PinnedDevicesConnection = {
  __typename?: 'PinnedDevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PinnedDevicesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PinnedDevicesEdge = {
  __typename?: 'PinnedDevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PinnedDevices>;
};

export enum PinnedDevicesField {
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for PinnedDevices connections */
export type PinnedDevicesOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PinnedDevicesSlice. */
  field: PinnedDevicesOrderField;
};

/** Properties by which PinnedDevices connections can be ordered. */
export enum PinnedDevicesOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PinnedDevicesWhereInput is used for filtering PinnedDevices objects.
 * Input was generated by ent.
 */
export type PinnedDevicesWhereInput = {
  and?: InputMaybe<Array<PinnedDevicesWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<PinnedDevicesWhereInput>;
  or?: InputMaybe<Array<PinnedDevicesWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Poi = Node & {
  __typename?: 'Poi';
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lat: Scalars['String']['output'];
  long: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type PoiConnection = {
  __typename?: 'PoiConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PoiEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PoiEdge = {
  __typename?: 'PoiEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Poi>;
};

export enum PoiField {
  CreatedAt = 'createdAt',
  Description = 'description',
  IconColor = 'iconColor',
  IconName = 'iconName',
  Lat = 'lat',
  Long = 'long',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for Poi connections */
export type PoiOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Pois. */
  field: PoiOrderField;
};

/** Properties by which Poi connections can be ordered. */
export enum PoiOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PoiWhereInput is used for filtering Poi objects.
 * Input was generated by ent.
 */
export type PoiWhereInput = {
  and?: InputMaybe<Array<PoiWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** icon_color field predicates */
  iconColor?: InputMaybe<Scalars['String']['input']>;
  iconColorContains?: InputMaybe<Scalars['String']['input']>;
  iconColorContainsFold?: InputMaybe<Scalars['String']['input']>;
  iconColorEqualFold?: InputMaybe<Scalars['String']['input']>;
  iconColorGT?: InputMaybe<Scalars['String']['input']>;
  iconColorGTE?: InputMaybe<Scalars['String']['input']>;
  iconColorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  iconColorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  iconColorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  iconColorLT?: InputMaybe<Scalars['String']['input']>;
  iconColorLTE?: InputMaybe<Scalars['String']['input']>;
  iconColorNEQ?: InputMaybe<Scalars['String']['input']>;
  iconColorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** icon_name field predicates */
  iconName?: InputMaybe<Scalars['String']['input']>;
  iconNameContains?: InputMaybe<Scalars['String']['input']>;
  iconNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  iconNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  iconNameGT?: InputMaybe<Scalars['String']['input']>;
  iconNameGTE?: InputMaybe<Scalars['String']['input']>;
  iconNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  iconNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  iconNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  iconNameLT?: InputMaybe<Scalars['String']['input']>;
  iconNameLTE?: InputMaybe<Scalars['String']['input']>;
  iconNameNEQ?: InputMaybe<Scalars['String']['input']>;
  iconNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** lat field predicates */
  lat?: InputMaybe<Scalars['String']['input']>;
  latContains?: InputMaybe<Scalars['String']['input']>;
  latContainsFold?: InputMaybe<Scalars['String']['input']>;
  latEqualFold?: InputMaybe<Scalars['String']['input']>;
  latGT?: InputMaybe<Scalars['String']['input']>;
  latGTE?: InputMaybe<Scalars['String']['input']>;
  latHasPrefix?: InputMaybe<Scalars['String']['input']>;
  latHasSuffix?: InputMaybe<Scalars['String']['input']>;
  latIn?: InputMaybe<Array<Scalars['String']['input']>>;
  latLT?: InputMaybe<Scalars['String']['input']>;
  latLTE?: InputMaybe<Scalars['String']['input']>;
  latNEQ?: InputMaybe<Scalars['String']['input']>;
  latNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** long field predicates */
  long?: InputMaybe<Scalars['String']['input']>;
  longContains?: InputMaybe<Scalars['String']['input']>;
  longContainsFold?: InputMaybe<Scalars['String']['input']>;
  longEqualFold?: InputMaybe<Scalars['String']['input']>;
  longGT?: InputMaybe<Scalars['String']['input']>;
  longGTE?: InputMaybe<Scalars['String']['input']>;
  longHasPrefix?: InputMaybe<Scalars['String']['input']>;
  longHasSuffix?: InputMaybe<Scalars['String']['input']>;
  longIn?: InputMaybe<Array<Scalars['String']['input']>>;
  longLT?: InputMaybe<Scalars['String']['input']>;
  longLTE?: InputMaybe<Scalars['String']['input']>;
  longNEQ?: InputMaybe<Scalars['String']['input']>;
  longNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PoiWhereInput>;
  or?: InputMaybe<Array<PoiWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PositionAttributeFormula = Node & {
  __typename?: 'PositionAttributeFormula';
  attribute: PositionAttributeFormulaAttribute;
  createdAt: Scalars['Time']['output'];
  device: Device;
  deviceID: Scalars['ID']['output'];
  expression: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** PositionAttributeFormulaAttribute is enum for the field attribute */
export enum PositionAttributeFormulaAttribute {
  AirConditioner = 'airConditioner',
  Alarm = 'alarm',
  Battery = 'battery',
  BatteryLevel = 'batteryLevel',
  Door = 'door',
  Engine2 = 'engine2',
  ExtBatt = 'extBatt',
  Fuel = 'fuel',
  FuelCompartment1 = 'fuelCompartment1',
  FuelCompartment2 = 'fuelCompartment2',
  Ignition = 'ignition',
  Motion = 'motion',
  Temp = 'temp',
  Temp1 = 'temp1'
}

/** A connection to a list of items. */
export type PositionAttributeFormulaConnection = {
  __typename?: 'PositionAttributeFormulaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PositionAttributeFormulaEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PositionAttributeFormulaEdge = {
  __typename?: 'PositionAttributeFormulaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PositionAttributeFormula>;
};

export enum PositionAttributeFormulaField {
  Attribute = 'attribute',
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  Expression = 'expression',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for PositionAttributeFormula connections */
export type PositionAttributeFormulaOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PositionAttributeFormulas. */
  field: PositionAttributeFormulaOrderField;
};

/** Properties by which PositionAttributeFormula connections can be ordered. */
export enum PositionAttributeFormulaOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PositionAttributeFormulaWhereInput is used for filtering PositionAttributeFormula objects.
 * Input was generated by ent.
 */
export type PositionAttributeFormulaWhereInput = {
  and?: InputMaybe<Array<PositionAttributeFormulaWhereInput>>;
  /** attribute field predicates */
  attribute?: InputMaybe<PositionAttributeFormulaAttribute>;
  attributeIn?: InputMaybe<Array<PositionAttributeFormulaAttribute>>;
  attributeNEQ?: InputMaybe<PositionAttributeFormulaAttribute>;
  attributeNotIn?: InputMaybe<Array<PositionAttributeFormulaAttribute>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** expression field predicates */
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionContains?: InputMaybe<Scalars['String']['input']>;
  expressionContainsFold?: InputMaybe<Scalars['String']['input']>;
  expressionEqualFold?: InputMaybe<Scalars['String']['input']>;
  expressionGT?: InputMaybe<Scalars['String']['input']>;
  expressionGTE?: InputMaybe<Scalars['String']['input']>;
  expressionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  expressionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  expressionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  expressionLT?: InputMaybe<Scalars['String']['input']>;
  expressionLTE?: InputMaybe<Scalars['String']['input']>;
  expressionNEQ?: InputMaybe<Scalars['String']['input']>;
  expressionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** device edge predicates */
  hasDevice?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<PositionAttributeFormulaWhereInput>;
  or?: InputMaybe<Array<PositionAttributeFormulaWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type PositionAttributesParsed = {
  __typename?: 'PositionAttributesParsed';
  ac?: Maybe<Scalars['Boolean']['output']>;
  adc1?: Maybe<Scalars['Float']['output']>;
  airConditionerOpen?: Maybe<Scalars['Boolean']['output']>;
  alarm?: Maybe<Scalars['String']['output']>;
  approximate?: Maybe<Scalars['Boolean']['output']>;
  armed?: Maybe<Scalars['Boolean']['output']>;
  battery?: Maybe<Scalars['Float']['output']>;
  batteryLevel?: Maybe<Scalars['Int']['output']>;
  charge?: Maybe<Scalars['Boolean']['output']>;
  course?: Maybe<Scalars['Float']['output']>;
  deviceStatus?: Maybe<Scalars['Boolean']['output']>;
  di1?: Maybe<Scalars['Int']['output']>;
  di2?: Maybe<Scalars['Int']['output']>;
  di3?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  door?: Maybe<Scalars['Boolean']['output']>;
  driverUniqueId?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['Int']['output']>;
  extBatt?: Maybe<Scalars['Float']['output']>;
  fuel?: Maybe<Scalars['Float']['output']>;
  fuelCompartment1?: Maybe<Scalars['Float']['output']>;
  geofence?: Maybe<Scalars['Boolean']['output']>;
  gpsStatus?: Maybe<Scalars['Boolean']['output']>;
  hdop?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  humidity?: Maybe<Scalars['Float']['output']>;
  ignition?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Invalid, use outside attributes value */
  immobilizer?: Maybe<Scalars['Boolean']['output']>;
  io6?: Maybe<Scalars['Int']['output']>;
  io24?: Maybe<Scalars['Int']['output']>;
  io68?: Maybe<Scalars['Int']['output']>;
  io113?: Maybe<Scalars['Int']['output']>;
  io200?: Maybe<Scalars['Int']['output']>;
  io263?: Maybe<Scalars['Int']['output']>;
  io270?: Maybe<Scalars['Int']['output']>;
  io306?: Maybe<Scalars['Int']['output']>;
  io335?: Maybe<Scalars['Int']['output']>;
  load?: Maybe<Scalars['Float']['output']>;
  loadCell?: Maybe<Scalars['Float']['output']>;
  lock?: Maybe<Scalars['Boolean']['output']>;
  maxSpeed?: Maybe<Scalars['Float']['output']>;
  motion?: Maybe<Scalars['Boolean']['output']>;
  odometer?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<Scalars['Int']['output']>;
  parking?: Maybe<Scalars['Boolean']['output']>;
  pdop?: Maybe<Scalars['Float']['output']>;
  power?: Maybe<Scalars['Float']['output']>;
  previousDistance?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  rssi?: Maybe<Scalars['Int']['output']>;
  sat?: Maybe<Scalars['Int']['output']>;
  temp?: Maybe<Scalars['Float']['output']>;
  temp1?: Maybe<Scalars['Float']['output']>;
  todayDistance?: Maybe<Scalars['Float']['output']>;
  totalDistance?: Maybe<Scalars['Float']['output']>;
  workMode?: Maybe<Scalars['Int']['output']>;
};

export type PositionPollingResponse = {
  __typename?: 'PositionPollingResponse';
  deviceId: Scalars['ID']['output'];
  deviceStatus: DeviceStatus;
  idleSinceFixTime?: Maybe<Scalars['Time']['output']>;
  immobilizer?: Maybe<Scalars['Boolean']['output']>;
  inGeofenceCount: Scalars['Int']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastIgnitionOffFixTime?: Maybe<Scalars['Time']['output']>;
  lastIgnitionOnFixTime?: Maybe<Scalars['Time']['output']>;
  lastUpdate?: Maybe<Scalars['Time']['output']>;
  latestPosition?: Maybe<ParsedPositionSubPacket>;
  videoEvents: Array<Maybe<VideoEventCache>>;
};

export type PositionPollingStats = {
  __typename?: 'PositionPollingStats';
  allDeviceCount: Scalars['Int']['output'];
  idleCount: Scalars['Int']['output'];
  ignitionOffCount: Scalars['Int']['output'];
  ignitionOnCount: Scalars['Int']['output'];
  inactiveCount: Scalars['Int']['output'];
  insideGeofenceCount: Scalars['Int']['output'];
  offlineCount: Scalars['Int']['output'];
  onlineCount: Scalars['Int']['output'];
  outsideGeofenceCount: Scalars['Int']['output'];
};

export type PositionPollingWithStatsResponse = {
  __typename?: 'PositionPollingWithStatsResponse';
  positions: Array<Maybe<PositionPollingResponse>>;
  stats: PositionPollingStats;
};

export type Profile = Node & {
  __typename?: 'Profile';
  baseLocation: Scalars['String']['output'];
  bloodGroup: Scalars['String']['output'];
  contractNumber: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  department: Scalars['String']['output'];
  employeeNo: Scalars['String']['output'];
  groups?: Maybe<Array<DeviceGroup>>;
  id: Scalars['ID']['output'];
  organisationuserID: Scalars['ID']['output'];
  organisationusers: OrganisationUser;
  supervisorName: Scalars['String']['output'];
  supervisorPhonenumber: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type ProfileConnection = {
  __typename?: 'ProfileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProfileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProfileEdge = {
  __typename?: 'ProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Profile>;
};

export enum ProfileField {
  BaseLocation = 'baseLocation',
  BloodGroup = 'bloodGroup',
  ContractNumber = 'contractNumber',
  CreatedAt = 'createdAt',
  Department = 'department',
  EmployeeNo = 'employeeNo',
  OrganisationuserId = 'organisationuserID',
  SupervisorName = 'supervisorName',
  SupervisorPhonenumber = 'supervisorPhonenumber',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Profile connections */
export type ProfileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Profiles. */
  field: ProfileOrderField;
};

/** Properties by which Profile connections can be ordered. */
export enum ProfileOrderField {
  EmployeeNo = 'EMPLOYEE_NO',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * ProfileWhereInput is used for filtering Profile objects.
 * Input was generated by ent.
 */
export type ProfileWhereInput = {
  and?: InputMaybe<Array<ProfileWhereInput>>;
  /** base_location field predicates */
  baseLocation?: InputMaybe<Scalars['String']['input']>;
  baseLocationContains?: InputMaybe<Scalars['String']['input']>;
  baseLocationContainsFold?: InputMaybe<Scalars['String']['input']>;
  baseLocationEqualFold?: InputMaybe<Scalars['String']['input']>;
  baseLocationGT?: InputMaybe<Scalars['String']['input']>;
  baseLocationGTE?: InputMaybe<Scalars['String']['input']>;
  baseLocationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  baseLocationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  baseLocationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  baseLocationLT?: InputMaybe<Scalars['String']['input']>;
  baseLocationLTE?: InputMaybe<Scalars['String']['input']>;
  baseLocationNEQ?: InputMaybe<Scalars['String']['input']>;
  baseLocationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** blood_group field predicates */
  bloodGroup?: InputMaybe<Scalars['String']['input']>;
  bloodGroupContains?: InputMaybe<Scalars['String']['input']>;
  bloodGroupContainsFold?: InputMaybe<Scalars['String']['input']>;
  bloodGroupEqualFold?: InputMaybe<Scalars['String']['input']>;
  bloodGroupGT?: InputMaybe<Scalars['String']['input']>;
  bloodGroupGTE?: InputMaybe<Scalars['String']['input']>;
  bloodGroupHasPrefix?: InputMaybe<Scalars['String']['input']>;
  bloodGroupHasSuffix?: InputMaybe<Scalars['String']['input']>;
  bloodGroupIn?: InputMaybe<Array<Scalars['String']['input']>>;
  bloodGroupLT?: InputMaybe<Scalars['String']['input']>;
  bloodGroupLTE?: InputMaybe<Scalars['String']['input']>;
  bloodGroupNEQ?: InputMaybe<Scalars['String']['input']>;
  bloodGroupNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** contract_number field predicates */
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  contractNumberContains?: InputMaybe<Scalars['String']['input']>;
  contractNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  contractNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  contractNumberGT?: InputMaybe<Scalars['String']['input']>;
  contractNumberGTE?: InputMaybe<Scalars['String']['input']>;
  contractNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contractNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contractNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contractNumberLT?: InputMaybe<Scalars['String']['input']>;
  contractNumberLTE?: InputMaybe<Scalars['String']['input']>;
  contractNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  contractNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** department field predicates */
  department?: InputMaybe<Scalars['String']['input']>;
  departmentContains?: InputMaybe<Scalars['String']['input']>;
  departmentContainsFold?: InputMaybe<Scalars['String']['input']>;
  departmentEqualFold?: InputMaybe<Scalars['String']['input']>;
  departmentGT?: InputMaybe<Scalars['String']['input']>;
  departmentGTE?: InputMaybe<Scalars['String']['input']>;
  departmentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  departmentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  departmentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentLT?: InputMaybe<Scalars['String']['input']>;
  departmentLTE?: InputMaybe<Scalars['String']['input']>;
  departmentNEQ?: InputMaybe<Scalars['String']['input']>;
  departmentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** employee_no field predicates */
  employeeNo?: InputMaybe<Scalars['String']['input']>;
  employeeNoContains?: InputMaybe<Scalars['String']['input']>;
  employeeNoContainsFold?: InputMaybe<Scalars['String']['input']>;
  employeeNoEqualFold?: InputMaybe<Scalars['String']['input']>;
  employeeNoGT?: InputMaybe<Scalars['String']['input']>;
  employeeNoGTE?: InputMaybe<Scalars['String']['input']>;
  employeeNoHasPrefix?: InputMaybe<Scalars['String']['input']>;
  employeeNoHasSuffix?: InputMaybe<Scalars['String']['input']>;
  employeeNoIn?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeNoLT?: InputMaybe<Scalars['String']['input']>;
  employeeNoLTE?: InputMaybe<Scalars['String']['input']>;
  employeeNoNEQ?: InputMaybe<Scalars['String']['input']>;
  employeeNoNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** groups edge predicates */
  hasGroups?: InputMaybe<Scalars['Boolean']['input']>;
  hasGroupsWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisationusers edge predicates */
  hasOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationusersWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProfileWhereInput>;
  or?: InputMaybe<Array<ProfileWhereInput>>;
  /** organisationuser_id field predicates */
  organisationuserID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationuserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationuserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** supervisor_name field predicates */
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  supervisorNameContains?: InputMaybe<Scalars['String']['input']>;
  supervisorNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  supervisorNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  supervisorNameGT?: InputMaybe<Scalars['String']['input']>;
  supervisorNameGTE?: InputMaybe<Scalars['String']['input']>;
  supervisorNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  supervisorNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  supervisorNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisorNameLT?: InputMaybe<Scalars['String']['input']>;
  supervisorNameLTE?: InputMaybe<Scalars['String']['input']>;
  supervisorNameNEQ?: InputMaybe<Scalars['String']['input']>;
  supervisorNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** supervisor_phonenumber field predicates */
  supervisorPhonenumber?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberContains?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberGT?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberGTE?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisorPhonenumberLT?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberLTE?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberNEQ?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type PusherConfig = Node & {
  __typename?: 'PusherConfig';
  active: Scalars['Boolean']['output'];
  adminID?: Maybe<Scalars['Int']['output']>;
  allData: Scalars['Boolean']['output'];
  allDevices: Scalars['Boolean']['output'];
  apiExtra?: Maybe<Scalars['String']['output']>;
  apiKeyName?: Maybe<Scalars['String']['output']>;
  apiKeySecret?: Maybe<Scalars['String']['output']>;
  apiSkipSsl: Scalars['Boolean']['output'];
  apiTimeoutSeconds: Scalars['Int']['output'];
  apiURL?: Maybe<Scalars['String']['output']>;
  config: Scalars['JSON']['output'];
  createdAt: Scalars['Time']['output'];
  deviceIds: Array<Scalars['Int']['output']>;
  headers: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  lastFailedAt?: Maybe<Scalars['Time']['output']>;
  lastResponse?: Maybe<Scalars['String']['output']>;
  lastSuccessAt?: Maybe<Scalars['Time']['output']>;
  nextAttemptAt?: Maybe<Scalars['Time']['output']>;
  pauseOnFailureSeconds: Scalars['Int']['output'];
  periodicBatchSeconds: Scalars['Int']['output'];
  periodicMaxBatchSize: Scalars['Int']['output'];
  taskName: Scalars['String']['output'];
  type: PusherConfigType;
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['Int']['output']>;
  withAddress: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type PusherConfigConnection = {
  __typename?: 'PusherConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PusherConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PusherConfigEdge = {
  __typename?: 'PusherConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PusherConfig>;
};

export enum PusherConfigField {
  Active = 'active',
  AdminId = 'adminID',
  AllData = 'allData',
  AllDevices = 'allDevices',
  ApiExtra = 'apiExtra',
  ApiKeyName = 'apiKeyName',
  ApiKeySecret = 'apiKeySecret',
  ApiSkipSsl = 'apiSkipSsl',
  ApiTimeoutSeconds = 'apiTimeoutSeconds',
  ApiUrl = 'apiURL',
  Config = 'config',
  CreatedAt = 'createdAt',
  DeviceIds = 'deviceIds',
  Headers = 'headers',
  LastFailedAt = 'lastFailedAt',
  LastResponse = 'lastResponse',
  LastSuccessAt = 'lastSuccessAt',
  NextAttemptAt = 'nextAttemptAt',
  PauseOnFailureSeconds = 'pauseOnFailureSeconds',
  PeriodicBatchSeconds = 'periodicBatchSeconds',
  PeriodicMaxBatchSize = 'periodicMaxBatchSize',
  TaskName = 'taskName',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  WithAddress = 'withAddress'
}

/** Ordering options for PusherConfig connections */
export type PusherConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PusherConfigs. */
  field: PusherConfigOrderField;
};

/** Properties by which PusherConfig connections can be ordered. */
export enum PusherConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** PusherConfigType is enum for the field type */
export enum PusherConfigType {
  Events = 'EVENTS',
  Positions = 'POSITIONS',
  VideoEvents = 'VIDEO_EVENTS'
}

/**
 * PusherConfigWhereInput is used for filtering PusherConfig objects.
 * Input was generated by ent.
 */
export type PusherConfigWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** admin_id field predicates */
  adminID?: InputMaybe<Scalars['Int']['input']>;
  adminIDGT?: InputMaybe<Scalars['Int']['input']>;
  adminIDGTE?: InputMaybe<Scalars['Int']['input']>;
  adminIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  adminIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  adminIDLT?: InputMaybe<Scalars['Int']['input']>;
  adminIDLTE?: InputMaybe<Scalars['Int']['input']>;
  adminIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  adminIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  adminIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** all_data field predicates */
  allData?: InputMaybe<Scalars['Boolean']['input']>;
  allDataNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** all_devices field predicates */
  allDevices?: InputMaybe<Scalars['Boolean']['input']>;
  allDevicesNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<PusherConfigWhereInput>>;
  /** api_extra field predicates */
  apiExtra?: InputMaybe<Scalars['String']['input']>;
  apiExtraContains?: InputMaybe<Scalars['String']['input']>;
  apiExtraContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiExtraEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiExtraGT?: InputMaybe<Scalars['String']['input']>;
  apiExtraGTE?: InputMaybe<Scalars['String']['input']>;
  apiExtraHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiExtraHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiExtraIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiExtraIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiExtraLT?: InputMaybe<Scalars['String']['input']>;
  apiExtraLTE?: InputMaybe<Scalars['String']['input']>;
  apiExtraNEQ?: InputMaybe<Scalars['String']['input']>;
  apiExtraNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiExtraNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key_name field predicates */
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContains?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyNameLT?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeyNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_key_secret field predicates */
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContains?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretGTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeySecretLT?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretLTE?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNEQ?: InputMaybe<Scalars['String']['input']>;
  apiKeySecretNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeySecretNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_skip_ssl field predicates */
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiSkipSslNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_timeout_seconds field predicates */
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  apiTimeoutSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  apiTimeoutSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** api_url field predicates */
  apiURL?: InputMaybe<Scalars['String']['input']>;
  apiURLContains?: InputMaybe<Scalars['String']['input']>;
  apiURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  apiURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  apiURLGT?: InputMaybe<Scalars['String']['input']>;
  apiURLGTE?: InputMaybe<Scalars['String']['input']>;
  apiURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  apiURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  apiURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  apiURLLT?: InputMaybe<Scalars['String']['input']>;
  apiURLLTE?: InputMaybe<Scalars['String']['input']>;
  apiURLNEQ?: InputMaybe<Scalars['String']['input']>;
  apiURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  apiURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** config field predicates */
  config?: InputMaybe<Scalars['JSON']['input']>;
  configGT?: InputMaybe<Scalars['JSON']['input']>;
  configGTE?: InputMaybe<Scalars['JSON']['input']>;
  configIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  configLT?: InputMaybe<Scalars['JSON']['input']>;
  configLTE?: InputMaybe<Scalars['JSON']['input']>;
  configNEQ?: InputMaybe<Scalars['JSON']['input']>;
  configNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** headers field predicates */
  headers?: InputMaybe<Scalars['JSON']['input']>;
  headersGT?: InputMaybe<Scalars['JSON']['input']>;
  headersGTE?: InputMaybe<Scalars['JSON']['input']>;
  headersIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  headersLT?: InputMaybe<Scalars['JSON']['input']>;
  headersLTE?: InputMaybe<Scalars['JSON']['input']>;
  headersNEQ?: InputMaybe<Scalars['JSON']['input']>;
  headersNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_failed_at field predicates */
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastFailedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastFailedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_response field predicates */
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastResponseContains?: InputMaybe<Scalars['String']['input']>;
  lastResponseContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastResponseEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastResponseGT?: InputMaybe<Scalars['String']['input']>;
  lastResponseGTE?: InputMaybe<Scalars['String']['input']>;
  lastResponseHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastResponseHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastResponseIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastResponseIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastResponseLT?: InputMaybe<Scalars['String']['input']>;
  lastResponseLTE?: InputMaybe<Scalars['String']['input']>;
  lastResponseNEQ?: InputMaybe<Scalars['String']['input']>;
  lastResponseNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastResponseNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_success_at field predicates */
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastSuccessAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastSuccessAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** next_attempt_at field predicates */
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtGT?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtGTE?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextAttemptAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nextAttemptAtLT?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtLTE?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  nextAttemptAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PusherConfigWhereInput>;
  or?: InputMaybe<Array<PusherConfigWhereInput>>;
  /** pause_on_failure_seconds field predicates */
  pauseOnFailureSeconds?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  pauseOnFailureSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  pauseOnFailureSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** periodic_batch_seconds field predicates */
  periodicBatchSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  periodicBatchSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** periodic_max_batch_size field predicates */
  periodicMaxBatchSize?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeGT?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeGTE?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  periodicMaxBatchSizeLT?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeLTE?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeNEQ?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSizeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** task_name field predicates */
  taskName?: InputMaybe<Scalars['String']['input']>;
  taskNameContains?: InputMaybe<Scalars['String']['input']>;
  taskNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  taskNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  taskNameGT?: InputMaybe<Scalars['String']['input']>;
  taskNameGTE?: InputMaybe<Scalars['String']['input']>;
  taskNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  taskNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  taskNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  taskNameLT?: InputMaybe<Scalars['String']['input']>;
  taskNameLTE?: InputMaybe<Scalars['String']['input']>;
  taskNameNEQ?: InputMaybe<Scalars['String']['input']>;
  taskNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** type field predicates */
  type?: InputMaybe<PusherConfigType>;
  typeIn?: InputMaybe<Array<PusherConfigType>>;
  typeNEQ?: InputMaybe<PusherConfigType>;
  typeNotIn?: InputMaybe<Array<PusherConfigType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** with_address field predicates */
  withAddress?: InputMaybe<Scalars['Boolean']['input']>;
  withAddressNEQ?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PusherLog = Node & {
  __typename?: 'PusherLog';
  createdAt: Scalars['Time']['output'];
  deviceID?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  responseData?: Maybe<Scalars['String']['output']>;
  responseSeconds?: Maybe<Scalars['Int']['output']>;
  sentData?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of items. */
export type PusherLogConnection = {
  __typename?: 'PusherLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PusherLogEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PusherLogEdge = {
  __typename?: 'PusherLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PusherLog>;
};

export enum PusherLogField {
  CreatedAt = 'createdAt',
  DeviceId = 'deviceID',
  Imei = 'imei',
  Notes = 'notes',
  ResponseCode = 'responseCode',
  ResponseData = 'responseData',
  ResponseSeconds = 'responseSeconds',
  SentData = 'sentData',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for PusherLog connections */
export type PusherLogOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order PusherLogs. */
  field: PusherLogOrderField;
};

/** Properties by which PusherLog connections can be ordered. */
export enum PusherLogOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * PusherLogWhereInput is used for filtering PusherLog objects.
 * Input was generated by ent.
 */
export type PusherLogWhereInput = {
  and?: InputMaybe<Array<PusherLogWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_id field predicates */
  deviceID?: InputMaybe<Scalars['Int']['input']>;
  deviceIDGT?: InputMaybe<Scalars['Int']['input']>;
  deviceIDGTE?: InputMaybe<Scalars['Int']['input']>;
  deviceIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  deviceIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deviceIDLT?: InputMaybe<Scalars['Int']['input']>;
  deviceIDLTE?: InputMaybe<Scalars['Int']['input']>;
  deviceIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  deviceIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  deviceIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** imei field predicates */
  imei?: InputMaybe<Scalars['String']['input']>;
  imeiContains?: InputMaybe<Scalars['String']['input']>;
  imeiContainsFold?: InputMaybe<Scalars['String']['input']>;
  imeiEqualFold?: InputMaybe<Scalars['String']['input']>;
  imeiGT?: InputMaybe<Scalars['String']['input']>;
  imeiGTE?: InputMaybe<Scalars['String']['input']>;
  imeiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  imeiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  imeiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imeiIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  imeiLT?: InputMaybe<Scalars['String']['input']>;
  imeiLTE?: InputMaybe<Scalars['String']['input']>;
  imeiNEQ?: InputMaybe<Scalars['String']['input']>;
  imeiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imeiNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<PusherLogWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<PusherLogWhereInput>>;
  /** response_code field predicates */
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  responseCodeGT?: InputMaybe<Scalars['Int']['input']>;
  responseCodeGTE?: InputMaybe<Scalars['Int']['input']>;
  responseCodeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseCodeLT?: InputMaybe<Scalars['Int']['input']>;
  responseCodeLTE?: InputMaybe<Scalars['Int']['input']>;
  responseCodeNEQ?: InputMaybe<Scalars['Int']['input']>;
  responseCodeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_data field predicates */
  responseData?: InputMaybe<Scalars['String']['input']>;
  responseDataContains?: InputMaybe<Scalars['String']['input']>;
  responseDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  responseDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  responseDataGT?: InputMaybe<Scalars['String']['input']>;
  responseDataGTE?: InputMaybe<Scalars['String']['input']>;
  responseDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  responseDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  responseDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseDataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseDataLT?: InputMaybe<Scalars['String']['input']>;
  responseDataLTE?: InputMaybe<Scalars['String']['input']>;
  responseDataNEQ?: InputMaybe<Scalars['String']['input']>;
  responseDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  responseDataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** response_seconds field predicates */
  responseSeconds?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseSecondsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  responseSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  responseSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  responseSecondsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sent_data field predicates */
  sentData?: InputMaybe<Scalars['String']['input']>;
  sentDataContains?: InputMaybe<Scalars['String']['input']>;
  sentDataContainsFold?: InputMaybe<Scalars['String']['input']>;
  sentDataEqualFold?: InputMaybe<Scalars['String']['input']>;
  sentDataGT?: InputMaybe<Scalars['String']['input']>;
  sentDataGTE?: InputMaybe<Scalars['String']['input']>;
  sentDataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  sentDataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  sentDataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sentDataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sentDataLT?: InputMaybe<Scalars['String']['input']>;
  sentDataLTE?: InputMaybe<Scalars['String']['input']>;
  sentDataNEQ?: InputMaybe<Scalars['String']['input']>;
  sentDataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  sentDataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  AdhocTableExport?: Maybe<Scalars['String']['output']>;
  AdhocTableQuery: AdhocTableConnection;
  AttendanceDetailExport?: Maybe<Scalars['String']['output']>;
  AttendanceDetailQuery: AttendanceDetailConnection;
  AttendanceExport?: Maybe<Scalars['String']['output']>;
  AttendanceQuery: AttendanceConnection;
  BaseAddonExport?: Maybe<Scalars['String']['output']>;
  BaseAddonQuery: BaseAddonConnection;
  BaseLicensePlanAddonExport?: Maybe<Scalars['String']['output']>;
  BaseLicensePlanAddonQuery: BaseLicensePlanAddonConnection;
  BaseLicensePlanExport?: Maybe<Scalars['String']['output']>;
  BaseLicensePlanQuery: BaseLicensePlanConnection;
  BaseReportExport?: Maybe<Scalars['String']['output']>;
  BaseReportQuery: BaseReportConnection;
  ChangeLogExport?: Maybe<Scalars['String']['output']>;
  ChangeLogQuery: ChangeLogConnection;
  Chatbot: Scalars['JSON']['output'];
  ConsumerConfigExport?: Maybe<Scalars['String']['output']>;
  ConsumerConfigQuery: ConsumerConfigConnection;
  ConsumerServerExport?: Maybe<Scalars['String']['output']>;
  ConsumerServerQuery: ConsumerServerConnection;
  CurrentUser?: Maybe<CurrentUserResponse>;
  DerivedReportExport?: Maybe<Scalars['String']['output']>;
  DerivedReportQuery: DerivedReportConnection;
  DeviceActionLogExport?: Maybe<Scalars['String']['output']>;
  DeviceActionLogQuery: DeviceActionLogConnection;
  DeviceCategoryExport?: Maybe<Scalars['String']['output']>;
  DeviceCategoryQuery: DeviceCategoryConnection;
  DeviceConfigExport?: Maybe<Scalars['String']['output']>;
  DeviceConfigQuery: DeviceConfigConnection;
  DeviceExport?: Maybe<Scalars['String']['output']>;
  DeviceGroupExport?: Maybe<Scalars['String']['output']>;
  DeviceGroupQuery: DeviceGroupConnection;
  DeviceModelExport?: Maybe<Scalars['String']['output']>;
  DeviceModelQuery: DeviceModelConnection;
  DeviceParkingModeConfigExport?: Maybe<Scalars['String']['output']>;
  DeviceParkingModeConfigQuery: DeviceParkingModeConfigConnection;
  DevicePlaybackFilesExport?: Maybe<Scalars['String']['output']>;
  DevicePlaybackFilesQuery: DevicePlaybackFilesConnection;
  DeviceQuery: DeviceConnection;
  DeviceTodayStats: DeviceTodayStatsResponse;
  EmailOrMobileBasedOrganisations: Array<Organisation>;
  FindOrganisationByDeviceImei: Array<OrganisationWithCounts>;
  FindOrganisationWithHierarchy: Array<OrganisationWithCounts>;
  FirebasePrivateKeyExport?: Maybe<Scalars['String']['output']>;
  FirebasePrivateKeyQuery: FirebasePrivateKeyConnection;
  GeneratePresignedUploadUrl: GeneratePresignedUploadUrlResponse;
  GeofenceDeviceGroupExport?: Maybe<Scalars['String']['output']>;
  GeofenceDeviceGroupQuery: GeofenceDeviceGroupConnection;
  GeofenceExport?: Maybe<Scalars['String']['output']>;
  GeofenceQuery: GeofenceConnection;
  GetOptimalEtaRoute: OptimisedHaltpointResponse;
  HaltPointExport?: Maybe<Scalars['String']['output']>;
  HaltPointQuery: HaltPointConnection;
  Impersonate: LoginResponse;
  InspectionReportExport?: Maybe<Scalars['String']['output']>;
  InspectionReportQuery: InspectionReportConnection;
  KmlExport?: Maybe<Scalars['String']['output']>;
  KmlQuery: KmlConnection;
  LastFewEvents: Array<Maybe<LastFewEventsResponse>>;
  LeaveDateExport?: Maybe<Scalars['String']['output']>;
  LeaveDateQuery: LeaveDateConnection;
  LeaveRequestExport?: Maybe<Scalars['String']['output']>;
  LeaveRequestQuery: LeaveRequestConnection;
  LeaveTypeExport?: Maybe<Scalars['String']['output']>;
  LeaveTypeQuery: LeaveTypeConnection;
  LicenseExport?: Maybe<Scalars['String']['output']>;
  LicenseOrderAddonExport?: Maybe<Scalars['String']['output']>;
  LicenseOrderAddonQuery: LicenseOrderAddonConnection;
  LicenseQuery: LicenseConnection;
  MapConfigExport?: Maybe<Scalars['String']['output']>;
  MapConfigQuery: MapConfigConnection;
  NotifyChannelExport?: Maybe<Scalars['String']['output']>;
  NotifyChannelQuery: NotifyChannelConnection;
  NotifyConfigChannelExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigChannelQuery: NotifyConfigChannelConnection;
  NotifyConfigDeviceGroupExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigDeviceGroupQuery: NotifyConfigDeviceGroupConnection;
  NotifyConfigEventExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigEventQuery: NotifyConfigEventConnection;
  NotifyConfigExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigGeofenceExport?: Maybe<Scalars['String']['output']>;
  NotifyConfigGeofenceQuery: NotifyConfigGeofenceConnection;
  NotifyConfigQuery: NotifyConfigConnection;
  NotifyEventOptionExport?: Maybe<Scalars['String']['output']>;
  NotifyEventOptionQuery: NotifyEventOptionConnection;
  OrganisationExport?: Maybe<Scalars['String']['output']>;
  OrganisationQuery: OrganisationConnection;
  OrganisationRoleExport?: Maybe<Scalars['String']['output']>;
  OrganisationRolePermissionExport?: Maybe<Scalars['String']['output']>;
  OrganisationRolePermissionQuery: OrganisationRolePermissionConnection;
  OrganisationRoleQuery: OrganisationRoleConnection;
  OrganisationUpgradeExport?: Maybe<Scalars['String']['output']>;
  OrganisationUpgradeQuery: OrganisationUpgradeConnection;
  OrganisationUserExport?: Maybe<Scalars['String']['output']>;
  OrganisationUserQuery: OrganisationUserConnection;
  OtpLogin: LoginResponse;
  PasswordLogin: LoginResponse;
  PermissionExport?: Maybe<Scalars['String']['output']>;
  PermissionQuery: PermissionConnection;
  PinnedDevicesExport?: Maybe<Scalars['String']['output']>;
  PinnedDevicesQuery: PinnedDevicesConnection;
  PoiExport?: Maybe<Scalars['String']['output']>;
  PoiQuery: PoiConnection;
  PositionAttributeFormulaExport?: Maybe<Scalars['String']['output']>;
  PositionAttributeFormulaQuery: PositionAttributeFormulaConnection;
  PositionPollingWithStats: PositionPollingWithStatsResponse;
  ProfileExport?: Maybe<Scalars['String']['output']>;
  ProfileQuery: ProfileConnection;
  PusherConfigExport?: Maybe<Scalars['String']['output']>;
  PusherConfigQuery: PusherConfigConnection;
  RefreshToken: LoginResponse;
  ReportEvent?: Maybe<ReportEventResponse>;
  ReportOnEmail?: Maybe<Scalars['String']['output']>;
  ReportPosition?: Maybe<ReportPositionResponse>;
  ReportStopIdle?: Maybe<ReportReportStopIdleResponse>;
  ReportSummary?: Maybe<ReportSummaryResponse>;
  ReportTrip?: Maybe<ReportTripResponse>;
  RosterExport?: Maybe<Scalars['String']['output']>;
  RosterQuery: RosterConnection;
  RosterScheduleExport?: Maybe<Scalars['String']['output']>;
  RosterScheduleQuery: RosterScheduleConnection;
  RosterShiftExport?: Maybe<Scalars['String']['output']>;
  RosterShiftQuery: RosterShiftConnection;
  RouteExport?: Maybe<Scalars['String']['output']>;
  RouteHaltPointExport?: Maybe<Scalars['String']['output']>;
  RouteHaltPointQuery: RouteHaltPointConnection;
  RouteHaltPointTargetExport?: Maybe<Scalars['String']['output']>;
  RouteHaltPointTargetQuery: RouteHaltPointTargetConnection;
  RouteQuery: RouteConnection;
  RouteShiftExport?: Maybe<Scalars['String']['output']>;
  RouteShiftQuery: RouteShiftConnection;
  RouteTimeLineExport?: Maybe<Scalars['String']['output']>;
  RouteTimeLineQuery: RouteTimeLineConnection;
  ScheduleTaskExport?: Maybe<Scalars['String']['output']>;
  ScheduleTaskQuery: ScheduleTaskConnection;
  SendFcmTestNotification: Scalars['Boolean']['output'];
  SendOtp: Scalars['Boolean']['output'];
  ShiftExport?: Maybe<Scalars['String']['output']>;
  ShiftQuery: ShiftConnection;
  SimExport?: Maybe<Scalars['String']['output']>;
  SimQuery: SimConnection;
  StiQRExport?: Maybe<Scalars['String']['output']>;
  StiQRQuery: StiQrConnection;
  SubscriptionLicenseOrderExport?: Maybe<Scalars['String']['output']>;
  SubscriptionLicenseOrderQuery: SubscriptionLicenseOrderConnection;
  SupportTicketExport?: Maybe<Scalars['String']['output']>;
  SupportTicketQuery: SupportTicketConnection;
  TargetExport?: Maybe<Scalars['String']['output']>;
  TargetQuery: TargetConnection;
  TaskStatus: TaskState;
  TripConfigsExport?: Maybe<Scalars['String']['output']>;
  TripConfigsQuery: TripConfigsConnection;
  TripExport?: Maybe<Scalars['String']['output']>;
  TripHaltPointExport?: Maybe<Scalars['String']['output']>;
  TripHaltPointQuery: TripHaltPointConnection;
  TripHaltPointTargetExport?: Maybe<Scalars['String']['output']>;
  TripHaltPointTargetQuery: TripHaltPointTargetConnection;
  TripHaltPointTargetTimeLineExport?: Maybe<Scalars['String']['output']>;
  TripHaltPointTargetTimeLineQuery: TripHaltPointTargetTimeLineConnection;
  TripHaltPointTimeLineExport?: Maybe<Scalars['String']['output']>;
  TripHaltPointTimeLineQuery: TripHaltPointTimeLineConnection;
  TripQuery: TripConnection;
  TripTimeLineExport?: Maybe<Scalars['String']['output']>;
  TripTimeLineQuery: TripTimeLineConnection;
  UpgradeExport?: Maybe<Scalars['String']['output']>;
  UpgradeOrganisationPriceExport?: Maybe<Scalars['String']['output']>;
  UpgradeOrganisationPriceQuery: UpgradeOrganisationPriceConnection;
  UpgradeQuery: UpgradeConnection;
  UserConfigExport?: Maybe<Scalars['String']['output']>;
  UserConfigQuery: UserConfigConnection;
  UserExport?: Maybe<Scalars['String']['output']>;
  UserLeaveBalanceExport?: Maybe<Scalars['String']['output']>;
  UserLeaveBalanceQuery: UserLeaveBalanceConnection;
  UserQuery: UserConnection;
  UserReportBookmarkExport?: Maybe<Scalars['String']['output']>;
  UserReportBookmarkQuery: UserReportBookmarkConnection;
  UserRosterAssignmentExport?: Maybe<Scalars['String']['output']>;
  UserRosterAssignmentQuery: UserRosterAssignmentConnection;
  WalletExport?: Maybe<Scalars['String']['output']>;
  WalletPaymentTransactionExport?: Maybe<Scalars['String']['output']>;
  WalletPaymentTransactionQuery: WalletPaymentTransactionConnection;
  WalletQuery: WalletConnection;
  WalletTransactionExport?: Maybe<Scalars['String']['output']>;
  WalletTransactionQuery: WalletTransactionConnection;
  WhitelabelConfigExport?: Maybe<Scalars['String']['output']>;
  WhitelabelConfigQuery: WhitelabelConfigConnection;
  YardTripStatusExport?: Maybe<Scalars['String']['output']>;
  YardTripStatusQuery: YardTripStatusConnection;
  YardWarehouseDockExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseDockQuery: YardWarehouseDockConnection;
  YardWarehouseDockSharingExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseDockSharingQuery: YardWarehouseDockSharingConnection;
  YardWarehouseRoutePathExport?: Maybe<Scalars['String']['output']>;
  YardWarehouseRoutePathQuery: YardWarehouseRoutePathConnection;
  attendanceDetailSummary: Array<StatusGroup>;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  nodes: Array<Maybe<Node>>;
};


export type QueryAdhocTableExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AdhocTableOrder>>;
  where?: InputMaybe<AdhocTableWhereInput>;
};


export type QueryAdhocTableQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AdhocTableOrder>>;
  where?: InputMaybe<AdhocTableWhereInput>;
};


export type QueryAttendanceDetailExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttendanceDetailOrder>>;
  where?: InputMaybe<AttendanceDetailWhereInput>;
};


export type QueryAttendanceDetailQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttendanceDetailOrder>>;
  where?: InputMaybe<AttendanceDetailWhereInput>;
};


export type QueryAttendanceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttendanceOrder>>;
  where?: InputMaybe<AttendanceWhereInput>;
};


export type QueryAttendanceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AttendanceOrder>>;
  where?: InputMaybe<AttendanceWhereInput>;
};


export type QueryBaseAddonExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseAddonOrder>>;
  where?: InputMaybe<BaseAddonWhereInput>;
};


export type QueryBaseAddonQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseAddonOrder>>;
  where?: InputMaybe<BaseAddonWhereInput>;
};


export type QueryBaseLicensePlanAddonExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseLicensePlanAddonOrder>>;
  where?: InputMaybe<BaseLicensePlanAddonWhereInput>;
};


export type QueryBaseLicensePlanAddonQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseLicensePlanAddonOrder>>;
  where?: InputMaybe<BaseLicensePlanAddonWhereInput>;
};


export type QueryBaseLicensePlanExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseLicensePlanOrder>>;
  where?: InputMaybe<BaseLicensePlanWhereInput>;
};


export type QueryBaseLicensePlanQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseLicensePlanOrder>>;
  where?: InputMaybe<BaseLicensePlanWhereInput>;
};


export type QueryBaseReportExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseReportOrder>>;
  where?: InputMaybe<BaseReportWhereInput>;
};


export type QueryBaseReportQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BaseReportOrder>>;
  where?: InputMaybe<BaseReportWhereInput>;
};


export type QueryChangeLogExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeLogOrder>>;
  where?: InputMaybe<ChangeLogWhereInput>;
};


export type QueryChangeLogQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeLogOrder>>;
  where?: InputMaybe<ChangeLogWhereInput>;
};


export type QueryChatbotArgs = {
  conversationId: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};


export type QueryConsumerConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumerConfigOrder>>;
  where?: InputMaybe<ConsumerConfigWhereInput>;
};


export type QueryConsumerConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumerConfigOrder>>;
  where?: InputMaybe<ConsumerConfigWhereInput>;
};


export type QueryConsumerServerExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumerServerOrder>>;
  where?: InputMaybe<ConsumerServerWhereInput>;
};


export type QueryConsumerServerQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumerServerOrder>>;
  where?: InputMaybe<ConsumerServerWhereInput>;
};


export type QueryDerivedReportExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DerivedReportOrder>>;
  where?: InputMaybe<DerivedReportWhereInput>;
};


export type QueryDerivedReportQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DerivedReportOrder>>;
  where?: InputMaybe<DerivedReportWhereInput>;
};


export type QueryDeviceActionLogExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceActionLogOrder>>;
  where?: InputMaybe<DeviceActionLogWhereInput>;
};


export type QueryDeviceActionLogQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceActionLogOrder>>;
  where?: InputMaybe<DeviceActionLogWhereInput>;
};


export type QueryDeviceCategoryExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceCategoryOrder>>;
  where?: InputMaybe<DeviceCategoryWhereInput>;
};


export type QueryDeviceCategoryQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceCategoryOrder>>;
  where?: InputMaybe<DeviceCategoryWhereInput>;
};


export type QueryDeviceConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceConfigOrder>>;
  where?: InputMaybe<DeviceConfigWhereInput>;
};


export type QueryDeviceConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceConfigOrder>>;
  where?: InputMaybe<DeviceConfigWhereInput>;
};


export type QueryDeviceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrder>>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type QueryDeviceGroupExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceGroupOrder>>;
  where?: InputMaybe<DeviceGroupWhereInput>;
};


export type QueryDeviceGroupQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceGroupOrder>>;
  where?: InputMaybe<DeviceGroupWhereInput>;
};


export type QueryDeviceModelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceModelOrder>>;
  where?: InputMaybe<DeviceModelWhereInput>;
};


export type QueryDeviceModelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceModelOrder>>;
  where?: InputMaybe<DeviceModelWhereInput>;
};


export type QueryDeviceParkingModeConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceParkingModeConfigOrder>>;
  where?: InputMaybe<DeviceParkingModeConfigWhereInput>;
};


export type QueryDeviceParkingModeConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceParkingModeConfigOrder>>;
  where?: InputMaybe<DeviceParkingModeConfigWhereInput>;
};


export type QueryDevicePlaybackFilesExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicePlaybackFilesOrder>>;
  where?: InputMaybe<DevicePlaybackFilesWhereInput>;
};


export type QueryDevicePlaybackFilesQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DevicePlaybackFilesOrder>>;
  where?: InputMaybe<DevicePlaybackFilesWhereInput>;
};


export type QueryDeviceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DeviceOrder>>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type QueryDeviceTodayStatsArgs = {
  deviceId: Scalars['ID']['input'];
};


export type QueryEmailOrMobileBasedOrganisationsArgs = {
  androidAppPackageName?: InputMaybe<Scalars['String']['input']>;
  emailOrMobile: Scalars['String']['input'];
  iosAppPackageName?: InputMaybe<Scalars['String']['input']>;
  webDomain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindOrganisationByDeviceImeiArgs = {
  imei: Scalars['String']['input'];
};


export type QueryFindOrganisationWithHierarchyArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryFirebasePrivateKeyExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FirebasePrivateKeyOrder>>;
  where?: InputMaybe<FirebasePrivateKeyWhereInput>;
};


export type QueryFirebasePrivateKeyQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FirebasePrivateKeyOrder>>;
  where?: InputMaybe<FirebasePrivateKeyWhereInput>;
};


export type QueryGeneratePresignedUploadUrlArgs = {
  contentEncoding: Scalars['String']['input'];
  directory: Scalars['String']['input'];
  fileExtension: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};


export type QueryGeofenceDeviceGroupExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeofenceDeviceGroupOrder>>;
  where?: InputMaybe<GeofenceDeviceGroupWhereInput>;
};


export type QueryGeofenceDeviceGroupQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeofenceDeviceGroupOrder>>;
  where?: InputMaybe<GeofenceDeviceGroupWhereInput>;
};


export type QueryGeofenceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeofenceOrder>>;
  where?: InputMaybe<GeofenceWhereInput>;
};


export type QueryGeofenceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeofenceOrder>>;
  where?: InputMaybe<GeofenceWhereInput>;
};


export type QueryGetOptimalEtaRouteArgs = {
  endpoint?: InputMaybe<Scalars['ID']['input']>;
  haltpoints: Array<Scalars['ID']['input']>;
  serviceType: ServiceType;
  startpoint?: InputMaybe<Scalars['ID']['input']>;
  vehicle: VehicleInput;
};


export type QueryHaltPointExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HaltPointOrder>>;
  where?: InputMaybe<HaltPointWhereInput>;
};


export type QueryHaltPointQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HaltPointOrder>>;
  where?: InputMaybe<HaltPointWhereInput>;
};


export type QueryImpersonateArgs = {
  organisationUserId: Scalars['ID']['input'];
};


export type QueryInspectionReportExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InspectionReportOrder>>;
  where?: InputMaybe<InspectionReportWhereInput>;
};


export type QueryInspectionReportQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InspectionReportOrder>>;
  where?: InputMaybe<InspectionReportWhereInput>;
};


export type QueryKmlExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KmlOrder>>;
  where?: InputMaybe<KmlWhereInput>;
};


export type QueryKmlQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<KmlOrder>>;
  where?: InputMaybe<KmlWhereInput>;
};


export type QueryLastFewEventsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeaveDateExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LeaveDateOrder>>;
  where?: InputMaybe<LeaveDateWhereInput>;
};


export type QueryLeaveDateQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LeaveDateOrder>>;
  where?: InputMaybe<LeaveDateWhereInput>;
};


export type QueryLeaveRequestExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LeaveRequestOrder>>;
  where?: InputMaybe<LeaveRequestWhereInput>;
};


export type QueryLeaveRequestQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LeaveRequestOrder>>;
  where?: InputMaybe<LeaveRequestWhereInput>;
};


export type QueryLeaveTypeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LeaveTypeOrder>>;
  where?: InputMaybe<LeaveTypeWhereInput>;
};


export type QueryLeaveTypeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LeaveTypeOrder>>;
  where?: InputMaybe<LeaveTypeWhereInput>;
};


export type QueryLicenseExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LicenseOrder>>;
  where?: InputMaybe<LicenseWhereInput>;
};


export type QueryLicenseOrderAddonExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LicenseOrderAddonOrder>>;
  where?: InputMaybe<LicenseOrderAddonWhereInput>;
};


export type QueryLicenseOrderAddonQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LicenseOrderAddonOrder>>;
  where?: InputMaybe<LicenseOrderAddonWhereInput>;
};


export type QueryLicenseQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LicenseOrder>>;
  where?: InputMaybe<LicenseWhereInput>;
};


export type QueryMapConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MapConfigOrder>>;
  where?: InputMaybe<MapConfigWhereInput>;
};


export type QueryMapConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MapConfigOrder>>;
  where?: InputMaybe<MapConfigWhereInput>;
};


export type QueryNotifyChannelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyChannelOrder>>;
  where?: InputMaybe<NotifyChannelWhereInput>;
};


export type QueryNotifyChannelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyChannelOrder>>;
  where?: InputMaybe<NotifyChannelWhereInput>;
};


export type QueryNotifyConfigChannelExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigChannelOrder>>;
  where?: InputMaybe<NotifyConfigChannelWhereInput>;
};


export type QueryNotifyConfigChannelQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigChannelOrder>>;
  where?: InputMaybe<NotifyConfigChannelWhereInput>;
};


export type QueryNotifyConfigDeviceGroupExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigDeviceGroupOrder>>;
  where?: InputMaybe<NotifyConfigDeviceGroupWhereInput>;
};


export type QueryNotifyConfigDeviceGroupQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigDeviceGroupOrder>>;
  where?: InputMaybe<NotifyConfigDeviceGroupWhereInput>;
};


export type QueryNotifyConfigEventExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigEventOrder>>;
  where?: InputMaybe<NotifyConfigEventWhereInput>;
};


export type QueryNotifyConfigEventQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigEventOrder>>;
  where?: InputMaybe<NotifyConfigEventWhereInput>;
};


export type QueryNotifyConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigOrder>>;
  where?: InputMaybe<NotifyConfigWhereInput>;
};


export type QueryNotifyConfigGeofenceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigGeofenceOrder>>;
  where?: InputMaybe<NotifyConfigGeofenceWhereInput>;
};


export type QueryNotifyConfigGeofenceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigGeofenceOrder>>;
  where?: InputMaybe<NotifyConfigGeofenceWhereInput>;
};


export type QueryNotifyConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyConfigOrder>>;
  where?: InputMaybe<NotifyConfigWhereInput>;
};


export type QueryNotifyEventOptionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyEventOptionOrder>>;
  where?: InputMaybe<NotifyEventOptionWhereInput>;
};


export type QueryNotifyEventOptionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotifyEventOptionOrder>>;
  where?: InputMaybe<NotifyEventOptionWhereInput>;
};


export type QueryOrganisationExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationOrder>>;
  where?: InputMaybe<OrganisationWhereInput>;
};


export type QueryOrganisationQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationOrder>>;
  where?: InputMaybe<OrganisationWhereInput>;
};


export type QueryOrganisationRoleExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationRoleOrder>>;
  where?: InputMaybe<OrganisationRoleWhereInput>;
};


export type QueryOrganisationRolePermissionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationRolePermissionOrder>>;
  where?: InputMaybe<OrganisationRolePermissionWhereInput>;
};


export type QueryOrganisationRolePermissionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationRolePermissionOrder>>;
  where?: InputMaybe<OrganisationRolePermissionWhereInput>;
};


export type QueryOrganisationRoleQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationRoleOrder>>;
  where?: InputMaybe<OrganisationRoleWhereInput>;
};


export type QueryOrganisationUpgradeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUpgradeOrder>>;
  where?: InputMaybe<OrganisationUpgradeWhereInput>;
};


export type QueryOrganisationUpgradeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUpgradeOrder>>;
  where?: InputMaybe<OrganisationUpgradeWhereInput>;
};


export type QueryOrganisationUserExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUserOrder>>;
  where?: InputMaybe<OrganisationUserWhereInput>;
};


export type QueryOrganisationUserQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationUserOrder>>;
  where?: InputMaybe<OrganisationUserWhereInput>;
};


export type QueryOtpLoginArgs = {
  mobileNumber: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  otp: Scalars['String']['input'];
  platformFriendlyName: Scalars['String']['input'];
  platformUniqueId: Scalars['String']['input'];
};


export type QueryPasswordLoginArgs = {
  email: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  platformFriendlyName: Scalars['String']['input'];
  platformUniqueId: Scalars['String']['input'];
};


export type QueryPermissionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PermissionOrder>>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryPermissionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PermissionOrder>>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryPinnedDevicesExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PinnedDevicesOrder>>;
  where?: InputMaybe<PinnedDevicesWhereInput>;
};


export type QueryPinnedDevicesQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PinnedDevicesOrder>>;
  where?: InputMaybe<PinnedDevicesWhereInput>;
};


export type QueryPoiExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoiOrder>>;
  where?: InputMaybe<PoiWhereInput>;
};


export type QueryPoiQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoiOrder>>;
  where?: InputMaybe<PoiWhereInput>;
};


export type QueryPositionAttributeFormulaExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PositionAttributeFormulaOrder>>;
  where?: InputMaybe<PositionAttributeFormulaWhereInput>;
};


export type QueryPositionAttributeFormulaQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PositionAttributeFormulaOrder>>;
  where?: InputMaybe<PositionAttributeFormulaWhereInput>;
};


export type QueryPositionPollingWithStatsArgs = {
  considerIdleAfterSeconds?: InputMaybe<Scalars['Int']['input']>;
  considerInactiveAfterSeconds?: InputMaybe<Scalars['Int']['input']>;
  onlyDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  onlyDeviceStatus?: InputMaybe<Array<InputMaybe<DeviceStatus>>>;
  onlyLastUpdateGTE?: InputMaybe<Scalars['Time']['input']>;
};


export type QueryProfileExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfileOrder>>;
  where?: InputMaybe<ProfileWhereInput>;
};


export type QueryProfileQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProfileOrder>>;
  where?: InputMaybe<ProfileWhereInput>;
};


export type QueryPusherConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PusherConfigOrder>>;
  where?: InputMaybe<PusherConfigWhereInput>;
};


export type QueryPusherConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PusherConfigOrder>>;
  where?: InputMaybe<PusherConfigWhereInput>;
};


export type QueryReportEventArgs = {
  filters?: InputMaybe<ReportEventFilter>;
  input: ReportQueryInput;
};


export type QueryReportOnEmailArgs = {
  emailInput: ReportEmailInput;
  queryInput: ReportQueryInput;
};


export type QueryReportPositionArgs = {
  input: ReportQueryInput;
};


export type QueryReportStopIdleArgs = {
  input: ReportQueryInput;
};


export type QueryReportSummaryArgs = {
  input: ReportQueryInput;
};


export type QueryReportTripArgs = {
  input: ReportQueryInput;
};


export type QueryRosterExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RosterOrder>>;
  where?: InputMaybe<RosterWhereInput>;
};


export type QueryRosterQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RosterOrder>>;
  where?: InputMaybe<RosterWhereInput>;
};


export type QueryRosterScheduleExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RosterScheduleOrder>>;
  where?: InputMaybe<RosterScheduleWhereInput>;
};


export type QueryRosterScheduleQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RosterScheduleOrder>>;
  where?: InputMaybe<RosterScheduleWhereInput>;
};


export type QueryRosterShiftExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RosterShiftOrder>>;
  where?: InputMaybe<RosterShiftWhereInput>;
};


export type QueryRosterShiftQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RosterShiftOrder>>;
  where?: InputMaybe<RosterShiftWhereInput>;
};


export type QueryRouteExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOrder>>;
  where?: InputMaybe<RouteWhereInput>;
};


export type QueryRouteHaltPointExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteHaltPointOrder>>;
  where?: InputMaybe<RouteHaltPointWhereInput>;
};


export type QueryRouteHaltPointQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteHaltPointOrder>>;
  where?: InputMaybe<RouteHaltPointWhereInput>;
};


export type QueryRouteHaltPointTargetExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteHaltPointTargetOrder>>;
  where?: InputMaybe<RouteHaltPointTargetWhereInput>;
};


export type QueryRouteHaltPointTargetQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteHaltPointTargetOrder>>;
  where?: InputMaybe<RouteHaltPointTargetWhereInput>;
};


export type QueryRouteQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteOrder>>;
  where?: InputMaybe<RouteWhereInput>;
};


export type QueryRouteShiftExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteShiftOrder>>;
  where?: InputMaybe<RouteShiftWhereInput>;
};


export type QueryRouteShiftQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteShiftOrder>>;
  where?: InputMaybe<RouteShiftWhereInput>;
};


export type QueryRouteTimeLineExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteTimeLineOrder>>;
  where?: InputMaybe<RouteTimeLineWhereInput>;
};


export type QueryRouteTimeLineQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RouteTimeLineOrder>>;
  where?: InputMaybe<RouteTimeLineWhereInput>;
};


export type QueryScheduleTaskExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduleTaskOrder>>;
  where?: InputMaybe<ScheduleTaskWhereInput>;
};


export type QueryScheduleTaskQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ScheduleTaskOrder>>;
  where?: InputMaybe<ScheduleTaskWhereInput>;
};


export type QuerySendFcmTestNotificationArgs = {
  platformUniqueId: Scalars['String']['input'];
};


export type QuerySendOtpArgs = {
  mobileNumber: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type QueryShiftExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShiftOrder>>;
  where?: InputMaybe<ShiftWhereInput>;
};


export type QueryShiftQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShiftOrder>>;
  where?: InputMaybe<ShiftWhereInput>;
};


export type QuerySimExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SimOrder>>;
  where?: InputMaybe<SimWhereInput>;
};


export type QuerySimQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SimOrder>>;
  where?: InputMaybe<SimWhereInput>;
};


export type QueryStiQrExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StiQrOrder>>;
  where?: InputMaybe<StiQrWhereInput>;
};


export type QueryStiQrQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StiQrOrder>>;
  where?: InputMaybe<StiQrWhereInput>;
};


export type QuerySubscriptionLicenseOrderExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubscriptionLicenseOrderOrder>>;
  where?: InputMaybe<SubscriptionLicenseOrderWhereInput>;
};


export type QuerySubscriptionLicenseOrderQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SubscriptionLicenseOrderOrder>>;
  where?: InputMaybe<SubscriptionLicenseOrderWhereInput>;
};


export type QuerySupportTicketExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupportTicketOrder>>;
  where?: InputMaybe<SupportTicketWhereInput>;
};


export type QuerySupportTicketQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupportTicketOrder>>;
  where?: InputMaybe<SupportTicketWhereInput>;
};


export type QueryTargetExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetOrder>>;
  where?: InputMaybe<TargetWhereInput>;
};


export type QueryTargetQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetOrder>>;
  where?: InputMaybe<TargetWhereInput>;
};


export type QueryTaskStatusArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryTripConfigsExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripConfigsOrder>>;
  where?: InputMaybe<TripConfigsWhereInput>;
};


export type QueryTripConfigsQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripConfigsOrder>>;
  where?: InputMaybe<TripConfigsWhereInput>;
};


export type QueryTripExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripOrder>>;
  where?: InputMaybe<TripWhereInput>;
};


export type QueryTripHaltPointExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripHaltPointOrder>>;
  where?: InputMaybe<TripHaltPointWhereInput>;
};


export type QueryTripHaltPointQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripHaltPointOrder>>;
  where?: InputMaybe<TripHaltPointWhereInput>;
};


export type QueryTripHaltPointTargetExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripHaltPointTargetOrder>>;
  where?: InputMaybe<TripHaltPointTargetWhereInput>;
};


export type QueryTripHaltPointTargetQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripHaltPointTargetOrder>>;
  where?: InputMaybe<TripHaltPointTargetWhereInput>;
};


export type QueryTripHaltPointTargetTimeLineExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripHaltPointTargetTimeLineOrder>>;
  where?: InputMaybe<TripHaltPointTargetTimeLineWhereInput>;
};


export type QueryTripHaltPointTargetTimeLineQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripHaltPointTargetTimeLineOrder>>;
  where?: InputMaybe<TripHaltPointTargetTimeLineWhereInput>;
};


export type QueryTripHaltPointTimeLineExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripHaltPointTimeLineOrder>>;
  where?: InputMaybe<TripHaltPointTimeLineWhereInput>;
};


export type QueryTripHaltPointTimeLineQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripHaltPointTimeLineOrder>>;
  where?: InputMaybe<TripHaltPointTimeLineWhereInput>;
};


export type QueryTripQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripOrder>>;
  where?: InputMaybe<TripWhereInput>;
};


export type QueryTripTimeLineExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripTimeLineOrder>>;
  where?: InputMaybe<TripTimeLineWhereInput>;
};


export type QueryTripTimeLineQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TripTimeLineOrder>>;
  where?: InputMaybe<TripTimeLineWhereInput>;
};


export type QueryUpgradeExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UpgradeOrder>>;
  where?: InputMaybe<UpgradeWhereInput>;
};


export type QueryUpgradeOrganisationPriceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UpgradeOrganisationPriceOrder>>;
  where?: InputMaybe<UpgradeOrganisationPriceWhereInput>;
};


export type QueryUpgradeOrganisationPriceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UpgradeOrganisationPriceOrder>>;
  where?: InputMaybe<UpgradeOrganisationPriceWhereInput>;
};


export type QueryUpgradeQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UpgradeOrder>>;
  where?: InputMaybe<UpgradeWhereInput>;
};


export type QueryUserConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserConfigOrder>>;
  where?: InputMaybe<UserConfigWhereInput>;
};


export type QueryUserConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserConfigOrder>>;
  where?: InputMaybe<UserConfigWhereInput>;
};


export type QueryUserExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrder>>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUserLeaveBalanceExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserLeaveBalanceOrder>>;
  where?: InputMaybe<UserLeaveBalanceWhereInput>;
};


export type QueryUserLeaveBalanceQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserLeaveBalanceOrder>>;
  where?: InputMaybe<UserLeaveBalanceWhereInput>;
};


export type QueryUserQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrder>>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUserReportBookmarkExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserReportBookmarkOrder>>;
  where?: InputMaybe<UserReportBookmarkWhereInput>;
};


export type QueryUserReportBookmarkQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserReportBookmarkOrder>>;
  where?: InputMaybe<UserReportBookmarkWhereInput>;
};


export type QueryUserRosterAssignmentExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRosterAssignmentOrder>>;
  where?: InputMaybe<UserRosterAssignmentWhereInput>;
};


export type QueryUserRosterAssignmentQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRosterAssignmentOrder>>;
  where?: InputMaybe<UserRosterAssignmentWhereInput>;
};


export type QueryWalletExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletOrder>>;
  where?: InputMaybe<WalletWhereInput>;
};


export type QueryWalletPaymentTransactionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletPaymentTransactionOrder>>;
  where?: InputMaybe<WalletPaymentTransactionWhereInput>;
};


export type QueryWalletPaymentTransactionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletPaymentTransactionOrder>>;
  where?: InputMaybe<WalletPaymentTransactionWhereInput>;
};


export type QueryWalletQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletOrder>>;
  where?: InputMaybe<WalletWhereInput>;
};


export type QueryWalletTransactionExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletTransactionOrder>>;
  where?: InputMaybe<WalletTransactionWhereInput>;
};


export type QueryWalletTransactionQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WalletTransactionOrder>>;
  where?: InputMaybe<WalletTransactionWhereInput>;
};


export type QueryWhitelabelConfigExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhitelabelConfigOrder>>;
  where?: InputMaybe<WhitelabelConfigWhereInput>;
};


export type QueryWhitelabelConfigQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhitelabelConfigOrder>>;
  where?: InputMaybe<WhitelabelConfigWhereInput>;
};


export type QueryYardTripStatusExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardTripStatusOrder>>;
  where?: InputMaybe<YardTripStatusWhereInput>;
};


export type QueryYardTripStatusQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardTripStatusOrder>>;
  where?: InputMaybe<YardTripStatusWhereInput>;
};


export type QueryYardWarehouseDockExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseDockOrder>>;
  where?: InputMaybe<YardWarehouseDockWhereInput>;
};


export type QueryYardWarehouseDockQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseDockOrder>>;
  where?: InputMaybe<YardWarehouseDockWhereInput>;
};


export type QueryYardWarehouseDockSharingExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseDockSharingOrder>>;
  where?: InputMaybe<YardWarehouseDockSharingWhereInput>;
};


export type QueryYardWarehouseDockSharingQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseDockSharingOrder>>;
  where?: InputMaybe<YardWarehouseDockSharingWhereInput>;
};


export type QueryYardWarehouseRoutePathExportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excelUrl?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseRoutePathOrder>>;
  where?: InputMaybe<YardWarehouseRoutePathWhereInput>;
};


export type QueryYardWarehouseRoutePathQueryArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<YardWarehouseRoutePathOrder>>;
  where?: InputMaybe<YardWarehouseRoutePathWhereInput>;
};


export type QueryAttendanceDetailSummaryArgs = {
  where?: InputMaybe<AttendanceWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type ReportEmailInput = {
  derivedReportIds: Array<Scalars['ID']['input']>;
  emailIds: Array<Scalars['String']['input']>;
  emailSubject: Scalars['String']['input'];
};

export type ReportEventFilter = {
  OnlyVideoEvents?: InputMaybe<Scalars['Boolean']['input']>;
  eventNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReportEventResponse = {
  __typename?: 'ReportEventResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportEventRow>>>;
};

export type ReportEventRow = {
  __typename?: 'ReportEventRow';
  EventID: Scalars['Int']['output'];
  attributes: Scalars['JSON']['output'];
  deviceId: Scalars['ID']['output'];
  eventName: Scalars['String']['output'];
  geofenceName?: Maybe<Scalars['String']['output']>;
  gpsFixTimestamp: Scalars['Time']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  serverTimestamp: Scalars['Time']['output'];
};

export type ReportPositionResponse = {
  __typename?: 'ReportPositionResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportPositionRow>>>;
};

export type ReportPositionRow = {
  __typename?: 'ReportPositionRow';
  deviceId: Scalars['ID']['output'];
  deviceTimestamp: Scalars['Time']['output'];
  distance: Scalars['Float']['output'];
  gpsFixTimestamp: Scalars['Time']['output'];
  ignition: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  motion: Scalars['Boolean']['output'];
  serverTimestamp: Scalars['Time']['output'];
  speed: Scalars['Float']['output'];
  temperature: Scalars['Float']['output'];
};

export type ReportQueryInput = {
  deviceIds: Array<Scalars['ID']['input']>;
  eventTypeFilter?: InputMaybe<Scalars['String']['input']>;
  fetchByDeviceTime: Scalars['Boolean']['input'];
  fromTimestamp: Scalars['Time']['input'];
  positionFilterBySeconds: Scalars['Int']['input'];
  positionFilterSpeedGreaterThan: Scalars['Float']['input'];
  positionFilterSpeedLesserThan: Scalars['Float']['input'];
  positionIgnoreFilterOutline: Scalars['Boolean']['input'];
  splitIntoDailyIntervals: Scalars['Boolean']['input'];
  toTimestamp: Scalars['Time']['input'];
  withAddress: Scalars['Boolean']['input'];
};

export type ReportReportStopIdleResponse = {
  __typename?: 'ReportReportStopIdleResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportReportStopIdleRow>>>;
};

export type ReportReportStopIdleRow = {
  __typename?: 'ReportReportStopIdleRow';
  deviceId: Scalars['ID']['output'];
  endTimestamp: Scalars['Time']['output'];
  engineDuration: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  startTimestamp: Scalars['Time']['output'];
  stopIdleDuration: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type ReportSummaryResponse = {
  __typename?: 'ReportSummaryResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportSummaryRow>>>;
};

export type ReportSummaryRow = {
  __typename?: 'ReportSummaryRow';
  averageSpeed: Scalars['Float']['output'];
  deviceId: Scalars['ID']['output'];
  distance: Scalars['Float']['output'];
  endLatitude: Scalars['Float']['output'];
  endLongitude: Scalars['Float']['output'];
  endTimestamp: Scalars['Time']['output'];
  engineDuration: Scalars['Int']['output'];
  geofenceInCount: Scalars['Int']['output'];
  geofenceOutCount: Scalars['Int']['output'];
  idleDuration: Scalars['Int']['output'];
  ignitionOffCount: Scalars['Int']['output'];
  ignitionOnCount: Scalars['Int']['output'];
  maxSpeed: Scalars['Float']['output'];
  maxSpeedTimestamp: Scalars['Time']['output'];
  startLatitude: Scalars['Float']['output'];
  startLongitude: Scalars['Float']['output'];
  startTimestamp: Scalars['Time']['output'];
};

export type ReportTripResponse = {
  __typename?: 'ReportTripResponse';
  extras: Scalars['JSON']['output'];
  rows?: Maybe<Array<Maybe<ReportTripRow>>>;
};

export type ReportTripRow = {
  __typename?: 'ReportTripRow';
  averageSpeed: Scalars['Float']['output'];
  deviceId: Scalars['ID']['output'];
  distance: Scalars['Float']['output'];
  duration: Scalars['Int']['output'];
  endLatitude: Scalars['Float']['output'];
  endLongitude: Scalars['Float']['output'];
  endTimestamp: Scalars['Time']['output'];
  maxSpeed: Scalars['Float']['output'];
  maxSpeedTimestamp: Scalars['Time']['output'];
  startLatitude: Scalars['Float']['output'];
  startLongitude: Scalars['Float']['output'];
  startTimestamp: Scalars['Time']['output'];
};

export type Roster = Node & {
  __typename?: 'Roster';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  rosterDate: Scalars['Time']['output'];
  rosterShifts?: Maybe<Array<RosterShift>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type RosterConnection = {
  __typename?: 'RosterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RosterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RosterEdge = {
  __typename?: 'RosterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Roster>;
};

export enum RosterField {
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  RosterDate = 'rosterDate',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for Roster connections */
export type RosterOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Rosters. */
  field: RosterOrderField;
};

/** Properties by which Roster connections can be ordered. */
export enum RosterOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type RosterSchedule = Node & {
  __typename?: 'RosterSchedule';
  createdAt: Scalars['Time']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  shift1EndTime: Scalars['Time']['output'];
  shift1StartTime: Scalars['Time']['output'];
  shift2EndTime?: Maybe<Scalars['Time']['output']>;
  shift2StartTime?: Maybe<Scalars['Time']['output']>;
  shift3EndTime?: Maybe<Scalars['Time']['output']>;
  shift3StartTime?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  userRosterAssignments?: Maybe<Array<UserRosterAssignment>>;
  users?: Maybe<Array<User>>;
  weekday: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type RosterScheduleConnection = {
  __typename?: 'RosterScheduleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RosterScheduleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RosterScheduleEdge = {
  __typename?: 'RosterScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RosterSchedule>;
};

export enum RosterScheduleField {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Description = 'description',
  IsActive = 'isActive',
  Name = 'name',
  OrganisationId = 'organisationID',
  Shift1EndTime = 'shift1EndTime',
  Shift1StartTime = 'shift1StartTime',
  Shift2EndTime = 'shift2EndTime',
  Shift2StartTime = 'shift2StartTime',
  Shift3EndTime = 'shift3EndTime',
  Shift3StartTime = 'shift3StartTime',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  Weekday = 'weekday'
}

/** Ordering options for RosterSchedule connections */
export type RosterScheduleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order RosterSchedules. */
  field: RosterScheduleOrderField;
};

/** Properties by which RosterSchedule connections can be ordered. */
export enum RosterScheduleOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * RosterScheduleWhereInput is used for filtering RosterSchedule objects.
 * Input was generated by ent.
 */
export type RosterScheduleWhereInput = {
  and?: InputMaybe<Array<RosterScheduleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by field predicates */
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  createdByGT?: InputMaybe<Scalars['Int']['input']>;
  createdByGTE?: InputMaybe<Scalars['Int']['input']>;
  createdByIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByLT?: InputMaybe<Scalars['Int']['input']>;
  createdByLTE?: InputMaybe<Scalars['Int']['input']>;
  createdByNEQ?: InputMaybe<Scalars['Int']['input']>;
  createdByNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** user_roster_assignments edge predicates */
  hasUserRosterAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserRosterAssignmentsWith?: InputMaybe<Array<UserRosterAssignmentWhereInput>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<RosterScheduleWhereInput>;
  or?: InputMaybe<Array<RosterScheduleWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** shift1_end_time field predicates */
  shift1EndTime?: InputMaybe<Scalars['Time']['input']>;
  shift1EndTimeGT?: InputMaybe<Scalars['Time']['input']>;
  shift1EndTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  shift1EndTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift1EndTimeLT?: InputMaybe<Scalars['Time']['input']>;
  shift1EndTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  shift1EndTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  shift1EndTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** shift1_start_time field predicates */
  shift1StartTime?: InputMaybe<Scalars['Time']['input']>;
  shift1StartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  shift1StartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  shift1StartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift1StartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  shift1StartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  shift1StartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  shift1StartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** shift2_end_time field predicates */
  shift2EndTime?: InputMaybe<Scalars['Time']['input']>;
  shift2EndTimeGT?: InputMaybe<Scalars['Time']['input']>;
  shift2EndTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  shift2EndTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift2EndTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  shift2EndTimeLT?: InputMaybe<Scalars['Time']['input']>;
  shift2EndTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  shift2EndTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  shift2EndTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift2EndTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** shift2_start_time field predicates */
  shift2StartTime?: InputMaybe<Scalars['Time']['input']>;
  shift2StartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  shift2StartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  shift2StartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift2StartTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  shift2StartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  shift2StartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  shift2StartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  shift2StartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift2StartTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** shift3_end_time field predicates */
  shift3EndTime?: InputMaybe<Scalars['Time']['input']>;
  shift3EndTimeGT?: InputMaybe<Scalars['Time']['input']>;
  shift3EndTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  shift3EndTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift3EndTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  shift3EndTimeLT?: InputMaybe<Scalars['Time']['input']>;
  shift3EndTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  shift3EndTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  shift3EndTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift3EndTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** shift3_start_time field predicates */
  shift3StartTime?: InputMaybe<Scalars['Time']['input']>;
  shift3StartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  shift3StartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  shift3StartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift3StartTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  shift3StartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  shift3StartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  shift3StartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  shift3StartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  shift3StartTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_by field predicates */
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  updatedByGT?: InputMaybe<Scalars['Int']['input']>;
  updatedByGTE?: InputMaybe<Scalars['Int']['input']>;
  updatedByIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedByIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  updatedByLT?: InputMaybe<Scalars['Int']['input']>;
  updatedByLTE?: InputMaybe<Scalars['Int']['input']>;
  updatedByNEQ?: InputMaybe<Scalars['Int']['input']>;
  updatedByNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedByNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** weekday field predicates */
  weekday?: InputMaybe<Scalars['Int']['input']>;
  weekdayGT?: InputMaybe<Scalars['Int']['input']>;
  weekdayGTE?: InputMaybe<Scalars['Int']['input']>;
  weekdayIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekdayLT?: InputMaybe<Scalars['Int']['input']>;
  weekdayLTE?: InputMaybe<Scalars['Int']['input']>;
  weekdayNEQ?: InputMaybe<Scalars['Int']['input']>;
  weekdayNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RosterShift = Node & {
  __typename?: 'RosterShift';
  attendanceDetails?: Maybe<Array<AttendanceDetail>>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  roster: Roster;
  rosterID: Scalars['ID']['output'];
  scheduledEndTime?: Maybe<Scalars['Time']['output']>;
  scheduledStartTime?: Maybe<Scalars['Time']['output']>;
  shiftNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type RosterShiftConnection = {
  __typename?: 'RosterShiftConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RosterShiftEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RosterShiftEdge = {
  __typename?: 'RosterShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RosterShift>;
};

export enum RosterShiftField {
  CreatedAt = 'createdAt',
  RosterId = 'rosterID',
  ScheduledEndTime = 'scheduledEndTime',
  ScheduledStartTime = 'scheduledStartTime',
  ShiftNumber = 'shiftNumber',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for RosterShift connections */
export type RosterShiftOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order RosterShifts. */
  field: RosterShiftOrderField;
};

/** Properties by which RosterShift connections can be ordered. */
export enum RosterShiftOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * RosterShiftWhereInput is used for filtering RosterShift objects.
 * Input was generated by ent.
 */
export type RosterShiftWhereInput = {
  and?: InputMaybe<Array<RosterShiftWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** attendance_details edge predicates */
  hasAttendanceDetails?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttendanceDetailsWith?: InputMaybe<Array<AttendanceDetailWhereInput>>;
  /** roster edge predicates */
  hasRoster?: InputMaybe<Scalars['Boolean']['input']>;
  hasRosterWith?: InputMaybe<Array<RosterWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<RosterShiftWhereInput>;
  or?: InputMaybe<Array<RosterShiftWhereInput>>;
  /** roster_id field predicates */
  rosterID?: InputMaybe<Scalars['ID']['input']>;
  rosterIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  rosterIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  rosterIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** scheduled_end_time field predicates */
  scheduledEndTime?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeGT?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  scheduledEndTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledEndTimeLT?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  scheduledEndTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  scheduledEndTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** scheduled_start_time field predicates */
  scheduledStartTime?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  scheduledStartTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledStartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  scheduledStartTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** shift_number field predicates */
  shiftNumber?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberGT?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberGTE?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  shiftNumberLT?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberLTE?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberNEQ?: InputMaybe<Scalars['Int']['input']>;
  shiftNumberNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * RosterWhereInput is used for filtering Roster objects.
 * Input was generated by ent.
 */
export type RosterWhereInput = {
  and?: InputMaybe<Array<RosterWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** roster_shifts edge predicates */
  hasRosterShifts?: InputMaybe<Scalars['Boolean']['input']>;
  hasRosterShiftsWith?: InputMaybe<Array<RosterShiftWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<RosterWhereInput>;
  or?: InputMaybe<Array<RosterWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** roster_date field predicates */
  rosterDate?: InputMaybe<Scalars['Time']['input']>;
  rosterDateGT?: InputMaybe<Scalars['Time']['input']>;
  rosterDateGTE?: InputMaybe<Scalars['Time']['input']>;
  rosterDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  rosterDateLT?: InputMaybe<Scalars['Time']['input']>;
  rosterDateLTE?: InputMaybe<Scalars['Time']['input']>;
  rosterDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  rosterDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Route = Node & {
  __typename?: 'Route';
  createdAt: Scalars['Time']['output'];
  distance?: Maybe<Scalars['Float']['output']>;
  endLocation?: Maybe<Scalars['String']['output']>;
  estimatedTime?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  routeHaltPoints?: Maybe<Array<RouteHaltPoint>>;
  routeShifts?: Maybe<Array<RouteShift>>;
  routeTimeLines?: Maybe<Array<RouteTimeLine>>;
  serviceType: RouteServiceType;
  startLocation?: Maybe<Scalars['String']['output']>;
  statusName?: Maybe<RouteStatusName>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type RouteConnection = {
  __typename?: 'RouteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RouteEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RouteEdge = {
  __typename?: 'RouteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Route>;
};

export enum RouteField {
  CreatedAt = 'createdAt',
  Distance = 'distance',
  EndLocation = 'endLocation',
  EstimatedTime = 'estimatedTime',
  Name = 'name',
  OrganisationId = 'organisationID',
  ServiceType = 'serviceType',
  StartLocation = 'startLocation',
  StatusName = 'statusName',
  UpdatedAt = 'updatedAt'
}

export type RouteHaltPoint = Node & {
  __typename?: 'RouteHaltPoint';
  createdAt: Scalars['Time']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  haltPoint: HaltPoint;
  haltPointID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  route: Route;
  routeHaltPointTargets?: Maybe<Array<RouteHaltPointTarget>>;
  routeID: Scalars['ID']['output'];
  sequence?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  waitTime?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of items. */
export type RouteHaltPointConnection = {
  __typename?: 'RouteHaltPointConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RouteHaltPointEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RouteHaltPointEdge = {
  __typename?: 'RouteHaltPointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RouteHaltPoint>;
};

export enum RouteHaltPointField {
  CreatedAt = 'createdAt',
  EndTime = 'endTime',
  HaltPointId = 'haltPointID',
  Notes = 'notes',
  OrganisationId = 'organisationID',
  RouteId = 'routeID',
  Sequence = 'sequence',
  StartTime = 'startTime',
  UpdatedAt = 'updatedAt',
  WaitTime = 'waitTime'
}

/** Ordering options for RouteHaltPoint connections */
export type RouteHaltPointOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order RouteHaltPoints. */
  field: RouteHaltPointOrderField;
};

/** Properties by which RouteHaltPoint connections can be ordered. */
export enum RouteHaltPointOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Notes = 'notes',
  Sequence = 'sequence',
  UpdatedAt = 'updatedAt'
}

export type RouteHaltPointTarget = Node & {
  __typename?: 'RouteHaltPointTarget';
  createdAt: Scalars['Time']['output'];
  externalTargetID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  plannedQty?: Maybe<Scalars['Int']['output']>;
  plannedUnit?: Maybe<Scalars['String']['output']>;
  routeHaltID: Scalars['ID']['output'];
  routeHaltPoints: RouteHaltPoint;
  taskType: RouteHaltPointTargetTaskType;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type RouteHaltPointTargetConnection = {
  __typename?: 'RouteHaltPointTargetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RouteHaltPointTargetEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RouteHaltPointTargetEdge = {
  __typename?: 'RouteHaltPointTargetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RouteHaltPointTarget>;
};

export enum RouteHaltPointTargetField {
  CreatedAt = 'createdAt',
  ExternalTargetId = 'externalTargetID',
  Notes = 'notes',
  OrganisationId = 'organisationID',
  PlannedQty = 'plannedQty',
  PlannedUnit = 'plannedUnit',
  RouteHaltId = 'routeHaltID',
  TaskType = 'taskType',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for RouteHaltPointTarget connections */
export type RouteHaltPointTargetOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order RouteHaltPointTargets. */
  field: RouteHaltPointTargetOrderField;
};

/** Properties by which RouteHaltPointTarget connections can be ordered. */
export enum RouteHaltPointTargetOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  PlannedQty = 'plannedQty',
  PlannedUnit = 'plannedUnit',
  TaskType = 'taskType',
  UpdatedAt = 'updatedAt'
}

/** RouteHaltPointTargetTaskType is enum for the field task_type */
export enum RouteHaltPointTargetTaskType {
  Drop = 'DROP',
  Exchange = 'EXCHANGE',
  Pickup = 'PICKUP'
}

/**
 * RouteHaltPointTargetWhereInput is used for filtering RouteHaltPointTarget objects.
 * Input was generated by ent.
 */
export type RouteHaltPointTargetWhereInput = {
  and?: InputMaybe<Array<RouteHaltPointTargetWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** external_target_id field predicates */
  externalTargetID?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDGT?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  externalTargetIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalTargetIDLT?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  externalTargetIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route_halt_points edge predicates */
  hasRouteHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteHaltPointsWith?: InputMaybe<Array<RouteHaltPointWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<RouteHaltPointTargetWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<RouteHaltPointTargetWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** planned_qty field predicates */
  plannedQty?: InputMaybe<Scalars['Int']['input']>;
  plannedQtyGT?: InputMaybe<Scalars['Int']['input']>;
  plannedQtyGTE?: InputMaybe<Scalars['Int']['input']>;
  plannedQtyIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  plannedQtyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plannedQtyLT?: InputMaybe<Scalars['Int']['input']>;
  plannedQtyLTE?: InputMaybe<Scalars['Int']['input']>;
  plannedQtyNEQ?: InputMaybe<Scalars['Int']['input']>;
  plannedQtyNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  plannedQtyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** planned_unit field predicates */
  plannedUnit?: InputMaybe<Scalars['String']['input']>;
  plannedUnitContains?: InputMaybe<Scalars['String']['input']>;
  plannedUnitContainsFold?: InputMaybe<Scalars['String']['input']>;
  plannedUnitEqualFold?: InputMaybe<Scalars['String']['input']>;
  plannedUnitGT?: InputMaybe<Scalars['String']['input']>;
  plannedUnitGTE?: InputMaybe<Scalars['String']['input']>;
  plannedUnitHasPrefix?: InputMaybe<Scalars['String']['input']>;
  plannedUnitHasSuffix?: InputMaybe<Scalars['String']['input']>;
  plannedUnitIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedUnitIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plannedUnitLT?: InputMaybe<Scalars['String']['input']>;
  plannedUnitLTE?: InputMaybe<Scalars['String']['input']>;
  plannedUnitNEQ?: InputMaybe<Scalars['String']['input']>;
  plannedUnitNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedUnitNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** route_halt_id field predicates */
  routeHaltID?: InputMaybe<Scalars['ID']['input']>;
  routeHaltIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeHaltIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routeHaltIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** task_type field predicates */
  taskType?: InputMaybe<RouteHaltPointTargetTaskType>;
  taskTypeIn?: InputMaybe<Array<RouteHaltPointTargetTaskType>>;
  taskTypeNEQ?: InputMaybe<RouteHaltPointTargetTaskType>;
  taskTypeNotIn?: InputMaybe<Array<RouteHaltPointTargetTaskType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * RouteHaltPointWhereInput is used for filtering RouteHaltPoint objects.
 * Input was generated by ent.
 */
export type RouteHaltPointWhereInput = {
  and?: InputMaybe<Array<RouteHaltPointWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** end_time field predicates */
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTimeGT?: InputMaybe<Scalars['Time']['input']>;
  endTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  endTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeLT?: InputMaybe<Scalars['Time']['input']>;
  endTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  endTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  endTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** halt_point_id field predicates */
  haltPointID?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  haltPointIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** halt_point edge predicates */
  hasHaltPoint?: InputMaybe<Scalars['Boolean']['input']>;
  hasHaltPointWith?: InputMaybe<Array<HaltPointWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route edge predicates */
  hasRoute?: InputMaybe<Scalars['Boolean']['input']>;
  /** route_halt_point_targets edge predicates */
  hasRouteHaltPointTargets?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteHaltPointTargetsWith?: InputMaybe<Array<RouteHaltPointTargetWhereInput>>;
  hasRouteWith?: InputMaybe<Array<RouteWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<RouteHaltPointWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<RouteHaltPointWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** route_id field predicates */
  routeID?: InputMaybe<Scalars['ID']['input']>;
  routeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** start_time field predicates */
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTimeGT?: InputMaybe<Scalars['Time']['input']>;
  startTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startTimeLT?: InputMaybe<Scalars['Time']['input']>;
  startTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  startTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wait_time field predicates */
  waitTime?: InputMaybe<Scalars['Float']['input']>;
  waitTimeGT?: InputMaybe<Scalars['Float']['input']>;
  waitTimeGTE?: InputMaybe<Scalars['Float']['input']>;
  waitTimeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  waitTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  waitTimeLT?: InputMaybe<Scalars['Float']['input']>;
  waitTimeLTE?: InputMaybe<Scalars['Float']['input']>;
  waitTimeNEQ?: InputMaybe<Scalars['Float']['input']>;
  waitTimeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  waitTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Ordering options for Route connections */
export type RouteOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Routes. */
  field: RouteOrderField;
};

/** Properties by which Route connections can be ordered. */
export enum RouteOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** RouteServiceType is enum for the field service_type */
export enum RouteServiceType {
  Drop = 'DROP',
  Mixed = 'MIXED',
  Pick = 'PICK'
}

export type RouteShift = Node & {
  __typename?: 'RouteShift';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  route: Route;
  routeID: Scalars['ID']['output'];
  shift: Shift;
  shiftID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type RouteShiftConnection = {
  __typename?: 'RouteShiftConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RouteShiftEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RouteShiftEdge = {
  __typename?: 'RouteShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RouteShift>;
};

export enum RouteShiftField {
  CreatedAt = 'createdAt',
  RouteId = 'routeID',
  ShiftId = 'shiftID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for RouteShift connections */
export type RouteShiftOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order RouteShifts. */
  field: RouteShiftOrderField;
};

/** Properties by which RouteShift connections can be ordered. */
export enum RouteShiftOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * RouteShiftWhereInput is used for filtering RouteShift objects.
 * Input was generated by ent.
 */
export type RouteShiftWhereInput = {
  and?: InputMaybe<Array<RouteShiftWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** route edge predicates */
  hasRoute?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteWith?: InputMaybe<Array<RouteWhereInput>>;
  /** shift edge predicates */
  hasShift?: InputMaybe<Scalars['Boolean']['input']>;
  hasShiftWith?: InputMaybe<Array<ShiftWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<RouteShiftWhereInput>;
  or?: InputMaybe<Array<RouteShiftWhereInput>>;
  /** route_id field predicates */
  routeID?: InputMaybe<Scalars['ID']['input']>;
  routeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** shift_id field predicates */
  shiftID?: InputMaybe<Scalars['ID']['input']>;
  shiftIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  shiftIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  shiftIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** RouteStatusName is enum for the field status_name */
export enum RouteStatusName {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type RouteTimeLine = Node & {
  __typename?: 'RouteTimeLine';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  route: Route;
  routeID: Scalars['ID']['output'];
  timestamp: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type RouteTimeLineConnection = {
  __typename?: 'RouteTimeLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RouteTimeLineEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RouteTimeLineEdge = {
  __typename?: 'RouteTimeLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RouteTimeLine>;
};

export enum RouteTimeLineField {
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  Remarks = 'remarks',
  RouteId = 'routeID',
  Timestamp = 'timestamp',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for RouteTimeLine connections */
export type RouteTimeLineOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order RouteTimeLines. */
  field: RouteTimeLineOrderField;
};

/** Properties by which RouteTimeLine connections can be ordered. */
export enum RouteTimeLineOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Timestamp = 'timestamp',
  UpdatedAt = 'updatedAt'
}

/**
 * RouteTimeLineWhereInput is used for filtering RouteTimeLine objects.
 * Input was generated by ent.
 */
export type RouteTimeLineWhereInput = {
  and?: InputMaybe<Array<RouteTimeLineWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route edge predicates */
  hasRoute?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteWith?: InputMaybe<Array<RouteWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<RouteTimeLineWhereInput>;
  or?: InputMaybe<Array<RouteTimeLineWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** remarks field predicates */
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksContains?: InputMaybe<Scalars['String']['input']>;
  remarksContainsFold?: InputMaybe<Scalars['String']['input']>;
  remarksEqualFold?: InputMaybe<Scalars['String']['input']>;
  remarksGT?: InputMaybe<Scalars['String']['input']>;
  remarksGTE?: InputMaybe<Scalars['String']['input']>;
  remarksHasPrefix?: InputMaybe<Scalars['String']['input']>;
  remarksHasSuffix?: InputMaybe<Scalars['String']['input']>;
  remarksIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remarksLT?: InputMaybe<Scalars['String']['input']>;
  remarksLTE?: InputMaybe<Scalars['String']['input']>;
  remarksNEQ?: InputMaybe<Scalars['String']['input']>;
  remarksNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** route_id field predicates */
  routeID?: InputMaybe<Scalars['ID']['input']>;
  routeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** timestamp field predicates */
  timestamp?: InputMaybe<Scalars['Time']['input']>;
  timestampGT?: InputMaybe<Scalars['Time']['input']>;
  timestampGTE?: InputMaybe<Scalars['Time']['input']>;
  timestampIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  timestampLT?: InputMaybe<Scalars['Time']['input']>;
  timestampLTE?: InputMaybe<Scalars['Time']['input']>;
  timestampNEQ?: InputMaybe<Scalars['Time']['input']>;
  timestampNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * RouteWhereInput is used for filtering Route objects.
 * Input was generated by ent.
 */
export type RouteWhereInput = {
  and?: InputMaybe<Array<RouteWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** distance field predicates */
  distance?: InputMaybe<Scalars['Float']['input']>;
  distanceGT?: InputMaybe<Scalars['Float']['input']>;
  distanceGTE?: InputMaybe<Scalars['Float']['input']>;
  distanceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  distanceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  distanceLT?: InputMaybe<Scalars['Float']['input']>;
  distanceLTE?: InputMaybe<Scalars['Float']['input']>;
  distanceNEQ?: InputMaybe<Scalars['Float']['input']>;
  distanceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  distanceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** end_location field predicates */
  endLocation?: InputMaybe<Scalars['String']['input']>;
  endLocationContains?: InputMaybe<Scalars['String']['input']>;
  endLocationContainsFold?: InputMaybe<Scalars['String']['input']>;
  endLocationEqualFold?: InputMaybe<Scalars['String']['input']>;
  endLocationGT?: InputMaybe<Scalars['String']['input']>;
  endLocationGTE?: InputMaybe<Scalars['String']['input']>;
  endLocationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  endLocationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  endLocationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  endLocationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endLocationLT?: InputMaybe<Scalars['String']['input']>;
  endLocationLTE?: InputMaybe<Scalars['String']['input']>;
  endLocationNEQ?: InputMaybe<Scalars['String']['input']>;
  endLocationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  endLocationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** estimated_time field predicates */
  estimatedTime?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeGT?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeGTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  estimatedTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedTimeLT?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeLTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeNEQ?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  estimatedTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route_halt_points edge predicates */
  hasRouteHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteHaltPointsWith?: InputMaybe<Array<RouteHaltPointWhereInput>>;
  /** route_shifts edge predicates */
  hasRouteShifts?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteShiftsWith?: InputMaybe<Array<RouteShiftWhereInput>>;
  /** route_time_lines edge predicates */
  hasRouteTimeLines?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteTimeLinesWith?: InputMaybe<Array<RouteTimeLineWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<RouteWhereInput>;
  or?: InputMaybe<Array<RouteWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** service_type field predicates */
  serviceType?: InputMaybe<RouteServiceType>;
  serviceTypeIn?: InputMaybe<Array<RouteServiceType>>;
  serviceTypeNEQ?: InputMaybe<RouteServiceType>;
  serviceTypeNotIn?: InputMaybe<Array<RouteServiceType>>;
  /** start_location field predicates */
  startLocation?: InputMaybe<Scalars['String']['input']>;
  startLocationContains?: InputMaybe<Scalars['String']['input']>;
  startLocationContainsFold?: InputMaybe<Scalars['String']['input']>;
  startLocationEqualFold?: InputMaybe<Scalars['String']['input']>;
  startLocationGT?: InputMaybe<Scalars['String']['input']>;
  startLocationGTE?: InputMaybe<Scalars['String']['input']>;
  startLocationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  startLocationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  startLocationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startLocationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startLocationLT?: InputMaybe<Scalars['String']['input']>;
  startLocationLTE?: InputMaybe<Scalars['String']['input']>;
  startLocationNEQ?: InputMaybe<Scalars['String']['input']>;
  startLocationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startLocationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status_name field predicates */
  statusName?: InputMaybe<RouteStatusName>;
  statusNameIn?: InputMaybe<Array<RouteStatusName>>;
  statusNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNameNEQ?: InputMaybe<RouteStatusName>;
  statusNameNotIn?: InputMaybe<Array<RouteStatusName>>;
  statusNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type ScheduleTask = Node & {
  __typename?: 'ScheduleTask';
  createdAt: Scalars['Time']['output'];
  eta?: Maybe<Scalars['Time']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impersonatedUserID?: Maybe<Scalars['ID']['output']>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  parameters?: Maybe<Scalars['JSON']['output']>;
  queueName: ScheduleTaskQueueName;
  status: ScheduleTaskStatus;
  taskFailed: Scalars['Boolean']['output'];
  taskName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of items. */
export type ScheduleTaskConnection = {
  __typename?: 'ScheduleTaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ScheduleTaskEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ScheduleTaskEdge = {
  __typename?: 'ScheduleTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ScheduleTask>;
};

export enum ScheduleTaskField {
  CreatedAt = 'createdAt',
  Eta = 'eta',
  FailureReason = 'failureReason',
  ImpersonatedUserId = 'impersonatedUserID',
  OrganisationId = 'organisationID',
  Parameters = 'parameters',
  QueueName = 'queueName',
  Status = 'status',
  TaskFailed = 'taskFailed',
  TaskName = 'taskName',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for ScheduleTask connections */
export type ScheduleTaskOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order ScheduleTasks. */
  field: ScheduleTaskOrderField;
};

/** Properties by which ScheduleTask connections can be ordered. */
export enum ScheduleTaskOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** ScheduleTaskQueueName is enum for the field queue_name */
export enum ScheduleTaskQueueName {
  MainQueue = 'main_queue',
  PassiveQueue = 'passive_queue'
}

/** ScheduleTaskStatus is enum for the field status */
export enum ScheduleTaskStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Success = 'Success'
}

/**
 * ScheduleTaskWhereInput is used for filtering ScheduleTask objects.
 * Input was generated by ent.
 */
export type ScheduleTaskWhereInput = {
  and?: InputMaybe<Array<ScheduleTaskWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** eta field predicates */
  eta?: InputMaybe<Scalars['Time']['input']>;
  etaGT?: InputMaybe<Scalars['Time']['input']>;
  etaGTE?: InputMaybe<Scalars['Time']['input']>;
  etaIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  etaIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  etaLT?: InputMaybe<Scalars['Time']['input']>;
  etaLTE?: InputMaybe<Scalars['Time']['input']>;
  etaNEQ?: InputMaybe<Scalars['Time']['input']>;
  etaNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  etaNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** failure_reason field predicates */
  failureReason?: InputMaybe<Scalars['String']['input']>;
  failureReasonContains?: InputMaybe<Scalars['String']['input']>;
  failureReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  failureReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  failureReasonGT?: InputMaybe<Scalars['String']['input']>;
  failureReasonGTE?: InputMaybe<Scalars['String']['input']>;
  failureReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  failureReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  failureReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  failureReasonLT?: InputMaybe<Scalars['String']['input']>;
  failureReasonLTE?: InputMaybe<Scalars['String']['input']>;
  failureReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  failureReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** impersonated_user_id field predicates */
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  impersonatedUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  impersonatedUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  impersonatedUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<ScheduleTaskWhereInput>;
  or?: InputMaybe<Array<ScheduleTaskWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** parameters field predicates */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  parametersGT?: InputMaybe<Scalars['JSON']['input']>;
  parametersGTE?: InputMaybe<Scalars['JSON']['input']>;
  parametersIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  parametersIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parametersLT?: InputMaybe<Scalars['JSON']['input']>;
  parametersLTE?: InputMaybe<Scalars['JSON']['input']>;
  parametersNEQ?: InputMaybe<Scalars['JSON']['input']>;
  parametersNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  parametersNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** queue_name field predicates */
  queueName?: InputMaybe<ScheduleTaskQueueName>;
  queueNameIn?: InputMaybe<Array<ScheduleTaskQueueName>>;
  queueNameNEQ?: InputMaybe<ScheduleTaskQueueName>;
  queueNameNotIn?: InputMaybe<Array<ScheduleTaskQueueName>>;
  /** status field predicates */
  status?: InputMaybe<ScheduleTaskStatus>;
  statusIn?: InputMaybe<Array<ScheduleTaskStatus>>;
  statusNEQ?: InputMaybe<ScheduleTaskStatus>;
  statusNotIn?: InputMaybe<Array<ScheduleTaskStatus>>;
  /** task_failed field predicates */
  taskFailed?: InputMaybe<Scalars['Boolean']['input']>;
  taskFailedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** task_name field predicates */
  taskName?: InputMaybe<Scalars['String']['input']>;
  taskNameContains?: InputMaybe<Scalars['String']['input']>;
  taskNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  taskNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  taskNameGT?: InputMaybe<Scalars['String']['input']>;
  taskNameGTE?: InputMaybe<Scalars['String']['input']>;
  taskNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  taskNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  taskNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  taskNameLT?: InputMaybe<Scalars['String']['input']>;
  taskNameLTE?: InputMaybe<Scalars['String']['input']>;
  taskNameNEQ?: InputMaybe<Scalars['String']['input']>;
  taskNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ServiceType {
  Drop = 'Drop',
  Pick = 'Pick'
}

export type Setting = Node & {
  __typename?: 'Setting';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type SettingConnection = {
  __typename?: 'SettingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SettingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SettingEdge = {
  __typename?: 'SettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Setting>;
};

export enum SettingField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

/** Ordering options for Setting connections */
export type SettingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Settings. */
  field: SettingOrderField;
};

/** Properties by which Setting connections can be ordered. */
export enum SettingOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * SettingWhereInput is used for filtering Setting objects.
 * Input was generated by ent.
 */
export type SettingWhereInput = {
  and?: InputMaybe<Array<SettingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<Scalars['String']['input']>;
  keyContains?: InputMaybe<Scalars['String']['input']>;
  keyContainsFold?: InputMaybe<Scalars['String']['input']>;
  keyEqualFold?: InputMaybe<Scalars['String']['input']>;
  keyGT?: InputMaybe<Scalars['String']['input']>;
  keyGTE?: InputMaybe<Scalars['String']['input']>;
  keyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  keyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  keyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keyLT?: InputMaybe<Scalars['String']['input']>;
  keyLTE?: InputMaybe<Scalars['String']['input']>;
  keyNEQ?: InputMaybe<Scalars['String']['input']>;
  keyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SettingWhereInput>;
  or?: InputMaybe<Array<SettingWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Shift = Node & {
  __typename?: 'Shift';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<OrganisationUser>;
  driverID?: Maybe<Scalars['ID']['output']>;
  /** End time of shift */
  endTime?: Maybe<Scalars['Time']['output']>;
  /** Exception dates - ISO 8601 date strings to exclude from recurrence (EXDATE) */
  exdates?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isTemplate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  /** Additional dates - ISO 8601 date strings to include in recurrence (RDATE) */
  rdates?: Maybe<Array<Scalars['String']['output']>>;
  /** End date/time for the recurring pattern (UNTIL), null for infinite */
  recurrenceEnd?: Maybe<Scalars['Time']['output']>;
  /** Start date/time for the recurring pattern (DTSTART) */
  recurrenceStart?: Maybe<Scalars['Time']['output']>;
  routeShifts?: Maybe<Array<RouteShift>>;
  /** iCalendar RRULE string (e.g., 'FREQ=WEEKLY;BYDAY=MO,WE,FR;INTERVAL=1') */
  rrule?: Maybe<Scalars['String']['output']>;
  /** Start time of shift */
  startTime?: Maybe<Scalars['Time']['output']>;
  /** Timezone for recurrence calculations (e.g., 'America/New_York') */
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  vehicle?: Maybe<DeviceGroup>;
  vehicleID?: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of items. */
export type ShiftConnection = {
  __typename?: 'ShiftConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShiftEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ShiftEdge = {
  __typename?: 'ShiftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Shift>;
};

export enum ShiftField {
  CreatedAt = 'createdAt',
  Description = 'description',
  DriverId = 'driverID',
  EndTime = 'endTime',
  Exdates = 'exdates',
  IsActive = 'isActive',
  IsTemplate = 'isTemplate',
  Name = 'name',
  OrganisationId = 'organisationID',
  Rdates = 'rdates',
  RecurrenceEnd = 'recurrenceEnd',
  RecurrenceStart = 'recurrenceStart',
  Rrule = 'rrule',
  StartTime = 'startTime',
  Timezone = 'timezone',
  UpdatedAt = 'updatedAt',
  VehicleId = 'vehicleID'
}

/** Ordering options for Shift connections */
export type ShiftOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Shifts. */
  field: ShiftOrderField;
};

/** Properties by which Shift connections can be ordered. */
export enum ShiftOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * ShiftWhereInput is used for filtering Shift objects.
 * Input was generated by ent.
 */
export type ShiftWhereInput = {
  and?: InputMaybe<Array<ShiftWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver_id field predicates */
  driverID?: InputMaybe<Scalars['ID']['input']>;
  driverIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  driverIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  driverIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** end_time field predicates */
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTimeGT?: InputMaybe<Scalars['Time']['input']>;
  endTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  endTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeLT?: InputMaybe<Scalars['Time']['input']>;
  endTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  endTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  endTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver edge predicates */
  hasDriver?: InputMaybe<Scalars['Boolean']['input']>;
  hasDriverWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route_shifts edge predicates */
  hasRouteShifts?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteShiftsWith?: InputMaybe<Array<RouteShiftWhereInput>>;
  /** vehicle edge predicates */
  hasVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  hasVehicleWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_template field predicates */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplateNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ShiftWhereInput>;
  or?: InputMaybe<Array<ShiftWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** recurrence_end field predicates */
  recurrenceEnd?: InputMaybe<Scalars['Time']['input']>;
  recurrenceEndGT?: InputMaybe<Scalars['Time']['input']>;
  recurrenceEndGTE?: InputMaybe<Scalars['Time']['input']>;
  recurrenceEndIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  recurrenceEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recurrenceEndLT?: InputMaybe<Scalars['Time']['input']>;
  recurrenceEndLTE?: InputMaybe<Scalars['Time']['input']>;
  recurrenceEndNEQ?: InputMaybe<Scalars['Time']['input']>;
  recurrenceEndNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  recurrenceEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** recurrence_start field predicates */
  recurrenceStart?: InputMaybe<Scalars['Time']['input']>;
  recurrenceStartGT?: InputMaybe<Scalars['Time']['input']>;
  recurrenceStartGTE?: InputMaybe<Scalars['Time']['input']>;
  recurrenceStartIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  recurrenceStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  recurrenceStartLT?: InputMaybe<Scalars['Time']['input']>;
  recurrenceStartLTE?: InputMaybe<Scalars['Time']['input']>;
  recurrenceStartNEQ?: InputMaybe<Scalars['Time']['input']>;
  recurrenceStartNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  recurrenceStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** rrule field predicates */
  rrule?: InputMaybe<Scalars['String']['input']>;
  rruleContains?: InputMaybe<Scalars['String']['input']>;
  rruleContainsFold?: InputMaybe<Scalars['String']['input']>;
  rruleEqualFold?: InputMaybe<Scalars['String']['input']>;
  rruleGT?: InputMaybe<Scalars['String']['input']>;
  rruleGTE?: InputMaybe<Scalars['String']['input']>;
  rruleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  rruleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  rruleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rruleIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  rruleLT?: InputMaybe<Scalars['String']['input']>;
  rruleLTE?: InputMaybe<Scalars['String']['input']>;
  rruleNEQ?: InputMaybe<Scalars['String']['input']>;
  rruleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rruleNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** start_time field predicates */
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTimeGT?: InputMaybe<Scalars['Time']['input']>;
  startTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startTimeLT?: InputMaybe<Scalars['Time']['input']>;
  startTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  startTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** timezone field predicates */
  timezone?: InputMaybe<Scalars['String']['input']>;
  timezoneContains?: InputMaybe<Scalars['String']['input']>;
  timezoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  timezoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  timezoneGT?: InputMaybe<Scalars['String']['input']>;
  timezoneGTE?: InputMaybe<Scalars['String']['input']>;
  timezoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  timezoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  timezoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  timezoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  timezoneLT?: InputMaybe<Scalars['String']['input']>;
  timezoneLTE?: InputMaybe<Scalars['String']['input']>;
  timezoneNEQ?: InputMaybe<Scalars['String']['input']>;
  timezoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  timezoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_id field predicates */
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
  vehicleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vehicleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Sim = Node & {
  __typename?: 'Sim';
  activationDate?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  devices?: Maybe<Device>;
  id: Scalars['ID']['output'];
  imsi: Scalars['String']['output'];
  organisation?: Maybe<Organisation>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  purchaseDate?: Maybe<Scalars['Time']['output']>;
  simNumber: Scalars['String']['output'];
  simOperator: SimSimOperator;
  status: SimStatus;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type SimConnection = {
  __typename?: 'SimConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SimEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SimEdge = {
  __typename?: 'SimEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Sim>;
};

export enum SimField {
  ActivationDate = 'activationDate',
  CreatedAt = 'createdAt',
  Imsi = 'imsi',
  OrganisationId = 'organisationID',
  PurchaseDate = 'purchaseDate',
  SimNumber = 'simNumber',
  SimOperator = 'simOperator',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Sim connections */
export type SimOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Sims. */
  field: SimOrderField;
};

/** Properties by which Sim connections can be ordered. */
export enum SimOrderField {
  ActivationDate = 'ACTIVATION_DATE',
  Imsi = 'IMSI',
  PurchaseDate = 'PURCHASE_DATE',
  SimNumber = 'SIM_NUMBER',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** SimSimOperator is enum for the field sim_operator */
export enum SimSimOperator {
  Airtel = 'Airtel',
  Bsnl = 'BSNL',
  Jio = 'Jio',
  Other = 'Other',
  Vodafone = 'Vodafone'
}

/** SimStatus is enum for the field status */
export enum SimStatus {
  Active = 'Active',
  Available = 'Available',
  Deactivated = 'Deactivated',
  Disposed = 'Disposed'
}

/**
 * SimWhereInput is used for filtering Sim objects.
 * Input was generated by ent.
 */
export type SimWhereInput = {
  /** activation_date field predicates */
  activationDate?: InputMaybe<Scalars['Time']['input']>;
  activationDateGT?: InputMaybe<Scalars['Time']['input']>;
  activationDateGTE?: InputMaybe<Scalars['Time']['input']>;
  activationDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activationDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activationDateLT?: InputMaybe<Scalars['Time']['input']>;
  activationDateLTE?: InputMaybe<Scalars['Time']['input']>;
  activationDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  activationDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activationDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<SimWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** devices edge predicates */
  hasDevices?: InputMaybe<Scalars['Boolean']['input']>;
  hasDevicesWith?: InputMaybe<Array<DeviceWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** imsi field predicates */
  imsi?: InputMaybe<Scalars['String']['input']>;
  imsiContains?: InputMaybe<Scalars['String']['input']>;
  imsiContainsFold?: InputMaybe<Scalars['String']['input']>;
  imsiEqualFold?: InputMaybe<Scalars['String']['input']>;
  imsiGT?: InputMaybe<Scalars['String']['input']>;
  imsiGTE?: InputMaybe<Scalars['String']['input']>;
  imsiHasPrefix?: InputMaybe<Scalars['String']['input']>;
  imsiHasSuffix?: InputMaybe<Scalars['String']['input']>;
  imsiIn?: InputMaybe<Array<Scalars['String']['input']>>;
  imsiLT?: InputMaybe<Scalars['String']['input']>;
  imsiLTE?: InputMaybe<Scalars['String']['input']>;
  imsiNEQ?: InputMaybe<Scalars['String']['input']>;
  imsiNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<SimWhereInput>;
  or?: InputMaybe<Array<SimWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** purchase_date field predicates */
  purchaseDate?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateGT?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateGTE?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  purchaseDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseDateLT?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateLTE?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  purchaseDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  purchaseDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sim_number field predicates */
  simNumber?: InputMaybe<Scalars['String']['input']>;
  simNumberContains?: InputMaybe<Scalars['String']['input']>;
  simNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  simNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  simNumberGT?: InputMaybe<Scalars['String']['input']>;
  simNumberGTE?: InputMaybe<Scalars['String']['input']>;
  simNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  simNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  simNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  simNumberLT?: InputMaybe<Scalars['String']['input']>;
  simNumberLTE?: InputMaybe<Scalars['String']['input']>;
  simNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  simNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** sim_operator field predicates */
  simOperator?: InputMaybe<SimSimOperator>;
  simOperatorIn?: InputMaybe<Array<SimSimOperator>>;
  simOperatorNEQ?: InputMaybe<SimSimOperator>;
  simOperatorNotIn?: InputMaybe<Array<SimSimOperator>>;
  /** status field predicates */
  status?: InputMaybe<SimStatus>;
  statusIn?: InputMaybe<Array<SimStatus>>;
  statusNEQ?: InputMaybe<SimStatus>;
  statusNotIn?: InputMaybe<Array<SimStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type StaffRole = Node & {
  __typename?: 'StaffRole';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['Time']['output'];
  users?: Maybe<Array<User>>;
};

/** A connection to a list of items. */
export type StaffRoleConnection = {
  __typename?: 'StaffRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StaffRoleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StaffRoleEdge = {
  __typename?: 'StaffRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<StaffRole>;
};

export enum StaffRoleField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  Name = 'name',
  Permissions = 'permissions',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for StaffRole connections */
export type StaffRoleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order StaffRoles. */
  field: StaffRoleOrderField;
};

/** Properties by which StaffRole connections can be ordered. */
export enum StaffRoleOrderField {
  Name = 'NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * StaffRoleWhereInput is used for filtering StaffRole objects.
 * Input was generated by ent.
 */
export type StaffRoleWhereInput = {
  and?: InputMaybe<Array<StaffRoleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** users edge predicates */
  hasUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasUsersWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<StaffRoleWhereInput>;
  or?: InputMaybe<Array<StaffRoleWhereInput>>;
  /** permissions field predicates */
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  permissionsGT?: InputMaybe<Scalars['JSON']['input']>;
  permissionsGTE?: InputMaybe<Scalars['JSON']['input']>;
  permissionsIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  permissionsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  permissionsLT?: InputMaybe<Scalars['JSON']['input']>;
  permissionsLTE?: InputMaybe<Scalars['JSON']['input']>;
  permissionsNEQ?: InputMaybe<Scalars['JSON']['input']>;
  permissionsNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  permissionsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type StatusGroup = {
  __typename?: 'StatusGroup';
  AttendanceDetails: Array<AttendanceDetail>;
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type StiQr = Node & {
  __typename?: 'StiQR';
  activatedOn?: Maybe<Scalars['Time']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  deviceCategory?: Maybe<DeviceCategory>;
  deviceCategoryID?: Maybe<Scalars['ID']['output']>;
  deviceGroup?: Maybe<DeviceGroup>;
  deviceGroupID?: Maybe<Scalars['ID']['output']>;
  emergencyContactNumbers?: Maybe<Scalars['JSON']['output']>;
  enableMasked: Scalars['Boolean']['output'];
  enableSms: Scalars['Boolean']['output'];
  enableVoip: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  organisationUser?: Maybe<OrganisationUser>;
  organisationUserID?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type StiQrConnection = {
  __typename?: 'StiQRConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StiQrEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StiQrEdge = {
  __typename?: 'StiQREdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<StiQr>;
};

export enum StiQrField {
  ActivatedOn = 'activatedOn',
  ContactNumber = 'contactNumber',
  CreatedAt = 'createdAt',
  DeviceCategoryId = 'deviceCategoryID',
  DeviceGroupId = 'deviceGroupID',
  EmergencyContactNumbers = 'emergencyContactNumbers',
  EnableMasked = 'enableMasked',
  EnableSms = 'enableSms',
  EnableVoip = 'enableVoip',
  IsActive = 'isActive',
  Name = 'name',
  OrganisationId = 'organisationID',
  OrganisationUserId = 'organisationUserID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for StiQR connections */
export type StiQrOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order StiQRs. */
  field: StiQrOrderField;
};

/** Properties by which StiQR connections can be ordered. */
export enum StiQrOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * StiQRWhereInput is used for filtering StiQR objects.
 * Input was generated by ent.
 */
export type StiQrWhereInput = {
  /** activated_on field predicates */
  activatedOn?: InputMaybe<Scalars['Time']['input']>;
  activatedOnGT?: InputMaybe<Scalars['Time']['input']>;
  activatedOnGTE?: InputMaybe<Scalars['Time']['input']>;
  activatedOnIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activatedOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activatedOnLT?: InputMaybe<Scalars['Time']['input']>;
  activatedOnLTE?: InputMaybe<Scalars['Time']['input']>;
  activatedOnNEQ?: InputMaybe<Scalars['Time']['input']>;
  activatedOnNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activatedOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<StiQrWhereInput>>;
  /** contact_number field predicates */
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  contactNumberContains?: InputMaybe<Scalars['String']['input']>;
  contactNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  contactNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  contactNumberGT?: InputMaybe<Scalars['String']['input']>;
  contactNumberGTE?: InputMaybe<Scalars['String']['input']>;
  contactNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  contactNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  contactNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contactNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  contactNumberLT?: InputMaybe<Scalars['String']['input']>;
  contactNumberLTE?: InputMaybe<Scalars['String']['input']>;
  contactNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  contactNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  contactNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_category_id field predicates */
  deviceCategoryID?: InputMaybe<Scalars['ID']['input']>;
  deviceCategoryIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceCategoryIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deviceCategoryIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceCategoryIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceCategoryIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_group_id field predicates */
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deviceGroupIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  deviceGroupIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** emergency_contact_numbers field predicates */
  emergencyContactNumbers?: InputMaybe<Scalars['JSON']['input']>;
  emergencyContactNumbersGT?: InputMaybe<Scalars['JSON']['input']>;
  emergencyContactNumbersGTE?: InputMaybe<Scalars['JSON']['input']>;
  emergencyContactNumbersIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  emergencyContactNumbersIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyContactNumbersLT?: InputMaybe<Scalars['JSON']['input']>;
  emergencyContactNumbersLTE?: InputMaybe<Scalars['JSON']['input']>;
  emergencyContactNumbersNEQ?: InputMaybe<Scalars['JSON']['input']>;
  emergencyContactNumbersNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  emergencyContactNumbersNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_masked field predicates */
  enableMasked?: InputMaybe<Scalars['Boolean']['input']>;
  enableMaskedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_sms field predicates */
  enableSms?: InputMaybe<Scalars['Boolean']['input']>;
  enableSmsNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable_voip field predicates */
  enableVoip?: InputMaybe<Scalars['Boolean']['input']>;
  enableVoipNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** device_category edge predicates */
  hasDeviceCategory?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceCategoryWith?: InputMaybe<Array<DeviceCategoryWhereInput>>;
  /** device_group edge predicates */
  hasDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceGroupWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_user edge predicates */
  hasOrganisationUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationUserWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<StiQrWhereInput>;
  or?: InputMaybe<Array<StiQrWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** organisation_user_id field predicates */
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  organisationUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SubscriptionLicenseOrder = Node & {
  __typename?: 'SubscriptionLicenseOrder';
  baseLicensePlanID: Scalars['ID']['output'];
  baselicenseplan: BaseLicensePlan;
  createdAt: Scalars['Time']['output'];
  gracePeriodDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  licenseorderaddons?: Maybe<Array<LicenseOrderAddon>>;
  licenses?: Maybe<Array<License>>;
  notes?: Maybe<Scalars['String']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  perUnitPrice: Scalars['Float']['output'];
  status: SubscriptionLicenseOrderStatus;
  tenure: Scalars['Int']['output'];
  tenureUnit: SubscriptionLicenseOrderTenureUnit;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type SubscriptionLicenseOrderConnection = {
  __typename?: 'SubscriptionLicenseOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubscriptionLicenseOrderEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubscriptionLicenseOrderEdge = {
  __typename?: 'SubscriptionLicenseOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SubscriptionLicenseOrder>;
};

export enum SubscriptionLicenseOrderField {
  BaseLicensePlanId = 'baseLicensePlanID',
  CreatedAt = 'createdAt',
  GracePeriodDays = 'gracePeriodDays',
  Notes = 'notes',
  OrganisationId = 'organisationID',
  PerUnitPrice = 'perUnitPrice',
  Status = 'status',
  Tenure = 'tenure',
  TenureUnit = 'tenureUnit',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for SubscriptionLicenseOrder connections */
export type SubscriptionLicenseOrderOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SubscriptionLicenseOrders. */
  field: SubscriptionLicenseOrderOrderField;
};

/** Properties by which SubscriptionLicenseOrder connections can be ordered. */
export enum SubscriptionLicenseOrderOrderField {
  Notes = 'NOTES',
  PerUnitPrice = 'PER_UNIT_PRICE',
  Status = 'STATUS',
  Tenure = 'TENURE',
  TenureUnit = 'TENURE_UNIT',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** SubscriptionLicenseOrderStatus is enum for the field status */
export enum SubscriptionLicenseOrderStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Pending = 'Pending'
}

/** SubscriptionLicenseOrderTenureUnit is enum for the field tenure_unit */
export enum SubscriptionLicenseOrderTenureUnit {
  Month = 'Month',
  Year = 'Year'
}

/**
 * SubscriptionLicenseOrderWhereInput is used for filtering SubscriptionLicenseOrder objects.
 * Input was generated by ent.
 */
export type SubscriptionLicenseOrderWhereInput = {
  and?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** base_license_plan_id field predicates */
  baseLicensePlanID?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseLicensePlanIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  baseLicensePlanIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** grace_period_days field predicates */
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysGT?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysGTE?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  gracePeriodDaysLT?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysLTE?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysNEQ?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodDaysNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** baselicenseplan edge predicates */
  hasBaselicenseplan?: InputMaybe<Scalars['Boolean']['input']>;
  hasBaselicenseplanWith?: InputMaybe<Array<BaseLicensePlanWhereInput>>;
  /** licenseorderaddons edge predicates */
  hasLicenseorderaddons?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicenseorderaddonsWith?: InputMaybe<Array<LicenseOrderAddonWhereInput>>;
  /** licenses edge predicates */
  hasLicenses?: InputMaybe<Scalars['Boolean']['input']>;
  hasLicensesWith?: InputMaybe<Array<LicenseWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<SubscriptionLicenseOrderWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<SubscriptionLicenseOrderWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** per_unit_price field predicates */
  perUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceGT?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceGTE?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  perUnitPriceLT?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceLTE?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceNEQ?: InputMaybe<Scalars['Float']['input']>;
  perUnitPriceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** status field predicates */
  status?: InputMaybe<SubscriptionLicenseOrderStatus>;
  statusIn?: InputMaybe<Array<SubscriptionLicenseOrderStatus>>;
  statusNEQ?: InputMaybe<SubscriptionLicenseOrderStatus>;
  statusNotIn?: InputMaybe<Array<SubscriptionLicenseOrderStatus>>;
  /** tenure field predicates */
  tenure?: InputMaybe<Scalars['Int']['input']>;
  tenureGT?: InputMaybe<Scalars['Int']['input']>;
  tenureGTE?: InputMaybe<Scalars['Int']['input']>;
  tenureIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  tenureLT?: InputMaybe<Scalars['Int']['input']>;
  tenureLTE?: InputMaybe<Scalars['Int']['input']>;
  tenureNEQ?: InputMaybe<Scalars['Int']['input']>;
  tenureNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** tenure_unit field predicates */
  tenureUnit?: InputMaybe<SubscriptionLicenseOrderTenureUnit>;
  tenureUnitIn?: InputMaybe<Array<SubscriptionLicenseOrderTenureUnit>>;
  tenureUnitNEQ?: InputMaybe<SubscriptionLicenseOrderTenureUnit>;
  tenureUnitNotIn?: InputMaybe<Array<SubscriptionLicenseOrderTenureUnit>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SupportDocument = Node & {
  __typename?: 'SupportDocument';
  createdAt: Scalars['Time']['output'];
  data: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nchunk: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type SupportDocumentConnection = {
  __typename?: 'SupportDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupportDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupportDocumentEdge = {
  __typename?: 'SupportDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupportDocument>;
};

export enum SupportDocumentField {
  CreatedAt = 'createdAt',
  Data = 'data',
  Embedding = 'embedding',
  Filename = 'filename',
  Metadata = 'metadata',
  Nchunk = 'nchunk',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for SupportDocument connections */
export type SupportDocumentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SupportDocuments. */
  field: SupportDocumentOrderField;
};

/** Properties by which SupportDocument connections can be ordered. */
export enum SupportDocumentOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * SupportDocumentWhereInput is used for filtering SupportDocument objects.
 * Input was generated by ent.
 */
export type SupportDocumentWhereInput = {
  and?: InputMaybe<Array<SupportDocumentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** data field predicates */
  data?: InputMaybe<Scalars['String']['input']>;
  dataContains?: InputMaybe<Scalars['String']['input']>;
  dataContainsFold?: InputMaybe<Scalars['String']['input']>;
  dataEqualFold?: InputMaybe<Scalars['String']['input']>;
  dataGT?: InputMaybe<Scalars['String']['input']>;
  dataGTE?: InputMaybe<Scalars['String']['input']>;
  dataHasPrefix?: InputMaybe<Scalars['String']['input']>;
  dataHasSuffix?: InputMaybe<Scalars['String']['input']>;
  dataIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dataLT?: InputMaybe<Scalars['String']['input']>;
  dataLTE?: InputMaybe<Scalars['String']['input']>;
  dataNEQ?: InputMaybe<Scalars['String']['input']>;
  dataNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filename field predicates */
  filename?: InputMaybe<Scalars['String']['input']>;
  filenameContains?: InputMaybe<Scalars['String']['input']>;
  filenameContainsFold?: InputMaybe<Scalars['String']['input']>;
  filenameEqualFold?: InputMaybe<Scalars['String']['input']>;
  filenameGT?: InputMaybe<Scalars['String']['input']>;
  filenameGTE?: InputMaybe<Scalars['String']['input']>;
  filenameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  filenameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  filenameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filenameLT?: InputMaybe<Scalars['String']['input']>;
  filenameLTE?: InputMaybe<Scalars['String']['input']>;
  filenameNEQ?: InputMaybe<Scalars['String']['input']>;
  filenameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** metadata field predicates */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  metadataGT?: InputMaybe<Scalars['JSON']['input']>;
  metadataGTE?: InputMaybe<Scalars['JSON']['input']>;
  metadataIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  metadataIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  metadataLT?: InputMaybe<Scalars['JSON']['input']>;
  metadataLTE?: InputMaybe<Scalars['JSON']['input']>;
  metadataNEQ?: InputMaybe<Scalars['JSON']['input']>;
  metadataNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  metadataNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** nchunk field predicates */
  nchunk?: InputMaybe<Scalars['Int']['input']>;
  nchunkGT?: InputMaybe<Scalars['Int']['input']>;
  nchunkGTE?: InputMaybe<Scalars['Int']['input']>;
  nchunkIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  nchunkLT?: InputMaybe<Scalars['Int']['input']>;
  nchunkLTE?: InputMaybe<Scalars['Int']['input']>;
  nchunkNEQ?: InputMaybe<Scalars['Int']['input']>;
  nchunkNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  not?: InputMaybe<SupportDocumentWhereInput>;
  or?: InputMaybe<Array<SupportDocumentWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type SupportTicket = Node & {
  __typename?: 'SupportTicket';
  attachmentUrls?: Maybe<Scalars['JSON']['output']>;
  category: SupportTicketCategory;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  impersonatedUserID?: Maybe<Scalars['ID']['output']>;
  organisationID?: Maybe<Scalars['ID']['output']>;
  status: SupportTicketStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['ID']['output']>;
};

/** SupportTicketCategory is enum for the field category */
export enum SupportTicketCategory {
  BugReport = 'BugReport',
  FeatureRequest = 'FeatureRequest',
  Feedback = 'Feedback'
}

/** A connection to a list of items. */
export type SupportTicketConnection = {
  __typename?: 'SupportTicketConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupportTicketEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupportTicketEdge = {
  __typename?: 'SupportTicketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupportTicket>;
};

export enum SupportTicketField {
  AttachmentUrls = 'attachmentUrls',
  Category = 'category',
  CreatedAt = 'createdAt',
  Description = 'description',
  ImpersonatedUserId = 'impersonatedUserID',
  OrganisationId = 'organisationID',
  Status = 'status',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for SupportTicket connections */
export type SupportTicketOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order SupportTickets. */
  field: SupportTicketOrderField;
};

/** Properties by which SupportTicket connections can be ordered. */
export enum SupportTicketOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** SupportTicketStatus is enum for the field status */
export enum SupportTicketStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Processing = 'Processing'
}

/**
 * SupportTicketWhereInput is used for filtering SupportTicket objects.
 * Input was generated by ent.
 */
export type SupportTicketWhereInput = {
  and?: InputMaybe<Array<SupportTicketWhereInput>>;
  /** attachment_urls field predicates */
  attachmentUrls?: InputMaybe<Scalars['JSON']['input']>;
  attachmentUrlsGT?: InputMaybe<Scalars['JSON']['input']>;
  attachmentUrlsGTE?: InputMaybe<Scalars['JSON']['input']>;
  attachmentUrlsIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  attachmentUrlsIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentUrlsLT?: InputMaybe<Scalars['JSON']['input']>;
  attachmentUrlsLTE?: InputMaybe<Scalars['JSON']['input']>;
  attachmentUrlsNEQ?: InputMaybe<Scalars['JSON']['input']>;
  attachmentUrlsNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  attachmentUrlsNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** category field predicates */
  category?: InputMaybe<SupportTicketCategory>;
  categoryIn?: InputMaybe<Array<SupportTicketCategory>>;
  categoryNEQ?: InputMaybe<SupportTicketCategory>;
  categoryNotIn?: InputMaybe<Array<SupportTicketCategory>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** impersonated_user_id field predicates */
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  impersonatedUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  impersonatedUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  impersonatedUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  impersonatedUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<SupportTicketWhereInput>;
  or?: InputMaybe<Array<SupportTicketWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDGTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIDLT?: InputMaybe<Scalars['ID']['input']>;
  organisationIDLTE?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<SupportTicketStatus>;
  statusIn?: InputMaybe<Array<SupportTicketStatus>>;
  statusNEQ?: InputMaybe<SupportTicketStatus>;
  statusNotIn?: InputMaybe<Array<SupportTicketStatus>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Target = Node & {
  __typename?: 'Target';
  address?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Scalars['Map']['output']>;
  createdAt: Scalars['Time']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  haltPoints?: Maybe<Array<HaltPoint>>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  load?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  targetType: TargetTargetType;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type TargetConnection = {
  __typename?: 'TargetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TargetEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TargetEdge = {
  __typename?: 'TargetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Target>;
};

export enum TargetField {
  Address = 'address',
  Attributes = 'attributes',
  CreatedAt = 'createdAt',
  ExternalId = 'externalID',
  Frequency = 'frequency',
  IsEnabled = 'isEnabled',
  Lat = 'lat',
  Lng = 'lng',
  Load = 'load',
  Name = 'name',
  OrganisationId = 'organisationID',
  Owner = 'owner',
  Phone = 'phone',
  TargetType = 'targetType',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Target connections */
export type TargetOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Targets. */
  field: TargetOrderField;
};

/** Properties by which Target connections can be ordered. */
export enum TargetOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** TargetTargetType is enum for the field target_type */
export enum TargetTargetType {
  Bin = 'BIN',
  Employee = 'EMPLOYEE',
  Order = 'ORDER',
  Student = 'STUDENT'
}

/**
 * TargetWhereInput is used for filtering Target objects.
 * Input was generated by ent.
 */
export type TargetWhereInput = {
  /** address field predicates */
  address?: InputMaybe<Scalars['String']['input']>;
  addressContains?: InputMaybe<Scalars['String']['input']>;
  addressContainsFold?: InputMaybe<Scalars['String']['input']>;
  addressEqualFold?: InputMaybe<Scalars['String']['input']>;
  addressGT?: InputMaybe<Scalars['String']['input']>;
  addressGTE?: InputMaybe<Scalars['String']['input']>;
  addressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  addressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  addressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addressLT?: InputMaybe<Scalars['String']['input']>;
  addressLTE?: InputMaybe<Scalars['String']['input']>;
  addressNEQ?: InputMaybe<Scalars['String']['input']>;
  addressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<TargetWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** frequency field predicates */
  frequency?: InputMaybe<Scalars['Int']['input']>;
  frequencyGT?: InputMaybe<Scalars['Int']['input']>;
  frequencyGTE?: InputMaybe<Scalars['Int']['input']>;
  frequencyIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  frequencyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  frequencyLT?: InputMaybe<Scalars['Int']['input']>;
  frequencyLTE?: InputMaybe<Scalars['Int']['input']>;
  frequencyNEQ?: InputMaybe<Scalars['Int']['input']>;
  frequencyNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  frequencyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** halt_points edge predicates */
  hasHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasHaltPointsWith?: InputMaybe<Array<HaltPointWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_enabled field predicates */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabledNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** lat field predicates */
  lat?: InputMaybe<Scalars['Float']['input']>;
  latGT?: InputMaybe<Scalars['Float']['input']>;
  latGTE?: InputMaybe<Scalars['Float']['input']>;
  latIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  latLT?: InputMaybe<Scalars['Float']['input']>;
  latLTE?: InputMaybe<Scalars['Float']['input']>;
  latNEQ?: InputMaybe<Scalars['Float']['input']>;
  latNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** lng field predicates */
  lng?: InputMaybe<Scalars['Float']['input']>;
  lngGT?: InputMaybe<Scalars['Float']['input']>;
  lngGTE?: InputMaybe<Scalars['Float']['input']>;
  lngIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  lngLT?: InputMaybe<Scalars['Float']['input']>;
  lngLTE?: InputMaybe<Scalars['Float']['input']>;
  lngNEQ?: InputMaybe<Scalars['Float']['input']>;
  lngNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** load field predicates */
  load?: InputMaybe<Scalars['Float']['input']>;
  loadGT?: InputMaybe<Scalars['Float']['input']>;
  loadGTE?: InputMaybe<Scalars['Float']['input']>;
  loadIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  loadIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  loadLT?: InputMaybe<Scalars['Float']['input']>;
  loadLTE?: InputMaybe<Scalars['Float']['input']>;
  loadNEQ?: InputMaybe<Scalars['Float']['input']>;
  loadNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  loadNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<TargetWhereInput>;
  or?: InputMaybe<Array<TargetWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** owner field predicates */
  owner?: InputMaybe<Scalars['String']['input']>;
  ownerContains?: InputMaybe<Scalars['String']['input']>;
  ownerContainsFold?: InputMaybe<Scalars['String']['input']>;
  ownerEqualFold?: InputMaybe<Scalars['String']['input']>;
  ownerGT?: InputMaybe<Scalars['String']['input']>;
  ownerGTE?: InputMaybe<Scalars['String']['input']>;
  ownerHasPrefix?: InputMaybe<Scalars['String']['input']>;
  ownerHasSuffix?: InputMaybe<Scalars['String']['input']>;
  ownerIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerLT?: InputMaybe<Scalars['String']['input']>;
  ownerLTE?: InputMaybe<Scalars['String']['input']>;
  ownerNEQ?: InputMaybe<Scalars['String']['input']>;
  ownerNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** phone field predicates */
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneContains?: InputMaybe<Scalars['String']['input']>;
  phoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneGT?: InputMaybe<Scalars['String']['input']>;
  phoneGTE?: InputMaybe<Scalars['String']['input']>;
  phoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  phoneLT?: InputMaybe<Scalars['String']['input']>;
  phoneLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_type field predicates */
  targetType?: InputMaybe<TargetTargetType>;
  targetTypeIn?: InputMaybe<Array<TargetTargetType>>;
  targetTypeNEQ?: InputMaybe<TargetTargetType>;
  targetTypeNotIn?: InputMaybe<Array<TargetTargetType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type TaskState = {
  __typename?: 'TaskState';
  created_at?: Maybe<Scalars['Time']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['JSON']['output']>;
  state: Scalars['String']['output'];
  task_id: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
};

export type Trip = Node & {
  __typename?: 'Trip';
  acceptedAt?: Maybe<Scalars['Time']['output']>;
  assignedAt?: Maybe<Scalars['Time']['output']>;
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  completedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  createdByUserID?: Maybe<Scalars['ID']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  driver?: Maybe<User>;
  driverID?: Maybe<Scalars['ID']['output']>;
  driverLicenseNo?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhone?: Maybe<Scalars['String']['output']>;
  endLocation?: Maybe<Scalars['String']['output']>;
  estimatedTime?: Maybe<Scalars['Float']['output']>;
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  plannedEndTime?: Maybe<Scalars['Time']['output']>;
  plannedStartTime?: Maybe<Scalars['Time']['output']>;
  routeID: Scalars['ID']['output'];
  serviceDate?: Maybe<Scalars['Time']['output']>;
  startLocation?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Time']['output']>;
  statusName?: Maybe<TripStatusName>;
  tripHaltPoints?: Maybe<Array<TripHaltPoint>>;
  tripTimelines?: Maybe<Array<TripTimeLine>>;
  updatedAt: Scalars['Time']['output'];
  vehicle?: Maybe<DeviceGroup>;
  vehicleID?: Maybe<Scalars['ID']['output']>;
};

export type TripConfigs = Node & {
  __typename?: 'TripConfigs';
  createdAt: Scalars['Time']['output'];
  deviceCategory?: Maybe<Scalars['String']['output']>;
  dropGeofenceRadius?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  pickUpGeofenceRadius?: Maybe<Scalars['Float']['output']>;
  targetAttributesConfig?: Maybe<Scalars['Map']['output']>;
  targetTypes: TripConfigsTargetTypes;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type TripConfigsConnection = {
  __typename?: 'TripConfigsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TripConfigsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TripConfigsEdge = {
  __typename?: 'TripConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TripConfigs>;
};

export enum TripConfigsField {
  CreatedAt = 'createdAt',
  DeviceCategory = 'deviceCategory',
  DropGeofenceRadius = 'dropGeofenceRadius',
  OrganisationId = 'organisationID',
  PickUpGeofenceRadius = 'pickUpGeofenceRadius',
  TargetAttributesConfig = 'targetAttributesConfig',
  TargetTypes = 'targetTypes',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for TripConfigs connections */
export type TripConfigsOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TripConfigsSlice. */
  field: TripConfigsOrderField;
};

/** Properties by which TripConfigs connections can be ordered. */
export enum TripConfigsOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** TripConfigsTargetTypes is enum for the field target_types */
export enum TripConfigsTargetTypes {
  Bin = 'BIN',
  Employee = 'EMPLOYEE',
  Order = 'ORDER',
  Student = 'STUDENT'
}

/**
 * TripConfigsWhereInput is used for filtering TripConfigs objects.
 * Input was generated by ent.
 */
export type TripConfigsWhereInput = {
  and?: InputMaybe<Array<TripConfigsWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_category field predicates */
  deviceCategory?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryContains?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryContainsFold?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryEqualFold?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryGT?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryGTE?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceCategoryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  deviceCategoryLT?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryLTE?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryNEQ?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceCategoryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** drop_geofence_radius field predicates */
  dropGeofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  dropGeofenceRadiusGT?: InputMaybe<Scalars['Float']['input']>;
  dropGeofenceRadiusGTE?: InputMaybe<Scalars['Float']['input']>;
  dropGeofenceRadiusIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  dropGeofenceRadiusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dropGeofenceRadiusLT?: InputMaybe<Scalars['Float']['input']>;
  dropGeofenceRadiusLTE?: InputMaybe<Scalars['Float']['input']>;
  dropGeofenceRadiusNEQ?: InputMaybe<Scalars['Float']['input']>;
  dropGeofenceRadiusNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  dropGeofenceRadiusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TripConfigsWhereInput>;
  or?: InputMaybe<Array<TripConfigsWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** pick_up_geofence_radius field predicates */
  pickUpGeofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  pickUpGeofenceRadiusGT?: InputMaybe<Scalars['Float']['input']>;
  pickUpGeofenceRadiusGTE?: InputMaybe<Scalars['Float']['input']>;
  pickUpGeofenceRadiusIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  pickUpGeofenceRadiusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pickUpGeofenceRadiusLT?: InputMaybe<Scalars['Float']['input']>;
  pickUpGeofenceRadiusLTE?: InputMaybe<Scalars['Float']['input']>;
  pickUpGeofenceRadiusNEQ?: InputMaybe<Scalars['Float']['input']>;
  pickUpGeofenceRadiusNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  pickUpGeofenceRadiusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_types field predicates */
  targetTypes?: InputMaybe<TripConfigsTargetTypes>;
  targetTypesIn?: InputMaybe<Array<TripConfigsTargetTypes>>;
  targetTypesNEQ?: InputMaybe<TripConfigsTargetTypes>;
  targetTypesNotIn?: InputMaybe<Array<TripConfigsTargetTypes>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** A connection to a list of items. */
export type TripConnection = {
  __typename?: 'TripConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TripEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TripEdge = {
  __typename?: 'TripEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Trip>;
};

export enum TripField {
  AcceptedAt = 'acceptedAt',
  AssignedAt = 'assignedAt',
  CancelledAt = 'cancelledAt',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserID',
  Distance = 'distance',
  DriverId = 'driverID',
  DriverLicenseNo = 'driverLicenseNo',
  DriverName = 'driverName',
  DriverPhone = 'driverPhone',
  EndLocation = 'endLocation',
  EstimatedTime = 'estimatedTime',
  ExternalId = 'externalID',
  Name = 'name',
  OrganisationId = 'organisationID',
  PlannedEndTime = 'plannedEndTime',
  PlannedStartTime = 'plannedStartTime',
  RouteId = 'routeID',
  ServiceDate = 'serviceDate',
  StartLocation = 'startLocation',
  StartedAt = 'startedAt',
  StatusName = 'statusName',
  UpdatedAt = 'updatedAt',
  VehicleId = 'vehicleID'
}

export type TripHaltPoint = Node & {
  __typename?: 'TripHaltPoint';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  haltName?: Maybe<Scalars['String']['output']>;
  haltPointID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  plannedTime?: Maybe<Scalars['String']['output']>;
  sequence: Scalars['Int']['output'];
  statusName?: Maybe<TripHaltPointStatusName>;
  trip: Trip;
  tripHaltPointTarget?: Maybe<Array<TripHaltPointTarget>>;
  tripHaltPointTimelines?: Maybe<Array<TripHaltPointTimeLine>>;
  tripID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  windowEnd?: Maybe<Scalars['Time']['output']>;
  windowStart?: Maybe<Scalars['Time']['output']>;
};

/** A connection to a list of items. */
export type TripHaltPointConnection = {
  __typename?: 'TripHaltPointConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TripHaltPointEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TripHaltPointEdge = {
  __typename?: 'TripHaltPointEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TripHaltPoint>;
};

export enum TripHaltPointField {
  Address = 'address',
  CreatedAt = 'createdAt',
  HaltName = 'haltName',
  HaltPointId = 'haltPointID',
  Lat = 'lat',
  Lng = 'lng',
  OrganisationId = 'organisationID',
  PlannedTime = 'plannedTime',
  Sequence = 'sequence',
  StatusName = 'statusName',
  TripId = 'tripID',
  UpdatedAt = 'updatedAt',
  WindowEnd = 'windowEnd',
  WindowStart = 'windowStart'
}

/** Ordering options for TripHaltPoint connections */
export type TripHaltPointOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TripHaltPoints. */
  field: TripHaltPointOrderField;
};

/** Properties by which TripHaltPoint connections can be ordered. */
export enum TripHaltPointOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Sequence = 'sequence',
  UpdatedAt = 'updatedAt'
}

/** TripHaltPointStatusName is enum for the field status_name */
export enum TripHaltPointStatusName {
  Arrived = 'ARRIVED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  PartialCompleted = 'PARTIAL_COMPLETED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type TripHaltPointTarget = Node & {
  __typename?: 'TripHaltPointTarget';
  attributes?: Maybe<Scalars['Map']['output']>;
  createdAt: Scalars['Time']['output'];
  externalID: Scalars['String']['output'];
  externalTargetID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  noShowReason?: Maybe<Scalars['String']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  proofOfDrop?: Maybe<Scalars['String']['output']>;
  proofOfDropTimestamp?: Maybe<Scalars['Time']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  routeHaltTargetID: Scalars['ID']['output'];
  statusName?: Maybe<TripHaltPointTargetStatusName>;
  targetID: Scalars['ID']['output'];
  targetName: Scalars['String']['output'];
  targetPhone: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
  taskType: TripHaltPointTargetTaskType;
  tripHalt: TripHaltPoint;
  tripHaltID: Scalars['ID']['output'];
  tripHaltPointTargetTimelines?: Maybe<Array<TripHaltPointTargetTimeLine>>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type TripHaltPointTargetConnection = {
  __typename?: 'TripHaltPointTargetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TripHaltPointTargetEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TripHaltPointTargetEdge = {
  __typename?: 'TripHaltPointTargetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TripHaltPointTarget>;
};

export enum TripHaltPointTargetField {
  Attributes = 'attributes',
  CreatedAt = 'createdAt',
  ExternalId = 'externalID',
  ExternalTargetId = 'externalTargetID',
  NoShowReason = 'noShowReason',
  OrganisationId = 'organisationID',
  ProofOfDrop = 'proofOfDrop',
  ProofOfDropTimestamp = 'proofOfDropTimestamp',
  Remarks = 'remarks',
  RouteHaltTargetId = 'routeHaltTargetID',
  StatusName = 'statusName',
  TargetId = 'targetID',
  TargetName = 'targetName',
  TargetPhone = 'targetPhone',
  TargetType = 'targetType',
  TaskType = 'taskType',
  TripHaltId = 'tripHaltID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for TripHaltPointTarget connections */
export type TripHaltPointTargetOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TripHaltPointTargets. */
  field: TripHaltPointTargetOrderField;
};

/** Properties by which TripHaltPointTarget connections can be ordered. */
export enum TripHaltPointTargetOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  TaskType = 'taskType',
  UpdatedAt = 'updatedAt'
}

/** TripHaltPointTargetStatusName is enum for the field status_name */
export enum TripHaltPointTargetStatusName {
  Dropped = 'DROPPED',
  NoShow = 'NO_SHOW',
  Pending = 'PENDING',
  PickedUp = 'PICKED_UP'
}

/** TripHaltPointTargetTaskType is enum for the field task_type */
export enum TripHaltPointTargetTaskType {
  Drop = 'DROP',
  Exchange = 'EXCHANGE',
  Pickup = 'PICKUP'
}

export type TripHaltPointTargetTimeLine = Node & {
  __typename?: 'TripHaltPointTargetTimeLine';
  actualQty?: Maybe<Scalars['Int']['output']>;
  actualUnit?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  eventTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  photoURL?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  statusName?: Maybe<TripHaltPointTargetTimeLineStatusName>;
  tripHaltTarget: TripHaltPointTarget;
  tripHaltTargetID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  userEmail: Scalars['String']['output'];
  userID?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
  userPhone: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type TripHaltPointTargetTimeLineConnection = {
  __typename?: 'TripHaltPointTargetTimeLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TripHaltPointTargetTimeLineEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TripHaltPointTargetTimeLineEdge = {
  __typename?: 'TripHaltPointTargetTimeLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TripHaltPointTargetTimeLine>;
};

export enum TripHaltPointTargetTimeLineField {
  ActualQty = 'actualQty',
  ActualUnit = 'actualUnit',
  CreatedAt = 'createdAt',
  EventTime = 'eventTime',
  OrganisationId = 'organisationID',
  PhotoUrl = 'photoURL',
  Remarks = 'remarks',
  StatusName = 'statusName',
  TripHaltTargetId = 'tripHaltTargetID',
  UpdatedAt = 'updatedAt',
  UserEmail = 'userEmail',
  UserId = 'userID',
  UserName = 'userName',
  UserPhone = 'userPhone'
}

/** Ordering options for TripHaltPointTargetTimeLine connections */
export type TripHaltPointTargetTimeLineOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TripHaltPointTargetTimeLines. */
  field: TripHaltPointTargetTimeLineOrderField;
};

/** Properties by which TripHaltPointTargetTimeLine connections can be ordered. */
export enum TripHaltPointTargetTimeLineOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** TripHaltPointTargetTimeLineStatusName is enum for the field status_name */
export enum TripHaltPointTargetTimeLineStatusName {
  Failed = 'FAILED',
  NoShow = 'NO_SHOW',
  Partial = 'PARTIAL',
  Serviced = 'SERVICED',
  Skipped = 'SKIPPED'
}

/**
 * TripHaltPointTargetTimeLineWhereInput is used for filtering TripHaltPointTargetTimeLine objects.
 * Input was generated by ent.
 */
export type TripHaltPointTargetTimeLineWhereInput = {
  /** actual_qty field predicates */
  actualQty?: InputMaybe<Scalars['Int']['input']>;
  actualQtyGT?: InputMaybe<Scalars['Int']['input']>;
  actualQtyGTE?: InputMaybe<Scalars['Int']['input']>;
  actualQtyIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  actualQtyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  actualQtyLT?: InputMaybe<Scalars['Int']['input']>;
  actualQtyLTE?: InputMaybe<Scalars['Int']['input']>;
  actualQtyNEQ?: InputMaybe<Scalars['Int']['input']>;
  actualQtyNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  actualQtyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** actual_unit field predicates */
  actualUnit?: InputMaybe<Scalars['String']['input']>;
  actualUnitContains?: InputMaybe<Scalars['String']['input']>;
  actualUnitContainsFold?: InputMaybe<Scalars['String']['input']>;
  actualUnitEqualFold?: InputMaybe<Scalars['String']['input']>;
  actualUnitGT?: InputMaybe<Scalars['String']['input']>;
  actualUnitGTE?: InputMaybe<Scalars['String']['input']>;
  actualUnitHasPrefix?: InputMaybe<Scalars['String']['input']>;
  actualUnitHasSuffix?: InputMaybe<Scalars['String']['input']>;
  actualUnitIn?: InputMaybe<Array<Scalars['String']['input']>>;
  actualUnitIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  actualUnitLT?: InputMaybe<Scalars['String']['input']>;
  actualUnitLTE?: InputMaybe<Scalars['String']['input']>;
  actualUnitNEQ?: InputMaybe<Scalars['String']['input']>;
  actualUnitNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  actualUnitNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<TripHaltPointTargetTimeLineWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** event_time field predicates */
  eventTime?: InputMaybe<Scalars['Time']['input']>;
  eventTimeGT?: InputMaybe<Scalars['Time']['input']>;
  eventTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  eventTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  eventTimeLT?: InputMaybe<Scalars['Time']['input']>;
  eventTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  eventTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  eventTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** trip_halt_target edge predicates */
  hasTripHaltTarget?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltTargetWith?: InputMaybe<Array<TripHaltPointTargetWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TripHaltPointTargetTimeLineWhereInput>;
  or?: InputMaybe<Array<TripHaltPointTargetTimeLineWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** photo_url field predicates */
  photoURL?: InputMaybe<Scalars['String']['input']>;
  photoURLContains?: InputMaybe<Scalars['String']['input']>;
  photoURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  photoURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  photoURLGT?: InputMaybe<Scalars['String']['input']>;
  photoURLGTE?: InputMaybe<Scalars['String']['input']>;
  photoURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  photoURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  photoURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  photoURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  photoURLLT?: InputMaybe<Scalars['String']['input']>;
  photoURLLTE?: InputMaybe<Scalars['String']['input']>;
  photoURLNEQ?: InputMaybe<Scalars['String']['input']>;
  photoURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  photoURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** remarks field predicates */
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksContains?: InputMaybe<Scalars['String']['input']>;
  remarksContainsFold?: InputMaybe<Scalars['String']['input']>;
  remarksEqualFold?: InputMaybe<Scalars['String']['input']>;
  remarksGT?: InputMaybe<Scalars['String']['input']>;
  remarksGTE?: InputMaybe<Scalars['String']['input']>;
  remarksHasPrefix?: InputMaybe<Scalars['String']['input']>;
  remarksHasSuffix?: InputMaybe<Scalars['String']['input']>;
  remarksIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remarksLT?: InputMaybe<Scalars['String']['input']>;
  remarksLTE?: InputMaybe<Scalars['String']['input']>;
  remarksNEQ?: InputMaybe<Scalars['String']['input']>;
  remarksNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status_name field predicates */
  statusName?: InputMaybe<TripHaltPointTargetTimeLineStatusName>;
  statusNameIn?: InputMaybe<Array<TripHaltPointTargetTimeLineStatusName>>;
  statusNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNameNEQ?: InputMaybe<TripHaltPointTargetTimeLineStatusName>;
  statusNameNotIn?: InputMaybe<Array<TripHaltPointTargetTimeLineStatusName>>;
  statusNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trip_halt_target_id field predicates */
  tripHaltTargetID?: InputMaybe<Scalars['ID']['input']>;
  tripHaltTargetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripHaltTargetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripHaltTargetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_email field predicates */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userEmailContains?: InputMaybe<Scalars['String']['input']>;
  userEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  userEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  userEmailGT?: InputMaybe<Scalars['String']['input']>;
  userEmailGTE?: InputMaybe<Scalars['String']['input']>;
  userEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userEmailLT?: InputMaybe<Scalars['String']['input']>;
  userEmailLTE?: InputMaybe<Scalars['String']['input']>;
  userEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  userEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['String']['input']>;
  userIDContains?: InputMaybe<Scalars['String']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  userIDGT?: InputMaybe<Scalars['String']['input']>;
  userIDGTE?: InputMaybe<Scalars['String']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['String']['input']>;
  userIDLTE?: InputMaybe<Scalars['String']['input']>;
  userIDNEQ?: InputMaybe<Scalars['String']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_name field predicates */
  userName?: InputMaybe<Scalars['String']['input']>;
  userNameContains?: InputMaybe<Scalars['String']['input']>;
  userNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  userNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  userNameGT?: InputMaybe<Scalars['String']['input']>;
  userNameGTE?: InputMaybe<Scalars['String']['input']>;
  userNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userNameLT?: InputMaybe<Scalars['String']['input']>;
  userNameLTE?: InputMaybe<Scalars['String']['input']>;
  userNameNEQ?: InputMaybe<Scalars['String']['input']>;
  userNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user_phone field predicates */
  userPhone?: InputMaybe<Scalars['String']['input']>;
  userPhoneContains?: InputMaybe<Scalars['String']['input']>;
  userPhoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  userPhoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  userPhoneGT?: InputMaybe<Scalars['String']['input']>;
  userPhoneGTE?: InputMaybe<Scalars['String']['input']>;
  userPhoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userPhoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userPhoneLT?: InputMaybe<Scalars['String']['input']>;
  userPhoneLTE?: InputMaybe<Scalars['String']['input']>;
  userPhoneNEQ?: InputMaybe<Scalars['String']['input']>;
  userPhoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * TripHaltPointTargetWhereInput is used for filtering TripHaltPointTarget objects.
 * Input was generated by ent.
 */
export type TripHaltPointTargetWhereInput = {
  and?: InputMaybe<Array<TripHaltPointTargetWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** external_target_id field predicates */
  externalTargetID?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDGT?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  externalTargetIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalTargetIDLT?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  externalTargetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  externalTargetIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** trip_halt edge predicates */
  hasTripHalt?: InputMaybe<Scalars['Boolean']['input']>;
  /** trip_halt_point_target_timelines edge predicates */
  hasTripHaltPointTargetTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltPointTargetTimelinesWith?: InputMaybe<Array<TripHaltPointTargetTimeLineWhereInput>>;
  hasTripHaltWith?: InputMaybe<Array<TripHaltPointWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** no_show_reason field predicates */
  noShowReason?: InputMaybe<Scalars['String']['input']>;
  noShowReasonContains?: InputMaybe<Scalars['String']['input']>;
  noShowReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  noShowReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  noShowReasonGT?: InputMaybe<Scalars['String']['input']>;
  noShowReasonGTE?: InputMaybe<Scalars['String']['input']>;
  noShowReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  noShowReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  noShowReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  noShowReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  noShowReasonLT?: InputMaybe<Scalars['String']['input']>;
  noShowReasonLTE?: InputMaybe<Scalars['String']['input']>;
  noShowReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  noShowReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  noShowReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<TripHaltPointTargetWhereInput>;
  or?: InputMaybe<Array<TripHaltPointTargetWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** proof_of_drop field predicates */
  proofOfDrop?: InputMaybe<Scalars['String']['input']>;
  proofOfDropContains?: InputMaybe<Scalars['String']['input']>;
  proofOfDropContainsFold?: InputMaybe<Scalars['String']['input']>;
  proofOfDropEqualFold?: InputMaybe<Scalars['String']['input']>;
  proofOfDropGT?: InputMaybe<Scalars['String']['input']>;
  proofOfDropGTE?: InputMaybe<Scalars['String']['input']>;
  proofOfDropHasPrefix?: InputMaybe<Scalars['String']['input']>;
  proofOfDropHasSuffix?: InputMaybe<Scalars['String']['input']>;
  proofOfDropIn?: InputMaybe<Array<Scalars['String']['input']>>;
  proofOfDropIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfDropLT?: InputMaybe<Scalars['String']['input']>;
  proofOfDropLTE?: InputMaybe<Scalars['String']['input']>;
  proofOfDropNEQ?: InputMaybe<Scalars['String']['input']>;
  proofOfDropNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  proofOfDropNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** proof_of_drop_timestamp field predicates */
  proofOfDropTimestamp?: InputMaybe<Scalars['Time']['input']>;
  proofOfDropTimestampGT?: InputMaybe<Scalars['Time']['input']>;
  proofOfDropTimestampGTE?: InputMaybe<Scalars['Time']['input']>;
  proofOfDropTimestampIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  proofOfDropTimestampIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfDropTimestampLT?: InputMaybe<Scalars['Time']['input']>;
  proofOfDropTimestampLTE?: InputMaybe<Scalars['Time']['input']>;
  proofOfDropTimestampNEQ?: InputMaybe<Scalars['Time']['input']>;
  proofOfDropTimestampNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  proofOfDropTimestampNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** remarks field predicates */
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksContains?: InputMaybe<Scalars['String']['input']>;
  remarksContainsFold?: InputMaybe<Scalars['String']['input']>;
  remarksEqualFold?: InputMaybe<Scalars['String']['input']>;
  remarksGT?: InputMaybe<Scalars['String']['input']>;
  remarksGTE?: InputMaybe<Scalars['String']['input']>;
  remarksHasPrefix?: InputMaybe<Scalars['String']['input']>;
  remarksHasSuffix?: InputMaybe<Scalars['String']['input']>;
  remarksIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remarksLT?: InputMaybe<Scalars['String']['input']>;
  remarksLTE?: InputMaybe<Scalars['String']['input']>;
  remarksNEQ?: InputMaybe<Scalars['String']['input']>;
  remarksNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** route_halt_target_id field predicates */
  routeHaltTargetID?: InputMaybe<Scalars['ID']['input']>;
  routeHaltTargetIDGT?: InputMaybe<Scalars['ID']['input']>;
  routeHaltTargetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  routeHaltTargetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeHaltTargetIDLT?: InputMaybe<Scalars['ID']['input']>;
  routeHaltTargetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  routeHaltTargetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routeHaltTargetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status_name field predicates */
  statusName?: InputMaybe<TripHaltPointTargetStatusName>;
  statusNameIn?: InputMaybe<Array<TripHaltPointTargetStatusName>>;
  statusNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNameNEQ?: InputMaybe<TripHaltPointTargetStatusName>;
  statusNameNotIn?: InputMaybe<Array<TripHaltPointTargetStatusName>>;
  statusNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_id field predicates */
  targetID?: InputMaybe<Scalars['ID']['input']>;
  targetIDGT?: InputMaybe<Scalars['ID']['input']>;
  targetIDGTE?: InputMaybe<Scalars['ID']['input']>;
  targetIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetIDLT?: InputMaybe<Scalars['ID']['input']>;
  targetIDLTE?: InputMaybe<Scalars['ID']['input']>;
  targetIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  targetIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** target_name field predicates */
  targetName?: InputMaybe<Scalars['String']['input']>;
  targetNameContains?: InputMaybe<Scalars['String']['input']>;
  targetNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  targetNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  targetNameGT?: InputMaybe<Scalars['String']['input']>;
  targetNameGTE?: InputMaybe<Scalars['String']['input']>;
  targetNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  targetNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  targetNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  targetNameLT?: InputMaybe<Scalars['String']['input']>;
  targetNameLTE?: InputMaybe<Scalars['String']['input']>;
  targetNameNEQ?: InputMaybe<Scalars['String']['input']>;
  targetNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** target_phone field predicates */
  targetPhone?: InputMaybe<Scalars['String']['input']>;
  targetPhoneContains?: InputMaybe<Scalars['String']['input']>;
  targetPhoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  targetPhoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  targetPhoneGT?: InputMaybe<Scalars['String']['input']>;
  targetPhoneGTE?: InputMaybe<Scalars['String']['input']>;
  targetPhoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  targetPhoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  targetPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  targetPhoneLT?: InputMaybe<Scalars['String']['input']>;
  targetPhoneLTE?: InputMaybe<Scalars['String']['input']>;
  targetPhoneNEQ?: InputMaybe<Scalars['String']['input']>;
  targetPhoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** target_type field predicates */
  targetType?: InputMaybe<Scalars['String']['input']>;
  targetTypeContains?: InputMaybe<Scalars['String']['input']>;
  targetTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  targetTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  targetTypeGT?: InputMaybe<Scalars['String']['input']>;
  targetTypeGTE?: InputMaybe<Scalars['String']['input']>;
  targetTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  targetTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  targetTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  targetTypeLT?: InputMaybe<Scalars['String']['input']>;
  targetTypeLTE?: InputMaybe<Scalars['String']['input']>;
  targetTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  targetTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** task_type field predicates */
  taskType?: InputMaybe<TripHaltPointTargetTaskType>;
  taskTypeIn?: InputMaybe<Array<TripHaltPointTargetTaskType>>;
  taskTypeNEQ?: InputMaybe<TripHaltPointTargetTaskType>;
  taskTypeNotIn?: InputMaybe<Array<TripHaltPointTargetTaskType>>;
  /** trip_halt_id field predicates */
  tripHaltID?: InputMaybe<Scalars['ID']['input']>;
  tripHaltIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripHaltIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripHaltIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type TripHaltPointTimeLine = Node & {
  __typename?: 'TripHaltPointTimeLine';
  arrivalTime?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  departureTime?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  statusName?: Maybe<TripHaltPointTimeLineStatusName>;
  tripHalt: TripHaltPoint;
  tripHaltID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  userEmail: Scalars['String']['output'];
  userID?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
  userPhone: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type TripHaltPointTimeLineConnection = {
  __typename?: 'TripHaltPointTimeLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TripHaltPointTimeLineEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TripHaltPointTimeLineEdge = {
  __typename?: 'TripHaltPointTimeLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TripHaltPointTimeLine>;
};

export enum TripHaltPointTimeLineField {
  ArrivalTime = 'arrivalTime',
  CreatedAt = 'createdAt',
  DepartureTime = 'departureTime',
  OrganisationId = 'organisationID',
  Remarks = 'remarks',
  StatusName = 'statusName',
  TripHaltId = 'tripHaltID',
  UpdatedAt = 'updatedAt',
  UserEmail = 'userEmail',
  UserId = 'userID',
  UserName = 'userName',
  UserPhone = 'userPhone'
}

/** Ordering options for TripHaltPointTimeLine connections */
export type TripHaltPointTimeLineOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TripHaltPointTimeLines. */
  field: TripHaltPointTimeLineOrderField;
};

/** Properties by which TripHaltPointTimeLine connections can be ordered. */
export enum TripHaltPointTimeLineOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** TripHaltPointTimeLineStatusName is enum for the field status_name */
export enum TripHaltPointTimeLineStatusName {
  Arrived = 'ARRIVED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Partial = 'PARTIAL',
  Skipped = 'SKIPPED'
}

/**
 * TripHaltPointTimeLineWhereInput is used for filtering TripHaltPointTimeLine objects.
 * Input was generated by ent.
 */
export type TripHaltPointTimeLineWhereInput = {
  and?: InputMaybe<Array<TripHaltPointTimeLineWhereInput>>;
  /** arrival_time field predicates */
  arrivalTime?: InputMaybe<Scalars['Time']['input']>;
  arrivalTimeGT?: InputMaybe<Scalars['Time']['input']>;
  arrivalTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  arrivalTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  arrivalTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalTimeLT?: InputMaybe<Scalars['Time']['input']>;
  arrivalTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  arrivalTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  arrivalTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  arrivalTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** departure_time field predicates */
  departureTime?: InputMaybe<Scalars['Time']['input']>;
  departureTimeGT?: InputMaybe<Scalars['Time']['input']>;
  departureTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  departureTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  departureTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  departureTimeLT?: InputMaybe<Scalars['Time']['input']>;
  departureTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  departureTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  departureTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  departureTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** trip_halt edge predicates */
  hasTripHalt?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltWith?: InputMaybe<Array<TripHaltPointWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TripHaltPointTimeLineWhereInput>;
  or?: InputMaybe<Array<TripHaltPointTimeLineWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** remarks field predicates */
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksContains?: InputMaybe<Scalars['String']['input']>;
  remarksContainsFold?: InputMaybe<Scalars['String']['input']>;
  remarksEqualFold?: InputMaybe<Scalars['String']['input']>;
  remarksGT?: InputMaybe<Scalars['String']['input']>;
  remarksGTE?: InputMaybe<Scalars['String']['input']>;
  remarksHasPrefix?: InputMaybe<Scalars['String']['input']>;
  remarksHasSuffix?: InputMaybe<Scalars['String']['input']>;
  remarksIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remarksLT?: InputMaybe<Scalars['String']['input']>;
  remarksLTE?: InputMaybe<Scalars['String']['input']>;
  remarksNEQ?: InputMaybe<Scalars['String']['input']>;
  remarksNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status_name field predicates */
  statusName?: InputMaybe<TripHaltPointTimeLineStatusName>;
  statusNameIn?: InputMaybe<Array<TripHaltPointTimeLineStatusName>>;
  statusNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNameNEQ?: InputMaybe<TripHaltPointTimeLineStatusName>;
  statusNameNotIn?: InputMaybe<Array<TripHaltPointTimeLineStatusName>>;
  statusNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trip_halt_id field predicates */
  tripHaltID?: InputMaybe<Scalars['ID']['input']>;
  tripHaltIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripHaltIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripHaltIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_email field predicates */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userEmailContains?: InputMaybe<Scalars['String']['input']>;
  userEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  userEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  userEmailGT?: InputMaybe<Scalars['String']['input']>;
  userEmailGTE?: InputMaybe<Scalars['String']['input']>;
  userEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userEmailLT?: InputMaybe<Scalars['String']['input']>;
  userEmailLTE?: InputMaybe<Scalars['String']['input']>;
  userEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  userEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['String']['input']>;
  userIDContains?: InputMaybe<Scalars['String']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  userIDGT?: InputMaybe<Scalars['String']['input']>;
  userIDGTE?: InputMaybe<Scalars['String']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['String']['input']>;
  userIDLTE?: InputMaybe<Scalars['String']['input']>;
  userIDNEQ?: InputMaybe<Scalars['String']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_name field predicates */
  userName?: InputMaybe<Scalars['String']['input']>;
  userNameContains?: InputMaybe<Scalars['String']['input']>;
  userNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  userNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  userNameGT?: InputMaybe<Scalars['String']['input']>;
  userNameGTE?: InputMaybe<Scalars['String']['input']>;
  userNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userNameLT?: InputMaybe<Scalars['String']['input']>;
  userNameLTE?: InputMaybe<Scalars['String']['input']>;
  userNameNEQ?: InputMaybe<Scalars['String']['input']>;
  userNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user_phone field predicates */
  userPhone?: InputMaybe<Scalars['String']['input']>;
  userPhoneContains?: InputMaybe<Scalars['String']['input']>;
  userPhoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  userPhoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  userPhoneGT?: InputMaybe<Scalars['String']['input']>;
  userPhoneGTE?: InputMaybe<Scalars['String']['input']>;
  userPhoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userPhoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userPhoneLT?: InputMaybe<Scalars['String']['input']>;
  userPhoneLTE?: InputMaybe<Scalars['String']['input']>;
  userPhoneNEQ?: InputMaybe<Scalars['String']['input']>;
  userPhoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * TripHaltPointWhereInput is used for filtering TripHaltPoint objects.
 * Input was generated by ent.
 */
export type TripHaltPointWhereInput = {
  /** address field predicates */
  address?: InputMaybe<Scalars['String']['input']>;
  addressContains?: InputMaybe<Scalars['String']['input']>;
  addressContainsFold?: InputMaybe<Scalars['String']['input']>;
  addressEqualFold?: InputMaybe<Scalars['String']['input']>;
  addressGT?: InputMaybe<Scalars['String']['input']>;
  addressGTE?: InputMaybe<Scalars['String']['input']>;
  addressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  addressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  addressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addressLT?: InputMaybe<Scalars['String']['input']>;
  addressLTE?: InputMaybe<Scalars['String']['input']>;
  addressNEQ?: InputMaybe<Scalars['String']['input']>;
  addressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<TripHaltPointWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** halt_name field predicates */
  haltName?: InputMaybe<Scalars['String']['input']>;
  haltNameContains?: InputMaybe<Scalars['String']['input']>;
  haltNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  haltNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  haltNameGT?: InputMaybe<Scalars['String']['input']>;
  haltNameGTE?: InputMaybe<Scalars['String']['input']>;
  haltNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  haltNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  haltNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  haltNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  haltNameLT?: InputMaybe<Scalars['String']['input']>;
  haltNameLTE?: InputMaybe<Scalars['String']['input']>;
  haltNameNEQ?: InputMaybe<Scalars['String']['input']>;
  haltNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  haltNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** halt_point_id field predicates */
  haltPointID?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDGT?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDGTE?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  haltPointIDLT?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDLTE?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  haltPointIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** trip edge predicates */
  hasTrip?: InputMaybe<Scalars['Boolean']['input']>;
  /** trip_halt_point_target edge predicates */
  hasTripHaltPointTarget?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltPointTargetWith?: InputMaybe<Array<TripHaltPointTargetWhereInput>>;
  /** trip_halt_point_timelines edge predicates */
  hasTripHaltPointTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltPointTimelinesWith?: InputMaybe<Array<TripHaltPointTimeLineWhereInput>>;
  hasTripWith?: InputMaybe<Array<TripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** lat field predicates */
  lat?: InputMaybe<Scalars['Float']['input']>;
  latGT?: InputMaybe<Scalars['Float']['input']>;
  latGTE?: InputMaybe<Scalars['Float']['input']>;
  latIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  latLT?: InputMaybe<Scalars['Float']['input']>;
  latLTE?: InputMaybe<Scalars['Float']['input']>;
  latNEQ?: InputMaybe<Scalars['Float']['input']>;
  latNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** lng field predicates */
  lng?: InputMaybe<Scalars['Float']['input']>;
  lngGT?: InputMaybe<Scalars['Float']['input']>;
  lngGTE?: InputMaybe<Scalars['Float']['input']>;
  lngIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  lngLT?: InputMaybe<Scalars['Float']['input']>;
  lngLTE?: InputMaybe<Scalars['Float']['input']>;
  lngNEQ?: InputMaybe<Scalars['Float']['input']>;
  lngNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<TripHaltPointWhereInput>;
  or?: InputMaybe<Array<TripHaltPointWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** planned_time field predicates */
  plannedTime?: InputMaybe<Scalars['String']['input']>;
  plannedTimeContains?: InputMaybe<Scalars['String']['input']>;
  plannedTimeContainsFold?: InputMaybe<Scalars['String']['input']>;
  plannedTimeEqualFold?: InputMaybe<Scalars['String']['input']>;
  plannedTimeGT?: InputMaybe<Scalars['String']['input']>;
  plannedTimeGTE?: InputMaybe<Scalars['String']['input']>;
  plannedTimeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  plannedTimeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  plannedTimeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plannedTimeLT?: InputMaybe<Scalars['String']['input']>;
  plannedTimeLTE?: InputMaybe<Scalars['String']['input']>;
  plannedTimeNEQ?: InputMaybe<Scalars['String']['input']>;
  plannedTimeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  plannedTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** status_name field predicates */
  statusName?: InputMaybe<TripHaltPointStatusName>;
  statusNameIn?: InputMaybe<Array<TripHaltPointStatusName>>;
  statusNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNameNEQ?: InputMaybe<TripHaltPointStatusName>;
  statusNameNotIn?: InputMaybe<Array<TripHaltPointStatusName>>;
  statusNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trip_id field predicates */
  tripID?: InputMaybe<Scalars['ID']['input']>;
  tripIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** window_end field predicates */
  windowEnd?: InputMaybe<Scalars['Time']['input']>;
  windowEndGT?: InputMaybe<Scalars['Time']['input']>;
  windowEndGTE?: InputMaybe<Scalars['Time']['input']>;
  windowEndIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  windowEndIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  windowEndLT?: InputMaybe<Scalars['Time']['input']>;
  windowEndLTE?: InputMaybe<Scalars['Time']['input']>;
  windowEndNEQ?: InputMaybe<Scalars['Time']['input']>;
  windowEndNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  windowEndNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** window_start field predicates */
  windowStart?: InputMaybe<Scalars['Time']['input']>;
  windowStartGT?: InputMaybe<Scalars['Time']['input']>;
  windowStartGTE?: InputMaybe<Scalars['Time']['input']>;
  windowStartIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  windowStartIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  windowStartLT?: InputMaybe<Scalars['Time']['input']>;
  windowStartLTE?: InputMaybe<Scalars['Time']['input']>;
  windowStartNEQ?: InputMaybe<Scalars['Time']['input']>;
  windowStartNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  windowStartNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Ordering options for Trip connections */
export type TripOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Trips. */
  field: TripOrderField;
};

/** Properties by which Trip connections can be ordered. */
export enum TripOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  ServiceDate = 'serviceDate',
  StatusName = 'statusName',
  UpdatedAt = 'updatedAt'
}

/** TripStatusName is enum for the field status_name */
export enum TripStatusName {
  Accepted = 'ACCEPTED',
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Started = 'STARTED',
  Unassigned = 'UNASSIGNED'
}

export type TripTimeLine = Node & {
  __typename?: 'TripTimeLine';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  statusName?: Maybe<TripTimeLineStatusName>;
  timestamp: Scalars['Time']['output'];
  trip: Trip;
  tripID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  userEmail: Scalars['String']['output'];
  userID?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
  userPhone: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type TripTimeLineConnection = {
  __typename?: 'TripTimeLineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TripTimeLineEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TripTimeLineEdge = {
  __typename?: 'TripTimeLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TripTimeLine>;
};

export enum TripTimeLineField {
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  Remarks = 'remarks',
  StatusName = 'statusName',
  Timestamp = 'timestamp',
  TripId = 'tripID',
  UpdatedAt = 'updatedAt',
  UserEmail = 'userEmail',
  UserId = 'userID',
  UserName = 'userName',
  UserPhone = 'userPhone'
}

/** Ordering options for TripTimeLine connections */
export type TripTimeLineOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order TripTimeLines. */
  field: TripTimeLineOrderField;
};

/** Properties by which TripTimeLine connections can be ordered. */
export enum TripTimeLineOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** TripTimeLineStatusName is enum for the field status_name */
export enum TripTimeLineStatusName {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Planned = 'PLANNED',
  Resumed = 'RESUMED',
  Started = 'STARTED'
}

/**
 * TripTimeLineWhereInput is used for filtering TripTimeLine objects.
 * Input was generated by ent.
 */
export type TripTimeLineWhereInput = {
  and?: InputMaybe<Array<TripTimeLineWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** trip edge predicates */
  hasTrip?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripWith?: InputMaybe<Array<TripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TripTimeLineWhereInput>;
  or?: InputMaybe<Array<TripTimeLineWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** remarks field predicates */
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarksContains?: InputMaybe<Scalars['String']['input']>;
  remarksContainsFold?: InputMaybe<Scalars['String']['input']>;
  remarksEqualFold?: InputMaybe<Scalars['String']['input']>;
  remarksGT?: InputMaybe<Scalars['String']['input']>;
  remarksGTE?: InputMaybe<Scalars['String']['input']>;
  remarksHasPrefix?: InputMaybe<Scalars['String']['input']>;
  remarksHasSuffix?: InputMaybe<Scalars['String']['input']>;
  remarksIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  remarksLT?: InputMaybe<Scalars['String']['input']>;
  remarksLTE?: InputMaybe<Scalars['String']['input']>;
  remarksNEQ?: InputMaybe<Scalars['String']['input']>;
  remarksNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  remarksNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status_name field predicates */
  statusName?: InputMaybe<TripTimeLineStatusName>;
  statusNameIn?: InputMaybe<Array<TripTimeLineStatusName>>;
  statusNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNameNEQ?: InputMaybe<TripTimeLineStatusName>;
  statusNameNotIn?: InputMaybe<Array<TripTimeLineStatusName>>;
  statusNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** timestamp field predicates */
  timestamp?: InputMaybe<Scalars['Time']['input']>;
  timestampGT?: InputMaybe<Scalars['Time']['input']>;
  timestampGTE?: InputMaybe<Scalars['Time']['input']>;
  timestampIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  timestampLT?: InputMaybe<Scalars['Time']['input']>;
  timestampLTE?: InputMaybe<Scalars['Time']['input']>;
  timestampNEQ?: InputMaybe<Scalars['Time']['input']>;
  timestampNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** trip_id field predicates */
  tripID?: InputMaybe<Scalars['ID']['input']>;
  tripIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_email field predicates */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userEmailContains?: InputMaybe<Scalars['String']['input']>;
  userEmailContainsFold?: InputMaybe<Scalars['String']['input']>;
  userEmailEqualFold?: InputMaybe<Scalars['String']['input']>;
  userEmailGT?: InputMaybe<Scalars['String']['input']>;
  userEmailGTE?: InputMaybe<Scalars['String']['input']>;
  userEmailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userEmailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userEmailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userEmailLT?: InputMaybe<Scalars['String']['input']>;
  userEmailLTE?: InputMaybe<Scalars['String']['input']>;
  userEmailNEQ?: InputMaybe<Scalars['String']['input']>;
  userEmailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['String']['input']>;
  userIDContains?: InputMaybe<Scalars['String']['input']>;
  userIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  userIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  userIDGT?: InputMaybe<Scalars['String']['input']>;
  userIDGTE?: InputMaybe<Scalars['String']['input']>;
  userIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['String']['input']>;
  userIDLTE?: InputMaybe<Scalars['String']['input']>;
  userIDNEQ?: InputMaybe<Scalars['String']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_name field predicates */
  userName?: InputMaybe<Scalars['String']['input']>;
  userNameContains?: InputMaybe<Scalars['String']['input']>;
  userNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  userNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  userNameGT?: InputMaybe<Scalars['String']['input']>;
  userNameGTE?: InputMaybe<Scalars['String']['input']>;
  userNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userNameLT?: InputMaybe<Scalars['String']['input']>;
  userNameLTE?: InputMaybe<Scalars['String']['input']>;
  userNameNEQ?: InputMaybe<Scalars['String']['input']>;
  userNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** user_phone field predicates */
  userPhone?: InputMaybe<Scalars['String']['input']>;
  userPhoneContains?: InputMaybe<Scalars['String']['input']>;
  userPhoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  userPhoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  userPhoneGT?: InputMaybe<Scalars['String']['input']>;
  userPhoneGTE?: InputMaybe<Scalars['String']['input']>;
  userPhoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  userPhoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  userPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  userPhoneLT?: InputMaybe<Scalars['String']['input']>;
  userPhoneLTE?: InputMaybe<Scalars['String']['input']>;
  userPhoneNEQ?: InputMaybe<Scalars['String']['input']>;
  userPhoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * TripWhereInput is used for filtering Trip objects.
 * Input was generated by ent.
 */
export type TripWhereInput = {
  /** accepted_at field predicates */
  acceptedAt?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  acceptedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedAtLT?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  acceptedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  acceptedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<TripWhereInput>>;
  /** assigned_at field predicates */
  assignedAt?: InputMaybe<Scalars['Time']['input']>;
  assignedAtGT?: InputMaybe<Scalars['Time']['input']>;
  assignedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  assignedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  assignedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedAtLT?: InputMaybe<Scalars['Time']['input']>;
  assignedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  assignedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  assignedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  assignedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** cancelled_at field predicates */
  cancelledAt?: InputMaybe<Scalars['Time']['input']>;
  cancelledAtGT?: InputMaybe<Scalars['Time']['input']>;
  cancelledAtGTE?: InputMaybe<Scalars['Time']['input']>;
  cancelledAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  cancelledAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledAtLT?: InputMaybe<Scalars['Time']['input']>;
  cancelledAtLTE?: InputMaybe<Scalars['Time']['input']>;
  cancelledAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  cancelledAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  cancelledAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** created_by_user_id field predicates */
  createdByUserID?: InputMaybe<Scalars['ID']['input']>;
  createdByUserIDGT?: InputMaybe<Scalars['ID']['input']>;
  createdByUserIDGTE?: InputMaybe<Scalars['ID']['input']>;
  createdByUserIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByUserIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  createdByUserIDLT?: InputMaybe<Scalars['ID']['input']>;
  createdByUserIDLTE?: InputMaybe<Scalars['ID']['input']>;
  createdByUserIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  createdByUserIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByUserIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** distance field predicates */
  distance?: InputMaybe<Scalars['Float']['input']>;
  distanceGT?: InputMaybe<Scalars['Float']['input']>;
  distanceGTE?: InputMaybe<Scalars['Float']['input']>;
  distanceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  distanceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  distanceLT?: InputMaybe<Scalars['Float']['input']>;
  distanceLTE?: InputMaybe<Scalars['Float']['input']>;
  distanceNEQ?: InputMaybe<Scalars['Float']['input']>;
  distanceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  distanceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver_id field predicates */
  driverID?: InputMaybe<Scalars['ID']['input']>;
  driverIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  driverIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  driverIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver_license_no field predicates */
  driverLicenseNo?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoContains?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoContainsFold?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoEqualFold?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoGT?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoGTE?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoHasPrefix?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoHasSuffix?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoIn?: InputMaybe<Array<Scalars['String']['input']>>;
  driverLicenseNoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  driverLicenseNoLT?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoLTE?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoNEQ?: InputMaybe<Scalars['String']['input']>;
  driverLicenseNoNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  driverLicenseNoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver_name field predicates */
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverNameContains?: InputMaybe<Scalars['String']['input']>;
  driverNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  driverNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  driverNameGT?: InputMaybe<Scalars['String']['input']>;
  driverNameGTE?: InputMaybe<Scalars['String']['input']>;
  driverNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  driverNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  driverNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  driverNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  driverNameLT?: InputMaybe<Scalars['String']['input']>;
  driverNameLTE?: InputMaybe<Scalars['String']['input']>;
  driverNameNEQ?: InputMaybe<Scalars['String']['input']>;
  driverNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  driverNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver_phone field predicates */
  driverPhone?: InputMaybe<Scalars['String']['input']>;
  driverPhoneContains?: InputMaybe<Scalars['String']['input']>;
  driverPhoneContainsFold?: InputMaybe<Scalars['String']['input']>;
  driverPhoneEqualFold?: InputMaybe<Scalars['String']['input']>;
  driverPhoneGT?: InputMaybe<Scalars['String']['input']>;
  driverPhoneGTE?: InputMaybe<Scalars['String']['input']>;
  driverPhoneHasPrefix?: InputMaybe<Scalars['String']['input']>;
  driverPhoneHasSuffix?: InputMaybe<Scalars['String']['input']>;
  driverPhoneIn?: InputMaybe<Array<Scalars['String']['input']>>;
  driverPhoneIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  driverPhoneLT?: InputMaybe<Scalars['String']['input']>;
  driverPhoneLTE?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNEQ?: InputMaybe<Scalars['String']['input']>;
  driverPhoneNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  driverPhoneNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** end_location field predicates */
  endLocation?: InputMaybe<Scalars['String']['input']>;
  endLocationContains?: InputMaybe<Scalars['String']['input']>;
  endLocationContainsFold?: InputMaybe<Scalars['String']['input']>;
  endLocationEqualFold?: InputMaybe<Scalars['String']['input']>;
  endLocationGT?: InputMaybe<Scalars['String']['input']>;
  endLocationGTE?: InputMaybe<Scalars['String']['input']>;
  endLocationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  endLocationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  endLocationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  endLocationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endLocationLT?: InputMaybe<Scalars['String']['input']>;
  endLocationLTE?: InputMaybe<Scalars['String']['input']>;
  endLocationNEQ?: InputMaybe<Scalars['String']['input']>;
  endLocationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  endLocationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** estimated_time field predicates */
  estimatedTime?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeGT?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeGTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  estimatedTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedTimeLT?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeLTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeNEQ?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  estimatedTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver edge predicates */
  hasDriver?: InputMaybe<Scalars['Boolean']['input']>;
  hasDriverWith?: InputMaybe<Array<UserWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** trip_halt_points edge predicates */
  hasTripHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripHaltPointsWith?: InputMaybe<Array<TripHaltPointWhereInput>>;
  /** trip_timelines edge predicates */
  hasTripTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripTimelinesWith?: InputMaybe<Array<TripTimeLineWhereInput>>;
  /** vehicle edge predicates */
  hasVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  hasVehicleWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<TripWhereInput>;
  or?: InputMaybe<Array<TripWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** planned_end_time field predicates */
  plannedEndTime?: InputMaybe<Scalars['Time']['input']>;
  plannedEndTimeGT?: InputMaybe<Scalars['Time']['input']>;
  plannedEndTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  plannedEndTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  plannedEndTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plannedEndTimeLT?: InputMaybe<Scalars['Time']['input']>;
  plannedEndTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  plannedEndTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  plannedEndTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  plannedEndTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** planned_start_time field predicates */
  plannedStartTime?: InputMaybe<Scalars['Time']['input']>;
  plannedStartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  plannedStartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  plannedStartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  plannedStartTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  plannedStartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  plannedStartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  plannedStartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  plannedStartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  plannedStartTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** route_id field predicates */
  routeID?: InputMaybe<Scalars['ID']['input']>;
  routeIDGT?: InputMaybe<Scalars['ID']['input']>;
  routeIDGTE?: InputMaybe<Scalars['ID']['input']>;
  routeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeIDLT?: InputMaybe<Scalars['ID']['input']>;
  routeIDLTE?: InputMaybe<Scalars['ID']['input']>;
  routeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** service_date field predicates */
  serviceDate?: InputMaybe<Scalars['Time']['input']>;
  serviceDateGT?: InputMaybe<Scalars['Time']['input']>;
  serviceDateGTE?: InputMaybe<Scalars['Time']['input']>;
  serviceDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  serviceDateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  serviceDateLT?: InputMaybe<Scalars['Time']['input']>;
  serviceDateLTE?: InputMaybe<Scalars['Time']['input']>;
  serviceDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  serviceDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  serviceDateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** start_location field predicates */
  startLocation?: InputMaybe<Scalars['String']['input']>;
  startLocationContains?: InputMaybe<Scalars['String']['input']>;
  startLocationContainsFold?: InputMaybe<Scalars['String']['input']>;
  startLocationEqualFold?: InputMaybe<Scalars['String']['input']>;
  startLocationGT?: InputMaybe<Scalars['String']['input']>;
  startLocationGTE?: InputMaybe<Scalars['String']['input']>;
  startLocationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  startLocationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  startLocationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startLocationIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startLocationLT?: InputMaybe<Scalars['String']['input']>;
  startLocationLTE?: InputMaybe<Scalars['String']['input']>;
  startLocationNEQ?: InputMaybe<Scalars['String']['input']>;
  startLocationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startLocationNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** started_at field predicates */
  startedAt?: InputMaybe<Scalars['Time']['input']>;
  startedAtGT?: InputMaybe<Scalars['Time']['input']>;
  startedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  startedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startedAtLT?: InputMaybe<Scalars['Time']['input']>;
  startedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  startedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  startedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status_name field predicates */
  statusName?: InputMaybe<TripStatusName>;
  statusNameIn?: InputMaybe<Array<TripStatusName>>;
  statusNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  statusNameNEQ?: InputMaybe<TripStatusName>;
  statusNameNotIn?: InputMaybe<Array<TripStatusName>>;
  statusNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_id field predicates */
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
  vehicleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vehicleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateAPIUserInput is used for update APIUser object.
 * Input was generated by ent.
 */
export type UpdateApiUserInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateAdhocTableInput is used for update AdhocTable object.
 * Input was generated by ent.
 */
export type UpdateAdhocTableInput = {
  approvedAt?: InputMaybe<Scalars['Time']['input']>;
  clearApprovedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearHaltpointLat?: InputMaybe<Scalars['Boolean']['input']>;
  clearHaltpointLng?: InputMaybe<Scalars['Boolean']['input']>;
  clearHaltpointLocation?: InputMaybe<Scalars['Boolean']['input']>;
  clearLoad?: InputMaybe<Scalars['Boolean']['input']>;
  clearRejectedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemarks?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripID?: InputMaybe<Scalars['Boolean']['input']>;
  clearWasteType?: InputMaybe<Scalars['Boolean']['input']>;
  haltPointID?: InputMaybe<Scalars['ID']['input']>;
  haltpointLat?: InputMaybe<Scalars['Float']['input']>;
  haltpointLng?: InputMaybe<Scalars['Float']['input']>;
  haltpointLocation?: InputMaybe<Scalars['String']['input']>;
  load?: InputMaybe<Scalars['Float']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  rejectedAt?: InputMaybe<Scalars['Time']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<AdhocTableServiceType>;
  status?: InputMaybe<AdhocTableStatus>;
  targetID?: InputMaybe<Scalars['ID']['input']>;
  tripID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  wasteType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAttendanceDetailInput is used for update AttendanceDetail object.
 * Input was generated by ent.
 */
export type UpdateAttendanceDetailInput = {
  actualDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  actualMarkIn?: InputMaybe<Scalars['Time']['input']>;
  actualMarkOut?: InputMaybe<Scalars['Time']['input']>;
  attendanceID?: InputMaybe<Scalars['ID']['input']>;
  attendanceType?: InputMaybe<AttendanceDetailAttendanceType>;
  checkInDistanceFromWorkplaceMeters?: InputMaybe<Scalars['Float']['input']>;
  checkInFaceDetected?: InputMaybe<Scalars['Boolean']['input']>;
  checkInFaceMatchScore?: InputMaybe<Scalars['Float']['input']>;
  checkInImagePath?: InputMaybe<Scalars['String']['input']>;
  checkInImageURL?: InputMaybe<Scalars['String']['input']>;
  checkInLatitude?: InputMaybe<Scalars['Float']['input']>;
  checkInLocationName?: InputMaybe<Scalars['String']['input']>;
  checkInLocationVerified?: InputMaybe<Scalars['Boolean']['input']>;
  checkInLongitude?: InputMaybe<Scalars['Float']['input']>;
  checkOutDistanceFromWorkplaceMeters?: InputMaybe<Scalars['Float']['input']>;
  checkOutFaceDetected?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutFaceMatchScore?: InputMaybe<Scalars['Float']['input']>;
  checkOutImagePath?: InputMaybe<Scalars['String']['input']>;
  checkOutImageURL?: InputMaybe<Scalars['String']['input']>;
  checkOutLatitude?: InputMaybe<Scalars['Float']['input']>;
  checkOutLocationName?: InputMaybe<Scalars['String']['input']>;
  checkOutLocationVerified?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutLongitude?: InputMaybe<Scalars['Float']['input']>;
  clearActualDurationMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  clearActualMarkIn?: InputMaybe<Scalars['Boolean']['input']>;
  clearActualMarkOut?: InputMaybe<Scalars['Boolean']['input']>;
  clearAttendanceType?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInDistanceFromWorkplaceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInFaceMatchScore?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInImagePath?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInImageURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInLatitude?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInLocationName?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInLongitude?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutDistanceFromWorkplaceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutFaceMatchScore?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutImagePath?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutImageURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutLatitude?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutLocationName?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutLongitude?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemarks?: InputMaybe<Scalars['Boolean']['input']>;
  clearScheduledEndTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearScheduledStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  rosterShiftID?: InputMaybe<Scalars['ID']['input']>;
  scheduledEndTime?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTime?: InputMaybe<Scalars['Time']['input']>;
  shiftNumber?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AttendanceDetailStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateAttendanceInput is used for update Attendance object.
 * Input was generated by ent.
 */
export type UpdateAttendanceInput = {
  addAttendanceDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  attendanceDate?: InputMaybe<Scalars['Time']['input']>;
  attendanceType?: InputMaybe<AttendanceAttendanceType>;
  clearAttendanceDetails?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveRequest?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveType?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemarks?: InputMaybe<Scalars['Boolean']['input']>;
  clearTotalActualMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  clearTotalScheduledMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  clearTotalShiftsCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  clearTotalShiftsScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  clearZoneName?: InputMaybe<Scalars['Boolean']['input']>;
  leaveDateID?: InputMaybe<Scalars['ID']['input']>;
  leaveRequestID?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  overallStatus?: InputMaybe<AttendanceOverallStatus>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  removeAttendanceDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  totalActualMinutes?: InputMaybe<Scalars['Float']['input']>;
  totalScheduledMinutes?: InputMaybe<Scalars['Float']['input']>;
  totalShiftsCompleted?: InputMaybe<Scalars['Int']['input']>;
  totalShiftsScheduled?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  zoneName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateBaseAddonInput is used for update BaseAddon object.
 * Input was generated by ent.
 */
export type UpdateBaseAddonInput = {
  addBaselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearBaselicenseplanaddon?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeBaselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateBaseLicensePlanAddonInput is used for update BaseLicensePlanAddon object.
 * Input was generated by ent.
 */
export type UpdateBaseLicensePlanAddonInput = {
  addLicenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseaddonID?: InputMaybe<Scalars['ID']['input']>;
  baselicenseplanID?: InputMaybe<Scalars['ID']['input']>;
  clearLicenseorderaddons?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  removeLicenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateBaseLicensePlanInput is used for update BaseLicensePlan object.
 * Input was generated by ent.
 */
export type UpdateBaseLicensePlanInput = {
  addBaselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLicenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  clearBaselicenseplanaddon?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicenseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  module?: InputMaybe<BaseLicensePlanModule>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  removeBaselicenseplanaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLicenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenure?: InputMaybe<Scalars['Int']['input']>;
  tenureUnit?: InputMaybe<BaseLicensePlanTenureUnit>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateBaseReportInput is used for update BaseReport object.
 * Input was generated by ent.
 */
export type UpdateBaseReportInput = {
  addDerivedReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  chartConfig?: InputMaybe<Scalars['JSON']['input']>;
  clearDerivedReports?: InputMaybe<Scalars['Boolean']['input']>;
  currentDateReport?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inputConfig?: InputMaybe<Scalars['JSON']['input']>;
  mapConfig?: InputMaybe<Scalars['JSON']['input']>;
  multiDateMultiRequest?: InputMaybe<Scalars['Boolean']['input']>;
  multiDevice?: InputMaybe<Scalars['Boolean']['input']>;
  multiDeviceMultiRequest?: InputMaybe<Scalars['Boolean']['input']>;
  removeDerivedReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  resolver?: InputMaybe<Scalars['String']['input']>;
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateChangeLogInput is used for update ChangeLog object.
 * Input was generated by ent.
 */
export type UpdateChangeLogInput = {
  action?: InputMaybe<ChangeLogAction>;
  clearImpersonatedUserID?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreviousData?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemoteIP?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpdatedData?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  modelID?: InputMaybe<Scalars['ID']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  previousData?: InputMaybe<Scalars['JSON']['input']>;
  remoteIP?: InputMaybe<Scalars['NullString']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedData?: InputMaybe<Scalars['JSON']['input']>;
  userAgent?: InputMaybe<Scalars['NullString']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateConsumerConfigInput is used for update ConsumerConfig object.
 * Input was generated by ent.
 */
export type UpdateConsumerConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  clearAPIKeyName?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIKeySecret?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastFailedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastResponse?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSuccessAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearName?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextAttemptAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  periodicSeconds?: InputMaybe<Scalars['Int']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  vehicleNameAsImei?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateConsumerServerInput is used for update ConsumerServer object.
 * Input was generated by ent.
 */
export type UpdateConsumerServerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowedImei?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  appendAllowedImei?: InputMaybe<Array<Scalars['String']['input']>>;
  clearAPIKeyName?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIKeySecret?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastFailedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastFailedImei?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSuccessAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSuccessImei?: InputMaybe<Scalars['Boolean']['input']>;
  clearName?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastFailedImei?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  lastSuccessImei?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateDerivedReportInput is used for update DerivedReport object.
 * Input was generated by ent.
 */
export type UpdateDerivedReportInput = {
  addOrganisationReportAccessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserReportBookmarkIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseReportID?: InputMaybe<Scalars['ID']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationReportAccesses?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserReportBookmarks?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledForAllOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeOrganisationReportAccessIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserReportBookmarkIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceACLInput is used for update DeviceACL object.
 * Input was generated by ent.
 */
export type UpdateDeviceAclInput = {
  clearName?: InputMaybe<Scalars['Boolean']['input']>;
  devicegroupsID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceActionLogInput is used for update DeviceActionLog object.
 * Input was generated by ent.
 */
export type UpdateDeviceActionLogInput = {
  actionDescription?: InputMaybe<Scalars['String']['input']>;
  actionType?: InputMaybe<DeviceActionLogActionType>;
  devicesID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DeviceActionLogStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceAddonModelInput is used for update DeviceAddonModel object.
 * Input was generated by ent.
 */
export type UpdateDeviceAddonModelInput = {
  addDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addonType?: InputMaybe<DeviceAddonModelAddonType>;
  channelType?: InputMaybe<DeviceAddonModelChannelType>;
  clearDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceAdvancedConfigInput is used for update DeviceAdvancedConfig object.
 * Input was generated by ent.
 */
export type UpdateDeviceAdvancedConfigInput = {
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateDeviceCategoryInput is used for update DeviceCategory object.
 * Input was generated by ent.
 */
export type UpdateDeviceCategoryInput = {
  addDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addStiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearGroupType?: InputMaybe<Scalars['Boolean']['input']>;
  clearStiqrs?: InputMaybe<Scalars['Boolean']['input']>;
  groupType?: InputMaybe<DeviceCategoryGroupType>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeStiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceChannelConfigInput is used for update DeviceChannelConfig object.
 * Input was generated by ent.
 */
export type UpdateDeviceChannelConfigInput = {
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceaddonmodelID?: InputMaybe<Scalars['ID']['input']>;
  devicemodelchannelID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceCommandInput is used for update DeviceCommand object.
 * Input was generated by ent.
 */
export type UpdateDeviceCommandInput = {
  addDeviceModelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDeviceModels?: InputMaybe<Scalars['Boolean']['input']>;
  command?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceModelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceConfigInput is used for update DeviceConfig object.
 * Input was generated by ent.
 */
export type UpdateDeviceConfigInput = {
  clearToken?: InputMaybe<Scalars['Boolean']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceDocumentInput is used for update DeviceDocument object.
 * Input was generated by ent.
 */
export type UpdateDeviceDocumentInput = {
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  deviceDocumentTypeID?: InputMaybe<Scalars['ID']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceDocumentTypeInput is used for update DeviceDocumentType object.
 * Input was generated by ent.
 */
export type UpdateDeviceDocumentTypeInput = {
  addDeviceDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDeviceDocumentTypeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceGroupDocumentInput is used for update DeviceGroupDocument object.
 * Input was generated by ent.
 */
export type UpdateDeviceGroupDocumentInput = {
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  deviceGroupDocumentTypeID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['Time']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceGroupDocumentTypeInput is used for update DeviceGroupDocumentType object.
 * Input was generated by ent.
 */
export type UpdateDeviceGroupDocumentTypeInput = {
  addDeviceGroupDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  applicableGroupType?: InputMaybe<DeviceGroupDocumentTypeApplicableGroupType>;
  clearDeviceGroupDocumentTypeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeDeviceGroupDocumentTypeDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceGroupInput is used for update DeviceGroup object.
 * Input was generated by ent.
 */
export type UpdateDeviceGroupInput = {
  addDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceParkingModeConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDriverprofileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addInspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addStiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardDriverTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDevice?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceParkingModeConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceacls?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriverprofiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearInspectionReports?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnerAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnerContactNumber?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnerFullName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwnerInstallationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearShifts?: InputMaybe<Scalars['Boolean']['input']>;
  clearStiqrs?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardDriverTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceVehicleID?: InputMaybe<Scalars['ID']['input']>;
  devicegroupOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  devicegroupRootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  groupType?: InputMaybe<DeviceGroupGroupType>;
  ownerAddress?: InputMaybe<Scalars['String']['input']>;
  ownerContactNumber?: InputMaybe<Scalars['String']['input']>;
  ownerFullName?: InputMaybe<Scalars['String']['input']>;
  ownerInstallationDate?: InputMaybe<Scalars['Time']['input']>;
  removeDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceParkingModeConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDriverprofileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeInspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeStiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardDriverTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceInput is used for update Device object.
 * Input was generated by ent.
 */
export type UpdateDeviceInput = {
  addDeviceActionLogIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicePlaybackFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceadvancedconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPositionAttributeFormulaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  clearBoltLegacyID?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceActionLogs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicePlaybackFiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceadvancedconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastPing?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicense?: InputMaybe<Scalars['Boolean']['input']>;
  clearPositionAttributeFormulas?: InputMaybe<Scalars['Boolean']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  devicecategoryID?: InputMaybe<Scalars['ID']['input']>;
  devicemodelID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  ingestServer?: InputMaybe<DeviceIngestServer>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  lastPing?: InputMaybe<Scalars['Time']['input']>;
  licenseID?: InputMaybe<Scalars['ID']['input']>;
  midnightTotalDistance?: InputMaybe<Scalars['Float']['input']>;
  midnightTotalEngineMs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeDeviceActionLogIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicePlaybackFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceadvancedconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePositionAttributeFormulaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  simID?: InputMaybe<Scalars['ID']['input']>;
  speedLimitKmHr?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceModelChannelInput is used for update DeviceModelChannel object.
 * Input was generated by ent.
 */
export type UpdateDeviceModelChannelInput = {
  addDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  channelName?: InputMaybe<Scalars['String']['input']>;
  channelType?: InputMaybe<DeviceModelChannelChannelType>;
  clearDevicechannelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModelID?: InputMaybe<Scalars['ID']['input']>;
  isBuiltin?: InputMaybe<Scalars['Boolean']['input']>;
  removeDevicechannelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceModelInput is used for update DeviceModel object.
 * Input was generated by ent.
 */
export type UpdateDeviceModelInput = {
  addCommandIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicemodelchannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMediaFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCommands?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicemodelchannels?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediaFiles?: InputMaybe<Scalars['Boolean']['input']>;
  isAssetTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isDashcam?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isVehicleTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isWireless?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeCommandIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicemodelchannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMediaFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceParkingModeConfigInput is used for update DeviceParkingModeConfig object.
 * Input was generated by ent.
 */
export type UpdateDeviceParkingModeConfigInput = {
  appendParkingScheduleDays?: InputMaybe<Array<Scalars['String']['input']>>;
  clearParkingScheduleDays?: InputMaybe<Scalars['Boolean']['input']>;
  clearParkingScheduleEndUtc?: InputMaybe<Scalars['Boolean']['input']>;
  clearParkingScheduleStartUtc?: InputMaybe<Scalars['Boolean']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  parkingMode?: InputMaybe<Scalars['Boolean']['input']>;
  parkingSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  parkingScheduleDays?: InputMaybe<Array<Scalars['String']['input']>>;
  parkingScheduleEndUtc?: InputMaybe<Scalars['Time']['input']>;
  parkingScheduleStartUtc?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDevicePlaybackFilesInput is used for update DevicePlaybackFiles object.
 * Input was generated by ent.
 */
export type UpdateDevicePlaybackFilesInput = {
  appendFileJSON?: InputMaybe<Array<Scalars['String']['input']>>;
  clearDeviceType?: InputMaybe<Scalars['Boolean']['input']>;
  clearFileJSON?: InputMaybe<Scalars['Boolean']['input']>;
  clearFiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearImei?: InputMaybe<Scalars['Boolean']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  fileJSON?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceSharingInput is used for update DeviceSharing object.
 * Input was generated by ent.
 */
export type UpdateDeviceSharingInput = {
  addDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearExpiresOn?: InputMaybe<Scalars['Boolean']['input']>;
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  removeDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  shareType?: InputMaybe<DeviceSharingShareType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateDeviceVehicleInput is used for update DeviceVehicle object.
 * Input was generated by ent.
 */
export type UpdateDeviceVehicleInput = {
  chassisNo?: InputMaybe<Scalars['String']['input']>;
  clearChassisNo?: InputMaybe<Scalars['Boolean']['input']>;
  clearCountry?: InputMaybe<Scalars['Boolean']['input']>;
  clearDealer?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsuranceCompany?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsuranceEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsurancePremium?: InputMaybe<Scalars['Boolean']['input']>;
  clearInsuranceStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearOem?: InputMaybe<Scalars['Boolean']['input']>;
  clearRegisteredRto?: InputMaybe<Scalars['Boolean']['input']>;
  clearState?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarranty?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dealer?: InputMaybe<Scalars['String']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceEndDate?: InputMaybe<Scalars['Time']['input']>;
  insurancePremium?: InputMaybe<Scalars['String']['input']>;
  insuranceStartDate?: InputMaybe<Scalars['Time']['input']>;
  oem?: InputMaybe<Scalars['String']['input']>;
  registeredRto?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<DeviceVehicleVehicleType>;
  warranty?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateDomainInput is used for update Domain object.
 * Input was generated by ent.
 */
export type UpdateDomainInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  clearAlias?: InputMaybe<Scalars['Boolean']['input']>;
  clearVerificationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearVerificationLastChecked?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  sslVerificationStatus?: InputMaybe<DomainSslVerificationStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  verificationID?: InputMaybe<Scalars['String']['input']>;
  verificationLastChecked?: InputMaybe<Scalars['Time']['input']>;
  verificationStatus?: InputMaybe<DomainVerificationStatus>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateExportInput is used for update Export object.
 * Input was generated by ent.
 */
export type UpdateExportInput = {
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusMsg?: InputMaybe<Scalars['Boolean']['input']>;
  exportData?: InputMaybe<Scalars['String']['input']>;
  exportKey?: InputMaybe<Scalars['String']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ExportStatus>;
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateFirebasePrivateKeyInput is used for update FirebasePrivateKey object.
 * Input was generated by ent.
 */
export type UpdateFirebasePrivateKeyInput = {
  authProviderX509CertURL?: InputMaybe<Scalars['String']['input']>;
  authURI?: InputMaybe<Scalars['String']['input']>;
  clearSenderID?: InputMaybe<Scalars['Boolean']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientID?: InputMaybe<Scalars['String']['input']>;
  clientX509CertURL?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  privateKey?: InputMaybe<Scalars['String']['input']>;
  privateKeyID?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['String']['input']>;
  senderID?: InputMaybe<Scalars['String']['input']>;
  tokenURI?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  universeDomain?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateGeofenceDeviceGroupInput is used for update GeofenceDeviceGroup object.
 * Input was generated by ent.
 */
export type UpdateGeofenceDeviceGroupInput = {
  clearLastCross?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastEnter?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastExit?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  devicegroupID?: InputMaybe<Scalars['ID']['input']>;
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  isIn?: InputMaybe<Scalars['Boolean']['input']>;
  lastCross?: InputMaybe<Scalars['Time']['input']>;
  lastEnter?: InputMaybe<Scalars['Time']['input']>;
  lastExit?: InputMaybe<Scalars['Time']['input']>;
  lastUpdate?: InputMaybe<Scalars['Time']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateGeofenceInput is used for update Geofence object.
 * Input was generated by ent.
 */
export type UpdateGeofenceInput = {
  addGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearGeoJSON?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  eventOnEntry?: InputMaybe<Scalars['Boolean']['input']>;
  eventOnExit?: InputMaybe<Scalars['Boolean']['input']>;
  geoJSON?: InputMaybe<Scalars['GeoJSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  removeGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  useAsAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateHaltPointInput is used for update HaltPoint object.
 * Input was generated by ent.
 */
export type UpdateHaltPointInput = {
  addRouteHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  clearAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofenceRadius?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  clearTargets?: InputMaybe<Scalars['Boolean']['input']>;
  geofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeRouteHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateInspectionReportInput is used for update InspectionReport object.
 * Input was generated by ent.
 */
export type UpdateInspectionReportInput = {
  bonnet?: InputMaybe<Scalars['Boolean']['input']>;
  bonnetCondition?: InputMaybe<Scalars['String']['input']>;
  checkInPic?: InputMaybe<Scalars['String']['input']>;
  checkOutPic?: InputMaybe<Scalars['String']['input']>;
  clearCheckInPic?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutPic?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  damageKind?: InputMaybe<Scalars['String']['input']>;
  damageSize?: InputMaybe<Scalars['String']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  doorFront?: InputMaybe<Scalars['Boolean']['input']>;
  doorFrontCondition?: InputMaybe<Scalars['String']['input']>;
  doorRear?: InputMaybe<Scalars['Boolean']['input']>;
  doorRearCondition?: InputMaybe<Scalars['String']['input']>;
  fenderFront?: InputMaybe<Scalars['Boolean']['input']>;
  fenderFrontCondition?: InputMaybe<Scalars['String']['input']>;
  fenderRear?: InputMaybe<Scalars['Boolean']['input']>;
  fenderRearCondition?: InputMaybe<Scalars['String']['input']>;
  frontBumper?: InputMaybe<Scalars['Boolean']['input']>;
  frontBumperCondition?: InputMaybe<Scalars['String']['input']>;
  fuelMain?: InputMaybe<Scalars['String']['input']>;
  fuelSub?: InputMaybe<Scalars['String']['input']>;
  headLamp?: InputMaybe<Scalars['Boolean']['input']>;
  headLampCondition?: InputMaybe<Scalars['String']['input']>;
  journey?: InputMaybe<InspectionReportJourney>;
  kind?: InputMaybe<InspectionReportKind>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  outKm?: InputMaybe<Scalars['Float']['input']>;
  outTime?: InputMaybe<Scalars['Time']['input']>;
  roof?: InputMaybe<Scalars['Boolean']['input']>;
  roofCondition?: InputMaybe<Scalars['String']['input']>;
  sideMirror?: InputMaybe<Scalars['Boolean']['input']>;
  sideMirrorCondition?: InputMaybe<Scalars['String']['input']>;
  sideWindow?: InputMaybe<Scalars['Boolean']['input']>;
  sideWindowCondition?: InputMaybe<Scalars['String']['input']>;
  tailLamp?: InputMaybe<Scalars['Boolean']['input']>;
  tailLampCondition?: InputMaybe<Scalars['String']['input']>;
  tyreFront?: InputMaybe<Scalars['Boolean']['input']>;
  tyreFrontCondition?: InputMaybe<Scalars['String']['input']>;
  tyreRear?: InputMaybe<Scalars['Boolean']['input']>;
  tyreRearCondition?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  windscreen?: InputMaybe<Scalars['Boolean']['input']>;
  windscreenCondition?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateKmlInput is used for update Kml object.
 * Input was generated by ent.
 */
export type UpdateKmlInput = {
  fileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLeaveDateInput is used for update LeaveDate object.
 * Input was generated by ent.
 */
export type UpdateLeaveDateInput = {
  addAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  isHalfDay?: InputMaybe<Scalars['Boolean']['input']>;
  leaveDate?: InputMaybe<Scalars['Time']['input']>;
  leaveRequestID?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  removeAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<LeaveDateStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateLeaveRequestInput is used for update LeaveRequest object.
 * Input was generated by ent.
 */
export type UpdateLeaveRequestInput = {
  addAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLeaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvedDate?: InputMaybe<Scalars['Time']['input']>;
  approverID?: InputMaybe<Scalars['ID']['input']>;
  clearApprovedDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearApprover?: InputMaybe<Scalars['Boolean']['input']>;
  clearAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveDates?: InputMaybe<Scalars['Boolean']['input']>;
  clearNumberOfDays?: InputMaybe<Scalars['Boolean']['input']>;
  clearReason?: InputMaybe<Scalars['Boolean']['input']>;
  clearRejectionReason?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  numberOfDays?: InputMaybe<Scalars['Float']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  removeAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLeaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestStatus?: InputMaybe<LeaveRequestRequestStatus>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateLeaveTypeInput is used for update LeaveType object.
 * Input was generated by ent.
 */
export type UpdateLeaveTypeInput = {
  addAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLeaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserLeaveBalanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  clearColorCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveDates?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  clearMaxDaysPerYear?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserLeaveBalances?: InputMaybe<Scalars['Boolean']['input']>;
  colorCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  leaveTypeName?: InputMaybe<Scalars['String']['input']>;
  maxDaysPerYear?: InputMaybe<Scalars['Int']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLeaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserLeaveBalanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLegacySyncInput is used for update LegacySync object.
 * Input was generated by ent.
 */
export type UpdateLegacySyncInput = {
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusMsg?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<LegacySyncStatus>;
  statusMsg?: InputMaybe<Scalars['String']['input']>;
  syncData?: InputMaybe<Scalars['String']['input']>;
  syncKey?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLicenseInput is used for update License object.
 * Input was generated by ent.
 */
export type UpdateLicenseInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevice?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  expiryReminderDays?: InputMaybe<Scalars['Int']['input']>;
  licenseOrderID?: InputMaybe<Scalars['ID']['input']>;
  moduleType?: InputMaybe<LicenseModuleType>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<LicenseStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLicenseOrderAddonInput is used for update LicenseOrderAddon object.
 * Input was generated by ent.
 */
export type UpdateLicenseOrderAddonInput = {
  baselicenseaddonID?: InputMaybe<Scalars['ID']['input']>;
  licenseorderID?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateLoginLogInput is used for update LoginLog object.
 * Input was generated by ent.
 */
export type UpdateLoginLogInput = {
  attempts?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifierType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateMapConfigInput is used for update MapConfig object.
 * Input was generated by ent.
 */
export type UpdateMapConfigInput = {
  key?: InputMaybe<MapConfigKey>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateMediaFileInput is used for update MediaFile object.
 * Input was generated by ent.
 */
export type UpdateMediaFileInput = {
  addDeviceDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceGroupDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceModelsMediaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWhitelabelLoginLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWhitelabelLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardDriverDetailsAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardDriverDetailsDlImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVehicleInsuranceImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVehiclePollutionImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVehicleRcImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDeviceDocumentMedia?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroupDocumentMedia?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceModelsMedias?: InputMaybe<Scalars['Boolean']['input']>;
  clearExport?: InputMaybe<Scalars['Boolean']['input']>;
  clearFileName?: InputMaybe<Scalars['Boolean']['input']>;
  clearKmls?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  clearUser?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabelLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabelLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardDriverDetailsAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardDriverDetailsDlImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVehicleInsuranceImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVehiclePollutionImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVehicleRcImage?: InputMaybe<Scalars['Boolean']['input']>;
  exportID?: InputMaybe<Scalars['ID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  removeDeviceDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceGroupDocumentMediumIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceModelsMediaIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWhitelabelLoginLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWhitelabelLogoIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardDriverDetailsAvatarIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardDriverDetailsDlImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVehicleInsuranceImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVehiclePollutionImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVehicleRcImageIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<MediaFileStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateNotifyChannelInput is used for update NotifyChannel object.
 * Input was generated by ent.
 */
export type UpdateNotifyChannelInput = {
  addNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  clearNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationUserID?: InputMaybe<Scalars['Boolean']['input']>;
  emailTo?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fcmDevicePlatform?: InputMaybe<NotifyChannelFcmDevicePlatform>;
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<NotifyChannelKind>;
  linkedData?: InputMaybe<Scalars['String']['input']>;
  loggedInDeviceID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  removeNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  serverNotes?: InputMaybe<Scalars['String']['input']>;
  smsCountryCode?: InputMaybe<Scalars['Int']['input']>;
  smsNumber?: InputMaybe<Scalars['Int']['input']>;
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  telegramBotToken?: InputMaybe<Scalars['String']['input']>;
  telegramChatID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyConfigChannelInput is used for update NotifyConfigChannel object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigChannelInput = {
  notifyChannelID?: InputMaybe<Scalars['ID']['input']>;
  notifyConfigID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyConfigDeviceGroupInput is used for update NotifyConfigDeviceGroup object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigDeviceGroupInput = {
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  notifyConfigID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyConfigEventInput is used for update NotifyConfigEvent object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigEventInput = {
  acceptableMax?: InputMaybe<Scalars['Float']['input']>;
  acceptableMin?: InputMaybe<Scalars['Float']['input']>;
  distanceMeters?: InputMaybe<Scalars['Float']['input']>;
  distanceToleranceMeters?: InputMaybe<Scalars['Float']['input']>;
  notifyConfigID?: InputMaybe<Scalars['ID']['input']>;
  notifyEventOptionID?: InputMaybe<Scalars['ID']['input']>;
  speedToleranceKnots?: InputMaybe<Scalars['Float']['input']>;
  timeToleranceSeconds?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTimeSeconds?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * UpdateNotifyConfigGeofenceInput is used for update NotifyConfigGeofence object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigGeofenceInput = {
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  notifyConfigID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyConfigInput is used for update NotifyConfig object.
 * Input was generated by ent.
 */
export type UpdateNotifyConfigInput = {
  addChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  alertWindow?: InputMaybe<Scalars['Boolean']['input']>;
  alertWindowEnd?: InputMaybe<Scalars['TimeOnly']['input']>;
  alertWindowStart?: InputMaybe<Scalars['TimeOnly']['input']>;
  /** Offset in minutes from UTC for alert window start and end times */
  alertWindowToUtcOffset?: InputMaybe<Scalars['Int']['input']>;
  autoAddNewDevices?: InputMaybe<Scalars['Boolean']['input']>;
  autoAddNewGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  clearAlertWindowEnd?: InputMaybe<Scalars['Boolean']['input']>;
  clearAlertWindowStart?: InputMaybe<Scalars['Boolean']['input']>;
  clearChannels?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearEvents?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDuplicateForSeconds?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<NotifyConfigPriority>;
  removeChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeEventIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateNotifyEventOptionInput is used for update NotifyEventOption object.
 * Input was generated by ent.
 */
export type UpdateNotifyEventOptionInput = {
  acceptableMax?: InputMaybe<Scalars['Boolean']['input']>;
  acceptableMaxLabel?: InputMaybe<Scalars['String']['input']>;
  acceptableMin?: InputMaybe<Scalars['Boolean']['input']>;
  acceptableMinLabel?: InputMaybe<Scalars['String']['input']>;
  addNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearNotifyConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceMetersLabel?: InputMaybe<Scalars['String']['input']>;
  distanceToleranceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceToleranceMetersLabel?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  /** Source of event for backend processing */
  kind?: InputMaybe<NotifyEventOptionKind>;
  /** label to display in UI */
  label?: InputMaybe<Scalars['String']['input']>;
  removeNotifyConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  speedToleranceKnots?: InputMaybe<Scalars['Boolean']['input']>;
  speedToleranceKnotsLabel?: InputMaybe<Scalars['String']['input']>;
  timeToleranceSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  timeToleranceSecondsLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTimeSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  waitTimeSecondsLabel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateOrganisationInput is used for update Organisation object.
 * Input was generated by ent.
 */
export type UpdateOrganisationInput = {
  addAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addBaselicenseplanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addChildOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicegroupsRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDevicesRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addExportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addInspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addKmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLeaveTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLegacysyncIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLicenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLicenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMapGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganistionroleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRosterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRosterScheduleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRouteHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRouteHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRouteTimeLineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSimIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addStiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addSubOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripHaltPointTargetTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripHaltPointTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUpgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardDriverProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardMaterialTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVehicleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardVendorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowChildCreation?: InputMaybe<Scalars['Boolean']['input']>;
  availableLicenses?: InputMaybe<Scalars['Int']['input']>;
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressCountry?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingAddressState?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  billingGstin?: InputMaybe<Scalars['String']['input']>;
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  centralisedWallet?: InputMaybe<Scalars['Boolean']['input']>;
  clearAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  clearBaselicenseplan?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressCity?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressCountry?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressLine1?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressLine2?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingAddressState?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clearBillingGstin?: InputMaybe<Scalars['Boolean']['input']>;
  clearBoltLegacyID?: InputMaybe<Scalars['Boolean']['input']>;
  clearChildOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicegroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicegroupsRoot?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevicesRoot?: InputMaybe<Scalars['Boolean']['input']>;
  clearExport?: InputMaybe<Scalars['Boolean']['input']>;
  clearGeofenceDeviceGroups?: InputMaybe<Scalars['Boolean']['input']>;
  clearHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  clearInspectionReports?: InputMaybe<Scalars['Boolean']['input']>;
  clearKmls?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveTypes?: InputMaybe<Scalars['Boolean']['input']>;
  clearLegacysync?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicense?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicenseOrders?: InputMaybe<Scalars['Boolean']['input']>;
  clearMapGeofences?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationDeviceDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationDeviceGroupDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationupgrade?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganistionroles?: InputMaybe<Scalars['Boolean']['input']>;
  clearParentOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearRootOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearRosterSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  clearRosters?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteHaltPointTargets?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteTimeLine?: InputMaybe<Scalars['Boolean']['input']>;
  clearRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  clearShifts?: InputMaybe<Scalars['Boolean']['input']>;
  clearSim?: InputMaybe<Scalars['Boolean']['input']>;
  clearStiqrs?: InputMaybe<Scalars['Boolean']['input']>;
  clearSubOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  clearTargets?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripHaltPointTarget?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripHaltPointTargetTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripHaltPointTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpgradeorganisationprice?: InputMaybe<Scalars['Boolean']['input']>;
  clearWallet?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardDriverProfiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardMaterialType?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardVendors?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseActivityTypes?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDockSharing?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseParkings?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouses?: InputMaybe<Scalars['Boolean']['input']>;
  deviceLimit?: InputMaybe<Scalars['Int']['input']>;
  ingestServer?: InputMaybe<OrganisationIngestServer>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationLimit?: InputMaybe<Scalars['Int']['input']>;
  parentOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  removeAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeBaselicenseplanIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeChildOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicegroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicegroupsRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDevicesRootIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeExportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeGeofenceDeviceGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeInspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeKmlIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLeaveTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLegacysyncIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLicenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLicenseOrderIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMapGeofenceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationDeviceDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationDeviceGroupDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganistionroleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRosterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRosterScheduleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRouteHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRouteHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRouteTimeLineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSimIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeStiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeSubOrganisationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripHaltPointTargetTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripHaltPointTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUpgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardDriverProfileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardMaterialTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVehicleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardVendorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rootOrganisationID?: InputMaybe<Scalars['ID']['input']>;
  totalLicenses?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateOrganisationReportAccessInput is used for update OrganisationReportAccess object.
 * Input was generated by ent.
 */
export type UpdateOrganisationReportAccessInput = {
  derivedReportID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateOrganisationRoleInput is used for update OrganisationRole object.
 * Input was generated by ent.
 */
export type UpdateOrganisationRoleInput = {
  addOrganisationRolePermissionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearOrganisationRolePermissions?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  clearPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  removeOrganisationRolePermissionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateOrganisationRolePermissionInput is used for update OrganisationRolePermission object.
 * Input was generated by ent.
 */
export type UpdateOrganisationRolePermissionInput = {
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  edit?: InputMaybe<Scalars['Boolean']['input']>;
  organisationRoleID?: InputMaybe<Scalars['ID']['input']>;
  permissionID?: InputMaybe<Scalars['ID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateOrganisationUpgradeInput is used for update OrganisationUpgrade object.
 * Input was generated by ent.
 */
export type UpdateOrganisationUpgradeInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<OrganisationUpgradeStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateOrganisationUserDocumentInput is used for update OrganisationUserDocument object.
 * Input was generated by ent.
 */
export type UpdateOrganisationUserDocumentInput = {
  attachment?: InputMaybe<Scalars['String']['input']>;
  organisationuserID?: InputMaybe<Scalars['ID']['input']>;
  organisationuserdocumenttypeID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  verificationStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdateOrganisationUserDocumentTypeInput is used for update OrganisationUserDocumentType object.
 * Input was generated by ent.
 */
export type UpdateOrganisationUserDocumentTypeInput = {
  addOrganisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearOrganisationuserDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeOrganisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateOrganisationUserInput is used for update OrganisationUser object.
 * Input was generated by ent.
 */
export type UpdateOrganisationUserInput = {
  addDeviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addStiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  boltLegacyID?: InputMaybe<Scalars['String']['input']>;
  clearBoltLegacyID?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceacls?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriverprofiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationuserDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  clearShifts?: InputMaybe<Scalars['Boolean']['input']>;
  clearStiqrs?: InputMaybe<Scalars['Boolean']['input']>;
  driverprofilesID?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeDeviceaclIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationuserDocumentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeStiqrIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  userType?: InputMaybe<OrganisationUserUserType>;
};

/**
 * UpdatePeriodicJobInput is used for update PeriodicJob object.
 * Input was generated by ent.
 */
export type UpdatePeriodicJobInput = {
  clearLastRunAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastTaskResponse?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextRunAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearParams?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastRunAt?: InputMaybe<Scalars['Time']['input']>;
  lastTaskResponse?: InputMaybe<Scalars['JSON']['input']>;
  nextRunAt?: InputMaybe<Scalars['Time']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  queueName?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdatePermissionInput is used for update Permission object.
 * Input was generated by ent.
 */
export type UpdatePermissionInput = {
  createLabel?: InputMaybe<Scalars['String']['input']>;
  deleteLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editLabel?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<PermissionGroup>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<PermissionName>;
  readLabel?: InputMaybe<Scalars['String']['input']>;
  showCreate?: InputMaybe<Scalars['Boolean']['input']>;
  showDelete?: InputMaybe<Scalars['Boolean']['input']>;
  showEdit?: InputMaybe<Scalars['Boolean']['input']>;
  showRead?: InputMaybe<Scalars['Boolean']['input']>;
  sorter?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdatePinnedDevicesInput is used for update PinnedDevices object.
 * Input was generated by ent.
 */
export type UpdatePinnedDevicesInput = {
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdatePoiInput is used for update Poi object.
 * Input was generated by ent.
 */
export type UpdatePoiInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconColor?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdatePositionAttributeFormulaInput is used for update PositionAttributeFormula object.
 * Input was generated by ent.
 */
export type UpdatePositionAttributeFormulaInput = {
  attribute?: InputMaybe<PositionAttributeFormulaAttribute>;
  deviceID?: InputMaybe<Scalars['ID']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateProfileInput is used for update Profile object.
 * Input was generated by ent.
 */
export type UpdateProfileInput = {
  addGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  baseLocation?: InputMaybe<Scalars['String']['input']>;
  bloodGroup?: InputMaybe<Scalars['String']['input']>;
  clearGroups?: InputMaybe<Scalars['Boolean']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  employeeNo?: InputMaybe<Scalars['String']['input']>;
  organisationusersID?: InputMaybe<Scalars['ID']['input']>;
  removeGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  supervisorPhonenumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdatePusherConfigInput is used for update PusherConfig object.
 * Input was generated by ent.
 */
export type UpdatePusherConfigInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  adminID?: InputMaybe<Scalars['Int']['input']>;
  allData?: InputMaybe<Scalars['Boolean']['input']>;
  allDevices?: InputMaybe<Scalars['Boolean']['input']>;
  apiExtra?: InputMaybe<Scalars['String']['input']>;
  apiKeyName?: InputMaybe<Scalars['String']['input']>;
  apiKeySecret?: InputMaybe<Scalars['String']['input']>;
  apiSkipSsl?: InputMaybe<Scalars['Boolean']['input']>;
  apiTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  appendDeviceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  clearAPIExtra?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIKeyName?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIKeySecret?: InputMaybe<Scalars['Boolean']['input']>;
  clearAPIURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearAdminID?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastFailedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastResponse?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastSuccessAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearNextAttemptAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  headers?: InputMaybe<Scalars['JSON']['input']>;
  lastFailedAt?: InputMaybe<Scalars['Time']['input']>;
  lastResponse?: InputMaybe<Scalars['String']['input']>;
  lastSuccessAt?: InputMaybe<Scalars['Time']['input']>;
  nextAttemptAt?: InputMaybe<Scalars['Time']['input']>;
  pauseOnFailureSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicBatchSeconds?: InputMaybe<Scalars['Int']['input']>;
  periodicMaxBatchSize?: InputMaybe<Scalars['Int']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PusherConfigType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  withAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * UpdatePusherLogInput is used for update PusherLog object.
 * Input was generated by ent.
 */
export type UpdatePusherLogInput = {
  clearDeviceID?: InputMaybe<Scalars['Boolean']['input']>;
  clearImei?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearResponseCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearResponseData?: InputMaybe<Scalars['Boolean']['input']>;
  clearResponseSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  clearSentData?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  deviceID?: InputMaybe<Scalars['Int']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  responseCode?: InputMaybe<Scalars['Int']['input']>;
  responseData?: InputMaybe<Scalars['String']['input']>;
  responseSeconds?: InputMaybe<Scalars['Int']['input']>;
  sentData?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateRosterInput is used for update Roster object.
 * Input was generated by ent.
 */
export type UpdateRosterInput = {
  addRosterShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearRosterShifts?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeRosterShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rosterDate?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateRosterScheduleInput is used for update RosterSchedule object.
 * Input was generated by ent.
 */
export type UpdateRosterScheduleInput = {
  addUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearShift2EndTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearShift2StartTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearShift3EndTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearShift3StartTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpdatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearUsers?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  shift1EndTime?: InputMaybe<Scalars['Time']['input']>;
  shift1StartTime?: InputMaybe<Scalars['Time']['input']>;
  shift2EndTime?: InputMaybe<Scalars['Time']['input']>;
  shift2StartTime?: InputMaybe<Scalars['Time']['input']>;
  shift3EndTime?: InputMaybe<Scalars['Time']['input']>;
  shift3StartTime?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  weekday?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateRosterShiftInput is used for update RosterShift object.
 * Input was generated by ent.
 */
export type UpdateRosterShiftInput = {
  addAttendanceDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAttendanceDetails?: InputMaybe<Scalars['Boolean']['input']>;
  clearScheduledEndTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearScheduledStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  removeAttendanceDetailIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rosterID?: InputMaybe<Scalars['ID']['input']>;
  scheduledEndTime?: InputMaybe<Scalars['Time']['input']>;
  scheduledStartTime?: InputMaybe<Scalars['Time']['input']>;
  shiftNumber?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateRouteHaltPointInput is used for update RouteHaltPoint object.
 * Input was generated by ent.
 */
export type UpdateRouteHaltPointInput = {
  addRouteHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearEndTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteHaltPointTargets?: InputMaybe<Scalars['Boolean']['input']>;
  clearSequence?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearWaitTime?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  haltPointID?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeRouteHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  waitTime?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * UpdateRouteHaltPointTargetInput is used for update RouteHaltPointTarget object.
 * Input was generated by ent.
 */
export type UpdateRouteHaltPointTargetInput = {
  clearExternalTargetID?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearPlannedQty?: InputMaybe<Scalars['Boolean']['input']>;
  clearPlannedUnit?: InputMaybe<Scalars['Boolean']['input']>;
  externalTargetID?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  plannedQty?: InputMaybe<Scalars['Int']['input']>;
  plannedUnit?: InputMaybe<Scalars['String']['input']>;
  routeHaltPointsID?: InputMaybe<Scalars['ID']['input']>;
  taskType?: InputMaybe<RouteHaltPointTargetTaskType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateRouteInput is used for update Route object.
 * Input was generated by ent.
 */
export type UpdateRouteInput = {
  addRouteHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRouteShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRouteTimeLineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDistance?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndLocation?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstimatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteShifts?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteTimeLines?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartLocation?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusName?: InputMaybe<Scalars['Boolean']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  endLocation?: InputMaybe<Scalars['String']['input']>;
  estimatedTime?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeRouteHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRouteShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRouteTimeLineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceType?: InputMaybe<RouteServiceType>;
  startLocation?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<RouteStatusName>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateRouteShiftInput is used for update RouteShift object.
 * Input was generated by ent.
 */
export type UpdateRouteShiftInput = {
  routeID?: InputMaybe<Scalars['ID']['input']>;
  shiftID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateRouteTimeLineInput is used for update RouteTimeLine object.
 * Input was generated by ent.
 */
export type UpdateRouteTimeLineInput = {
  clearRemarks?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  routeID?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateScheduleTaskInput is used for update ScheduleTask object.
 * Input was generated by ent.
 */
export type UpdateScheduleTaskInput = {
  clearEta?: InputMaybe<Scalars['Boolean']['input']>;
  clearFailureReason?: InputMaybe<Scalars['Boolean']['input']>;
  clearImpersonatedUserID?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearParameters?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  eta?: InputMaybe<Scalars['Time']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  queueName?: InputMaybe<ScheduleTaskQueueName>;
  status?: InputMaybe<ScheduleTaskStatus>;
  taskFailed?: InputMaybe<Scalars['Boolean']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateSettingInput is used for update Setting object.
 * Input was generated by ent.
 */
export type UpdateSettingInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateShiftInput is used for update Shift object.
 * Input was generated by ent.
 */
export type UpdateShiftInput = {
  addRouteShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendExdates?: InputMaybe<Array<Scalars['String']['input']>>;
  appendRdates?: InputMaybe<Array<Scalars['String']['input']>>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriver?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearExdates?: InputMaybe<Scalars['Boolean']['input']>;
  clearRdates?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecurrenceEnd?: InputMaybe<Scalars['Boolean']['input']>;
  clearRecurrenceStart?: InputMaybe<Scalars['Boolean']['input']>;
  clearRouteShifts?: InputMaybe<Scalars['Boolean']['input']>;
  clearRrule?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  clearVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driverID?: InputMaybe<Scalars['ID']['input']>;
  /** End time of shift */
  endTime?: InputMaybe<Scalars['Time']['input']>;
  /** Exception dates - ISO 8601 date strings to exclude from recurrence (EXDATE) */
  exdates?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  /** Additional dates - ISO 8601 date strings to include in recurrence (RDATE) */
  rdates?: InputMaybe<Array<Scalars['String']['input']>>;
  /** End date/time for the recurring pattern (UNTIL), null for infinite */
  recurrenceEnd?: InputMaybe<Scalars['Time']['input']>;
  /** Start date/time for the recurring pattern (DTSTART) */
  recurrenceStart?: InputMaybe<Scalars['Time']['input']>;
  removeRouteShiftIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** iCalendar RRULE string (e.g., 'FREQ=WEEKLY;BYDAY=MO,WE,FR;INTERVAL=1') */
  rrule?: InputMaybe<Scalars['String']['input']>;
  /** Start time of shift */
  startTime?: InputMaybe<Scalars['Time']['input']>;
  /** Timezone for recurrence calculations (e.g., 'America/New_York') */
  timezone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateSimInput is used for update Sim object.
 * Input was generated by ent.
 */
export type UpdateSimInput = {
  activationDate?: InputMaybe<Scalars['Time']['input']>;
  clearActivationDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearDevices?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  clearPurchaseDate?: InputMaybe<Scalars['Boolean']['input']>;
  devicesID?: InputMaybe<Scalars['ID']['input']>;
  imsi?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  purchaseDate?: InputMaybe<Scalars['Time']['input']>;
  simNumber?: InputMaybe<Scalars['String']['input']>;
  simOperator?: InputMaybe<SimSimOperator>;
  status?: InputMaybe<SimStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateStaffRoleInput is used for update StaffRole object.
 * Input was generated by ent.
 */
export type UpdateStaffRoleInput = {
  addUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  clearUsers?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['JSON']['input']>;
  removeUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateStiQRInput is used for update StiQR object.
 * Input was generated by ent.
 */
export type UpdateStiQrInput = {
  activatedOn?: InputMaybe<Scalars['Time']['input']>;
  clearActivatedOn?: InputMaybe<Scalars['Boolean']['input']>;
  clearContactNumber?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceCategory?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmergencyContactNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  clearName?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationUser?: InputMaybe<Scalars['Boolean']['input']>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  deviceCategoryID?: InputMaybe<Scalars['ID']['input']>;
  deviceGroupID?: InputMaybe<Scalars['ID']['input']>;
  emergencyContactNumbers?: InputMaybe<Scalars['JSON']['input']>;
  enableMasked?: InputMaybe<Scalars['Boolean']['input']>;
  enableSms?: InputMaybe<Scalars['Boolean']['input']>;
  enableVoip?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSubscriptionLicenseOrderInput is used for update SubscriptionLicenseOrder object.
 * Input was generated by ent.
 */
export type UpdateSubscriptionLicenseOrderInput = {
  addLicenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLicenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  baselicenseplanID?: InputMaybe<Scalars['ID']['input']>;
  clearLicenseorderaddons?: InputMaybe<Scalars['Boolean']['input']>;
  clearLicenses?: InputMaybe<Scalars['Boolean']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  perUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  removeLicenseIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLicenseorderaddonIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<SubscriptionLicenseOrderStatus>;
  tenure?: InputMaybe<Scalars['Int']['input']>;
  tenureUnit?: InputMaybe<SubscriptionLicenseOrderTenureUnit>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSupportDocumentInput is used for update SupportDocument object.
 * Input was generated by ent.
 */
export type UpdateSupportDocumentInput = {
  clearMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  nchunk?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateSupportTicketInput is used for update SupportTicket object.
 * Input was generated by ent.
 */
export type UpdateSupportTicketInput = {
  attachmentUrls?: InputMaybe<Scalars['JSON']['input']>;
  category?: InputMaybe<SupportTicketCategory>;
  clearAttachmentUrls?: InputMaybe<Scalars['Boolean']['input']>;
  clearImpersonatedUserID?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationID?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  impersonatedUserID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SupportTicketStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateTargetInput is used for update Target object.
 * Input was generated by ent.
 */
export type UpdateTargetInput = {
  addHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Scalars['Map']['input']>;
  clearAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  clearHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  clearLoad?: InputMaybe<Scalars['Boolean']['input']>;
  clearOwner?: InputMaybe<Scalars['Boolean']['input']>;
  clearPhone?: InputMaybe<Scalars['Boolean']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  load?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  removeHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetType?: InputMaybe<TargetTargetType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTripConfigsInput is used for update TripConfigs object.
 * Input was generated by ent.
 */
export type UpdateTripConfigsInput = {
  clearDeviceCategory?: InputMaybe<Scalars['Boolean']['input']>;
  clearDropGeofenceRadius?: InputMaybe<Scalars['Boolean']['input']>;
  clearPickUpGeofenceRadius?: InputMaybe<Scalars['Boolean']['input']>;
  clearTargetAttributesConfig?: InputMaybe<Scalars['Boolean']['input']>;
  deviceCategory?: InputMaybe<Scalars['String']['input']>;
  dropGeofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  pickUpGeofenceRadius?: InputMaybe<Scalars['Float']['input']>;
  targetAttributesConfig?: InputMaybe<Scalars['Map']['input']>;
  targetTypes?: InputMaybe<TripConfigsTargetTypes>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTripHaltPointInput is used for update TripHaltPoint object.
 * Input was generated by ent.
 */
export type UpdateTripHaltPointInput = {
  addTripHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripHaltPointTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  clearAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearHaltName?: InputMaybe<Scalars['Boolean']['input']>;
  clearPlannedTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusName?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripHaltPointTarget?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripHaltPointTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  clearWindowEnd?: InputMaybe<Scalars['Boolean']['input']>;
  clearWindowStart?: InputMaybe<Scalars['Boolean']['input']>;
  haltName?: InputMaybe<Scalars['String']['input']>;
  haltPointID?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  plannedTime?: InputMaybe<Scalars['String']['input']>;
  removeTripHaltPointTargetIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripHaltPointTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  statusName?: InputMaybe<TripHaltPointStatusName>;
  tripID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  windowEnd?: InputMaybe<Scalars['Time']['input']>;
  windowStart?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTripHaltPointTargetInput is used for update TripHaltPointTarget object.
 * Input was generated by ent.
 */
export type UpdateTripHaltPointTargetInput = {
  addTripHaltPointTargetTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  attributes?: InputMaybe<Scalars['Map']['input']>;
  clearAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalTargetID?: InputMaybe<Scalars['Boolean']['input']>;
  clearNoShowReason?: InputMaybe<Scalars['Boolean']['input']>;
  clearProofOfDrop?: InputMaybe<Scalars['Boolean']['input']>;
  clearProofOfDropTimestamp?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemarks?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusName?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripHaltPointTargetTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalTargetID?: InputMaybe<Scalars['ID']['input']>;
  noShowReason?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  proofOfDrop?: InputMaybe<Scalars['String']['input']>;
  proofOfDropTimestamp?: InputMaybe<Scalars['Time']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  removeTripHaltPointTargetTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeHaltTargetID?: InputMaybe<Scalars['ID']['input']>;
  statusName?: InputMaybe<TripHaltPointTargetStatusName>;
  targetID?: InputMaybe<Scalars['ID']['input']>;
  targetName?: InputMaybe<Scalars['String']['input']>;
  targetPhone?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<TripHaltPointTargetTaskType>;
  tripHaltID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateTripHaltPointTargetTimeLineInput is used for update TripHaltPointTargetTimeLine object.
 * Input was generated by ent.
 */
export type UpdateTripHaltPointTargetTimeLineInput = {
  actualQty?: InputMaybe<Scalars['Int']['input']>;
  actualUnit?: InputMaybe<Scalars['String']['input']>;
  clearActualQty?: InputMaybe<Scalars['Boolean']['input']>;
  clearActualUnit?: InputMaybe<Scalars['Boolean']['input']>;
  clearPhotoURL?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemarks?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusName?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  eventTime?: InputMaybe<Scalars['Time']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  photoURL?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<TripHaltPointTargetTimeLineStatusName>;
  tripHaltTargetID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateTripHaltPointTimeLineInput is used for update TripHaltPointTimeLine object.
 * Input was generated by ent.
 */
export type UpdateTripHaltPointTimeLineInput = {
  arrivalTime?: InputMaybe<Scalars['Time']['input']>;
  clearArrivalTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearDepartureTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearRemarks?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusName?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  departureTime?: InputMaybe<Scalars['Time']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<TripHaltPointTimeLineStatusName>;
  tripHaltID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateTripInput is used for update Trip object.
 * Input was generated by ent.
 */
export type UpdateTripInput = {
  acceptedAt?: InputMaybe<Scalars['Time']['input']>;
  addTripHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedAt?: InputMaybe<Scalars['Time']['input']>;
  cancelledAt?: InputMaybe<Scalars['Time']['input']>;
  clearAcceptedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearCancelledAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearCreatedByUserID?: InputMaybe<Scalars['Boolean']['input']>;
  clearDistance?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriver?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriverLicenseNo?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriverName?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriverPhone?: InputMaybe<Scalars['Boolean']['input']>;
  clearEndLocation?: InputMaybe<Scalars['Boolean']['input']>;
  clearEstimatedTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearPlannedEndTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearPlannedStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearServiceDate?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartLocation?: InputMaybe<Scalars['Boolean']['input']>;
  clearStartedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusName?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripHaltPoints?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripTimelines?: InputMaybe<Scalars['Boolean']['input']>;
  clearVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  createdByUserID?: InputMaybe<Scalars['ID']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  driverID?: InputMaybe<Scalars['ID']['input']>;
  driverLicenseNo?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  driverPhone?: InputMaybe<Scalars['String']['input']>;
  endLocation?: InputMaybe<Scalars['String']['input']>;
  estimatedTime?: InputMaybe<Scalars['Float']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  plannedEndTime?: InputMaybe<Scalars['Time']['input']>;
  plannedStartTime?: InputMaybe<Scalars['Time']['input']>;
  removeTripHaltPointIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripTimelineIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeID?: InputMaybe<Scalars['ID']['input']>;
  serviceDate?: InputMaybe<Scalars['Time']['input']>;
  startLocation?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['Time']['input']>;
  statusName?: InputMaybe<TripStatusName>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateTripTimeLineInput is used for update TripTimeLine object.
 * Input was generated by ent.
 */
export type UpdateTripTimeLineInput = {
  clearRemarks?: InputMaybe<Scalars['Boolean']['input']>;
  clearStatusName?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<TripTimeLineStatusName>;
  timestamp?: InputMaybe<Scalars['Time']['input']>;
  tripID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  userPhone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateUpgradeInput is used for update Upgrade object.
 * Input was generated by ent.
 */
export type UpdateUpgradeInput = {
  addOrganisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUpgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendFeatures?: InputMaybe<Array<Scalars['String']['input']>>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationupgrade?: InputMaybe<Scalars['Boolean']['input']>;
  clearUpgradeorganisationprice?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  removeOrganisationupgradeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUpgradeorganisationpriceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateUpgradeOrganisationPriceInput is used for update UpgradeOrganisationPrice object.
 * Input was generated by ent.
 */
export type UpdateUpgradeOrganisationPriceInput = {
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateUserConfigInput is used for update UserConfig object.
 * Input was generated by ent.
 */
export type UpdateUserConfigInput = {
  key?: InputMaybe<UserConfigKey>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateUserFcmTokenInput is used for update UserFcmToken object.
 * Input was generated by ent.
 */
export type UpdateUserFcmTokenInput = {
  clearFcmSenderID?: InputMaybe<Scalars['Boolean']['input']>;
  clearInvalidReason?: InputMaybe<Scalars['Boolean']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  fcmValid?: InputMaybe<Scalars['Boolean']['input']>;
  invalidReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateUserInput is used for update User object.
 * Input was generated by ent.
 */
export type UpdateUserInput = {
  addAPIUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addApprovedLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addExportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addInspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLeaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMapConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addMediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addPoiIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRosterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRosterScheduleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addUserLeaveBalanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatusInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatusOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsWarehouseInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsWarehouseOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Address of the user */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Alternate mobile number of the user */
  alternateMobileNumber?: InputMaybe<Scalars['String']['input']>;
  /** City of the user */
  city?: InputMaybe<Scalars['String']['input']>;
  clearAPIUser?: InputMaybe<Scalars['Boolean']['input']>;
  clearAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clearAlternateMobileNumber?: InputMaybe<Scalars['Boolean']['input']>;
  clearApprovedLeaveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  clearAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  clearCity?: InputMaybe<Scalars['Boolean']['input']>;
  clearCountry?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clearExport?: InputMaybe<Scalars['Boolean']['input']>;
  clearFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  clearGender?: InputMaybe<Scalars['Boolean']['input']>;
  clearInspectionReports?: InputMaybe<Scalars['Boolean']['input']>;
  clearLastName?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveDates?: InputMaybe<Scalars['Boolean']['input']>;
  clearLeaveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  clearMapConfig?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafiles?: InputMaybe<Scalars['Boolean']['input']>;
  clearMobileNumber?: InputMaybe<Scalars['Boolean']['input']>;
  clearOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  clearPoi?: InputMaybe<Scalars['Boolean']['input']>;
  clearPostalCode?: InputMaybe<Scalars['Boolean']['input']>;
  clearRoleID?: InputMaybe<Scalars['Boolean']['input']>;
  clearRosterSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  clearRosters?: InputMaybe<Scalars['Boolean']['input']>;
  clearState?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserConfig?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserLeaveBalances?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatusIn?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatusOut?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsIn?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsOut?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsWarehouseIn?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsWarehouseOut?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDockSharing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Country of the user */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserGender>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediafileID?: InputMaybe<Scalars['ID']['input']>;
  /** Mobile number of the user */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  mobileNumberConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Postal code of the user */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  removeAPIUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeApprovedLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeAttendanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeDeviceSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeExportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeInspectionReportIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLeaveDateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeLeaveRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMapConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeMediafileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeOrganisationuserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removePoiIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRosterIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRosterScheduleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserConfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeUserLeaveBalanceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatusInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatusOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsWarehouseInIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsWarehouseOutIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  role?: InputMaybe<UserRole>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  /** State of the user */
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateUserLeaveBalanceInput is used for update UserLeaveBalance object.
 * Input was generated by ent.
 */
export type UpdateUserLeaveBalanceInput = {
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  totalAvailableDays?: InputMaybe<Scalars['Float']['input']>;
  totalRemainingDays?: InputMaybe<Scalars['Float']['input']>;
  totalUsedDays?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * UpdateUserReportBookmarkInput is used for update UserReportBookmark object.
 * Input was generated by ent.
 */
export type UpdateUserReportBookmarkInput = {
  clearLastGeneratedAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearUserID?: InputMaybe<Scalars['Boolean']['input']>;
  derivedReportID?: InputMaybe<Scalars['ID']['input']>;
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  lastGeneratedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateUserRosterAssignmentInput is used for update UserRosterAssignment object.
 * Input was generated by ent.
 */
export type UpdateUserRosterAssignmentInput = {
  rosterScheduleID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWalletInput is used for update Wallet object.
 * Input was generated by ent.
 */
export type UpdateWalletInput = {
  addWalletpaymenttransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWallettransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  autoLoadLimit?: InputMaybe<Scalars['Int']['input']>;
  clearWalletpaymenttransaction?: InputMaybe<Scalars['Boolean']['input']>;
  clearWallettransaction?: InputMaybe<Scalars['Boolean']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  negativeLimit?: InputMaybe<Scalars['Float']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeWalletpaymenttransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWallettransactionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateWalletPaymentTransactionInput is used for update WalletPaymentTransaction object.
 * Input was generated by ent.
 */
export type UpdateWalletPaymentTransactionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  clearProcessorPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  clearProcessorTransactionID?: InputMaybe<Scalars['Boolean']['input']>;
  clearProcessorTransactionStatus?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentProcessor?: InputMaybe<WalletPaymentTransactionPaymentProcessor>;
  processorPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  processorTransactionID?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WalletPaymentTransactionStatus>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  tax?: InputMaybe<Scalars['Float']['input']>;
  transactionDate?: InputMaybe<Scalars['Time']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWalletTransactionInput is used for update WalletTransaction object.
 * Input was generated by ent.
 */
export type UpdateWalletTransactionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearUsageID?: InputMaybe<Scalars['Boolean']['input']>;
  clearUsageType?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<WalletTransactionTransactionType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  usageID?: InputMaybe<Scalars['String']['input']>;
  usageType?: InputMaybe<WalletTransactionUsageType>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWhatsAppConfigInput is used for update WhatsAppConfig object.
 * Input was generated by ent.
 */
export type UpdateWhatsAppConfigInput = {
  clearNotes?: InputMaybe<Scalars['Boolean']['input']>;
  clearPhoneNumberID?: InputMaybe<Scalars['Boolean']['input']>;
  clearToken?: InputMaybe<Scalars['Boolean']['input']>;
  companyID?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['Int']['input']>;
  phoneNumberID?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateWhitelabelConfigInput is used for update WhitelabelConfig object.
 * Input was generated by ent.
 */
export type UpdateWhitelabelConfigInput = {
  appcolorscheme?: InputMaybe<Scalars['JSON']['input']>;
  clearAppColorScheme?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<WhitelabelConfigKey>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWhitelabelCoreSettingOverrideInput is used for update WhitelabelCoreSettingOverride object.
 * Input was generated by ent.
 */
export type UpdateWhitelabelCoreSettingOverrideInput = {
  key?: InputMaybe<WhitelabelCoreSettingOverrideKey>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateWhitelabelInput is used for update Whitelabel object.
 * Input was generated by ent.
 */
export type UpdateWhitelabelInput = {
  addDomainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWhitelabelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addWhitelabelcoresettingoverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  appendEnabledLoginMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  clearDomains?: InputMaybe<Scalars['Boolean']['input']>;
  clearEnabledLoginMethods?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileWhitelabelLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileWhitelabelLogo?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  clearWhitelabelcoresettingoverrides?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Array of enabled methods, options are:
   * 				- email_password
   * 				- email_otp
   * 				- mobile_otp
   */
  enabledLoginMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediafileWhitelabelLoginLogoID?: InputMaybe<Scalars['ID']['input']>;
  mediafileWhitelabelLogoID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeDomainIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWhitelabelconfigIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeWhitelabelcoresettingoverrideIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardDriverProfileInput is used for update YardDriverProfile object.
 * Input was generated by ent.
 */
export type UpdateYardDriverProfileInput = {
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDateOfBirth?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileDlImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  dlExpiry?: InputMaybe<Scalars['Time']['input']>;
  dlNumber?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['Time']['input']>;
  mediafileAvatarID?: InputMaybe<Scalars['ID']['input']>;
  mediafileDlImageID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardMaterialInput is used for update YardMaterial object.
 * Input was generated by ent.
 */
export type UpdateYardMaterialInput = {
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardMaterialType?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  yardMaterialTypeID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardMaterialTypeInput is used for update YardMaterialType object.
 * Input was generated by ent.
 */
export type UpdateYardMaterialTypeInput = {
  addYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardTripApprovalInput is used for update YardTripApproval object.
 * Input was generated by ent.
 */
export type UpdateYardTripApprovalInput = {
  approvalMatrixID?: InputMaybe<Scalars['ID']['input']>;
  clearReviewReason?: InputMaybe<Scalars['Boolean']['input']>;
  clearReviewedBy?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  reviewReason?: InputMaybe<Scalars['String']['input']>;
  reviewedByID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<YardTripApprovalStatus>;
  tripID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardTripInput is used for update YardTrip object.
 * Input was generated by ent.
 */
export type UpdateYardTripInput = {
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedDriverTrackerID?: InputMaybe<Scalars['ID']['input']>;
  assignedRouteID?: InputMaybe<Scalars['ID']['input']>;
  assignedTrackerBatteryLevel?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerID?: InputMaybe<Scalars['ID']['input']>;
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  clearAssignedDriverTracker?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedRoute?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedTracker?: InputMaybe<Scalars['Boolean']['input']>;
  clearAssignedTrackerBatteryLevel?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckinTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckoutTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearDeclaredMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  clearDriver?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearParking?: InputMaybe<Scalars['Boolean']['input']>;
  clearParkingInTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearParkingOutTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearPurpose?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripStatusCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  clearTripStatusLast?: InputMaybe<Scalars['Boolean']['input']>;
  clearVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  clearVendor?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarehouseInBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarehouseInTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarehouseOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearWarehouseOutTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  declaredMaterialID?: InputMaybe<Scalars['ID']['input']>;
  driverID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  parkingID?: InputMaybe<Scalars['ID']['input']>;
  parkingInTime?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTime?: InputMaybe<Scalars['Time']['input']>;
  purpose?: InputMaybe<YardTripPurpose>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripStatus?: InputMaybe<YardTripTripStatus>;
  tripStatusCurrentID?: InputMaybe<Scalars['ID']['input']>;
  tripStatusLastID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
  vendorID?: InputMaybe<Scalars['ID']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseInByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseInTime?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseOutTime?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardTripStatusInput is used for update YardTripStatus object.
 * Input was generated by ent.
 */
export type UpdateYardTripStatusInput = {
  activityStartTime?: InputMaybe<Scalars['Time']['input']>;
  activityTypeID?: InputMaybe<Scalars['ID']['input']>;
  addYardTripsCurrentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripsLastIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  clearActivityStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearActivityType?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckInBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckinTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearCheckoutTime?: InputMaybe<Scalars['Boolean']['input']>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripsLast?: InputMaybe<Scalars['Boolean']['input']>;
  dockID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  materialID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripsCurrentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripsLastIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routePathID?: InputMaybe<Scalars['ID']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<YardTripStatusStatus>;
  tripID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardVehicleInput is used for update YardVehicle object.
 * Input was generated by ent.
 */
export type UpdateYardVehicleInput = {
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearInsuranceExpiry?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileVehicleInsuranceImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileVehiclePollutionImage?: InputMaybe<Scalars['Boolean']['input']>;
  clearMediafileVehicleRc?: InputMaybe<Scalars['Boolean']['input']>;
  clearPollutionExpiry?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceExpiry?: InputMaybe<Scalars['Time']['input']>;
  lastUpdated?: InputMaybe<Scalars['Time']['input']>;
  mediafileVehicleInsuranceImageID?: InputMaybe<Scalars['ID']['input']>;
  mediafileVehiclePollutionImageID?: InputMaybe<Scalars['ID']['input']>;
  mediafileVehicleRcID?: InputMaybe<Scalars['ID']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  pollutionExpiry?: InputMaybe<Scalars['Time']['input']>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleRcExpiry?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateYardVendorInput is used for update YardVendor object.
 * Input was generated by ent.
 */
export type UpdateYardVendorInput = {
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  vendorCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateYardWarehouseActivityTypeInput is used for update YardWarehouseActivityType object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseActivityTypeInput = {
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseApprovalMatrixInput is used for update YardWarehouseApprovalMatrix object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseApprovalMatrixInput = {
  addPreApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvalMatrixID?: InputMaybe<Scalars['ID']['input']>;
  clearApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removePreApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseDockInput is used for update YardWarehouseDock object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseDockInput = {
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDockSharing?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  dockType?: InputMaybe<YardWarehouseDockDockType>;
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockSharingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseDockSharingInput is used for update YardWarehouseDockSharing object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseDockSharingInput = {
  clearExpiresOn?: InputMaybe<Scalars['Boolean']['input']>;
  dockID?: InputMaybe<Scalars['ID']['input']>;
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationUserID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardWarehouseInput is used for update YardWarehouse object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseInput = {
  addYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseActivityTypes?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseParkings?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripApprovalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseActivityTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseApprovalMatrixIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseDockIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseParkingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRouteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * UpdateYardWarehouseParkingInput is used for update YardWarehouseParking object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseParkingInput = {
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  slotName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseRouteInput is used for update YardWarehouseRoute object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseRouteInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addPreferredYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearPreferredYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  clearPrimaryDock?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  ensureOrder?: InputMaybe<Scalars['Boolean']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  primaryDockID?: InputMaybe<Scalars['ID']['input']>;
  removePreferredYardMaterialIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardTripIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeYardWarehouseRoutePathIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeType?: InputMaybe<YardWarehouseRouteRouteType>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * UpdateYardWarehouseRoutePathInput is used for update YardWarehouseRoutePath object.
 * Input was generated by ent.
 */
export type UpdateYardWarehouseRoutePathInput = {
  addYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearExternalID?: InputMaybe<Scalars['Boolean']['input']>;
  clearYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  dockID?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  maxWaitTime?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  removeYardTripStatuIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

export type Upgrade = Node & {
  __typename?: 'Upgrade';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  iconID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  integrationCode: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  mediafile?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  organisationupgrade?: Maybe<Array<OrganisationUpgrade>>;
  percentPerUnit: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  upgradeorganisationprice?: Maybe<Array<UpgradeOrganisationPrice>>;
};

/** A connection to a list of items. */
export type UpgradeConnection = {
  __typename?: 'UpgradeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UpgradeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UpgradeEdge = {
  __typename?: 'UpgradeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Upgrade>;
};

export enum UpgradeField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Features = 'features',
  IconId = 'iconID',
  IntegrationCode = 'integrationCode',
  IsActive = 'isActive',
  Name = 'name',
  PercentPerUnit = 'percentPerUnit',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Upgrade connections */
export type UpgradeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Upgrades. */
  field: UpgradeOrderField;
};

/** Properties by which Upgrade connections can be ordered. */
export enum UpgradeOrderField {
  Description = 'DESCRIPTION',
  IntegrationCode = 'INTEGRATION_CODE',
  Name = 'NAME',
  PercentPerUnit = 'PERCENT_PER_UNIT',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type UpgradeOrganisationPrice = Node & {
  __typename?: 'UpgradeOrganisationPrice';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  percentPerUnit: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  upgrade: Upgrade;
  upgradeID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type UpgradeOrganisationPriceConnection = {
  __typename?: 'UpgradeOrganisationPriceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UpgradeOrganisationPriceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UpgradeOrganisationPriceEdge = {
  __typename?: 'UpgradeOrganisationPriceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UpgradeOrganisationPrice>;
};

export enum UpgradeOrganisationPriceField {
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  PercentPerUnit = 'percentPerUnit',
  UpdatedAt = 'updatedAt',
  UpgradeId = 'upgradeID'
}

/** Ordering options for UpgradeOrganisationPrice connections */
export type UpgradeOrganisationPriceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UpgradeOrganisationPrices. */
  field: UpgradeOrganisationPriceOrderField;
};

/** Properties by which UpgradeOrganisationPrice connections can be ordered. */
export enum UpgradeOrganisationPriceOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UpgradeOrganisationPriceWhereInput is used for filtering UpgradeOrganisationPrice objects.
 * Input was generated by ent.
 */
export type UpgradeOrganisationPriceWhereInput = {
  and?: InputMaybe<Array<UpgradeOrganisationPriceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** upgrade edge predicates */
  hasUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeWith?: InputMaybe<Array<UpgradeWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UpgradeOrganisationPriceWhereInput>;
  or?: InputMaybe<Array<UpgradeOrganisationPriceWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** percent_per_unit field predicates */
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitGT?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitGTE?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  percentPerUnitLT?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitLTE?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitNEQ?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** upgrade_id field predicates */
  upgradeID?: InputMaybe<Scalars['ID']['input']>;
  upgradeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  upgradeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  upgradeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpgradeWhereInput is used for filtering Upgrade objects.
 * Input was generated by ent.
 */
export type UpgradeWhereInput = {
  and?: InputMaybe<Array<UpgradeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisationupgrade edge predicates */
  hasOrganisationupgrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationupgradeWith?: InputMaybe<Array<OrganisationUpgradeWhereInput>>;
  /** upgradeorganisationprice edge predicates */
  hasUpgradeorganisationprice?: InputMaybe<Scalars['Boolean']['input']>;
  hasUpgradeorganisationpriceWith?: InputMaybe<Array<UpgradeOrganisationPriceWhereInput>>;
  /** icon_id field predicates */
  iconID?: InputMaybe<Scalars['ID']['input']>;
  iconIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  iconIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  iconIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  iconIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  iconIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** integration_code field predicates */
  integrationCode?: InputMaybe<Scalars['String']['input']>;
  integrationCodeContains?: InputMaybe<Scalars['String']['input']>;
  integrationCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  integrationCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  integrationCodeGT?: InputMaybe<Scalars['String']['input']>;
  integrationCodeGTE?: InputMaybe<Scalars['String']['input']>;
  integrationCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  integrationCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  integrationCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationCodeLT?: InputMaybe<Scalars['String']['input']>;
  integrationCodeLTE?: InputMaybe<Scalars['String']['input']>;
  integrationCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  integrationCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<UpgradeWhereInput>;
  or?: InputMaybe<Array<UpgradeWhereInput>>;
  /** percent_per_unit field predicates */
  percentPerUnit?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitGT?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitGTE?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  percentPerUnitLT?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitLTE?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitNEQ?: InputMaybe<Scalars['Float']['input']>;
  percentPerUnitNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type User = Node & {
  __typename?: 'User';
  /** Address of the user */
  address?: Maybe<Scalars['String']['output']>;
  /** Alternate mobile number of the user */
  alternateMobileNumber?: Maybe<Scalars['String']['output']>;
  apiUser?: Maybe<Array<ApiUser>>;
  approvedLeaveRequests?: Maybe<Array<LeaveRequest>>;
  attendances?: Maybe<Array<Attendance>>;
  avatarID?: Maybe<Scalars['ID']['output']>;
  /** City of the user */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of the user */
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  dateJoined: Scalars['Time']['output'];
  deviceSharings?: Maybe<Array<DeviceSharing>>;
  /** Email address of the user */
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmed: Scalars['Boolean']['output'];
  export?: Maybe<Array<Export>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserGender>;
  id: Scalars['ID']['output'];
  inspectionReports?: Maybe<Array<InspectionReport>>;
  isActive: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['Time']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leaveDates?: Maybe<Array<LeaveDate>>;
  leaveRequests?: Maybe<Array<LeaveRequest>>;
  mapConfig?: Maybe<Array<MapConfig>>;
  mediafile?: Maybe<MediaFile>;
  mediafiles?: Maybe<Array<MediaFile>>;
  /** Mobile number of the user */
  mobileNumber?: Maybe<Scalars['String']['output']>;
  mobileNumberConfirmed: Scalars['Boolean']['output'];
  organisationusers?: Maybe<Array<OrganisationUser>>;
  poi?: Maybe<Array<Poi>>;
  /** Postal code of the user */
  postalCode?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  roleID?: Maybe<Scalars['ID']['output']>;
  rosterSchedules?: Maybe<Array<RosterSchedule>>;
  rosters?: Maybe<Array<Roster>>;
  staffRoleID?: Maybe<Scalars['ID']['output']>;
  /** State of the user */
  state?: Maybe<Scalars['String']['output']>;
  trips?: Maybe<Array<Trip>>;
  updatedAt: Scalars['Time']['output'];
  userConfig?: Maybe<Array<UserConfig>>;
  userLeaveBalances?: Maybe<Array<UserLeaveBalance>>;
  userRosterAssignments?: Maybe<Array<UserRosterAssignment>>;
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
  yardTripStatusIn?: Maybe<Array<YardTripStatus>>;
  yardTripStatusOut?: Maybe<Array<YardTripStatus>>;
  yardTripsIn?: Maybe<Array<YardTrip>>;
  yardTripsOut?: Maybe<Array<YardTrip>>;
  yardTripsWarehouseIn?: Maybe<Array<YardTrip>>;
  yardTripsWarehouseOut?: Maybe<Array<YardTrip>>;
  yardWarehouseDockSharing?: Maybe<Array<YardWarehouseDockSharing>>;
};

export type UserConfig = Node & {
  __typename?: 'UserConfig';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: UserConfigKey;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type UserConfigConnection = {
  __typename?: 'UserConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserConfigEdge = {
  __typename?: 'UserConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserConfig>;
};

export enum UserConfigField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  Value = 'value'
}

/** UserConfigKey is enum for the field key */
export enum UserConfigKey {
  DatetimeFormat = 'datetime_format',
  DistanceUnit = 'distance_unit',
  Language = 'language',
  TemperatureUnit = 'temperature_unit',
  Timezone = 'timezone'
}

/** Ordering options for UserConfig connections */
export type UserConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserConfigs. */
  field: UserConfigOrderField;
};

/** Properties by which UserConfig connections can be ordered. */
export enum UserConfigOrderField {
  Key = 'KEY',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UserConfigWhereInput is used for filtering UserConfig objects.
 * Input was generated by ent.
 */
export type UserConfigWhereInput = {
  and?: InputMaybe<Array<UserConfigWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<UserConfigKey>;
  keyIn?: InputMaybe<Array<UserConfigKey>>;
  keyNEQ?: InputMaybe<UserConfigKey>;
  keyNotIn?: InputMaybe<Array<UserConfigKey>>;
  not?: InputMaybe<UserConfigWhereInput>;
  or?: InputMaybe<Array<UserConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserFcmToken = Node & {
  __typename?: 'UserFcmToken';
  createdAt: Scalars['Time']['output'];
  deviceType: Scalars['String']['output'];
  fcmSenderID?: Maybe<Scalars['String']['output']>;
  fcmToken: Scalars['String']['output'];
  fcmValid: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invalidReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type UserFcmTokenConnection = {
  __typename?: 'UserFcmTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserFcmTokenEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserFcmTokenEdge = {
  __typename?: 'UserFcmTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserFcmToken>;
};

export enum UserFcmTokenField {
  CreatedAt = 'createdAt',
  DeviceType = 'deviceType',
  FcmSenderId = 'fcmSenderID',
  FcmToken = 'fcmToken',
  FcmValid = 'fcmValid',
  InvalidReason = 'invalidReason',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for UserFcmToken connections */
export type UserFcmTokenOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserFcmTokens. */
  field: UserFcmTokenOrderField;
};

/** Properties by which UserFcmToken connections can be ordered. */
export enum UserFcmTokenOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UserFcmTokenWhereInput is used for filtering UserFcmToken objects.
 * Input was generated by ent.
 */
export type UserFcmTokenWhereInput = {
  and?: InputMaybe<Array<UserFcmTokenWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** device_type field predicates */
  deviceType?: InputMaybe<Scalars['String']['input']>;
  deviceTypeContains?: InputMaybe<Scalars['String']['input']>;
  deviceTypeContainsFold?: InputMaybe<Scalars['String']['input']>;
  deviceTypeEqualFold?: InputMaybe<Scalars['String']['input']>;
  deviceTypeGT?: InputMaybe<Scalars['String']['input']>;
  deviceTypeGTE?: InputMaybe<Scalars['String']['input']>;
  deviceTypeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  deviceTypeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  deviceTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  deviceTypeLT?: InputMaybe<Scalars['String']['input']>;
  deviceTypeLTE?: InputMaybe<Scalars['String']['input']>;
  deviceTypeNEQ?: InputMaybe<Scalars['String']['input']>;
  deviceTypeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** fcm_sender_id field predicates */
  fcmSenderID?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDContains?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDGT?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDGTE?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmSenderIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  fcmSenderIDLT?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDLTE?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDNEQ?: InputMaybe<Scalars['String']['input']>;
  fcmSenderIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmSenderIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** fcm_token field predicates */
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  fcmTokenContains?: InputMaybe<Scalars['String']['input']>;
  fcmTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  fcmTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  fcmTokenGT?: InputMaybe<Scalars['String']['input']>;
  fcmTokenGTE?: InputMaybe<Scalars['String']['input']>;
  fcmTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fcmTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fcmTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fcmTokenLT?: InputMaybe<Scalars['String']['input']>;
  fcmTokenLTE?: InputMaybe<Scalars['String']['input']>;
  fcmTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  fcmTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** fcm_valid field predicates */
  fcmValid?: InputMaybe<Scalars['Boolean']['input']>;
  fcmValidNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** invalid_reason field predicates */
  invalidReason?: InputMaybe<Scalars['String']['input']>;
  invalidReasonContains?: InputMaybe<Scalars['String']['input']>;
  invalidReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  invalidReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  invalidReasonGT?: InputMaybe<Scalars['String']['input']>;
  invalidReasonGTE?: InputMaybe<Scalars['String']['input']>;
  invalidReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  invalidReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  invalidReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  invalidReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  invalidReasonLT?: InputMaybe<Scalars['String']['input']>;
  invalidReasonLTE?: InputMaybe<Scalars['String']['input']>;
  invalidReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  invalidReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  invalidReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserFcmTokenWhereInput>;
  or?: InputMaybe<Array<UserFcmTokenWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['Int']['input']>;
  userIDGT?: InputMaybe<Scalars['Int']['input']>;
  userIDGTE?: InputMaybe<Scalars['Int']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIDLT?: InputMaybe<Scalars['Int']['input']>;
  userIDLTE?: InputMaybe<Scalars['Int']['input']>;
  userIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum UserField {
  Address = 'address',
  AlternateMobileNumber = 'alternateMobileNumber',
  AvatarId = 'avatarID',
  City = 'city',
  Country = 'country',
  CreatedAt = 'createdAt',
  DateJoined = 'dateJoined',
  Email = 'email',
  EmailConfirmed = 'emailConfirmed',
  FirstName = 'firstName',
  Gender = 'gender',
  IsActive = 'isActive',
  LastLogin = 'lastLogin',
  LastName = 'lastName',
  MobileNumber = 'mobileNumber',
  MobileNumberConfirmed = 'mobileNumberConfirmed',
  Password = 'password',
  PostalCode = 'postalCode',
  Role = 'role',
  RoleId = 'roleID',
  StaffRoleId = 'staffRoleID',
  State = 'state',
  UpdatedAt = 'updatedAt'
}

/** UserGender is enum for the field gender */
export enum UserGender {
  Female = 'Female',
  Male = 'Male',
  Others = 'Others'
}

export type UserLeaveBalance = Node & {
  __typename?: 'UserLeaveBalance';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  leaveType: LeaveType;
  leaveTypeID: Scalars['ID']['output'];
  totalAvailableDays: Scalars['Float']['output'];
  totalRemainingDays: Scalars['Float']['output'];
  totalUsedDays: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type UserLeaveBalanceConnection = {
  __typename?: 'UserLeaveBalanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserLeaveBalanceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserLeaveBalanceEdge = {
  __typename?: 'UserLeaveBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserLeaveBalance>;
};

export enum UserLeaveBalanceField {
  CreatedAt = 'createdAt',
  LeaveTypeId = 'leaveTypeID',
  TotalAvailableDays = 'totalAvailableDays',
  TotalRemainingDays = 'totalRemainingDays',
  TotalUsedDays = 'totalUsedDays',
  UpdatedAt = 'updatedAt',
  UserId = 'userID',
  Year = 'year'
}

/** Ordering options for UserLeaveBalance connections */
export type UserLeaveBalanceOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserLeaveBalances. */
  field: UserLeaveBalanceOrderField;
};

/** Properties by which UserLeaveBalance connections can be ordered. */
export enum UserLeaveBalanceOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UserLeaveBalanceWhereInput is used for filtering UserLeaveBalance objects.
 * Input was generated by ent.
 */
export type UserLeaveBalanceWhereInput = {
  and?: InputMaybe<Array<UserLeaveBalanceWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** leave_type edge predicates */
  hasLeaveType?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveTypeWith?: InputMaybe<Array<LeaveTypeWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** leave_type_id field predicates */
  leaveTypeID?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  leaveTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  leaveTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserLeaveBalanceWhereInput>;
  or?: InputMaybe<Array<UserLeaveBalanceWhereInput>>;
  /** total_available_days field predicates */
  totalAvailableDays?: InputMaybe<Scalars['Float']['input']>;
  totalAvailableDaysGT?: InputMaybe<Scalars['Float']['input']>;
  totalAvailableDaysGTE?: InputMaybe<Scalars['Float']['input']>;
  totalAvailableDaysIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalAvailableDaysLT?: InputMaybe<Scalars['Float']['input']>;
  totalAvailableDaysLTE?: InputMaybe<Scalars['Float']['input']>;
  totalAvailableDaysNEQ?: InputMaybe<Scalars['Float']['input']>;
  totalAvailableDaysNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** total_remaining_days field predicates */
  totalRemainingDays?: InputMaybe<Scalars['Float']['input']>;
  totalRemainingDaysGT?: InputMaybe<Scalars['Float']['input']>;
  totalRemainingDaysGTE?: InputMaybe<Scalars['Float']['input']>;
  totalRemainingDaysIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalRemainingDaysLT?: InputMaybe<Scalars['Float']['input']>;
  totalRemainingDaysLTE?: InputMaybe<Scalars['Float']['input']>;
  totalRemainingDaysNEQ?: InputMaybe<Scalars['Float']['input']>;
  totalRemainingDaysNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** total_used_days field predicates */
  totalUsedDays?: InputMaybe<Scalars['Float']['input']>;
  totalUsedDaysGT?: InputMaybe<Scalars['Float']['input']>;
  totalUsedDaysGTE?: InputMaybe<Scalars['Float']['input']>;
  totalUsedDaysIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalUsedDaysLT?: InputMaybe<Scalars['Float']['input']>;
  totalUsedDaysLTE?: InputMaybe<Scalars['Float']['input']>;
  totalUsedDaysNEQ?: InputMaybe<Scalars['Float']['input']>;
  totalUsedDaysNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** year field predicates */
  year?: InputMaybe<Scalars['Int']['input']>;
  yearGT?: InputMaybe<Scalars['Int']['input']>;
  yearGTE?: InputMaybe<Scalars['Int']['input']>;
  yearIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  yearLT?: InputMaybe<Scalars['Int']['input']>;
  yearLTE?: InputMaybe<Scalars['Int']['input']>;
  yearNEQ?: InputMaybe<Scalars['Int']['input']>;
  yearNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Ordering options for User connections */
export type UserOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Users. */
  field: UserOrderField;
};

/** Properties by which User connections can be ordered. */
export enum UserOrderField {
  DateJoined = 'DATE_JOINED',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type UserReportBookmark = Node & {
  __typename?: 'UserReportBookmark';
  createdAt: Scalars['Time']['output'];
  derivedReport: DerivedReport;
  derivedReportID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isBookmarked: Scalars['Boolean']['output'];
  lastGeneratedAt?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  userID?: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of items. */
export type UserReportBookmarkConnection = {
  __typename?: 'UserReportBookmarkConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserReportBookmarkEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserReportBookmarkEdge = {
  __typename?: 'UserReportBookmarkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserReportBookmark>;
};

export enum UserReportBookmarkField {
  CreatedAt = 'createdAt',
  DerivedReportId = 'derivedReportID',
  IsBookmarked = 'isBookmarked',
  LastGeneratedAt = 'lastGeneratedAt',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for UserReportBookmark connections */
export type UserReportBookmarkOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserReportBookmarks. */
  field: UserReportBookmarkOrderField;
};

/** Properties by which UserReportBookmark connections can be ordered. */
export enum UserReportBookmarkOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UserReportBookmarkWhereInput is used for filtering UserReportBookmark objects.
 * Input was generated by ent.
 */
export type UserReportBookmarkWhereInput = {
  and?: InputMaybe<Array<UserReportBookmarkWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** derived_report_id field predicates */
  derivedReportID?: InputMaybe<Scalars['ID']['input']>;
  derivedReportIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  derivedReportIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  derivedReportIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** derived_report edge predicates */
  hasDerivedReport?: InputMaybe<Scalars['Boolean']['input']>;
  hasDerivedReportWith?: InputMaybe<Array<DerivedReportWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_bookmarked field predicates */
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
  isBookmarkedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_generated_at field predicates */
  lastGeneratedAt?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtGT?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastGeneratedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastGeneratedAtLT?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastGeneratedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastGeneratedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserReportBookmarkWhereInput>;
  or?: InputMaybe<Array<UserReportBookmarkWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDGT?: InputMaybe<Scalars['ID']['input']>;
  userIDGTE?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  userIDLT?: InputMaybe<Scalars['ID']['input']>;
  userIDLTE?: InputMaybe<Scalars['ID']['input']>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

/** UserRole is enum for the field role */
export enum UserRole {
  Admin = 'Admin',
  Staff = 'Staff',
  Subscriber = 'Subscriber'
}

export type UserRosterAssignment = Node & {
  __typename?: 'UserRosterAssignment';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  rosterSchedule: RosterSchedule;
  rosterScheduleID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type UserRosterAssignmentConnection = {
  __typename?: 'UserRosterAssignmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserRosterAssignmentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserRosterAssignmentEdge = {
  __typename?: 'UserRosterAssignmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserRosterAssignment>;
};

export enum UserRosterAssignmentField {
  CreatedAt = 'createdAt',
  RosterScheduleId = 'rosterScheduleID',
  UpdatedAt = 'updatedAt',
  UserId = 'userID'
}

/** Ordering options for UserRosterAssignment connections */
export type UserRosterAssignmentOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserRosterAssignments. */
  field: UserRosterAssignmentOrderField;
};

/** Properties by which UserRosterAssignment connections can be ordered. */
export enum UserRosterAssignmentOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * UserRosterAssignmentWhereInput is used for filtering UserRosterAssignment objects.
 * Input was generated by ent.
 */
export type UserRosterAssignmentWhereInput = {
  and?: InputMaybe<Array<UserRosterAssignmentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserRosterAssignmentWhereInput>;
  or?: InputMaybe<Array<UserRosterAssignmentWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export type UserWhereInput = {
  /** address field predicates */
  address?: InputMaybe<Scalars['String']['input']>;
  addressContains?: InputMaybe<Scalars['String']['input']>;
  addressContainsFold?: InputMaybe<Scalars['String']['input']>;
  addressEqualFold?: InputMaybe<Scalars['String']['input']>;
  addressGT?: InputMaybe<Scalars['String']['input']>;
  addressGTE?: InputMaybe<Scalars['String']['input']>;
  addressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  addressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  addressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  addressLT?: InputMaybe<Scalars['String']['input']>;
  addressLTE?: InputMaybe<Scalars['String']['input']>;
  addressNEQ?: InputMaybe<Scalars['String']['input']>;
  addressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  addressNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** alternate_mobile_number field predicates */
  alternateMobileNumber?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberContains?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberGT?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberGTE?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  alternateMobileNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  alternateMobileNumberLT?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberLTE?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  alternateMobileNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  alternateMobileNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<UserWhereInput>>;
  /** avatar_id field predicates */
  avatarID?: InputMaybe<Scalars['ID']['input']>;
  avatarIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatarIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  avatarIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  avatarIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatarIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** city field predicates */
  city?: InputMaybe<Scalars['String']['input']>;
  cityContains?: InputMaybe<Scalars['String']['input']>;
  cityContainsFold?: InputMaybe<Scalars['String']['input']>;
  cityEqualFold?: InputMaybe<Scalars['String']['input']>;
  cityGT?: InputMaybe<Scalars['String']['input']>;
  cityGTE?: InputMaybe<Scalars['String']['input']>;
  cityHasPrefix?: InputMaybe<Scalars['String']['input']>;
  cityHasSuffix?: InputMaybe<Scalars['String']['input']>;
  cityIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  cityLT?: InputMaybe<Scalars['String']['input']>;
  cityLTE?: InputMaybe<Scalars['String']['input']>;
  cityNEQ?: InputMaybe<Scalars['String']['input']>;
  cityNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  cityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** country field predicates */
  country?: InputMaybe<Scalars['String']['input']>;
  countryContains?: InputMaybe<Scalars['String']['input']>;
  countryContainsFold?: InputMaybe<Scalars['String']['input']>;
  countryEqualFold?: InputMaybe<Scalars['String']['input']>;
  countryGT?: InputMaybe<Scalars['String']['input']>;
  countryGTE?: InputMaybe<Scalars['String']['input']>;
  countryHasPrefix?: InputMaybe<Scalars['String']['input']>;
  countryHasSuffix?: InputMaybe<Scalars['String']['input']>;
  countryIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  countryLT?: InputMaybe<Scalars['String']['input']>;
  countryLTE?: InputMaybe<Scalars['String']['input']>;
  countryNEQ?: InputMaybe<Scalars['String']['input']>;
  countryNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  countryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** date_joined field predicates */
  dateJoined?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedGT?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedGTE?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateJoinedLT?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedLTE?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedNEQ?: InputMaybe<Scalars['Time']['input']>;
  dateJoinedNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  /** email_confirmed field predicates */
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  emailConfirmedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameContains?: InputMaybe<Scalars['String']['input']>;
  firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstNameGT?: InputMaybe<Scalars['String']['input']>;
  firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstNameLT?: InputMaybe<Scalars['String']['input']>;
  firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** gender field predicates */
  gender?: InputMaybe<UserGender>;
  genderIn?: InputMaybe<Array<UserGender>>;
  genderIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  genderNEQ?: InputMaybe<UserGender>;
  genderNotIn?: InputMaybe<Array<UserGender>>;
  genderNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** api_user edge predicates */
  hasAPIUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasAPIUserWith?: InputMaybe<Array<ApiUserWhereInput>>;
  /** approved_leave_requests edge predicates */
  hasApprovedLeaveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprovedLeaveRequestsWith?: InputMaybe<Array<LeaveRequestWhereInput>>;
  /** attendances edge predicates */
  hasAttendances?: InputMaybe<Scalars['Boolean']['input']>;
  hasAttendancesWith?: InputMaybe<Array<AttendanceWhereInput>>;
  /** device_sharings edge predicates */
  hasDeviceSharings?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeviceSharingsWith?: InputMaybe<Array<DeviceSharingWhereInput>>;
  /** export edge predicates */
  hasExport?: InputMaybe<Scalars['Boolean']['input']>;
  hasExportWith?: InputMaybe<Array<ExportWhereInput>>;
  /** inspection_reports edge predicates */
  hasInspectionReports?: InputMaybe<Scalars['Boolean']['input']>;
  hasInspectionReportsWith?: InputMaybe<Array<InspectionReportWhereInput>>;
  /** leave_dates edge predicates */
  hasLeaveDates?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveDatesWith?: InputMaybe<Array<LeaveDateWhereInput>>;
  /** leave_requests edge predicates */
  hasLeaveRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeaveRequestsWith?: InputMaybe<Array<LeaveRequestWhereInput>>;
  /** map_config edge predicates */
  hasMapConfig?: InputMaybe<Scalars['Boolean']['input']>;
  hasMapConfigWith?: InputMaybe<Array<MapConfigWhereInput>>;
  /** mediafile edge predicates */
  hasMediafile?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafiles edge predicates */
  hasMediafiles?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafilesWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisationusers edge predicates */
  hasOrganisationusers?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationusersWith?: InputMaybe<Array<OrganisationUserWhereInput>>;
  /** poi edge predicates */
  hasPoi?: InputMaybe<Scalars['Boolean']['input']>;
  hasPoiWith?: InputMaybe<Array<PoiWhereInput>>;
  /** roster_schedules edge predicates */
  hasRosterSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  hasRosterSchedulesWith?: InputMaybe<Array<RosterScheduleWhereInput>>;
  /** rosters edge predicates */
  hasRosters?: InputMaybe<Scalars['Boolean']['input']>;
  hasRostersWith?: InputMaybe<Array<RosterWhereInput>>;
  /** trips edge predicates */
  hasTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripsWith?: InputMaybe<Array<TripWhereInput>>;
  /** user_config edge predicates */
  hasUserConfig?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserConfigWith?: InputMaybe<Array<UserConfigWhereInput>>;
  /** user_leave_balances edge predicates */
  hasUserLeaveBalances?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserLeaveBalancesWith?: InputMaybe<Array<UserLeaveBalanceWhereInput>>;
  /** user_roster_assignments edge predicates */
  hasUserRosterAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserRosterAssignmentsWith?: InputMaybe<Array<UserRosterAssignmentWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** yard_trip_status_in edge predicates */
  hasYardTripStatusIn?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusInWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trip_status_out edge predicates */
  hasYardTripStatusOut?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusOutWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trips_in edge predicates */
  hasYardTripsIn?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsInWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips_out edge predicates */
  hasYardTripsOut?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsOutWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips_warehouse_in edge predicates */
  hasYardTripsWarehouseIn?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWarehouseInWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips_warehouse_out edge predicates */
  hasYardTripsWarehouseOut?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWarehouseOutWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_warehouse_dock_sharing edge predicates */
  hasYardWarehouseDockSharing?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDockSharingWith?: InputMaybe<Array<YardWarehouseDockSharingWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameContains?: InputMaybe<Scalars['String']['input']>;
  lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastNameGT?: InputMaybe<Scalars['String']['input']>;
  lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameLT?: InputMaybe<Scalars['String']['input']>;
  lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** mobile_number field predicates */
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  /** mobile_number_confirmed field predicates */
  mobileNumberConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  mobileNumberConfirmedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  mobileNumberContains?: InputMaybe<Scalars['String']['input']>;
  mobileNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  mobileNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  mobileNumberGT?: InputMaybe<Scalars['String']['input']>;
  mobileNumberGTE?: InputMaybe<Scalars['String']['input']>;
  mobileNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mobileNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mobileNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNumberIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mobileNumberLT?: InputMaybe<Scalars['String']['input']>;
  mobileNumberLTE?: InputMaybe<Scalars['String']['input']>;
  mobileNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  mobileNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mobileNumberNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserWhereInput>;
  or?: InputMaybe<Array<UserWhereInput>>;
  /** postal_code field predicates */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeContains?: InputMaybe<Scalars['String']['input']>;
  postalCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  postalCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  postalCodeGT?: InputMaybe<Scalars['String']['input']>;
  postalCodeGTE?: InputMaybe<Scalars['String']['input']>;
  postalCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  postalCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  postalCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  postalCodeLT?: InputMaybe<Scalars['String']['input']>;
  postalCodeLTE?: InputMaybe<Scalars['String']['input']>;
  postalCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  postalCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** role field predicates */
  role?: InputMaybe<UserRole>;
  /** role_id field predicates */
  roleID?: InputMaybe<Scalars['ID']['input']>;
  roleIDGT?: InputMaybe<Scalars['ID']['input']>;
  roleIDGTE?: InputMaybe<Scalars['ID']['input']>;
  roleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  roleIDLT?: InputMaybe<Scalars['ID']['input']>;
  roleIDLTE?: InputMaybe<Scalars['ID']['input']>;
  roleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  roleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  roleIn?: InputMaybe<Array<UserRole>>;
  roleNEQ?: InputMaybe<UserRole>;
  roleNotIn?: InputMaybe<Array<UserRole>>;
  /** staff_role_id field predicates */
  staffRoleID?: InputMaybe<Scalars['ID']['input']>;
  staffRoleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  staffRoleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  staffRoleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  staffRoleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  staffRoleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** state field predicates */
  state?: InputMaybe<Scalars['String']['input']>;
  stateContains?: InputMaybe<Scalars['String']['input']>;
  stateContainsFold?: InputMaybe<Scalars['String']['input']>;
  stateEqualFold?: InputMaybe<Scalars['String']['input']>;
  stateGT?: InputMaybe<Scalars['String']['input']>;
  stateGTE?: InputMaybe<Scalars['String']['input']>;
  stateHasPrefix?: InputMaybe<Scalars['String']['input']>;
  stateHasSuffix?: InputMaybe<Scalars['String']['input']>;
  stateIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stateLT?: InputMaybe<Scalars['String']['input']>;
  stateLTE?: InputMaybe<Scalars['String']['input']>;
  stateNEQ?: InputMaybe<Scalars['String']['input']>;
  stateNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stateNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type VehicleInput = {
  capacity: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type VideoEventCache = {
  __typename?: 'VideoEventCache';
  channel: Scalars['Int']['output'];
  fixTime: Scalars['Time']['output'];
  isVideo: Scalars['Boolean']['output'];
  serverTime: Scalars['Time']['output'];
  thumbnailUrl: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export type Wallet = Node & {
  __typename?: 'Wallet';
  autoLoadLimit: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  currentBalance: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  negativeLimit: Scalars['Float']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  walletpaymenttransaction?: Maybe<Array<WalletPaymentTransaction>>;
  wallettransaction?: Maybe<Array<WalletTransaction>>;
};

/** A connection to a list of items. */
export type WalletConnection = {
  __typename?: 'WalletConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WalletEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WalletEdge = {
  __typename?: 'WalletEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Wallet>;
};

export enum WalletField {
  AutoLoadLimit = 'autoLoadLimit',
  CreatedAt = 'createdAt',
  CurrentBalance = 'currentBalance',
  NegativeLimit = 'negativeLimit',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Wallet connections */
export type WalletOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Wallets. */
  field: WalletOrderField;
};

/** Properties by which Wallet connections can be ordered. */
export enum WalletOrderField {
  AutoLoadLimit = 'AUTO_LOAD_LIMIT',
  CurrentBalance = 'CURRENT_BALANCE',
  NegativeLimit = 'NEGATIVE_LIMIT',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type WalletPaymentTransaction = Node & {
  __typename?: 'WalletPaymentTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Time']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  paidAmount: Scalars['Float']['output'];
  paymentProcessor: WalletPaymentTransactionPaymentProcessor;
  processorPaymentMethod?: Maybe<Scalars['String']['output']>;
  processorTransactionID?: Maybe<Scalars['String']['output']>;
  processorTransactionStatus?: Maybe<Scalars['String']['output']>;
  status: WalletPaymentTransactionStatus;
  subtotal: Scalars['Float']['output'];
  tax: Scalars['Float']['output'];
  transactionDate: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  wallet: Wallet;
  walletID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WalletPaymentTransactionConnection = {
  __typename?: 'WalletPaymentTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WalletPaymentTransactionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WalletPaymentTransactionEdge = {
  __typename?: 'WalletPaymentTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WalletPaymentTransaction>;
};

export enum WalletPaymentTransactionField {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  PaidAmount = 'paidAmount',
  PaymentProcessor = 'paymentProcessor',
  ProcessorPaymentMethod = 'processorPaymentMethod',
  ProcessorTransactionId = 'processorTransactionID',
  ProcessorTransactionStatus = 'processorTransactionStatus',
  Status = 'status',
  Subtotal = 'subtotal',
  Tax = 'tax',
  TransactionDate = 'transactionDate',
  UpdatedAt = 'updatedAt',
  WalletId = 'walletID'
}

/** Ordering options for WalletPaymentTransaction connections */
export type WalletPaymentTransactionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WalletPaymentTransactions. */
  field: WalletPaymentTransactionOrderField;
};

/** Properties by which WalletPaymentTransaction connections can be ordered. */
export enum WalletPaymentTransactionOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

/** WalletPaymentTransactionPaymentProcessor is enum for the field payment_processor */
export enum WalletPaymentTransactionPaymentProcessor {
  Razorpay = 'razorpay'
}

/** WalletPaymentTransactionStatus is enum for the field status */
export enum WalletPaymentTransactionStatus {
  Failed = 'failed',
  Initiated = 'initiated',
  Pending = 'pending',
  Success = 'success'
}

/**
 * WalletPaymentTransactionWhereInput is used for filtering WalletPaymentTransaction objects.
 * Input was generated by ent.
 */
export type WalletPaymentTransactionWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<WalletPaymentTransactionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyContains?: InputMaybe<Scalars['String']['input']>;
  currencyContainsFold?: InputMaybe<Scalars['String']['input']>;
  currencyEqualFold?: InputMaybe<Scalars['String']['input']>;
  currencyGT?: InputMaybe<Scalars['String']['input']>;
  currencyGTE?: InputMaybe<Scalars['String']['input']>;
  currencyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  currencyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  currencyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyLT?: InputMaybe<Scalars['String']['input']>;
  currencyLTE?: InputMaybe<Scalars['String']['input']>;
  currencyNEQ?: InputMaybe<Scalars['String']['input']>;
  currencyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** wallet edge predicates */
  hasWallet?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletWith?: InputMaybe<Array<WalletWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WalletPaymentTransactionWhereInput>;
  or?: InputMaybe<Array<WalletPaymentTransactionWhereInput>>;
  /** paid_amount field predicates */
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  paidAmountGT?: InputMaybe<Scalars['Float']['input']>;
  paidAmountGTE?: InputMaybe<Scalars['Float']['input']>;
  paidAmountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  paidAmountLT?: InputMaybe<Scalars['Float']['input']>;
  paidAmountLTE?: InputMaybe<Scalars['Float']['input']>;
  paidAmountNEQ?: InputMaybe<Scalars['Float']['input']>;
  paidAmountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** payment_processor field predicates */
  paymentProcessor?: InputMaybe<WalletPaymentTransactionPaymentProcessor>;
  paymentProcessorIn?: InputMaybe<Array<WalletPaymentTransactionPaymentProcessor>>;
  paymentProcessorNEQ?: InputMaybe<WalletPaymentTransactionPaymentProcessor>;
  paymentProcessorNotIn?: InputMaybe<Array<WalletPaymentTransactionPaymentProcessor>>;
  /** processor_payment_method field predicates */
  processorPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodContains?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodContainsFold?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodEqualFold?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodGT?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodGTE?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodHasPrefix?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodHasSuffix?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorPaymentMethodIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  processorPaymentMethodLT?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodLTE?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodNEQ?: InputMaybe<Scalars['String']['input']>;
  processorPaymentMethodNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorPaymentMethodNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processor_transaction_id field predicates */
  processorTransactionID?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDContains?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDGT?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDGTE?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  processorTransactionIDLT?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDLTE?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDNEQ?: InputMaybe<Scalars['String']['input']>;
  processorTransactionIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** processor_transaction_status field predicates */
  processorTransactionStatus?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusContains?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusContainsFold?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusEqualFold?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusGT?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusGTE?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusHasPrefix?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusHasSuffix?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  processorTransactionStatusLT?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusLTE?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusNEQ?: InputMaybe<Scalars['String']['input']>;
  processorTransactionStatusNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  processorTransactionStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<WalletPaymentTransactionStatus>;
  statusIn?: InputMaybe<Array<WalletPaymentTransactionStatus>>;
  statusNEQ?: InputMaybe<WalletPaymentTransactionStatus>;
  statusNotIn?: InputMaybe<Array<WalletPaymentTransactionStatus>>;
  /** subtotal field predicates */
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  subtotalGT?: InputMaybe<Scalars['Float']['input']>;
  subtotalGTE?: InputMaybe<Scalars['Float']['input']>;
  subtotalIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  subtotalLT?: InputMaybe<Scalars['Float']['input']>;
  subtotalLTE?: InputMaybe<Scalars['Float']['input']>;
  subtotalNEQ?: InputMaybe<Scalars['Float']['input']>;
  subtotalNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** tax field predicates */
  tax?: InputMaybe<Scalars['Float']['input']>;
  taxGT?: InputMaybe<Scalars['Float']['input']>;
  taxGTE?: InputMaybe<Scalars['Float']['input']>;
  taxIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  taxLT?: InputMaybe<Scalars['Float']['input']>;
  taxLTE?: InputMaybe<Scalars['Float']['input']>;
  taxNEQ?: InputMaybe<Scalars['Float']['input']>;
  taxNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** transaction_date field predicates */
  transactionDate?: InputMaybe<Scalars['Time']['input']>;
  transactionDateGT?: InputMaybe<Scalars['Time']['input']>;
  transactionDateGTE?: InputMaybe<Scalars['Time']['input']>;
  transactionDateIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  transactionDateLT?: InputMaybe<Scalars['Time']['input']>;
  transactionDateLTE?: InputMaybe<Scalars['Time']['input']>;
  transactionDateNEQ?: InputMaybe<Scalars['Time']['input']>;
  transactionDateNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wallet_id field predicates */
  walletID?: InputMaybe<Scalars['ID']['input']>;
  walletIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  walletIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  walletIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WalletTransaction = Node & {
  __typename?: 'WalletTransaction';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  transactionType: WalletTransactionTransactionType;
  updatedAt: Scalars['Time']['output'];
  usageID?: Maybe<Scalars['String']['output']>;
  usageType?: Maybe<WalletTransactionUsageType>;
  wallet: Wallet;
  walletID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WalletTransactionConnection = {
  __typename?: 'WalletTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WalletTransactionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WalletTransactionEdge = {
  __typename?: 'WalletTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WalletTransaction>;
};

export enum WalletTransactionField {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Notes = 'notes',
  TransactionType = 'transactionType',
  UpdatedAt = 'updatedAt',
  UsageId = 'usageID',
  UsageType = 'usageType',
  WalletId = 'walletID'
}

/** Ordering options for WalletTransaction connections */
export type WalletTransactionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WalletTransactions. */
  field: WalletTransactionOrderField;
};

/** Properties by which WalletTransaction connections can be ordered. */
export enum WalletTransactionOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** WalletTransactionTransactionType is enum for the field transaction_type */
export enum WalletTransactionTransactionType {
  Bonus = 'bonus',
  Credit = 'credit',
  Debit = 'debit',
  Refund = 'refund',
  Topup = 'topup'
}

/** WalletTransactionUsageType is enum for the field usage_type */
export enum WalletTransactionUsageType {
  License = 'license',
  Transfer = 'transfer',
  Trip = 'trip',
  Upgrade = 'upgrade'
}

/**
 * WalletTransactionWhereInput is used for filtering WalletTransaction objects.
 * Input was generated by ent.
 */
export type WalletTransactionWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountGT?: InputMaybe<Scalars['Float']['input']>;
  amountGTE?: InputMaybe<Scalars['Float']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  amountLT?: InputMaybe<Scalars['Float']['input']>;
  amountLTE?: InputMaybe<Scalars['Float']['input']>;
  amountNEQ?: InputMaybe<Scalars['Float']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  and?: InputMaybe<Array<WalletTransactionWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wallet edge predicates */
  hasWallet?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletWith?: InputMaybe<Array<WalletWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WalletTransactionWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['String']['input']>;
  notesContains?: InputMaybe<Scalars['String']['input']>;
  notesContainsFold?: InputMaybe<Scalars['String']['input']>;
  notesEqualFold?: InputMaybe<Scalars['String']['input']>;
  notesGT?: InputMaybe<Scalars['String']['input']>;
  notesGTE?: InputMaybe<Scalars['String']['input']>;
  notesHasPrefix?: InputMaybe<Scalars['String']['input']>;
  notesHasSuffix?: InputMaybe<Scalars['String']['input']>;
  notesIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['String']['input']>;
  notesLTE?: InputMaybe<Scalars['String']['input']>;
  notesNEQ?: InputMaybe<Scalars['String']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<WalletTransactionWhereInput>>;
  /** transaction_type field predicates */
  transactionType?: InputMaybe<WalletTransactionTransactionType>;
  transactionTypeIn?: InputMaybe<Array<WalletTransactionTransactionType>>;
  transactionTypeNEQ?: InputMaybe<WalletTransactionTransactionType>;
  transactionTypeNotIn?: InputMaybe<Array<WalletTransactionTransactionType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** usage_id field predicates */
  usageID?: InputMaybe<Scalars['String']['input']>;
  usageIDContains?: InputMaybe<Scalars['String']['input']>;
  usageIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  usageIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  usageIDGT?: InputMaybe<Scalars['String']['input']>;
  usageIDGTE?: InputMaybe<Scalars['String']['input']>;
  usageIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  usageIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  usageIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  usageIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  usageIDLT?: InputMaybe<Scalars['String']['input']>;
  usageIDLTE?: InputMaybe<Scalars['String']['input']>;
  usageIDNEQ?: InputMaybe<Scalars['String']['input']>;
  usageIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  usageIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** usage_type field predicates */
  usageType?: InputMaybe<WalletTransactionUsageType>;
  usageTypeIn?: InputMaybe<Array<WalletTransactionUsageType>>;
  usageTypeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  usageTypeNEQ?: InputMaybe<WalletTransactionUsageType>;
  usageTypeNotIn?: InputMaybe<Array<WalletTransactionUsageType>>;
  usageTypeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** wallet_id field predicates */
  walletID?: InputMaybe<Scalars['ID']['input']>;
  walletIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  walletIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  walletIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * WalletWhereInput is used for filtering Wallet objects.
 * Input was generated by ent.
 */
export type WalletWhereInput = {
  and?: InputMaybe<Array<WalletWhereInput>>;
  /** auto_load_limit field predicates */
  autoLoadLimit?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitGT?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitGTE?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  autoLoadLimitLT?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitLTE?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitNEQ?: InputMaybe<Scalars['Int']['input']>;
  autoLoadLimitNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** current_balance field predicates */
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceGT?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceGTE?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  currentBalanceLT?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceLTE?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceNEQ?: InputMaybe<Scalars['Float']['input']>;
  currentBalanceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** walletpaymenttransaction edge predicates */
  hasWalletpaymenttransaction?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletpaymenttransactionWith?: InputMaybe<Array<WalletPaymentTransactionWhereInput>>;
  /** wallettransaction edge predicates */
  hasWallettransaction?: InputMaybe<Scalars['Boolean']['input']>;
  hasWallettransactionWith?: InputMaybe<Array<WalletTransactionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** negative_limit field predicates */
  negativeLimit?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitGT?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitGTE?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  negativeLimitLT?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitLTE?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitNEQ?: InputMaybe<Scalars['Float']['input']>;
  negativeLimitNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<WalletWhereInput>;
  or?: InputMaybe<Array<WalletWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type WhatsAppConfig = Node & {
  __typename?: 'WhatsAppConfig';
  companyID: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['Int']['output']>;
  phoneNumberID?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type WhatsAppConfigConnection = {
  __typename?: 'WhatsAppConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WhatsAppConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WhatsAppConfigEdge = {
  __typename?: 'WhatsAppConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WhatsAppConfig>;
};

export enum WhatsAppConfigField {
  CompanyId = 'companyID',
  CreatedAt = 'createdAt',
  Notes = 'notes',
  PhoneNumberId = 'phoneNumberID',
  Token = 'token',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for WhatsAppConfig connections */
export type WhatsAppConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WhatsAppConfigs. */
  field: WhatsAppConfigOrderField;
};

/** Properties by which WhatsAppConfig connections can be ordered. */
export enum WhatsAppConfigOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * WhatsAppConfigWhereInput is used for filtering WhatsAppConfig objects.
 * Input was generated by ent.
 */
export type WhatsAppConfigWhereInput = {
  and?: InputMaybe<Array<WhatsAppConfigWhereInput>>;
  /** company_id field predicates */
  companyID?: InputMaybe<Scalars['Int']['input']>;
  companyIDGT?: InputMaybe<Scalars['Int']['input']>;
  companyIDGTE?: InputMaybe<Scalars['Int']['input']>;
  companyIDIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyIDLT?: InputMaybe<Scalars['Int']['input']>;
  companyIDLTE?: InputMaybe<Scalars['Int']['input']>;
  companyIDNEQ?: InputMaybe<Scalars['Int']['input']>;
  companyIDNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WhatsAppConfigWhereInput>;
  /** notes field predicates */
  notes?: InputMaybe<Scalars['Int']['input']>;
  notesGT?: InputMaybe<Scalars['Int']['input']>;
  notesGTE?: InputMaybe<Scalars['Int']['input']>;
  notesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  notesIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  notesLT?: InputMaybe<Scalars['Int']['input']>;
  notesLTE?: InputMaybe<Scalars['Int']['input']>;
  notesNEQ?: InputMaybe<Scalars['Int']['input']>;
  notesNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  notesNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<WhatsAppConfigWhereInput>>;
  /** phone_number_id field predicates */
  phoneNumberID?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDContains?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDGT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDGTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumberIDLT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** token field predicates */
  token?: InputMaybe<Scalars['String']['input']>;
  tokenContains?: InputMaybe<Scalars['String']['input']>;
  tokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  tokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  tokenGT?: InputMaybe<Scalars['String']['input']>;
  tokenGTE?: InputMaybe<Scalars['String']['input']>;
  tokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  tokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  tokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  tokenLT?: InputMaybe<Scalars['String']['input']>;
  tokenLTE?: InputMaybe<Scalars['String']['input']>;
  tokenNEQ?: InputMaybe<Scalars['String']['input']>;
  tokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Whitelabel = Node & {
  __typename?: 'Whitelabel';
  brandName: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  domains?: Maybe<Array<Domain>>;
  /**
   * Array of enabled methods, options are:
   * 				- email_password
   * 				- email_otp
   * 				- mobile_otp
   */
  enabledLoginMethods?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  loginLogo?: Maybe<Scalars['ID']['output']>;
  logo?: Maybe<Scalars['ID']['output']>;
  mediafileWhitelabelLoginLogo?: Maybe<MediaFile>;
  mediafileWhitelabelLogo?: Maybe<MediaFile>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  whitelabelconfigs?: Maybe<Array<WhitelabelConfig>>;
  whitelabelcoresettingoverrides?: Maybe<Array<WhitelabelCoreSettingOverride>>;
};

export type WhitelabelConfig = Node & {
  __typename?: 'WhitelabelConfig';
  appcolorscheme?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: WhitelabelConfigKey;
  updatedAt: Scalars['Time']['output'];
  value: Scalars['String']['output'];
  whitelabel: Whitelabel;
  whitelabelID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WhitelabelConfigConnection = {
  __typename?: 'WhitelabelConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WhitelabelConfigEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WhitelabelConfigEdge = {
  __typename?: 'WhitelabelConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WhitelabelConfig>;
};

export enum WhitelabelConfigField {
  Appcolorscheme = 'appcolorscheme',
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  WhitelabelId = 'whitelabelID'
}

/** WhitelabelConfigKey is enum for the field key */
export enum WhitelabelConfigKey {
  AboutUrl = 'about_url',
  AndroidAppUrl = 'android_app_url',
  DefaultLoginMethod = 'default_login_method',
  DefaultTimezone = 'default_timezone',
  FaqUrl = 'faq_url',
  FaviconMediaId = 'favicon_media_id',
  IosAppUrl = 'ios_app_url',
  LoginCarousel = 'login_carousel',
  LogoMediaId = 'logo_media_id',
  PrivacyPolicyUrl = 'privacy_policy_url',
  TermsConditionUrl = 'terms_condition_url',
  Theme = 'theme'
}

/** Ordering options for WhitelabelConfig connections */
export type WhitelabelConfigOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WhitelabelConfigs. */
  field: WhitelabelConfigOrderField;
};

/** Properties by which WhitelabelConfig connections can be ordered. */
export enum WhitelabelConfigOrderField {
  Key = 'KEY',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * WhitelabelConfigWhereInput is used for filtering WhitelabelConfig objects.
 * Input was generated by ent.
 */
export type WhitelabelConfigWhereInput = {
  and?: InputMaybe<Array<WhitelabelConfigWhereInput>>;
  /** AppColorScheme field predicates */
  appcolorscheme?: InputMaybe<Scalars['JSON']['input']>;
  appcolorschemeGT?: InputMaybe<Scalars['JSON']['input']>;
  appcolorschemeGTE?: InputMaybe<Scalars['JSON']['input']>;
  appcolorschemeIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  appcolorschemeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  appcolorschemeLT?: InputMaybe<Scalars['JSON']['input']>;
  appcolorschemeLTE?: InputMaybe<Scalars['JSON']['input']>;
  appcolorschemeNEQ?: InputMaybe<Scalars['JSON']['input']>;
  appcolorschemeNotIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
  appcolorschemeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** whitelabel edge predicates */
  hasWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<WhitelabelConfigKey>;
  keyIn?: InputMaybe<Array<WhitelabelConfigKey>>;
  keyNEQ?: InputMaybe<WhitelabelConfigKey>;
  keyNotIn?: InputMaybe<Array<WhitelabelConfigKey>>;
  not?: InputMaybe<WhitelabelConfigWhereInput>;
  or?: InputMaybe<Array<WhitelabelConfigWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** whitelabel_id field predicates */
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A connection to a list of items. */
export type WhitelabelConnection = {
  __typename?: 'WhitelabelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WhitelabelEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type WhitelabelCoreSettingOverride = Node & {
  __typename?: 'WhitelabelCoreSettingOverride';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  key: WhitelabelCoreSettingOverrideKey;
  updatedAt: Scalars['Time']['output'];
  value: Scalars['String']['output'];
  whitelabel: Whitelabel;
  whitelabelID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WhitelabelCoreSettingOverrideConnection = {
  __typename?: 'WhitelabelCoreSettingOverrideConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WhitelabelCoreSettingOverrideEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WhitelabelCoreSettingOverrideEdge = {
  __typename?: 'WhitelabelCoreSettingOverrideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WhitelabelCoreSettingOverride>;
};

export enum WhitelabelCoreSettingOverrideField {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  WhitelabelId = 'whitelabelID'
}

/** WhitelabelCoreSettingOverrideKey is enum for the field key */
export enum WhitelabelCoreSettingOverrideKey {
  DefaultJwtSeconds = 'default_jwt_seconds',
  DefaultPaymentGateway = 'default_payment_gateway',
  FcmSenderId = 'fcm_sender_id',
  FcmServerKey = 'fcm_server_key',
  GoogleMapsKey = 'google_maps_key',
  HereMapsKey = 'here_maps_key',
  RazorpayApiKey = 'razorpay_api_key',
  RazorpayApiSecret = 'razorpay_api_secret',
  SmtpHost = 'smtp_host',
  SmtpPass = 'smtp_pass',
  SmtpPort = 'smtp_port',
  SmtpSendEmailAs = 'smtp_send_email_as',
  SmtpSsl = 'smtp_ssl',
  SmtpTls = 'smtp_tls',
  SmtpUser = 'smtp_user',
  TwilioApiKey = 'twilio_api_key',
  TwilioApiSecret = 'twilio_api_secret',
  TwilioAppSid = 'twilio_app_sid',
  TwilioCaller = 'twilio_caller',
  TwilioSid = 'twilio_sid',
  WellenPassword = 'wellen_password',
  WellenSender = 'wellen_sender',
  WellenUsername = 'wellen_username'
}

/** Ordering options for WhitelabelCoreSettingOverride connections */
export type WhitelabelCoreSettingOverrideOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order WhitelabelCoreSettingOverrides. */
  field: WhitelabelCoreSettingOverrideOrderField;
};

/** Properties by which WhitelabelCoreSettingOverride connections can be ordered. */
export enum WhitelabelCoreSettingOverrideOrderField {
  Key = 'KEY',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * WhitelabelCoreSettingOverrideWhereInput is used for filtering WhitelabelCoreSettingOverride objects.
 * Input was generated by ent.
 */
export type WhitelabelCoreSettingOverrideWhereInput = {
  and?: InputMaybe<Array<WhitelabelCoreSettingOverrideWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** whitelabel edge predicates */
  hasWhitelabel?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelWith?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** key field predicates */
  key?: InputMaybe<WhitelabelCoreSettingOverrideKey>;
  keyIn?: InputMaybe<Array<WhitelabelCoreSettingOverrideKey>>;
  keyNEQ?: InputMaybe<WhitelabelCoreSettingOverrideKey>;
  keyNotIn?: InputMaybe<Array<WhitelabelCoreSettingOverrideKey>>;
  not?: InputMaybe<WhitelabelCoreSettingOverrideWhereInput>;
  or?: InputMaybe<Array<WhitelabelCoreSettingOverrideWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['String']['input']>;
  valueContains?: InputMaybe<Scalars['String']['input']>;
  valueContainsFold?: InputMaybe<Scalars['String']['input']>;
  valueEqualFold?: InputMaybe<Scalars['String']['input']>;
  valueGT?: InputMaybe<Scalars['String']['input']>;
  valueGTE?: InputMaybe<Scalars['String']['input']>;
  valueHasPrefix?: InputMaybe<Scalars['String']['input']>;
  valueHasSuffix?: InputMaybe<Scalars['String']['input']>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueLT?: InputMaybe<Scalars['String']['input']>;
  valueLTE?: InputMaybe<Scalars['String']['input']>;
  valueNEQ?: InputMaybe<Scalars['String']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** whitelabel_id field predicates */
  whitelabelID?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  whitelabelIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  whitelabelIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An edge in a connection. */
export type WhitelabelEdge = {
  __typename?: 'WhitelabelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Whitelabel>;
};

export enum WhitelabelField {
  BrandName = 'brandName',
  CreatedAt = 'createdAt',
  EnabledLoginMethods = 'enabledLoginMethods',
  IsActive = 'isActive',
  LoginLogo = 'loginLogo',
  Logo = 'logo',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for Whitelabel connections */
export type WhitelabelOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Whitelabels. */
  field: WhitelabelOrderField;
};

/** Properties by which Whitelabel connections can be ordered. */
export enum WhitelabelOrderField {
  BrandName = 'BRAND_NAME',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * WhitelabelWhereInput is used for filtering Whitelabel objects.
 * Input was generated by ent.
 */
export type WhitelabelWhereInput = {
  and?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** brand_name field predicates */
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandNameContains?: InputMaybe<Scalars['String']['input']>;
  brandNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  brandNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  brandNameGT?: InputMaybe<Scalars['String']['input']>;
  brandNameGTE?: InputMaybe<Scalars['String']['input']>;
  brandNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  brandNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  brandNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNameLT?: InputMaybe<Scalars['String']['input']>;
  brandNameLTE?: InputMaybe<Scalars['String']['input']>;
  brandNameNEQ?: InputMaybe<Scalars['String']['input']>;
  brandNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** domains edge predicates */
  hasDomains?: InputMaybe<Scalars['Boolean']['input']>;
  hasDomainsWith?: InputMaybe<Array<DomainWhereInput>>;
  /** mediafile_whitelabel_login_logo edge predicates */
  hasMediafileWhitelabelLoginLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWhitelabelLoginLogoWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafile_whitelabel_logo edge predicates */
  hasMediafileWhitelabelLogo?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileWhitelabelLogoWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** whitelabelconfigs edge predicates */
  hasWhitelabelconfigs?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelconfigsWith?: InputMaybe<Array<WhitelabelConfigWhereInput>>;
  /** whitelabelcoresettingoverrides edge predicates */
  hasWhitelabelcoresettingoverrides?: InputMaybe<Scalars['Boolean']['input']>;
  hasWhitelabelcoresettingoverridesWith?: InputMaybe<Array<WhitelabelCoreSettingOverrideWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** login_logo field predicates */
  loginLogo?: InputMaybe<Scalars['ID']['input']>;
  loginLogoIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  loginLogoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  loginLogoNEQ?: InputMaybe<Scalars['ID']['input']>;
  loginLogoNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  loginLogoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** logo field predicates */
  logo?: InputMaybe<Scalars['ID']['input']>;
  logoIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  logoNEQ?: InputMaybe<Scalars['ID']['input']>;
  logoNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  logoNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<WhitelabelWhereInput>;
  or?: InputMaybe<Array<WhitelabelWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type YardDriverProfile = Node & {
  __typename?: 'YardDriverProfile';
  avatar?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  dlExpiry: Scalars['Time']['output'];
  dlImage?: Maybe<Scalars['ID']['output']>;
  dlNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdated: Scalars['Time']['output'];
  mediafileAvatar?: Maybe<MediaFile>;
  mediafileDlImage?: Maybe<MediaFile>;
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardDriverProfileConnection = {
  __typename?: 'YardDriverProfileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardDriverProfileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardDriverProfileEdge = {
  __typename?: 'YardDriverProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardDriverProfile>;
};

export enum YardDriverProfileField {
  Avatar = 'avatar',
  CreatedAt = 'createdAt',
  DateOfBirth = 'dateOfBirth',
  DlExpiry = 'dlExpiry',
  DlImage = 'dlImage',
  DlNumber = 'dlNumber',
  LastUpdated = 'lastUpdated',
  Name = 'name',
  OrganisationId = 'organisationID',
  PhoneNumber = 'phoneNumber',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardDriverProfile connections */
export type YardDriverProfileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardDriverProfiles. */
  field: YardDriverProfileOrderField;
};

/** Properties by which YardDriverProfile connections can be ordered. */
export enum YardDriverProfileOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardDriverProfileWhereInput is used for filtering YardDriverProfile objects.
 * Input was generated by ent.
 */
export type YardDriverProfileWhereInput = {
  and?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** avatar field predicates */
  avatar?: InputMaybe<Scalars['ID']['input']>;
  avatarIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatarIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  avatarNEQ?: InputMaybe<Scalars['ID']['input']>;
  avatarNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatarNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** date_of_birth field predicates */
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthGT?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthGTE?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateOfBirthIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirthLT?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthLTE?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthNEQ?: InputMaybe<Scalars['Time']['input']>;
  dateOfBirthNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dateOfBirthNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dl_expiry field predicates */
  dlExpiry?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  dlExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  dlExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dl_image field predicates */
  dlImage?: InputMaybe<Scalars['ID']['input']>;
  dlImageIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dlImageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  dlImageNEQ?: InputMaybe<Scalars['ID']['input']>;
  dlImageNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dlImageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dl_number field predicates */
  dlNumber?: InputMaybe<Scalars['String']['input']>;
  dlNumberContains?: InputMaybe<Scalars['String']['input']>;
  dlNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  dlNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  dlNumberGT?: InputMaybe<Scalars['String']['input']>;
  dlNumberGTE?: InputMaybe<Scalars['String']['input']>;
  dlNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  dlNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  dlNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  dlNumberLT?: InputMaybe<Scalars['String']['input']>;
  dlNumberLTE?: InputMaybe<Scalars['String']['input']>;
  dlNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  dlNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** mediafile_avatar edge predicates */
  hasMediafileAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileAvatarWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafile_dl_image edge predicates */
  hasMediafileDlImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileDlImageWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_updated field predicates */
  lastUpdated?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdatedLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardDriverProfileWhereInput>;
  or?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** phone_number field predicates */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberContains?: InputMaybe<Scalars['String']['input']>;
  phoneNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  phoneNumberGT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberGTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumberLT?: InputMaybe<Scalars['String']['input']>;
  phoneNumberLTE?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  phoneNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type YardMaterial = Node & {
  __typename?: 'YardMaterial';
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardMaterialType?: Maybe<YardMaterialType>;
  yardMaterialTypeID?: Maybe<Scalars['ID']['output']>;
  yardTripApprovals?: Maybe<Array<YardTripStatus>>;
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
  yardTrips?: Maybe<Array<YardTrip>>;
  yardWarehouseRoutes?: Maybe<Array<YardWarehouseRoute>>;
};

/** A connection to a list of items. */
export type YardMaterialConnection = {
  __typename?: 'YardMaterialConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardMaterialEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardMaterialEdge = {
  __typename?: 'YardMaterialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardMaterial>;
};

export enum YardMaterialField {
  Code = 'code',
  CreatedAt = 'createdAt',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt',
  YardMaterialTypeId = 'yardMaterialTypeID'
}

/** Ordering options for YardMaterial connections */
export type YardMaterialOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardMaterials. */
  field: YardMaterialOrderField;
};

/** Properties by which YardMaterial connections can be ordered. */
export enum YardMaterialOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type YardMaterialType = Node & {
  __typename?: 'YardMaterialType';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardMaterials?: Maybe<Array<YardMaterial>>;
};

/** A connection to a list of items. */
export type YardMaterialTypeConnection = {
  __typename?: 'YardMaterialTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardMaterialTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardMaterialTypeEdge = {
  __typename?: 'YardMaterialTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardMaterialType>;
};

export enum YardMaterialTypeField {
  CreatedAt = 'createdAt',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardMaterialType connections */
export type YardMaterialTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardMaterialTypes. */
  field: YardMaterialTypeOrderField;
};

/** Properties by which YardMaterialType connections can be ordered. */
export enum YardMaterialTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardMaterialTypeWhereInput is used for filtering YardMaterialType objects.
 * Input was generated by ent.
 */
export type YardMaterialTypeWhereInput = {
  and?: InputMaybe<Array<YardMaterialTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_materials edge predicates */
  hasYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardMaterialsWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardMaterialTypeWhereInput>;
  or?: InputMaybe<Array<YardMaterialTypeWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * YardMaterialWhereInput is used for filtering YardMaterial objects.
 * Input was generated by ent.
 */
export type YardMaterialWhereInput = {
  and?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** code field predicates */
  code?: InputMaybe<Scalars['String']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeContainsFold?: InputMaybe<Scalars['String']['input']>;
  codeEqualFold?: InputMaybe<Scalars['String']['input']>;
  codeGT?: InputMaybe<Scalars['String']['input']>;
  codeGTE?: InputMaybe<Scalars['String']['input']>;
  codeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  codeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  codeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  codeLT?: InputMaybe<Scalars['String']['input']>;
  codeLTE?: InputMaybe<Scalars['String']['input']>;
  codeNEQ?: InputMaybe<Scalars['String']['input']>;
  codeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_material_type edge predicates */
  hasYardMaterialType?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardMaterialTypeWith?: InputMaybe<Array<YardMaterialTypeWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_warehouse_routes edge predicates */
  hasYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutesWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardMaterialWhereInput>;
  or?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** yard_material_type_id field predicates */
  yardMaterialTypeID?: InputMaybe<Scalars['ID']['input']>;
  yardMaterialTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardMaterialTypeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  yardMaterialTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  yardMaterialTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  yardMaterialTypeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type YardTrip = Node & {
  __typename?: 'YardTrip';
  assignedDriverTracker?: Maybe<DeviceGroup>;
  assignedDriverTrackerID?: Maybe<Scalars['ID']['output']>;
  assignedRoute?: Maybe<YardWarehouseRoute>;
  assignedRouteID?: Maybe<Scalars['ID']['output']>;
  assignedTracker?: Maybe<DeviceGroup>;
  assignedTrackerBatteryLevel?: Maybe<Scalars['Int']['output']>;
  assignedTrackerID?: Maybe<Scalars['ID']['output']>;
  checkInBy?: Maybe<User>;
  checkInByID?: Maybe<Scalars['ID']['output']>;
  checkOutBy?: Maybe<User>;
  checkOutByID?: Maybe<Scalars['ID']['output']>;
  checkinTime?: Maybe<Scalars['Time']['output']>;
  checkoutTime?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  currentTripStatus?: Maybe<Scalars['ID']['output']>;
  declaredMaterial?: Maybe<YardMaterial>;
  declaredMaterialID?: Maybe<Scalars['ID']['output']>;
  driver?: Maybe<YardDriverProfile>;
  driverID?: Maybe<Scalars['ID']['output']>;
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastTripStatus?: Maybe<Scalars['ID']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  parking?: Maybe<YardWarehouseParking>;
  parkingID?: Maybe<Scalars['ID']['output']>;
  parkingInTime?: Maybe<Scalars['Time']['output']>;
  parkingOutTime?: Maybe<Scalars['Time']['output']>;
  purpose?: Maybe<YardTripPurpose>;
  tripStatus: YardTripTripStatus;
  tripStatusCurrent?: Maybe<YardTripStatus>;
  tripStatusLast?: Maybe<YardTripStatus>;
  updatedAt: Scalars['Time']['output'];
  vehicle?: Maybe<YardVehicle>;
  vehicleID?: Maybe<Scalars['ID']['output']>;
  vendor?: Maybe<YardVendor>;
  vendorID?: Maybe<Scalars['ID']['output']>;
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  warehouseInBy?: Maybe<User>;
  warehouseInByID?: Maybe<Scalars['ID']['output']>;
  warehouseInTime?: Maybe<Scalars['Time']['output']>;
  warehouseOutBy?: Maybe<User>;
  warehouseOutByID?: Maybe<Scalars['ID']['output']>;
  warehouseOutTime?: Maybe<Scalars['Time']['output']>;
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
};

export type YardTripApproval = Node & {
  __typename?: 'YardTripApproval';
  approvalMatrix: YardWarehouseApprovalMatrix;
  approvalMatrixID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  reviewReason?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<User>;
  reviewedByID?: Maybe<Scalars['ID']['output']>;
  status: YardTripApprovalStatus;
  trip: YardTrip;
  tripID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type YardTripApprovalConnection = {
  __typename?: 'YardTripApprovalConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardTripApprovalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardTripApprovalEdge = {
  __typename?: 'YardTripApprovalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardTripApproval>;
};

export enum YardTripApprovalField {
  ApprovalMatrixId = 'approvalMatrixID',
  CreatedAt = 'createdAt',
  OrganisationId = 'organisationID',
  ReviewReason = 'reviewReason',
  ReviewedById = 'reviewedByID',
  Status = 'status',
  TripId = 'tripID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardTripApproval connections */
export type YardTripApprovalOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardTripApprovals. */
  field: YardTripApprovalOrderField;
};

/** Properties by which YardTripApproval connections can be ordered. */
export enum YardTripApprovalOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** YardTripApprovalStatus is enum for the field status */
export enum YardTripApprovalStatus {
  Approved = 'Approved',
  Hold = 'Hold',
  On = 'On',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

/**
 * YardTripApprovalWhereInput is used for filtering YardTripApproval objects.
 * Input was generated by ent.
 */
export type YardTripApprovalWhereInput = {
  and?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** approval_matrix_id field predicates */
  approvalMatrixID?: InputMaybe<Scalars['ID']['input']>;
  approvalMatrixIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approvalMatrixIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approvalMatrixIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** approval_matrix edge predicates */
  hasApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** reviewed_by edge predicates */
  hasReviewedBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasReviewedByWith?: InputMaybe<Array<UserWhereInput>>;
  /** trip edge predicates */
  hasTrip?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<YardTripApprovalWhereInput>;
  or?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** review_reason field predicates */
  reviewReason?: InputMaybe<Scalars['String']['input']>;
  reviewReasonContains?: InputMaybe<Scalars['String']['input']>;
  reviewReasonContainsFold?: InputMaybe<Scalars['String']['input']>;
  reviewReasonEqualFold?: InputMaybe<Scalars['String']['input']>;
  reviewReasonGT?: InputMaybe<Scalars['String']['input']>;
  reviewReasonGTE?: InputMaybe<Scalars['String']['input']>;
  reviewReasonHasPrefix?: InputMaybe<Scalars['String']['input']>;
  reviewReasonHasSuffix?: InputMaybe<Scalars['String']['input']>;
  reviewReasonIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewReasonIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reviewReasonLT?: InputMaybe<Scalars['String']['input']>;
  reviewReasonLTE?: InputMaybe<Scalars['String']['input']>;
  reviewReasonNEQ?: InputMaybe<Scalars['String']['input']>;
  reviewReasonNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewReasonNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** reviewed_by_id field predicates */
  reviewedByID?: InputMaybe<Scalars['ID']['input']>;
  reviewedByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewedByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  reviewedByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  reviewedByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<YardTripApprovalStatus>;
  statusIn?: InputMaybe<Array<YardTripApprovalStatus>>;
  statusNEQ?: InputMaybe<YardTripApprovalStatus>;
  statusNotIn?: InputMaybe<Array<YardTripApprovalStatus>>;
  /** trip_id field predicates */
  tripID?: InputMaybe<Scalars['ID']['input']>;
  tripIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A connection to a list of items. */
export type YardTripConnection = {
  __typename?: 'YardTripConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardTripEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardTripEdge = {
  __typename?: 'YardTripEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardTrip>;
};

export enum YardTripField {
  AssignedDriverTrackerId = 'assignedDriverTrackerID',
  AssignedRouteId = 'assignedRouteID',
  AssignedTrackerBatteryLevel = 'assignedTrackerBatteryLevel',
  AssignedTrackerId = 'assignedTrackerID',
  CheckInById = 'checkInByID',
  CheckOutById = 'checkOutByID',
  CheckinTime = 'checkinTime',
  CheckoutTime = 'checkoutTime',
  CreatedAt = 'createdAt',
  CurrentTripStatus = 'currentTripStatus',
  DeclaredMaterialId = 'declaredMaterialID',
  DriverId = 'driverID',
  ExternalId = 'externalID',
  LastTripStatus = 'lastTripStatus',
  OrganisationId = 'organisationID',
  ParkingId = 'parkingID',
  ParkingInTime = 'parkingInTime',
  ParkingOutTime = 'parkingOutTime',
  Purpose = 'purpose',
  TripStatus = 'tripStatus',
  UpdatedAt = 'updatedAt',
  VehicleId = 'vehicleID',
  VendorId = 'vendorID',
  WarehouseId = 'warehouseID',
  WarehouseInById = 'warehouseInByID',
  WarehouseInTime = 'warehouseInTime',
  WarehouseOutById = 'warehouseOutByID',
  WarehouseOutTime = 'warehouseOutTime'
}

/** Ordering options for YardTrip connections */
export type YardTripOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardTrips. */
  field: YardTripOrderField;
};

/** Properties by which YardTrip connections can be ordered. */
export enum YardTripOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/** YardTripPurpose is enum for the field purpose */
export enum YardTripPurpose {
  Both = 'both',
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export type YardTripStatus = Node & {
  __typename?: 'YardTripStatus';
  activityStartTime?: Maybe<Scalars['Time']['output']>;
  activityType?: Maybe<YardWarehouseActivityType>;
  activityTypeID?: Maybe<Scalars['ID']['output']>;
  checkInBy?: Maybe<User>;
  checkInByID?: Maybe<Scalars['ID']['output']>;
  checkOutBy?: Maybe<User>;
  checkOutByID?: Maybe<Scalars['ID']['output']>;
  checkinTime?: Maybe<Scalars['Time']['output']>;
  checkoutTime?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  dock: YardWarehouseDock;
  dockID: Scalars['ID']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  material?: Maybe<YardMaterial>;
  materialID?: Maybe<Scalars['ID']['output']>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  routePath: YardWarehouseRoutePath;
  routePathID: Scalars['ID']['output'];
  sequence: Scalars['Int']['output'];
  status: YardTripStatusStatus;
  trip: YardTrip;
  tripID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTripsCurrent?: Maybe<Array<YardTrip>>;
  yardTripsLast?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardTripStatusConnection = {
  __typename?: 'YardTripStatusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardTripStatusEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardTripStatusEdge = {
  __typename?: 'YardTripStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardTripStatus>;
};

export enum YardTripStatusField {
  ActivityStartTime = 'activityStartTime',
  ActivityTypeId = 'activityTypeID',
  CheckInById = 'checkInByID',
  CheckOutById = 'checkOutByID',
  CheckinTime = 'checkinTime',
  CheckoutTime = 'checkoutTime',
  CreatedAt = 'createdAt',
  DockId = 'dockID',
  ExternalId = 'externalID',
  MaterialId = 'materialID',
  OrganisationId = 'organisationID',
  RoutePathId = 'routePathID',
  Sequence = 'sequence',
  Status = 'status',
  TripId = 'tripID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardTripStatus connections */
export type YardTripStatusOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardTripStatusSlice. */
  field: YardTripStatusOrderField;
};

/** Properties by which YardTripStatus connections can be ordered. */
export enum YardTripStatusOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Sequence = 'sequence',
  UpdatedAt = 'updatedAt'
}

/** YardTripStatusStatus is enum for the field status */
export enum YardTripStatusStatus {
  CheckedIn = 'CheckedIn',
  CheckedOut = 'CheckedOut',
  Missed = 'Missed',
  Pending = 'Pending'
}

/**
 * YardTripStatusWhereInput is used for filtering YardTripStatus objects.
 * Input was generated by ent.
 */
export type YardTripStatusWhereInput = {
  /** activity_start_time field predicates */
  activityStartTime?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeGT?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activityStartTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activityStartTimeLT?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  activityStartTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  activityStartTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** activity_type_id field predicates */
  activityTypeID?: InputMaybe<Scalars['ID']['input']>;
  activityTypeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityTypeIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  activityTypeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  activityTypeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityTypeIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** check_in_by_id field predicates */
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkInByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  checkInByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_by_id field predicates */
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkOutByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  checkOutByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkOutByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkin_time field predicates */
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeGT?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkinTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkinTimeLT?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkinTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkout_time field predicates */
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeGT?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutTimeLT?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dock_id field predicates */
  dockID?: InputMaybe<Scalars['ID']['input']>;
  dockIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dockIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  dockIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** activity_type edge predicates */
  hasActivityType?: InputMaybe<Scalars['Boolean']['input']>;
  hasActivityTypeWith?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** check_in_by edge predicates */
  hasCheckInBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckInByWith?: InputMaybe<Array<UserWhereInput>>;
  /** check_out_by edge predicates */
  hasCheckOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckOutByWith?: InputMaybe<Array<UserWhereInput>>;
  /** dock edge predicates */
  hasDock?: InputMaybe<Scalars['Boolean']['input']>;
  hasDockWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** material edge predicates */
  hasMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  hasMaterialWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route_path edge predicates */
  hasRoutePath?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoutePathWith?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** trip edge predicates */
  hasTrip?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trips_current edge predicates */
  hasYardTripsCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsCurrentWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_trips_last edge predicates */
  hasYardTripsLast?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsLastWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** material_id field predicates */
  materialID?: InputMaybe<Scalars['ID']['input']>;
  materialIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  materialIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  materialIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<YardTripStatusWhereInput>;
  or?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** route_path_id field predicates */
  routePathID?: InputMaybe<Scalars['ID']['input']>;
  routePathIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routePathIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routePathIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sequence field predicates */
  sequence?: InputMaybe<Scalars['Int']['input']>;
  sequenceGT?: InputMaybe<Scalars['Int']['input']>;
  sequenceGTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  sequenceLT?: InputMaybe<Scalars['Int']['input']>;
  sequenceLTE?: InputMaybe<Scalars['Int']['input']>;
  sequenceNEQ?: InputMaybe<Scalars['Int']['input']>;
  sequenceNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** status field predicates */
  status?: InputMaybe<YardTripStatusStatus>;
  statusIn?: InputMaybe<Array<YardTripStatusStatus>>;
  statusNEQ?: InputMaybe<YardTripStatusStatus>;
  statusNotIn?: InputMaybe<Array<YardTripStatusStatus>>;
  /** trip_id field predicates */
  tripID?: InputMaybe<Scalars['ID']['input']>;
  tripIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  tripIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  tripIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** YardTripTripStatus is enum for the field trip_status */
export enum YardTripTripStatus {
  Approved = 'approved',
  Closed = 'closed',
  InDock = 'in_dock',
  OnHold = 'on_hold',
  Pending = 'pending',
  PendingApproval = 'pending_approval',
  Rejected = 'rejected',
  TransitionDock = 'transition_dock',
  WaitCheckIn = 'wait_check_in',
  WaitParkingCheckIn = 'wait_parking_check_in',
  WaitingPath = 'waiting_path',
  WarehouseCheckOut = 'warehouse_check_out'
}

/**
 * YardTripWhereInput is used for filtering YardTrip objects.
 * Input was generated by ent.
 */
export type YardTripWhereInput = {
  and?: InputMaybe<Array<YardTripWhereInput>>;
  /** assigned_driver_tracker_id field predicates */
  assignedDriverTrackerID?: InputMaybe<Scalars['ID']['input']>;
  assignedDriverTrackerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedDriverTrackerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedDriverTrackerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assignedDriverTrackerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedDriverTrackerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_route_id field predicates */
  assignedRouteID?: InputMaybe<Scalars['ID']['input']>;
  assignedRouteIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedRouteIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedRouteIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assignedRouteIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedRouteIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_tracker_battery_level field predicates */
  assignedTrackerBatteryLevel?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelGT?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelGTE?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  assignedTrackerBatteryLevelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTrackerBatteryLevelLT?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelLTE?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelNEQ?: InputMaybe<Scalars['Int']['input']>;
  assignedTrackerBatteryLevelNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  assignedTrackerBatteryLevelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_tracker_id field predicates */
  assignedTrackerID?: InputMaybe<Scalars['ID']['input']>;
  assignedTrackerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedTrackerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTrackerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  assignedTrackerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedTrackerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_in_by_id field predicates */
  checkInByID?: InputMaybe<Scalars['ID']['input']>;
  checkInByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkInByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  checkInByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** check_out_by_id field predicates */
  checkOutByID?: InputMaybe<Scalars['ID']['input']>;
  checkOutByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkOutByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkOutByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  checkOutByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkOutByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkin_time field predicates */
  checkinTime?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeGT?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkinTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkinTimeLT?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkinTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkinTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** checkout_time field predicates */
  checkoutTime?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeGT?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  checkoutTimeLT?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  checkoutTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  checkoutTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** current_trip_status field predicates */
  currentTripStatus?: InputMaybe<Scalars['ID']['input']>;
  currentTripStatusIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  currentTripStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  currentTripStatusNEQ?: InputMaybe<Scalars['ID']['input']>;
  currentTripStatusNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  currentTripStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** declared_material_id field predicates */
  declaredMaterialID?: InputMaybe<Scalars['ID']['input']>;
  declaredMaterialIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  declaredMaterialIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  declaredMaterialIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  declaredMaterialIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  declaredMaterialIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** driver_id field predicates */
  driverID?: InputMaybe<Scalars['ID']['input']>;
  driverIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  driverIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  driverIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  driverIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** assigned_driver_tracker edge predicates */
  hasAssignedDriverTracker?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedDriverTrackerWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** assigned_route edge predicates */
  hasAssignedRoute?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedRouteWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** assigned_tracker edge predicates */
  hasAssignedTracker?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedTrackerWith?: InputMaybe<Array<DeviceGroupWhereInput>>;
  /** check_in_by edge predicates */
  hasCheckInBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckInByWith?: InputMaybe<Array<UserWhereInput>>;
  /** check_out_by edge predicates */
  hasCheckOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasCheckOutByWith?: InputMaybe<Array<UserWhereInput>>;
  /** declared_material edge predicates */
  hasDeclaredMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeclaredMaterialWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** driver edge predicates */
  hasDriver?: InputMaybe<Scalars['Boolean']['input']>;
  hasDriverWith?: InputMaybe<Array<YardDriverProfileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** parking edge predicates */
  hasParking?: InputMaybe<Scalars['Boolean']['input']>;
  hasParkingWith?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** trip_status_current edge predicates */
  hasTripStatusCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripStatusCurrentWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** trip_status_last edge predicates */
  hasTripStatusLast?: InputMaybe<Scalars['Boolean']['input']>;
  hasTripStatusLastWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** vehicle edge predicates */
  hasVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  hasVehicleWith?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** vendor edge predicates */
  hasVendor?: InputMaybe<Scalars['Boolean']['input']>;
  hasVendorWith?: InputMaybe<Array<YardVendorWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_in_by edge predicates */
  hasWarehouseInBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseInByWith?: InputMaybe<Array<UserWhereInput>>;
  /** warehouse_out_by edge predicates */
  hasWarehouseOutBy?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseOutByWith?: InputMaybe<Array<UserWhereInput>>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_trip_status field predicates */
  lastTripStatus?: InputMaybe<Scalars['ID']['input']>;
  lastTripStatusIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastTripStatusIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastTripStatusNEQ?: InputMaybe<Scalars['ID']['input']>;
  lastTripStatusNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastTripStatusNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<YardTripWhereInput>;
  or?: InputMaybe<Array<YardTripWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** parking_id field predicates */
  parkingID?: InputMaybe<Scalars['ID']['input']>;
  parkingIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parkingIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  parkingIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  parkingIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_in_time field predicates */
  parkingInTime?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeGT?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingInTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingInTimeLT?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  parkingInTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingInTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** parking_out_time field predicates */
  parkingOutTime?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeGT?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingOutTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  parkingOutTimeLT?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  parkingOutTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  parkingOutTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** purpose field predicates */
  purpose?: InputMaybe<YardTripPurpose>;
  purposeIn?: InputMaybe<Array<YardTripPurpose>>;
  purposeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  purposeNEQ?: InputMaybe<YardTripPurpose>;
  purposeNotIn?: InputMaybe<Array<YardTripPurpose>>;
  purposeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** trip_status field predicates */
  tripStatus?: InputMaybe<YardTripTripStatus>;
  tripStatusIn?: InputMaybe<Array<YardTripTripStatus>>;
  tripStatusNEQ?: InputMaybe<YardTripTripStatus>;
  tripStatusNotIn?: InputMaybe<Array<YardTripTripStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_id field predicates */
  vehicleID?: InputMaybe<Scalars['ID']['input']>;
  vehicleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vehicleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vendor_id field predicates */
  vendorID?: InputMaybe<Scalars['ID']['input']>;
  vendorIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vendorIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  vendorIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vendorIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** warehouse_in_by_id field predicates */
  warehouseInByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseInByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseInByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseInByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseInByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseInByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_in_time field predicates */
  warehouseInTime?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeGT?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  warehouseInTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseInTimeLT?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  warehouseInTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  warehouseInTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_out_by_id field predicates */
  warehouseOutByID?: InputMaybe<Scalars['ID']['input']>;
  warehouseOutByIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseOutByIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseOutByIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseOutByIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseOutByIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** warehouse_out_time field predicates */
  warehouseOutTime?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeGT?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  warehouseOutTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseOutTimeLT?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  warehouseOutTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  warehouseOutTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type YardVehicle = Node & {
  __typename?: 'YardVehicle';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  insuranceCertificateImage?: Maybe<Scalars['ID']['output']>;
  insuranceExpiry?: Maybe<Scalars['Time']['output']>;
  lastUpdated: Scalars['Time']['output'];
  mediafileVehicleInsuranceImage?: Maybe<MediaFile>;
  mediafileVehiclePollutionImage?: Maybe<MediaFile>;
  mediafileVehicleRc?: Maybe<MediaFile>;
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  pollutionCertificateImage?: Maybe<Scalars['ID']['output']>;
  pollutionExpiry?: Maybe<Scalars['Time']['output']>;
  updatedAt: Scalars['Time']['output'];
  vehicleNumber: Scalars['String']['output'];
  vehicleRcExpiry: Scalars['Time']['output'];
  vehicleRcImage?: Maybe<Scalars['ID']['output']>;
  vehicleRcNumber: Scalars['String']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardVehicleConnection = {
  __typename?: 'YardVehicleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardVehicleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardVehicleEdge = {
  __typename?: 'YardVehicleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardVehicle>;
};

export enum YardVehicleField {
  CreatedAt = 'createdAt',
  InsuranceCertificateImage = 'insuranceCertificateImage',
  InsuranceExpiry = 'insuranceExpiry',
  LastUpdated = 'lastUpdated',
  OrganisationId = 'organisationID',
  PollutionCertificateImage = 'pollutionCertificateImage',
  PollutionExpiry = 'pollutionExpiry',
  UpdatedAt = 'updatedAt',
  VehicleNumber = 'vehicleNumber',
  VehicleRcExpiry = 'vehicleRcExpiry',
  VehicleRcImage = 'vehicleRcImage',
  VehicleRcNumber = 'vehicleRcNumber'
}

/** Ordering options for YardVehicle connections */
export type YardVehicleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardVehicles. */
  field: YardVehicleOrderField;
};

/** Properties by which YardVehicle connections can be ordered. */
export enum YardVehicleOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardVehicleWhereInput is used for filtering YardVehicle objects.
 * Input was generated by ent.
 */
export type YardVehicleWhereInput = {
  and?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** mediafile_vehicle_insurance_image edge predicates */
  hasMediafileVehicleInsuranceImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileVehicleInsuranceImageWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafile_vehicle_pollution_image edge predicates */
  hasMediafileVehiclePollutionImage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileVehiclePollutionImageWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** mediafile_vehicle_rc edge predicates */
  hasMediafileVehicleRc?: InputMaybe<Scalars['Boolean']['input']>;
  hasMediafileVehicleRcWith?: InputMaybe<Array<MediaFileWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** insurance_certificate_image field predicates */
  insuranceCertificateImage?: InputMaybe<Scalars['ID']['input']>;
  insuranceCertificateImageIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  insuranceCertificateImageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceCertificateImageNEQ?: InputMaybe<Scalars['ID']['input']>;
  insuranceCertificateImageNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  insuranceCertificateImageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** insurance_expiry field predicates */
  insuranceExpiry?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceExpiryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  insuranceExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  insuranceExpiryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** last_updated field predicates */
  lastUpdated?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedGT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedGTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastUpdatedLT?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedLTE?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastUpdatedNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<YardVehicleWhereInput>;
  or?: InputMaybe<Array<YardVehicleWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** pollution_certificate_image field predicates */
  pollutionCertificateImage?: InputMaybe<Scalars['ID']['input']>;
  pollutionCertificateImageIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  pollutionCertificateImageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pollutionCertificateImageNEQ?: InputMaybe<Scalars['ID']['input']>;
  pollutionCertificateImageNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  pollutionCertificateImageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** pollution_expiry field predicates */
  pollutionExpiry?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  pollutionExpiryIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  pollutionExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  pollutionExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  pollutionExpiryNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_number field predicates */
  vehicleNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberContains?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberGT?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberGTE?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleNumberLT?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberLTE?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  vehicleNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** vehicle_rc_expiry field predicates */
  vehicleRcExpiry?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryGT?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryGTE?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  vehicleRcExpiryLT?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryLTE?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryNEQ?: InputMaybe<Scalars['Time']['input']>;
  vehicleRcExpiryNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vehicle_rc_image field predicates */
  vehicleRcImage?: InputMaybe<Scalars['ID']['input']>;
  vehicleRcImageIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleRcImageIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleRcImageNEQ?: InputMaybe<Scalars['ID']['input']>;
  vehicleRcImageNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleRcImageNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** vehicle_rc_number field predicates */
  vehicleRcNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberContains?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberContainsFold?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberEqualFold?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberGT?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberGTE?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleRcNumberLT?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberLTE?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberNEQ?: InputMaybe<Scalars['String']['input']>;
  vehicleRcNumberNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type YardVendor = Node & {
  __typename?: 'YardVendor';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  vendorCode: Scalars['String']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardVendorConnection = {
  __typename?: 'YardVendorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardVendorEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardVendorEdge = {
  __typename?: 'YardVendorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardVendor>;
};

export enum YardVendorField {
  CreatedAt = 'createdAt',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt',
  VendorCode = 'vendorCode'
}

/** Ordering options for YardVendor connections */
export type YardVendorOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardVendors. */
  field: YardVendorOrderField;
};

/** Properties by which YardVendor connections can be ordered. */
export enum YardVendorOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardVendorWhereInput is used for filtering YardVendor objects.
 * Input was generated by ent.
 */
export type YardVendorWhereInput = {
  and?: InputMaybe<Array<YardVendorWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardVendorWhereInput>;
  or?: InputMaybe<Array<YardVendorWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** vendor_code field predicates */
  vendorCode?: InputMaybe<Scalars['String']['input']>;
  vendorCodeContains?: InputMaybe<Scalars['String']['input']>;
  vendorCodeContainsFold?: InputMaybe<Scalars['String']['input']>;
  vendorCodeEqualFold?: InputMaybe<Scalars['String']['input']>;
  vendorCodeGT?: InputMaybe<Scalars['String']['input']>;
  vendorCodeGTE?: InputMaybe<Scalars['String']['input']>;
  vendorCodeHasPrefix?: InputMaybe<Scalars['String']['input']>;
  vendorCodeHasSuffix?: InputMaybe<Scalars['String']['input']>;
  vendorCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCodeLT?: InputMaybe<Scalars['String']['input']>;
  vendorCodeLTE?: InputMaybe<Scalars['String']['input']>;
  vendorCodeNEQ?: InputMaybe<Scalars['String']['input']>;
  vendorCodeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type YardWarehouse = Node & {
  __typename?: 'YardWarehouse';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
  yardTrips?: Maybe<Array<YardTrip>>;
  yardWarehouseActivityTypes?: Maybe<Array<YardWarehouseActivityType>>;
  yardWarehouseApprovalMatrix?: Maybe<Array<YardWarehouseApprovalMatrix>>;
  yardWarehouseDocks?: Maybe<Array<YardWarehouseDock>>;
  yardWarehouseParkings?: Maybe<Array<YardWarehouseParking>>;
  yardWarehouseRoutes?: Maybe<Array<YardWarehouseRoute>>;
};

export type YardWarehouseActivityType = Node & {
  __typename?: 'YardWarehouseActivityType';
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
};

/** A connection to a list of items. */
export type YardWarehouseActivityTypeConnection = {
  __typename?: 'YardWarehouseActivityTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseActivityTypeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseActivityTypeEdge = {
  __typename?: 'YardWarehouseActivityTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseActivityType>;
};

export enum YardWarehouseActivityTypeField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseActivityType connections */
export type YardWarehouseActivityTypeOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseActivityTypes. */
  field: YardWarehouseActivityTypeOrderField;
};

/** Properties by which YardWarehouseActivityType connections can be ordered. */
export enum YardWarehouseActivityTypeOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseActivityTypeWhereInput is used for filtering YardWarehouseActivityType objects.
 * Input was generated by ent.
 */
export type YardWarehouseActivityTypeWhereInput = {
  and?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseActivityTypeWhereInput>;
  or?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type YardWarehouseApprovalMatrix = Node & {
  __typename?: 'YardWarehouseApprovalMatrix';
  approvalMatrix?: Maybe<YardWarehouseApprovalMatrix>;
  approveAfterID?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  preApprovalMatrix?: Maybe<Array<YardWarehouseApprovalMatrix>>;
  role: OrganisationRole;
  roleID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTripApprovals?: Maybe<Array<YardTripApproval>>;
};

/** A connection to a list of items. */
export type YardWarehouseApprovalMatrixConnection = {
  __typename?: 'YardWarehouseApprovalMatrixConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseApprovalMatrixEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseApprovalMatrixEdge = {
  __typename?: 'YardWarehouseApprovalMatrixEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseApprovalMatrix>;
};

export enum YardWarehouseApprovalMatrixField {
  ApproveAfterId = 'approveAfterID',
  CreatedAt = 'createdAt',
  Label = 'label',
  OrganisationId = 'organisationID',
  RoleId = 'roleID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseApprovalMatrix connections */
export type YardWarehouseApprovalMatrixOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseApprovalMatrixes. */
  field: YardWarehouseApprovalMatrixOrderField;
};

/** Properties by which YardWarehouseApprovalMatrix connections can be ordered. */
export enum YardWarehouseApprovalMatrixOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseApprovalMatrixWhereInput is used for filtering YardWarehouseApprovalMatrix objects.
 * Input was generated by ent.
 */
export type YardWarehouseApprovalMatrixWhereInput = {
  and?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** approve_after_id field predicates */
  approveAfterID?: InputMaybe<Scalars['ID']['input']>;
  approveAfterIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approveAfterIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  approveAfterIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  approveAfterIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  approveAfterIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** approval_matrix edge predicates */
  hasApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** pre_approval_matrix edge predicates */
  hasPreApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** role edge predicates */
  hasRole?: InputMaybe<Scalars['Boolean']['input']>;
  hasRoleWith?: InputMaybe<Array<OrganisationRoleWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** label field predicates */
  label?: InputMaybe<Scalars['String']['input']>;
  labelContains?: InputMaybe<Scalars['String']['input']>;
  labelContainsFold?: InputMaybe<Scalars['String']['input']>;
  labelEqualFold?: InputMaybe<Scalars['String']['input']>;
  labelGT?: InputMaybe<Scalars['String']['input']>;
  labelGTE?: InputMaybe<Scalars['String']['input']>;
  labelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  labelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  labelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  labelLT?: InputMaybe<Scalars['String']['input']>;
  labelLTE?: InputMaybe<Scalars['String']['input']>;
  labelNEQ?: InputMaybe<Scalars['String']['input']>;
  labelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseApprovalMatrixWhereInput>;
  or?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** role_id field predicates */
  roleID?: InputMaybe<Scalars['ID']['input']>;
  roleIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  roleIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A connection to a list of items. */
export type YardWarehouseConnection = {
  __typename?: 'YardWarehouseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type YardWarehouseDock = Node & {
  __typename?: 'YardWarehouseDock';
  createdAt: Scalars['Time']['output'];
  dockType: YardWarehouseDockDockType;
  geofence: Geofence;
  geofenceID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
  yardWarehouseDockSharing?: Maybe<Array<YardWarehouseDockSharing>>;
  yardWarehouseRoutePaths?: Maybe<Array<YardWarehouseRoutePath>>;
  yardWarehouseRoutes?: Maybe<Array<YardWarehouseRoute>>;
};

/** A connection to a list of items. */
export type YardWarehouseDockConnection = {
  __typename?: 'YardWarehouseDockConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseDockEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** YardWarehouseDockDockType is enum for the field dock_type */
export enum YardWarehouseDockDockType {
  DualPurpose = 'DualPurpose',
  LoadingBay = 'LoadingBay',
  Others = 'Others',
  UnloadingBay = 'UnloadingBay'
}

/** An edge in a connection. */
export type YardWarehouseDockEdge = {
  __typename?: 'YardWarehouseDockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseDock>;
};

export enum YardWarehouseDockField {
  CreatedAt = 'createdAt',
  DockType = 'dockType',
  GeofenceId = 'geofenceID',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseDock connections */
export type YardWarehouseDockOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseDocks. */
  field: YardWarehouseDockOrderField;
};

/** Properties by which YardWarehouseDock connections can be ordered. */
export enum YardWarehouseDockOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type YardWarehouseDockSharing = Node & {
  __typename?: 'YardWarehouseDockSharing';
  createdAt: Scalars['Time']['output'];
  dock: YardWarehouseDock;
  dockID: Scalars['ID']['output'];
  expiresOn?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  organisationUser: User;
  sharedbyID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type YardWarehouseDockSharingConnection = {
  __typename?: 'YardWarehouseDockSharingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseDockSharingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseDockSharingEdge = {
  __typename?: 'YardWarehouseDockSharingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseDockSharing>;
};

export enum YardWarehouseDockSharingField {
  CreatedAt = 'createdAt',
  DockId = 'dockID',
  ExpiresOn = 'expiresOn',
  IsActive = 'isActive',
  OrganisationId = 'organisationID',
  SharedbyId = 'sharedbyID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardWarehouseDockSharing connections */
export type YardWarehouseDockSharingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseDockSharings. */
  field: YardWarehouseDockSharingOrderField;
};

/** Properties by which YardWarehouseDockSharing connections can be ordered. */
export enum YardWarehouseDockSharingOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseDockSharingWhereInput is used for filtering YardWarehouseDockSharing objects.
 * Input was generated by ent.
 */
export type YardWarehouseDockSharingWhereInput = {
  and?: InputMaybe<Array<YardWarehouseDockSharingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dock_id field predicates */
  dockID?: InputMaybe<Scalars['ID']['input']>;
  dockIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dockIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  dockIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** expires_on field predicates */
  expiresOn?: InputMaybe<Scalars['Time']['input']>;
  expiresOnGT?: InputMaybe<Scalars['Time']['input']>;
  expiresOnGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresOnIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresOnIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresOnLT?: InputMaybe<Scalars['Time']['input']>;
  expiresOnLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresOnNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresOnNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresOnNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dock edge predicates */
  hasDock?: InputMaybe<Scalars['Boolean']['input']>;
  hasDockWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation_user edge predicates */
  hasOrganisationUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationUserWith?: InputMaybe<Array<UserWhereInput>>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<YardWarehouseDockSharingWhereInput>;
  or?: InputMaybe<Array<YardWarehouseDockSharingWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** sharedby_id field predicates */
  sharedbyID?: InputMaybe<Scalars['ID']['input']>;
  sharedbyIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharedbyIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  sharedbyIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/**
 * YardWarehouseDockWhereInput is used for filtering YardWarehouseDock objects.
 * Input was generated by ent.
 */
export type YardWarehouseDockWhereInput = {
  and?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dock_type field predicates */
  dockType?: InputMaybe<YardWarehouseDockDockType>;
  dockTypeIn?: InputMaybe<Array<YardWarehouseDockDockType>>;
  dockTypeNEQ?: InputMaybe<YardWarehouseDockDockType>;
  dockTypeNotIn?: InputMaybe<Array<YardWarehouseDockDockType>>;
  /** geofence_id field predicates */
  geofenceID?: InputMaybe<Scalars['ID']['input']>;
  geofenceIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  geofenceIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  geofenceIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** geofence edge predicates */
  hasGeofence?: InputMaybe<Scalars['Boolean']['input']>;
  hasGeofenceWith?: InputMaybe<Array<GeofenceWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_warehouse_dock_sharing edge predicates */
  hasYardWarehouseDockSharing?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDockSharingWith?: InputMaybe<Array<YardWarehouseDockSharingWhereInput>>;
  /** yard_warehouse_route_paths edge predicates */
  hasYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutePathsWith?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** yard_warehouse_routes edge predicates */
  hasYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutesWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseDockWhereInput>;
  or?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An edge in a connection. */
export type YardWarehouseEdge = {
  __typename?: 'YardWarehouseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouse>;
};

export enum YardWarehouseField {
  CreatedAt = 'createdAt',
  Name = 'name',
  OrganisationId = 'organisationID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardWarehouse connections */
export type YardWarehouseOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouses. */
  field: YardWarehouseOrderField;
};

/** Properties by which YardWarehouse connections can be ordered. */
export enum YardWarehouseOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type YardWarehouseParking = Node & {
  __typename?: 'YardWarehouseParking';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  slotName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
};

/** A connection to a list of items. */
export type YardWarehouseParkingConnection = {
  __typename?: 'YardWarehouseParkingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseParkingEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseParkingEdge = {
  __typename?: 'YardWarehouseParkingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseParking>;
};

export enum YardWarehouseParkingField {
  CreatedAt = 'createdAt',
  IsActive = 'isActive',
  OrganisationId = 'organisationID',
  SlotName = 'slotName',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseParking connections */
export type YardWarehouseParkingOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseParkings. */
  field: YardWarehouseParkingOrderField;
};

/** Properties by which YardWarehouseParking connections can be ordered. */
export enum YardWarehouseParkingOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseParkingWhereInput is used for filtering YardWarehouseParking objects.
 * Input was generated by ent.
 */
export type YardWarehouseParkingWhereInput = {
  and?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<YardWarehouseParkingWhereInput>;
  or?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** slot_name field predicates */
  slotName?: InputMaybe<Scalars['String']['input']>;
  slotNameContains?: InputMaybe<Scalars['String']['input']>;
  slotNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  slotNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  slotNameGT?: InputMaybe<Scalars['String']['input']>;
  slotNameGTE?: InputMaybe<Scalars['String']['input']>;
  slotNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  slotNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  slotNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  slotNameLT?: InputMaybe<Scalars['String']['input']>;
  slotNameLTE?: InputMaybe<Scalars['String']['input']>;
  slotNameNEQ?: InputMaybe<Scalars['String']['input']>;
  slotNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type YardWarehouseRoute = Node & {
  __typename?: 'YardWarehouseRoute';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  ensureOrder: Scalars['Boolean']['output'];
  /** @deprecated moved away from eta module */
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  preferredYardMaterials?: Maybe<Array<YardMaterial>>;
  primaryDock?: Maybe<YardWarehouseDock>;
  primaryDockID?: Maybe<Scalars['ID']['output']>;
  routeType: YardWarehouseRouteRouteType;
  updatedAt: Scalars['Time']['output'];
  warehouse: YardWarehouse;
  warehouseID: Scalars['ID']['output'];
  yardTrips?: Maybe<Array<YardTrip>>;
  yardWarehouseRoutePaths?: Maybe<Array<YardWarehouseRoutePath>>;
};

/** A connection to a list of items. */
export type YardWarehouseRouteConnection = {
  __typename?: 'YardWarehouseRouteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseRouteEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseRouteEdge = {
  __typename?: 'YardWarehouseRouteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseRoute>;
};

export enum YardWarehouseRouteField {
  Active = 'active',
  CreatedAt = 'createdAt',
  EnsureOrder = 'ensureOrder',
  ExternalId = 'externalID',
  Name = 'name',
  OrganisationId = 'organisationID',
  PrimaryDockId = 'primaryDockID',
  RouteType = 'routeType',
  UpdatedAt = 'updatedAt',
  WarehouseId = 'warehouseID'
}

/** Ordering options for YardWarehouseRoute connections */
export type YardWarehouseRouteOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseRoutes. */
  field: YardWarehouseRouteOrderField;
};

/** Properties by which YardWarehouseRoute connections can be ordered. */
export enum YardWarehouseRouteOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type YardWarehouseRoutePath = Node & {
  __typename?: 'YardWarehouseRoutePath';
  createdAt: Scalars['Time']['output'];
  dock: YardWarehouseDock;
  dockID: Scalars['ID']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxWaitTime: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  organisation: Organisation;
  organisationID: Scalars['ID']['output'];
  route: YardWarehouseRoute;
  routeID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  yardTripStatus?: Maybe<Array<YardTripStatus>>;
};

/** A connection to a list of items. */
export type YardWarehouseRoutePathConnection = {
  __typename?: 'YardWarehouseRoutePathConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<YardWarehouseRoutePathEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type YardWarehouseRoutePathEdge = {
  __typename?: 'YardWarehouseRoutePathEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<YardWarehouseRoutePath>;
};

export enum YardWarehouseRoutePathField {
  CreatedAt = 'createdAt',
  DockId = 'dockID',
  ExternalId = 'externalID',
  MaxWaitTime = 'maxWaitTime',
  Name = 'name',
  Order = 'order',
  OrganisationId = 'organisationID',
  RouteId = 'routeID',
  UpdatedAt = 'updatedAt'
}

/** Ordering options for YardWarehouseRoutePath connections */
export type YardWarehouseRoutePathOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order YardWarehouseRoutePaths. */
  field: YardWarehouseRoutePathOrderField;
};

/** Properties by which YardWarehouseRoutePath connections can be ordered. */
export enum YardWarehouseRoutePathOrderField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

/**
 * YardWarehouseRoutePathWhereInput is used for filtering YardWarehouseRoutePath objects.
 * Input was generated by ent.
 */
export type YardWarehouseRoutePathWhereInput = {
  and?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** dock_id field predicates */
  dockID?: InputMaybe<Scalars['ID']['input']>;
  dockIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  dockIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  dockIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** dock edge predicates */
  hasDock?: InputMaybe<Scalars['Boolean']['input']>;
  hasDockWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** route edge predicates */
  hasRoute?: InputMaybe<Scalars['Boolean']['input']>;
  hasRouteWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** max_wait_time field predicates */
  maxWaitTime?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeGT?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeGTE?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxWaitTimeLT?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeLTE?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeNEQ?: InputMaybe<Scalars['Int']['input']>;
  maxWaitTimeNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseRoutePathWhereInput>;
  or?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** order field predicates */
  order?: InputMaybe<Scalars['Int']['input']>;
  orderGT?: InputMaybe<Scalars['Int']['input']>;
  orderGTE?: InputMaybe<Scalars['Int']['input']>;
  orderIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  orderLT?: InputMaybe<Scalars['Int']['input']>;
  orderLTE?: InputMaybe<Scalars['Int']['input']>;
  orderNEQ?: InputMaybe<Scalars['Int']['input']>;
  orderNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** route_id field predicates */
  routeID?: InputMaybe<Scalars['ID']['input']>;
  routeIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  routeIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  routeIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** YardWarehouseRouteRouteType is enum for the field route_type */
export enum YardWarehouseRouteRouteType {
  Auto = 'Auto',
  Manual = 'Manual'
}

/**
 * YardWarehouseRouteWhereInput is used for filtering YardWarehouseRoute objects.
 * Input was generated by ent.
 */
export type YardWarehouseRouteWhereInput = {
  /** active field predicates */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activeNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** ensure_order field predicates */
  ensureOrder?: InputMaybe<Scalars['Boolean']['input']>;
  ensureOrderNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** external_id field predicates */
  externalID?: InputMaybe<Scalars['String']['input']>;
  externalIDContains?: InputMaybe<Scalars['String']['input']>;
  externalIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  externalIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  externalIDGT?: InputMaybe<Scalars['String']['input']>;
  externalIDGTE?: InputMaybe<Scalars['String']['input']>;
  externalIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  externalIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  externalIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  externalIDLT?: InputMaybe<Scalars['String']['input']>;
  externalIDLTE?: InputMaybe<Scalars['String']['input']>;
  externalIDNEQ?: InputMaybe<Scalars['String']['input']>;
  externalIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  externalIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** preferred_yard_materials edge predicates */
  hasPreferredYardMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreferredYardMaterialsWith?: InputMaybe<Array<YardMaterialWhereInput>>;
  /** primary_dock edge predicates */
  hasPrimaryDock?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrimaryDockWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** warehouse edge predicates */
  hasWarehouse?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarehouseWith?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_warehouse_route_paths edge predicates */
  hasYardWarehouseRoutePaths?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutePathsWith?: InputMaybe<Array<YardWarehouseRoutePathWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseRouteWhereInput>;
  or?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** primary_dock_id field predicates */
  primaryDockID?: InputMaybe<Scalars['ID']['input']>;
  primaryDockIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryDockIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  primaryDockIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  primaryDockIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  primaryDockIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** route_type field predicates */
  routeType?: InputMaybe<YardWarehouseRouteRouteType>;
  routeTypeIn?: InputMaybe<Array<YardWarehouseRouteRouteType>>;
  routeTypeNEQ?: InputMaybe<YardWarehouseRouteRouteType>;
  routeTypeNotIn?: InputMaybe<Array<YardWarehouseRouteRouteType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** warehouse_id field predicates */
  warehouseID?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  warehouseIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * YardWarehouseWhereInput is used for filtering YardWarehouse objects.
 * Input was generated by ent.
 */
export type YardWarehouseWhereInput = {
  and?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** organisation edge predicates */
  hasOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganisationWith?: InputMaybe<Array<OrganisationWhereInput>>;
  /** yard_trip_approvals edge predicates */
  hasYardTripApprovals?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripApprovalsWith?: InputMaybe<Array<YardTripApprovalWhereInput>>;
  /** yard_trip_status edge predicates */
  hasYardTripStatus?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripStatusWith?: InputMaybe<Array<YardTripStatusWhereInput>>;
  /** yard_trips edge predicates */
  hasYardTrips?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardTripsWith?: InputMaybe<Array<YardTripWhereInput>>;
  /** yard_warehouse_activity_types edge predicates */
  hasYardWarehouseActivityTypes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseActivityTypesWith?: InputMaybe<Array<YardWarehouseActivityTypeWhereInput>>;
  /** yard_warehouse_approval_matrix edge predicates */
  hasYardWarehouseApprovalMatrix?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseApprovalMatrixWith?: InputMaybe<Array<YardWarehouseApprovalMatrixWhereInput>>;
  /** yard_warehouse_docks edge predicates */
  hasYardWarehouseDocks?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseDocksWith?: InputMaybe<Array<YardWarehouseDockWhereInput>>;
  /** yard_warehouse_parkings edge predicates */
  hasYardWarehouseParkings?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseParkingsWith?: InputMaybe<Array<YardWarehouseParkingWhereInput>>;
  /** yard_warehouse_routes edge predicates */
  hasYardWarehouseRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  hasYardWarehouseRoutesWith?: InputMaybe<Array<YardWarehouseRouteWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<YardWarehouseWhereInput>;
  or?: InputMaybe<Array<YardWarehouseWhereInput>>;
  /** organisation_id field predicates */
  organisationID?: InputMaybe<Scalars['ID']['input']>;
  organisationIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  organisationIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};
